/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z,
   *     compliant with the 'date-time' format outlined in section 5.6 of
   *     the RFC 3339 profile of the ISO 8601 standard for representation
   *     of dates and times using the Gregorian calendar.
   */
  DateTime: { input: any; output: any; }
  /** The 'Dimension' type represents dimensions as whole numeric values between `1` and `4000`. */
  Dimension: { input: any; output: any; }
  /** The 'HexColor' type represents color in `rgb:ffffff` string format. */
  HexColor: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
  /** The 'Quality' type represents quality as whole numeric values between `1` and `100`. */
  Quality: { input: any; output: any; }
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAsset) */
export type ActivitySheetAsset = Entry & _Node & {
  __typename?: 'ActivitySheetAsset';
  _id: Scalars['ID']['output'];
  asset: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  id: Maybe<Scalars['String']['output']>;
  isVisible: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<ActivitySheetAssetLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAsset) */
export type ActivitySheetAssetAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAsset) */
export type ActivitySheetAssetIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAsset) */
export type ActivitySheetAssetIsVisibleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAsset) */
export type ActivitySheetAssetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAsset) */
export type ActivitySheetAssetNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAsset) */
export type ActivitySheetAssetSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySheetAssetCollection = {
  __typename?: 'ActivitySheetAssetCollection';
  items: Array<Maybe<ActivitySheetAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ActivitySheetAssetCursorCollection = {
  __typename?: 'ActivitySheetAssetCursorCollection';
  items: Array<Maybe<ActivitySheetAsset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ActivitySheetAssetFilter = {
  AND: InputMaybe<Array<InputMaybe<ActivitySheetAssetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ActivitySheetAssetFilter>>>;
  asset_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isVisible: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_exists: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_not: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAssetGroup) */
export type ActivitySheetAssetGroup = Entry & _Node & {
  __typename?: 'ActivitySheetAssetGroup';
  _id: Scalars['ID']['output'];
  activitySheetSection: Maybe<ActivitySheetSection>;
  assetsCollection: Maybe<ActivitySheetAssetGroupAssetsCollection>;
  assetsCursorCollection: Maybe<ActivitySheetAssetGroupAssetsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ActivitySheetAssetGroupLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAssetGroup) */
export type ActivitySheetAssetGroupActivitySheetSectionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ActivitySheetSectionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAssetGroup) */
export type ActivitySheetAssetGroupAssetsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetAssetGroupAssetsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ActivitySheetAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAssetGroup) */
export type ActivitySheetAssetGroupAssetsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetAssetGroupAssetsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ActivitySheetAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAssetGroup) */
export type ActivitySheetAssetGroupLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAssetGroup) */
export type ActivitySheetAssetGroupNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetAssetGroup) */
export type ActivitySheetAssetGroupSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySheetAssetGroupAssetsCollection = {
  __typename?: 'ActivitySheetAssetGroupAssetsCollection';
  items: Array<Maybe<ActivitySheetAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ActivitySheetAssetGroupAssetsCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsVisibleAsc = 'isVisible_ASC',
  IsVisibleDesc = 'isVisible_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ActivitySheetAssetGroupAssetsCursorCollection = {
  __typename?: 'ActivitySheetAssetGroupAssetsCursorCollection';
  items: Array<Maybe<ActivitySheetAsset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ActivitySheetAssetGroupAssetsCursorCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsVisibleAsc = 'isVisible_ASC',
  IsVisibleDesc = 'isVisible_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ActivitySheetAssetGroupCollection = {
  __typename?: 'ActivitySheetAssetGroupCollection';
  items: Array<Maybe<ActivitySheetAssetGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ActivitySheetAssetGroupCursorCollection = {
  __typename?: 'ActivitySheetAssetGroupCursorCollection';
  items: Array<Maybe<ActivitySheetAssetGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ActivitySheetAssetGroupFilter = {
  AND: InputMaybe<Array<InputMaybe<ActivitySheetAssetGroupFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ActivitySheetAssetGroupFilter>>>;
  activitySheetSection: InputMaybe<CfActivitySheetSectionNestedFilter>;
  activitySheetSection_exists: InputMaybe<Scalars['Boolean']['input']>;
  assets: InputMaybe<CfActivitySheetAssetNestedFilter>;
  assetsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ActivitySheetAssetGroupLinkingCollections = {
  __typename?: 'ActivitySheetAssetGroupLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ActivitySheetAssetGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ActivitySheetAssetGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ActivitySheetAssetGroupOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ActivitySheetAssetLinkingCollections = {
  __typename?: 'ActivitySheetAssetLinkingCollections';
  activitySheetAssetGroupCollection: Maybe<ActivitySheetAssetGroupCollection>;
  activitySheetAssetGroupCursorCollection: Maybe<ActivitySheetAssetGroupCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ActivitySheetAssetLinkingCollectionsActivitySheetAssetGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetAssetLinkingCollectionsActivitySheetAssetGroupCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ActivitySheetAssetLinkingCollectionsActivitySheetAssetGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetAssetLinkingCollectionsActivitySheetAssetGroupCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ActivitySheetAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ActivitySheetAssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ActivitySheetAssetLinkingCollectionsActivitySheetAssetGroupCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ActivitySheetAssetLinkingCollectionsActivitySheetAssetGroupCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ActivitySheetAssetOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsVisibleAsc = 'isVisible_ASC',
  IsVisibleDesc = 'isVisible_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetSection) */
export type ActivitySheetSection = Entry & _Node & {
  __typename?: 'ActivitySheetSection';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ActivitySheetSectionLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  product: Maybe<Product>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetSection) */
export type ActivitySheetSectionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetSection) */
export type ActivitySheetSectionNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetSection) */
export type ActivitySheetSectionProductArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ProductFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/activitySheetSection) */
export type ActivitySheetSectionSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivitySheetSectionCollection = {
  __typename?: 'ActivitySheetSectionCollection';
  items: Array<Maybe<ActivitySheetSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ActivitySheetSectionCursorCollection = {
  __typename?: 'ActivitySheetSectionCursorCollection';
  items: Array<Maybe<ActivitySheetSection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ActivitySheetSectionFilter = {
  AND: InputMaybe<Array<InputMaybe<ActivitySheetSectionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ActivitySheetSectionFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product: InputMaybe<CfProductNestedFilter>;
  product_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ActivitySheetSectionLinkingCollections = {
  __typename?: 'ActivitySheetSectionLinkingCollections';
  activitySheetAssetGroupCollection: Maybe<ActivitySheetAssetGroupCollection>;
  activitySheetAssetGroupCursorCollection: Maybe<ActivitySheetAssetGroupCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ActivitySheetSectionLinkingCollectionsActivitySheetAssetGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetSectionLinkingCollectionsActivitySheetAssetGroupCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ActivitySheetSectionLinkingCollectionsActivitySheetAssetGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetSectionLinkingCollectionsActivitySheetAssetGroupCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ActivitySheetSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ActivitySheetSectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ActivitySheetSectionLinkingCollectionsActivitySheetAssetGroupCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ActivitySheetSectionLinkingCollectionsActivitySheetAssetGroupCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ActivitySheetSectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** Represents a binary file in a space. An asset can be any file type. */
export type Asset = _Node & {
  __typename?: 'Asset';
  _id: Scalars['ID']['output'];
  contentType: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  fileName: Maybe<Scalars['String']['output']>;
  height: Maybe<Scalars['Int']['output']>;
  linkedFrom: Maybe<AssetLinkingCollections>;
  size: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
  width: Maybe<Scalars['Int']['output']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetContentTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetFileNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetHeightArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetSizeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  transform: InputMaybe<ImageTransformOptions>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** Represents a binary file in a space. An asset can be any file type. */
export type AssetWidthArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type AssetCollection = {
  __typename?: 'AssetCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type AssetCursorCollection = {
  __typename?: 'AssetCursorCollection';
  items: Array<Maybe<Asset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type AssetFilter = {
  AND: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<AssetFilter>>>;
  contentType: InputMaybe<Scalars['String']['input']>;
  contentType_contains: InputMaybe<Scalars['String']['input']>;
  contentType_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentType_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType_not: InputMaybe<Scalars['String']['input']>;
  contentType_not_contains: InputMaybe<Scalars['String']['input']>;
  contentType_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName: InputMaybe<Scalars['String']['input']>;
  fileName_contains: InputMaybe<Scalars['String']['input']>;
  fileName_exists: InputMaybe<Scalars['Boolean']['input']>;
  fileName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileName_not: InputMaybe<Scalars['String']['input']>;
  fileName_not_contains: InputMaybe<Scalars['String']['input']>;
  fileName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  height: InputMaybe<Scalars['Int']['input']>;
  height_exists: InputMaybe<Scalars['Boolean']['input']>;
  height_gt: InputMaybe<Scalars['Int']['input']>;
  height_gte: InputMaybe<Scalars['Int']['input']>;
  height_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  height_lt: InputMaybe<Scalars['Int']['input']>;
  height_lte: InputMaybe<Scalars['Int']['input']>;
  height_not: InputMaybe<Scalars['Int']['input']>;
  height_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size: InputMaybe<Scalars['Int']['input']>;
  size_exists: InputMaybe<Scalars['Boolean']['input']>;
  size_gt: InputMaybe<Scalars['Int']['input']>;
  size_gte: InputMaybe<Scalars['Int']['input']>;
  size_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  size_lt: InputMaybe<Scalars['Int']['input']>;
  size_lte: InputMaybe<Scalars['Int']['input']>;
  size_not: InputMaybe<Scalars['Int']['input']>;
  size_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  width: InputMaybe<Scalars['Int']['input']>;
  width_exists: InputMaybe<Scalars['Boolean']['input']>;
  width_gt: InputMaybe<Scalars['Int']['input']>;
  width_gte: InputMaybe<Scalars['Int']['input']>;
  width_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  width_lt: InputMaybe<Scalars['Int']['input']>;
  width_lte: InputMaybe<Scalars['Int']['input']>;
  width_not: InputMaybe<Scalars['Int']['input']>;
  width_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type AssetLinkingCollections = {
  __typename?: 'AssetLinkingCollections';
  activitySheetAssetCollection: Maybe<ActivitySheetAssetCollection>;
  activitySheetAssetCursorCollection: Maybe<ActivitySheetAssetCursorCollection>;
  composeComponentDownloadableAssetCollection: Maybe<ComposeComponentDownloadableAssetCollection>;
  composeComponentDownloadableAssetCursorCollection: Maybe<ComposeComponentDownloadableAssetCursorCollection>;
  composeComponentImageAndAdjacentTextCollection: Maybe<ComposeComponentImageAndAdjacentTextCollection>;
  composeComponentImageAndAdjacentTextCursorCollection: Maybe<ComposeComponentImageAndAdjacentTextCursorCollection>;
  composeComponentImageCollection: Maybe<ComposeComponentImageCollection>;
  composeComponentImageCursorCollection: Maybe<ComposeComponentImageCursorCollection>;
  composeComponentTopicBackgroundCollection: Maybe<ComposeComponentTopicBackgroundCollection>;
  composeComponentTopicBackgroundCursorCollection: Maybe<ComposeComponentTopicBackgroundCursorCollection>;
  composeComponentVideoAndAdjacentTextCollection: Maybe<ComposeComponentVideoAndAdjacentTextCollection>;
  composeComponentVideoAndAdjacentTextCursorCollection: Maybe<ComposeComponentVideoAndAdjacentTextCursorCollection>;
  composeComponentWlFooterBlockCollection: Maybe<ComposeComponentWlFooterBlockCollection>;
  composeComponentWlFooterBlockCursorCollection: Maybe<ComposeComponentWlFooterBlockCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  homeschoolMaxGuidesCollection: Maybe<HomeschoolMaxGuidesCollection>;
  homeschoolMaxGuidesCursorCollection: Maybe<HomeschoolMaxGuidesCursorCollection>;
  homeschoolMaxWebinarCollection: Maybe<HomeschoolMaxWebinarCollection>;
  homeschoolMaxWebinarCursorCollection: Maybe<HomeschoolMaxWebinarCursorCollection>;
  homeschoolPlusGuidesCollection: Maybe<HomeschoolPlusGuidesCollection>;
  homeschoolPlusGuidesCursorCollection: Maybe<HomeschoolPlusGuidesCursorCollection>;
  homeschoolPlusWebinarCollection: Maybe<HomeschoolPlusWebinarCollection>;
  homeschoolPlusWebinarCursorCollection: Maybe<HomeschoolPlusWebinarCursorCollection>;
  homeschoolProgramCollection: Maybe<HomeschoolProgramCollection>;
  homeschoolProgramCursorCollection: Maybe<HomeschoolProgramCursorCollection>;
  legoUiVideoBlockCollection: Maybe<LegoUiVideoBlockCollection>;
  legoUiVideoBlockCursorCollection: Maybe<LegoUiVideoBlockCursorCollection>;
  legoUiVideoCollection: Maybe<LegoUiVideoCollection>;
  legoUiVideoCursorCollection: Maybe<LegoUiVideoCursorCollection>;
  lessonOverviewCollection: Maybe<LessonOverviewCollection>;
  lessonOverviewCursorCollection: Maybe<LessonOverviewCursorCollection>;
  pCampaignB2BCollection: Maybe<PCampaignB2BCollection>;
  pCampaignB2BCursorCollection: Maybe<PCampaignB2BCursorCollection>;
  pCampaignCollection: Maybe<PCampaignCollection>;
  pCampaignCursorCollection: Maybe<PCampaignCursorCollection>;
  pContentPageCollection: Maybe<PContentPageCollection>;
  pContentPageCursorCollection: Maybe<PContentPageCursorCollection>;
  pFreeResourceCollection: Maybe<PFreeResourceCollection>;
  pFreeResourceCursorCollection: Maybe<PFreeResourceCursorCollection>;
  pJsonCollection: Maybe<PJsonCollection>;
  pJsonCursorCollection: Maybe<PJsonCursorCollection>;
  pLinkedEntryCollection: Maybe<PLinkedEntryCollection>;
  pLinkedEntryCursorCollection: Maybe<PLinkedEntryCursorCollection>;
  placementTestOverviewCollection: Maybe<PlacementTestOverviewCollection>;
  placementTestOverviewCursorCollection: Maybe<PlacementTestOverviewCursorCollection>;
  puiDashboardRedesignIntroVideoCollection: Maybe<PuiDashboardRedesignIntroVideoCollection>;
  puiDashboardRedesignIntroVideoCursorCollection: Maybe<PuiDashboardRedesignIntroVideoCursorCollection>;
  rewardMapCollection: Maybe<RewardMapCollection>;
  rewardMapCursorCollection: Maybe<RewardMapCursorCollection>;
  sampleLessonCollection: Maybe<SampleLessonCollection>;
  sampleLessonCursorCollection: Maybe<SampleLessonCursorCollection>;
  spanishActivitySheetAssetCollection: Maybe<SpanishActivitySheetAssetCollection>;
  spanishActivitySheetAssetCursorCollection: Maybe<SpanishActivitySheetAssetCursorCollection>;
  summerSchoolResourceCollection: Maybe<SummerSchoolResourceCollection>;
  summerSchoolResourceCursorCollection: Maybe<SummerSchoolResourceCursorCollection>;
  summerSchoolWebinarCollection: Maybe<SummerSchoolWebinarCollection>;
  summerSchoolWebinarCursorCollection: Maybe<SummerSchoolWebinarCursorCollection>;
  writingLegendsFreeTrialBlockCollection: Maybe<WritingLegendsFreeTrialBlockCollection>;
  writingLegendsFreeTrialBlockCursorCollection: Maybe<WritingLegendsFreeTrialBlockCursorCollection>;
};


export type AssetLinkingCollectionsActivitySheetAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsActivitySheetAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentDownloadableAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentDownloadableAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentImageAndAdjacentTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentImageAndAdjacentTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentTopicBackgroundCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentTopicBackgroundCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentVideoAndAdjacentTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentVideoAndAdjacentTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentWlFooterBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsComposeComponentWlFooterBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomeschoolMaxGuidesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomeschoolMaxGuidesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomeschoolMaxWebinarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomeschoolMaxWebinarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomeschoolPlusGuidesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomeschoolPlusGuidesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomeschoolPlusWebinarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomeschoolPlusWebinarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomeschoolProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsHomeschoolProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsLegoUiVideoBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsLegoUiVideoBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsLegoUiVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsLegoUiVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsLessonOverviewCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsLessonOverviewCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPCampaignB2BCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPCampaignB2BCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPCampaignCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPCampaignCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPFreeResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPFreeResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPJsonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPJsonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPLinkedEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPLinkedEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPlacementTestOverviewCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPlacementTestOverviewCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPuiDashboardRedesignIntroVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsPuiDashboardRedesignIntroVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsRewardMapCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsRewardMapCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSampleLessonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSampleLessonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSpanishActivitySheetAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSpanishActivitySheetAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSummerSchoolResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSummerSchoolResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSummerSchoolWebinarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsSummerSchoolWebinarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWritingLegendsFreeTrialBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type AssetLinkingCollectionsWritingLegendsFreeTrialBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AssetOrder {
  ContentTypeAsc = 'contentType_ASC',
  ContentTypeDesc = 'contentType_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/bigSchoolResourceList) */
export type BigSchoolResourceList = Entry & _Node & {
  __typename?: 'BigSchoolResourceList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<BigSchoolResourceListLinkingCollections>;
  resourceListsCollection: Maybe<BigSchoolResourceListResourceListsCollection>;
  resourceListsCursorCollection: Maybe<BigSchoolResourceListResourceListsCursorCollection>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/bigSchoolResourceList) */
export type BigSchoolResourceListLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/bigSchoolResourceList) */
export type BigSchoolResourceListResourceListsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<BigSchoolResourceListResourceListsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/bigSchoolResourceList) */
export type BigSchoolResourceListResourceListsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<BigSchoolResourceListResourceListsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/bigSchoolResourceList) */
export type BigSchoolResourceListTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type BigSchoolResourceListCollection = {
  __typename?: 'BigSchoolResourceListCollection';
  items: Array<Maybe<BigSchoolResourceList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type BigSchoolResourceListCursorCollection = {
  __typename?: 'BigSchoolResourceListCursorCollection';
  items: Array<Maybe<BigSchoolResourceList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type BigSchoolResourceListFilter = {
  AND: InputMaybe<Array<InputMaybe<BigSchoolResourceListFilter>>>;
  OR: InputMaybe<Array<InputMaybe<BigSchoolResourceListFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  resourceLists: InputMaybe<CfSummerSchoolResourceNestedFilter>;
  resourceListsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BigSchoolResourceListLinkingCollections = {
  __typename?: 'BigSchoolResourceListLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  getReadyForBigSchoolListCollection: Maybe<GetReadyForBigSchoolListCollection>;
  getReadyForBigSchoolListCursorCollection: Maybe<GetReadyForBigSchoolListCursorCollection>;
};


export type BigSchoolResourceListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type BigSchoolResourceListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type BigSchoolResourceListLinkingCollectionsGetReadyForBigSchoolListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<BigSchoolResourceListLinkingCollectionsGetReadyForBigSchoolListCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type BigSchoolResourceListLinkingCollectionsGetReadyForBigSchoolListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<BigSchoolResourceListLinkingCollectionsGetReadyForBigSchoolListCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum BigSchoolResourceListLinkingCollectionsGetReadyForBigSchoolListCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BigSchoolResourceListLinkingCollectionsGetReadyForBigSchoolListCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum BigSchoolResourceListOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BigSchoolResourceListResourceListsCollection = {
  __typename?: 'BigSchoolResourceListResourceListsCollection';
  items: Array<Maybe<SummerSchoolResource>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum BigSchoolResourceListResourceListsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type BigSchoolResourceListResourceListsCursorCollection = {
  __typename?: 'BigSchoolResourceListResourceListsCursorCollection';
  items: Array<Maybe<SummerSchoolResource>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum BigSchoolResourceListResourceListsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentArticleBody) */
export type ComposeComponentArticleBody = Entry & _Node & {
  __typename?: 'ComposeComponentArticleBody';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentArticleBodyLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text: Maybe<ComposeComponentArticleBodyText>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentArticleBody) */
export type ComposeComponentArticleBodyLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentArticleBody) */
export type ComposeComponentArticleBodyNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentArticleBody) */
export type ComposeComponentArticleBodyTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentArticleBodyCollection = {
  __typename?: 'ComposeComponentArticleBodyCollection';
  items: Array<Maybe<ComposeComponentArticleBody>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentArticleBodyCursorCollection = {
  __typename?: 'ComposeComponentArticleBodyCursorCollection';
  items: Array<Maybe<ComposeComponentArticleBody>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentArticleBodyFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentArticleBodyFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentArticleBodyFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
};

export type ComposeComponentArticleBodyLinkingCollections = {
  __typename?: 'ComposeComponentArticleBodyLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentArticleBodyLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentArticleBodyLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentArticleBodyOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentArticleBodyText = {
  __typename?: 'ComposeComponentArticleBodyText';
  json: Scalars['JSON']['output'];
  links: ComposeComponentArticleBodyTextLinks;
};

export type ComposeComponentArticleBodyTextAssets = {
  __typename?: 'ComposeComponentArticleBodyTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposeComponentArticleBodyTextEntries = {
  __typename?: 'ComposeComponentArticleBodyTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposeComponentArticleBodyTextLinks = {
  __typename?: 'ComposeComponentArticleBodyTextLinks';
  assets: ComposeComponentArticleBodyTextAssets;
  entries: ComposeComponentArticleBodyTextEntries;
  resources: ComposeComponentArticleBodyTextResources;
};

export type ComposeComponentArticleBodyTextResources = {
  __typename?: 'ComposeComponentArticleBodyTextResources';
  block: Array<ComposeComponentArticleBodyTextResourcesBlock>;
  hyperlink: Array<ComposeComponentArticleBodyTextResourcesHyperlink>;
  inline: Array<ComposeComponentArticleBodyTextResourcesInline>;
};

export type ComposeComponentArticleBodyTextResourcesBlock = ResourceLink & {
  __typename?: 'ComposeComponentArticleBodyTextResourcesBlock';
  sys: ResourceSys;
};

export type ComposeComponentArticleBodyTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposeComponentArticleBodyTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposeComponentArticleBodyTextResourcesInline = ResourceLink & {
  __typename?: 'ComposeComponentArticleBodyTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentBlockQuote) */
export type ComposeComponentBlockQuote = Entry & _Node & {
  __typename?: 'ComposeComponentBlockQuote';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentBlockQuoteLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text: Maybe<ComposeComponentBlockQuoteText>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentBlockQuote) */
export type ComposeComponentBlockQuoteLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentBlockQuote) */
export type ComposeComponentBlockQuoteNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentBlockQuote) */
export type ComposeComponentBlockQuoteTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentBlockQuoteCollection = {
  __typename?: 'ComposeComponentBlockQuoteCollection';
  items: Array<Maybe<ComposeComponentBlockQuote>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentBlockQuoteCursorCollection = {
  __typename?: 'ComposeComponentBlockQuoteCursorCollection';
  items: Array<Maybe<ComposeComponentBlockQuote>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentBlockQuoteFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentBlockQuoteFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentBlockQuoteFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
};

export type ComposeComponentBlockQuoteLinkingCollections = {
  __typename?: 'ComposeComponentBlockQuoteLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentBlockQuoteLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentBlockQuoteLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentBlockQuoteOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentBlockQuoteText = {
  __typename?: 'ComposeComponentBlockQuoteText';
  json: Scalars['JSON']['output'];
  links: ComposeComponentBlockQuoteTextLinks;
};

export type ComposeComponentBlockQuoteTextAssets = {
  __typename?: 'ComposeComponentBlockQuoteTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposeComponentBlockQuoteTextEntries = {
  __typename?: 'ComposeComponentBlockQuoteTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposeComponentBlockQuoteTextLinks = {
  __typename?: 'ComposeComponentBlockQuoteTextLinks';
  assets: ComposeComponentBlockQuoteTextAssets;
  entries: ComposeComponentBlockQuoteTextEntries;
  resources: ComposeComponentBlockQuoteTextResources;
};

export type ComposeComponentBlockQuoteTextResources = {
  __typename?: 'ComposeComponentBlockQuoteTextResources';
  block: Array<ComposeComponentBlockQuoteTextResourcesBlock>;
  hyperlink: Array<ComposeComponentBlockQuoteTextResourcesHyperlink>;
  inline: Array<ComposeComponentBlockQuoteTextResourcesInline>;
};

export type ComposeComponentBlockQuoteTextResourcesBlock = ResourceLink & {
  __typename?: 'ComposeComponentBlockQuoteTextResourcesBlock';
  sys: ResourceSys;
};

export type ComposeComponentBlockQuoteTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposeComponentBlockQuoteTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposeComponentBlockQuoteTextResourcesInline = ResourceLink & {
  __typename?: 'ComposeComponentBlockQuoteTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentDownloadableAsset) */
export type ComposeComponentDownloadableAsset = Entry & _Node & {
  __typename?: 'ComposeComponentDownloadableAsset';
  _id: Scalars['ID']['output'];
  asset: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<ComposeComponentImage>;
  linkedFrom: Maybe<ComposeComponentDownloadableAssetLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentDownloadableAsset) */
export type ComposeComponentDownloadableAssetAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentDownloadableAsset) */
export type ComposeComponentDownloadableAssetImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentDownloadableAsset) */
export type ComposeComponentDownloadableAssetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentDownloadableAsset) */
export type ComposeComponentDownloadableAssetNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentDownloadableAssetCollection = {
  __typename?: 'ComposeComponentDownloadableAssetCollection';
  items: Array<Maybe<ComposeComponentDownloadableAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentDownloadableAssetCursorCollection = {
  __typename?: 'ComposeComponentDownloadableAssetCursorCollection';
  items: Array<Maybe<ComposeComponentDownloadableAsset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentDownloadableAssetFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentDownloadableAssetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentDownloadableAssetFilter>>>;
  asset_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image: InputMaybe<CfComposeComponentImageNestedFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentDownloadableAssetLinkingCollections = {
  __typename?: 'ComposeComponentDownloadableAssetLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentDownloadableAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentDownloadableAssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentDownloadableAssetOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentFeaturedArticle) */
export type ComposeComponentFeaturedArticle = Entry & _Node & {
  __typename?: 'ComposeComponentFeaturedArticle';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  featuredArticle: Maybe<ComposePageArticle>;
  linkedFrom: Maybe<ComposeComponentFeaturedArticleLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentFeaturedArticle) */
export type ComposeComponentFeaturedArticleFeaturedArticleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentFeaturedArticle) */
export type ComposeComponentFeaturedArticleLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentFeaturedArticle) */
export type ComposeComponentFeaturedArticleNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentFeaturedArticleCollection = {
  __typename?: 'ComposeComponentFeaturedArticleCollection';
  items: Array<Maybe<ComposeComponentFeaturedArticle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentFeaturedArticleCursorCollection = {
  __typename?: 'ComposeComponentFeaturedArticleCursorCollection';
  items: Array<Maybe<ComposeComponentFeaturedArticle>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentFeaturedArticleFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentFeaturedArticleFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentFeaturedArticleFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  featuredArticle: InputMaybe<CfComposePageArticleNestedFilter>;
  featuredArticle_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentFeaturedArticleLinkingCollections = {
  __typename?: 'ComposeComponentFeaturedArticleLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentFeaturedArticleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentFeaturedArticleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentFeaturedArticleOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentGlobalHorizontalImageCta) */
export type ComposeComponentGlobalHorizontalImageCta = Entry & _Node & {
  __typename?: 'ComposeComponentGlobalHorizontalImageCta';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  cta: Maybe<ComposeComponentHorizontalImageCta>;
  linkedFrom: Maybe<ComposeComponentGlobalHorizontalImageCtaLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentGlobalHorizontalImageCta) */
export type ComposeComponentGlobalHorizontalImageCtaCtaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentHorizontalImageCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentGlobalHorizontalImageCta) */
export type ComposeComponentGlobalHorizontalImageCtaLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentGlobalHorizontalImageCta) */
export type ComposeComponentGlobalHorizontalImageCtaNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentGlobalHorizontalImageCtaCollection = {
  __typename?: 'ComposeComponentGlobalHorizontalImageCtaCollection';
  items: Array<Maybe<ComposeComponentGlobalHorizontalImageCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentGlobalHorizontalImageCtaCursorCollection = {
  __typename?: 'ComposeComponentGlobalHorizontalImageCtaCursorCollection';
  items: Array<Maybe<ComposeComponentGlobalHorizontalImageCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentGlobalHorizontalImageCtaFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentGlobalHorizontalImageCtaFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentGlobalHorizontalImageCtaFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  cta: InputMaybe<CfComposeComponentHorizontalImageCtaNestedFilter>;
  cta_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentGlobalHorizontalImageCtaLinkingCollections = {
  __typename?: 'ComposeComponentGlobalHorizontalImageCtaLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentGlobalHorizontalImageCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentGlobalHorizontalImageCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentGlobalHorizontalImageCtaOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentGlobalVerticalImageCta) */
export type ComposeComponentGlobalVerticalImageCta = Entry & _Node & {
  __typename?: 'ComposeComponentGlobalVerticalImageCta';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  cta: Maybe<ComposeComponentVerticalImageCta>;
  linkedFrom: Maybe<ComposeComponentGlobalVerticalImageCtaLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentGlobalVerticalImageCta) */
export type ComposeComponentGlobalVerticalImageCtaCtaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentVerticalImageCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentGlobalVerticalImageCta) */
export type ComposeComponentGlobalVerticalImageCtaLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentGlobalVerticalImageCta) */
export type ComposeComponentGlobalVerticalImageCtaNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentGlobalVerticalImageCtaCollection = {
  __typename?: 'ComposeComponentGlobalVerticalImageCtaCollection';
  items: Array<Maybe<ComposeComponentGlobalVerticalImageCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentGlobalVerticalImageCtaCursorCollection = {
  __typename?: 'ComposeComponentGlobalVerticalImageCtaCursorCollection';
  items: Array<Maybe<ComposeComponentGlobalVerticalImageCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentGlobalVerticalImageCtaFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentGlobalVerticalImageCtaFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentGlobalVerticalImageCtaFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  cta: InputMaybe<CfComposeComponentVerticalImageCtaNestedFilter>;
  cta_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentGlobalVerticalImageCtaLinkingCollections = {
  __typename?: 'ComposeComponentGlobalVerticalImageCtaLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentGlobalVerticalImageCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentGlobalVerticalImageCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentGlobalVerticalImageCtaOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentHorizontalImageCta) */
export type ComposeComponentHorizontalImageCta = Entry & _Node & {
  __typename?: 'ComposeComponentHorizontalImageCta';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<ComposeComponentImage>;
  largeImage: Maybe<ComposeComponentImage>;
  linkedFrom: Maybe<ComposeComponentHorizontalImageCtaLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  url: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentHorizontalImageCta) */
export type ComposeComponentHorizontalImageCtaImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentHorizontalImageCta) */
export type ComposeComponentHorizontalImageCtaLargeImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentHorizontalImageCta) */
export type ComposeComponentHorizontalImageCtaLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentHorizontalImageCta) */
export type ComposeComponentHorizontalImageCtaNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentHorizontalImageCta) */
export type ComposeComponentHorizontalImageCtaUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentHorizontalImageCtaCollection = {
  __typename?: 'ComposeComponentHorizontalImageCtaCollection';
  items: Array<Maybe<ComposeComponentHorizontalImageCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentHorizontalImageCtaCursorCollection = {
  __typename?: 'ComposeComponentHorizontalImageCtaCursorCollection';
  items: Array<Maybe<ComposeComponentHorizontalImageCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentHorizontalImageCtaFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentHorizontalImageCtaFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentHorizontalImageCtaFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image: InputMaybe<CfComposeComponentImageNestedFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  largeImage: InputMaybe<CfComposeComponentImageNestedFilter>;
  largeImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComposeComponentHorizontalImageCtaLinkingCollections = {
  __typename?: 'ComposeComponentHorizontalImageCtaLinkingCollections';
  composeComponentGlobalHorizontalImageCtaCollection: Maybe<ComposeComponentGlobalHorizontalImageCtaCollection>;
  composeComponentGlobalHorizontalImageCtaCursorCollection: Maybe<ComposeComponentGlobalHorizontalImageCtaCursorCollection>;
  composePageArticleCollection: Maybe<ComposePageArticleCollection>;
  composePageArticleCursorCollection: Maybe<ComposePageArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentHorizontalImageCtaLinkingCollectionsComposeComponentGlobalHorizontalImageCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentHorizontalImageCtaLinkingCollectionsComposeComponentGlobalHorizontalImageCtaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentHorizontalImageCtaLinkingCollectionsComposeComponentGlobalHorizontalImageCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentHorizontalImageCtaLinkingCollectionsComposeComponentGlobalHorizontalImageCtaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentHorizontalImageCtaLinkingCollectionsComposePageArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentHorizontalImageCtaLinkingCollectionsComposePageArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentHorizontalImageCtaLinkingCollectionsComposePageArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentHorizontalImageCtaLinkingCollectionsComposePageArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentHorizontalImageCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentHorizontalImageCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentHorizontalImageCtaLinkingCollectionsComposeComponentGlobalHorizontalImageCtaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentHorizontalImageCtaLinkingCollectionsComposeComponentGlobalHorizontalImageCtaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentHorizontalImageCtaLinkingCollectionsComposePageArticleCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentHorizontalImageCtaLinkingCollectionsComposePageArticleCursorCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentHorizontalImageCtaOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImage) */
export type ComposeComponentImage = Entry & _Node & {
  __typename?: 'ComposeComponentImage';
  _id: Scalars['ID']['output'];
  altText: Maybe<Scalars['String']['output']>;
  caption: Maybe<ComposeComponentImageCaption>;
  contentfulMetadata: ContentfulMetadata;
  imageAsset: Maybe<Asset>;
  linkedFrom: Maybe<ComposeComponentImageLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImage) */
export type ComposeComponentImageAltTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImage) */
export type ComposeComponentImageCaptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImage) */
export type ComposeComponentImageImageAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImage) */
export type ComposeComponentImageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImage) */
export type ComposeComponentImageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImageAndAdjacentText) */
export type ComposeComponentImageAndAdjacentText = Entry & _Node & {
  __typename?: 'ComposeComponentImageAndAdjacentText';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<Asset>;
  imageAlignment: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<ComposeComponentImageAndAdjacentTextLinkingCollections>;
  sys: Sys;
  text: Maybe<ComposeComponentImageAndAdjacentTextText>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImageAndAdjacentText) */
export type ComposeComponentImageAndAdjacentTextImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImageAndAdjacentText) */
export type ComposeComponentImageAndAdjacentTextImageAlignmentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImageAndAdjacentText) */
export type ComposeComponentImageAndAdjacentTextLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImageAndAdjacentText) */
export type ComposeComponentImageAndAdjacentTextTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentImageAndAdjacentTextCollection = {
  __typename?: 'ComposeComponentImageAndAdjacentTextCollection';
  items: Array<Maybe<ComposeComponentImageAndAdjacentText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentImageAndAdjacentTextCursorCollection = {
  __typename?: 'ComposeComponentImageAndAdjacentTextCursorCollection';
  items: Array<Maybe<ComposeComponentImageAndAdjacentText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentImageAndAdjacentTextFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  imageAlignment: InputMaybe<Scalars['String']['input']>;
  imageAlignment_contains: InputMaybe<Scalars['String']['input']>;
  imageAlignment_exists: InputMaybe<Scalars['Boolean']['input']>;
  imageAlignment_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAlignment_not: InputMaybe<Scalars['String']['input']>;
  imageAlignment_not_contains: InputMaybe<Scalars['String']['input']>;
  imageAlignment_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
};

export type ComposeComponentImageAndAdjacentTextLinkingCollections = {
  __typename?: 'ComposeComponentImageAndAdjacentTextLinkingCollections';
  composeComponentImageAndAdjacentTextListCollection: Maybe<ComposeComponentImageAndAdjacentTextListCollection>;
  composeComponentImageAndAdjacentTextListCursorCollection: Maybe<ComposeComponentImageAndAdjacentTextListCursorCollection>;
  composeComponentTeacherSupportStatementCollection: Maybe<ComposeComponentTeacherSupportStatementCollection>;
  composeComponentTeacherSupportStatementCursorCollection: Maybe<ComposeComponentTeacherSupportStatementCursorCollection>;
  composeComponentWlProductAimBlockCollection: Maybe<ComposeComponentWlProductAimBlockCollection>;
  composeComponentWlProductAimBlockCursorCollection: Maybe<ComposeComponentWlProductAimBlockCursorCollection>;
  composePageWlMarketingHomePageCollection: Maybe<ComposePageWlMarketingHomePageCollection>;
  composePageWlMarketingHomePageCursorCollection: Maybe<ComposePageWlMarketingHomePageCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentImageAndAdjacentTextListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentImageAndAdjacentTextListCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentImageAndAdjacentTextListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentImageAndAdjacentTextListCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentTeacherSupportStatementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentTeacherSupportStatementCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentTeacherSupportStatementCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentTeacherSupportStatementCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentWlProductAimBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentWlProductAimBlockCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentWlProductAimBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentWlProductAimBlockCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageAndAdjacentTextLinkingCollectionsComposePageWlMarketingHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageAndAdjacentTextLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageAndAdjacentTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageAndAdjacentTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentImageAndAdjacentTextListCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentImageAndAdjacentTextListCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentTeacherSupportStatementCollectionOrder {
  ListHeadingAsc = 'listHeading_ASC',
  ListHeadingDesc = 'listHeading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentTeacherSupportStatementCursorCollectionOrder {
  ListHeadingAsc = 'listHeading_ASC',
  ListHeadingDesc = 'listHeading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentWlProductAimBlockCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentImageAndAdjacentTextLinkingCollectionsComposeComponentWlProductAimBlockCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentImageAndAdjacentTextLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageAndAdjacentTextLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImageAndAdjacentTextList) */
export type ComposeComponentImageAndAdjacentTextList = Entry & _Node & {
  __typename?: 'ComposeComponentImageAndAdjacentTextList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  imageAndTextItemsCollection: Maybe<ComposeComponentImageAndAdjacentTextListImageAndTextItemsCollection>;
  imageAndTextItemsCursorCollection: Maybe<ComposeComponentImageAndAdjacentTextListImageAndTextItemsCursorCollection>;
  linkedFrom: Maybe<ComposeComponentImageAndAdjacentTextListLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImageAndAdjacentTextList) */
export type ComposeComponentImageAndAdjacentTextListImageAndTextItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextListImageAndTextItemsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageAndAdjacentTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImageAndAdjacentTextList) */
export type ComposeComponentImageAndAdjacentTextListImageAndTextItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextListImageAndTextItemsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageAndAdjacentTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImageAndAdjacentTextList) */
export type ComposeComponentImageAndAdjacentTextListLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentImageAndAdjacentTextList) */
export type ComposeComponentImageAndAdjacentTextListNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentImageAndAdjacentTextListCollection = {
  __typename?: 'ComposeComponentImageAndAdjacentTextListCollection';
  items: Array<Maybe<ComposeComponentImageAndAdjacentTextList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentImageAndAdjacentTextListCursorCollection = {
  __typename?: 'ComposeComponentImageAndAdjacentTextListCursorCollection';
  items: Array<Maybe<ComposeComponentImageAndAdjacentTextList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentImageAndAdjacentTextListFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextListFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextListFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  imageAndTextItems: InputMaybe<CfComposeComponentImageAndAdjacentTextNestedFilter>;
  imageAndTextItemsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentImageAndAdjacentTextListImageAndTextItemsCollection = {
  __typename?: 'ComposeComponentImageAndAdjacentTextListImageAndTextItemsCollection';
  items: Array<Maybe<ComposeComponentImageAndAdjacentText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComposeComponentImageAndAdjacentTextListImageAndTextItemsCollectionOrder {
  ImageAlignmentAsc = 'imageAlignment_ASC',
  ImageAlignmentDesc = 'imageAlignment_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentImageAndAdjacentTextListImageAndTextItemsCursorCollection = {
  __typename?: 'ComposeComponentImageAndAdjacentTextListImageAndTextItemsCursorCollection';
  items: Array<Maybe<ComposeComponentImageAndAdjacentText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComposeComponentImageAndAdjacentTextListImageAndTextItemsCursorCollectionOrder {
  ImageAlignmentAsc = 'imageAlignment_ASC',
  ImageAlignmentDesc = 'imageAlignment_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentImageAndAdjacentTextListLinkingCollections = {
  __typename?: 'ComposeComponentImageAndAdjacentTextListLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentImageAndAdjacentTextListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageAndAdjacentTextListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentImageAndAdjacentTextListOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageAndAdjacentTextOrder {
  ImageAlignmentAsc = 'imageAlignment_ASC',
  ImageAlignmentDesc = 'imageAlignment_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentImageAndAdjacentTextText = {
  __typename?: 'ComposeComponentImageAndAdjacentTextText';
  json: Scalars['JSON']['output'];
  links: ComposeComponentImageAndAdjacentTextTextLinks;
};

export type ComposeComponentImageAndAdjacentTextTextAssets = {
  __typename?: 'ComposeComponentImageAndAdjacentTextTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposeComponentImageAndAdjacentTextTextEntries = {
  __typename?: 'ComposeComponentImageAndAdjacentTextTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposeComponentImageAndAdjacentTextTextLinks = {
  __typename?: 'ComposeComponentImageAndAdjacentTextTextLinks';
  assets: ComposeComponentImageAndAdjacentTextTextAssets;
  entries: ComposeComponentImageAndAdjacentTextTextEntries;
  resources: ComposeComponentImageAndAdjacentTextTextResources;
};

export type ComposeComponentImageAndAdjacentTextTextResources = {
  __typename?: 'ComposeComponentImageAndAdjacentTextTextResources';
  block: Array<ComposeComponentImageAndAdjacentTextTextResourcesBlock>;
  hyperlink: Array<ComposeComponentImageAndAdjacentTextTextResourcesHyperlink>;
  inline: Array<ComposeComponentImageAndAdjacentTextTextResourcesInline>;
};

export type ComposeComponentImageAndAdjacentTextTextResourcesBlock = ResourceLink & {
  __typename?: 'ComposeComponentImageAndAdjacentTextTextResourcesBlock';
  sys: ResourceSys;
};

export type ComposeComponentImageAndAdjacentTextTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposeComponentImageAndAdjacentTextTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposeComponentImageAndAdjacentTextTextResourcesInline = ResourceLink & {
  __typename?: 'ComposeComponentImageAndAdjacentTextTextResourcesInline';
  sys: ResourceSys;
};

export type ComposeComponentImageCaption = {
  __typename?: 'ComposeComponentImageCaption';
  json: Scalars['JSON']['output'];
  links: ComposeComponentImageCaptionLinks;
};

export type ComposeComponentImageCaptionAssets = {
  __typename?: 'ComposeComponentImageCaptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposeComponentImageCaptionEntries = {
  __typename?: 'ComposeComponentImageCaptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposeComponentImageCaptionLinks = {
  __typename?: 'ComposeComponentImageCaptionLinks';
  assets: ComposeComponentImageCaptionAssets;
  entries: ComposeComponentImageCaptionEntries;
  resources: ComposeComponentImageCaptionResources;
};

export type ComposeComponentImageCaptionResources = {
  __typename?: 'ComposeComponentImageCaptionResources';
  block: Array<ComposeComponentImageCaptionResourcesBlock>;
  hyperlink: Array<ComposeComponentImageCaptionResourcesHyperlink>;
  inline: Array<ComposeComponentImageCaptionResourcesInline>;
};

export type ComposeComponentImageCaptionResourcesBlock = ResourceLink & {
  __typename?: 'ComposeComponentImageCaptionResourcesBlock';
  sys: ResourceSys;
};

export type ComposeComponentImageCaptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposeComponentImageCaptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposeComponentImageCaptionResourcesInline = ResourceLink & {
  __typename?: 'ComposeComponentImageCaptionResourcesInline';
  sys: ResourceSys;
};

export type ComposeComponentImageCollection = {
  __typename?: 'ComposeComponentImageCollection';
  items: Array<Maybe<ComposeComponentImage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentImageCursorCollection = {
  __typename?: 'ComposeComponentImageCursorCollection';
  items: Array<Maybe<ComposeComponentImage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentImageFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentImageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentImageFilter>>>;
  altText: InputMaybe<Scalars['String']['input']>;
  altText_contains: InputMaybe<Scalars['String']['input']>;
  altText_exists: InputMaybe<Scalars['Boolean']['input']>;
  altText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not: InputMaybe<Scalars['String']['input']>;
  altText_not_contains: InputMaybe<Scalars['String']['input']>;
  altText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caption_contains: InputMaybe<Scalars['String']['input']>;
  caption_exists: InputMaybe<Scalars['Boolean']['input']>;
  caption_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  imageAsset_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentImageLinkingCollections = {
  __typename?: 'ComposeComponentImageLinkingCollections';
  composeComponentDownloadableAssetCollection: Maybe<ComposeComponentDownloadableAssetCollection>;
  composeComponentDownloadableAssetCursorCollection: Maybe<ComposeComponentDownloadableAssetCursorCollection>;
  composeComponentHorizontalImageCtaCollection: Maybe<ComposeComponentHorizontalImageCtaCollection>;
  composeComponentHorizontalImageCtaCursorCollection: Maybe<ComposeComponentHorizontalImageCtaCursorCollection>;
  composeComponentVerticalImageCtaCollection: Maybe<ComposeComponentVerticalImageCtaCollection>;
  composeComponentVerticalImageCtaCursorCollection: Maybe<ComposeComponentVerticalImageCtaCursorCollection>;
  composePageArticleCollection: Maybe<ComposePageArticleCollection>;
  composePageArticleCursorCollection: Maybe<ComposePageArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiCallToActionBlockCollection: Maybe<LegoUiCallToActionBlockCollection>;
  legoUiCallToActionBlockCursorCollection: Maybe<LegoUiCallToActionBlockCursorCollection>;
  legoUiFooterCollection: Maybe<LegoUiFooterCollection>;
  legoUiFooterCursorCollection: Maybe<LegoUiFooterCursorCollection>;
  legoUiHeroCardCollection: Maybe<LegoUiHeroCardCollection>;
  legoUiHeroCardCursorCollection: Maybe<LegoUiHeroCardCursorCollection>;
  legoUiImageWithLinkCollection: Maybe<LegoUiImageWithLinkCollection>;
  legoUiImageWithLinkCursorCollection: Maybe<LegoUiImageWithLinkCursorCollection>;
  legoUiPageDividerCollection: Maybe<LegoUiPageDividerCollection>;
  legoUiPageDividerCursorCollection: Maybe<LegoUiPageDividerCursorCollection>;
  legoUiProgramCardCollection: Maybe<LegoUiProgramCardCollection>;
  legoUiProgramCardCursorCollection: Maybe<LegoUiProgramCardCursorCollection>;
  legoUiVideoBlockCollection: Maybe<LegoUiVideoBlockCollection>;
  legoUiVideoBlockCursorCollection: Maybe<LegoUiVideoBlockCursorCollection>;
  writingLegendsMarketingSiteContactUsPageV2Collection: Maybe<WritingLegendsMarketingSiteContactUsPageV2Collection>;
  writingLegendsMarketingSiteContactUsPageV2CursorCollection: Maybe<WritingLegendsMarketingSiteContactUsPageV2CursorCollection>;
};


export type ComposeComponentImageLinkingCollectionsComposeComponentDownloadableAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsComposeComponentDownloadableAssetCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsComposeComponentDownloadableAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsComposeComponentDownloadableAssetCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsComposeComponentHorizontalImageCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsComposeComponentHorizontalImageCtaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsComposeComponentHorizontalImageCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsComposeComponentHorizontalImageCtaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsComposeComponentVerticalImageCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsComposeComponentVerticalImageCtaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsComposeComponentVerticalImageCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsComposeComponentVerticalImageCtaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsComposePageArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsComposePageArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsComposePageArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsComposePageArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiCallToActionBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiCallToActionBlockCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiCallToActionBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiCallToActionBlockCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiFooterCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiFooterCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiHeroCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiHeroCardCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiHeroCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiHeroCardCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiImageWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiImageWithLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiImageWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiImageWithLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiPageDividerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiPageDividerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiPageDividerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiPageDividerCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiProgramCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiProgramCardCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiProgramCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiProgramCardCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiVideoBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiVideoBlockCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsLegoUiVideoBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsLegoUiVideoBlockCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentImageLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentImageLinkingCollectionsComposeComponentDownloadableAssetCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsComposeComponentDownloadableAssetCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsComposeComponentHorizontalImageCtaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum ComposeComponentImageLinkingCollectionsComposeComponentHorizontalImageCtaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum ComposeComponentImageLinkingCollectionsComposeComponentVerticalImageCtaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum ComposeComponentImageLinkingCollectionsComposeComponentVerticalImageCtaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum ComposeComponentImageLinkingCollectionsComposePageArticleCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsComposePageArticleCursorCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiCallToActionBlockCollectionOrder {
  DirectionAsc = 'direction_ASC',
  DirectionDesc = 'direction_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiCallToActionBlockCursorCollectionOrder {
  DirectionAsc = 'direction_ASC',
  DirectionDesc = 'direction_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiFooterCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SignUpCtaSubtextAsc = 'signUpCtaSubtext_ASC',
  SignUpCtaSubtextDesc = 'signUpCtaSubtext_DESC',
  SignUpCtaTitleAsc = 'signUpCtaTitle_ASC',
  SignUpCtaTitleDesc = 'signUpCtaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiFooterCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SignUpCtaSubtextAsc = 'signUpCtaSubtext_ASC',
  SignUpCtaSubtextDesc = 'signUpCtaSubtext_DESC',
  SignUpCtaTitleAsc = 'signUpCtaTitle_ASC',
  SignUpCtaTitleDesc = 'signUpCtaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiHeroCardCollectionOrder {
  ContentPositionAsc = 'contentPosition_ASC',
  ContentPositionDesc = 'contentPosition_DESC',
  ContentTitleAsc = 'contentTitle_ASC',
  ContentTitleDesc = 'contentTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiHeroCardCursorCollectionOrder {
  ContentPositionAsc = 'contentPosition_ASC',
  ContentPositionDesc = 'contentPosition_DESC',
  ContentTitleAsc = 'contentTitle_ASC',
  ContentTitleDesc = 'contentTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiImageWithLinkCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiImageWithLinkCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiPageDividerCollectionOrder {
  DisplayAsAsc = 'displayAs_ASC',
  DisplayAsDesc = 'displayAs_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiPageDividerCursorCollectionOrder {
  DisplayAsAsc = 'displayAs_ASC',
  DisplayAsDesc = 'displayAs_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiProgramCardCollectionOrder {
  AgeRangeAsc = 'ageRange_ASC',
  AgeRangeDesc = 'ageRange_DESC',
  CodeAsc = 'code_ASC',
  CodeDesc = 'code_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiProgramCardCursorCollectionOrder {
  AgeRangeAsc = 'ageRange_ASC',
  AgeRangeDesc = 'ageRange_DESC',
  CodeAsc = 'code_ASC',
  CodeDesc = 'code_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiVideoBlockCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DurationAsc = 'duration_ASC',
  DurationDesc = 'duration_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UploadDateAsc = 'uploadDate_ASC',
  UploadDateDesc = 'uploadDate_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export enum ComposeComponentImageLinkingCollectionsLegoUiVideoBlockCursorCollectionOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DurationAsc = 'duration_ASC',
  DurationDesc = 'duration_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UploadDateAsc = 'uploadDate_ASC',
  UploadDateDesc = 'uploadDate_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export enum ComposeComponentImageLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CollectionOrder {
  DownloadSectionButtonTextAsc = 'downloadSectionButtonText_ASC',
  DownloadSectionButtonTextDesc = 'downloadSectionButtonText_DESC',
  DownloadSectionDescriptionAsc = 'downloadSectionDescription_ASC',
  DownloadSectionDescriptionDesc = 'downloadSectionDescription_DESC',
  DownloadSectionLinkAsc = 'downloadSectionLink_ASC',
  DownloadSectionLinkDesc = 'downloadSectionLink_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  FormLinkAsc = 'formLink_ASC',
  FormLinkDesc = 'formLink_DESC',
  FormTitleAsc = 'formTitle_ASC',
  FormTitleDesc = 'formTitle_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PhoneNumberAsc = 'phoneNumber_ASC',
  PhoneNumberDesc = 'phoneNumber_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CursorCollectionOrder {
  DownloadSectionButtonTextAsc = 'downloadSectionButtonText_ASC',
  DownloadSectionButtonTextDesc = 'downloadSectionButtonText_DESC',
  DownloadSectionDescriptionAsc = 'downloadSectionDescription_ASC',
  DownloadSectionDescriptionDesc = 'downloadSectionDescription_DESC',
  DownloadSectionLinkAsc = 'downloadSectionLink_ASC',
  DownloadSectionLinkDesc = 'downloadSectionLink_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  FormLinkAsc = 'formLink_ASC',
  FormLinkDesc = 'formLink_DESC',
  FormTitleAsc = 'formTitle_ASC',
  FormTitleDesc = 'formTitle_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PhoneNumberAsc = 'phoneNumber_ASC',
  PhoneNumberDesc = 'phoneNumber_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentImageOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentLink) */
export type ComposeComponentLink = Entry & _Node & {
  __typename?: 'ComposeComponentLink';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  link: Maybe<ComposeComponentLinkLink>;
  linkedFrom: Maybe<ComposeComponentLinkLinkingCollections>;
  opensInANewTab: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  text: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentLink) */
export type ComposeComponentLinkLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentLink) */
export type ComposeComponentLinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentLink) */
export type ComposeComponentLinkOpensInANewTabArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentLink) */
export type ComposeComponentLinkTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentLink) */
export type ComposeComponentLinkTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentLinkCollection = {
  __typename?: 'ComposeComponentLinkCollection';
  items: Array<Maybe<ComposeComponentLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentLinkCursorCollection = {
  __typename?: 'ComposeComponentLinkCursorCollection';
  items: Array<Maybe<ComposeComponentLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentLinkFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentLinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentLinkFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  opensInANewTab: InputMaybe<Scalars['Boolean']['input']>;
  opensInANewTab_exists: InputMaybe<Scalars['Boolean']['input']>;
  opensInANewTab_not: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  text: InputMaybe<Scalars['String']['input']>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not: InputMaybe<Scalars['String']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
  text_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComposeComponentLinkLink = ComposeComponentUrl | ComposePageArticle;

export type ComposeComponentLinkLinkingCollections = {
  __typename?: 'ComposeComponentLinkLinkingCollections';
  composeComponentRichTextCtaCollection: Maybe<ComposeComponentRichTextCtaCollection>;
  composeComponentRichTextCtaCursorCollection: Maybe<ComposeComponentRichTextCtaCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentLinkLinkingCollectionsComposeComponentRichTextCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentLinkLinkingCollectionsComposeComponentRichTextCtaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentLinkLinkingCollectionsComposeComponentRichTextCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentLinkLinkingCollectionsComposeComponentRichTextCtaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentLinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentLinkLinkingCollectionsComposeComponentRichTextCtaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentLinkLinkingCollectionsComposeComponentRichTextCtaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentLinkOrder {
  OpensInANewTabAsc = 'opensInANewTab_ASC',
  OpensInANewTabDesc = 'opensInANewTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentMissionStatement) */
export type ComposeComponentMissionStatement = Entry & _Node & {
  __typename?: 'ComposeComponentMissionStatement';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentMissionStatementLinkingCollections>;
  missionStatement: Maybe<Entry>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentMissionStatement) */
export type ComposeComponentMissionStatementLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentMissionStatement) */
export type ComposeComponentMissionStatementMissionStatementArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentMissionStatementCollection = {
  __typename?: 'ComposeComponentMissionStatementCollection';
  items: Array<Maybe<ComposeComponentMissionStatement>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentMissionStatementCursorCollection = {
  __typename?: 'ComposeComponentMissionStatementCursorCollection';
  items: Array<Maybe<ComposeComponentMissionStatement>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentMissionStatementFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentMissionStatementFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentMissionStatementFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  missionStatement_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentMissionStatementLinkingCollections = {
  __typename?: 'ComposeComponentMissionStatementLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentMissionStatementLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentMissionStatementLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentMissionStatementOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentPopularArticles) */
export type ComposeComponentPopularArticles = Entry & _Node & {
  __typename?: 'ComposeComponentPopularArticles';
  _id: Scalars['ID']['output'];
  articlesCollection: Maybe<ComposeComponentPopularArticlesArticlesCollection>;
  articlesCursorCollection: Maybe<ComposeComponentPopularArticlesArticlesCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentPopularArticlesLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentPopularArticles) */
export type ComposeComponentPopularArticlesArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentPopularArticlesArticlesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentPopularArticles) */
export type ComposeComponentPopularArticlesArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentPopularArticlesArticlesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentPopularArticles) */
export type ComposeComponentPopularArticlesLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentPopularArticles) */
export type ComposeComponentPopularArticlesNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentPopularArticlesArticlesCollection = {
  __typename?: 'ComposeComponentPopularArticlesArticlesCollection';
  items: Array<Maybe<ComposePageArticle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComposeComponentPopularArticlesArticlesCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentPopularArticlesArticlesCursorCollection = {
  __typename?: 'ComposeComponentPopularArticlesArticlesCursorCollection';
  items: Array<Maybe<ComposePageArticle>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComposeComponentPopularArticlesArticlesCursorCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentPopularArticlesCollection = {
  __typename?: 'ComposeComponentPopularArticlesCollection';
  items: Array<Maybe<ComposeComponentPopularArticles>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentPopularArticlesCursorCollection = {
  __typename?: 'ComposeComponentPopularArticlesCursorCollection';
  items: Array<Maybe<ComposeComponentPopularArticles>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentPopularArticlesFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentPopularArticlesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentPopularArticlesFilter>>>;
  articles: InputMaybe<CfComposePageArticleNestedFilter>;
  articlesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentPopularArticlesLinkingCollections = {
  __typename?: 'ComposeComponentPopularArticlesLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentPopularArticlesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentPopularArticlesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentPopularArticlesOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentRichTextColouredBackground) */
export type ComposeComponentRichTextColouredBackground = Entry & _Node & {
  __typename?: 'ComposeComponentRichTextColouredBackground';
  _id: Scalars['ID']['output'];
  backgroundTheme: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentRichTextColouredBackgroundLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text: Maybe<ComposeComponentRichTextColouredBackgroundText>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentRichTextColouredBackground) */
export type ComposeComponentRichTextColouredBackgroundBackgroundThemeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentRichTextColouredBackground) */
export type ComposeComponentRichTextColouredBackgroundLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentRichTextColouredBackground) */
export type ComposeComponentRichTextColouredBackgroundNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentRichTextColouredBackground) */
export type ComposeComponentRichTextColouredBackgroundTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentRichTextColouredBackgroundCollection = {
  __typename?: 'ComposeComponentRichTextColouredBackgroundCollection';
  items: Array<Maybe<ComposeComponentRichTextColouredBackground>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentRichTextColouredBackgroundCursorCollection = {
  __typename?: 'ComposeComponentRichTextColouredBackgroundCursorCollection';
  items: Array<Maybe<ComposeComponentRichTextColouredBackground>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentRichTextColouredBackgroundFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentRichTextColouredBackgroundFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentRichTextColouredBackgroundFilter>>>;
  backgroundTheme: InputMaybe<Scalars['String']['input']>;
  backgroundTheme_contains: InputMaybe<Scalars['String']['input']>;
  backgroundTheme_exists: InputMaybe<Scalars['Boolean']['input']>;
  backgroundTheme_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  backgroundTheme_not: InputMaybe<Scalars['String']['input']>;
  backgroundTheme_not_contains: InputMaybe<Scalars['String']['input']>;
  backgroundTheme_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
};

export type ComposeComponentRichTextColouredBackgroundLinkingCollections = {
  __typename?: 'ComposeComponentRichTextColouredBackgroundLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentRichTextColouredBackgroundLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentRichTextColouredBackgroundLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentRichTextColouredBackgroundOrder {
  BackgroundThemeAsc = 'backgroundTheme_ASC',
  BackgroundThemeDesc = 'backgroundTheme_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentRichTextColouredBackgroundText = {
  __typename?: 'ComposeComponentRichTextColouredBackgroundText';
  json: Scalars['JSON']['output'];
  links: ComposeComponentRichTextColouredBackgroundTextLinks;
};

export type ComposeComponentRichTextColouredBackgroundTextAssets = {
  __typename?: 'ComposeComponentRichTextColouredBackgroundTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposeComponentRichTextColouredBackgroundTextEntries = {
  __typename?: 'ComposeComponentRichTextColouredBackgroundTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposeComponentRichTextColouredBackgroundTextLinks = {
  __typename?: 'ComposeComponentRichTextColouredBackgroundTextLinks';
  assets: ComposeComponentRichTextColouredBackgroundTextAssets;
  entries: ComposeComponentRichTextColouredBackgroundTextEntries;
  resources: ComposeComponentRichTextColouredBackgroundTextResources;
};

export type ComposeComponentRichTextColouredBackgroundTextResources = {
  __typename?: 'ComposeComponentRichTextColouredBackgroundTextResources';
  block: Array<ComposeComponentRichTextColouredBackgroundTextResourcesBlock>;
  hyperlink: Array<ComposeComponentRichTextColouredBackgroundTextResourcesHyperlink>;
  inline: Array<ComposeComponentRichTextColouredBackgroundTextResourcesInline>;
};

export type ComposeComponentRichTextColouredBackgroundTextResourcesBlock = ResourceLink & {
  __typename?: 'ComposeComponentRichTextColouredBackgroundTextResourcesBlock';
  sys: ResourceSys;
};

export type ComposeComponentRichTextColouredBackgroundTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposeComponentRichTextColouredBackgroundTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposeComponentRichTextColouredBackgroundTextResourcesInline = ResourceLink & {
  __typename?: 'ComposeComponentRichTextColouredBackgroundTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentRichTextCta) */
export type ComposeComponentRichTextCta = Entry & _Node & {
  __typename?: 'ComposeComponentRichTextCta';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  link: Maybe<ComposeComponentLink>;
  linkedFrom: Maybe<ComposeComponentRichTextCtaLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text: Maybe<ComposeComponentRichTextCtaText>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentRichTextCta) */
export type ComposeComponentRichTextCtaLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentRichTextCta) */
export type ComposeComponentRichTextCtaLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentRichTextCta) */
export type ComposeComponentRichTextCtaNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentRichTextCta) */
export type ComposeComponentRichTextCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentRichTextCtaCollection = {
  __typename?: 'ComposeComponentRichTextCtaCollection';
  items: Array<Maybe<ComposeComponentRichTextCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentRichTextCtaCursorCollection = {
  __typename?: 'ComposeComponentRichTextCtaCursorCollection';
  items: Array<Maybe<ComposeComponentRichTextCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentRichTextCtaFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentRichTextCtaFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentRichTextCtaFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  link: InputMaybe<CfComposeComponentLinkNestedFilter>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
};

export type ComposeComponentRichTextCtaLinkingCollections = {
  __typename?: 'ComposeComponentRichTextCtaLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentRichTextCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentRichTextCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentRichTextCtaOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentRichTextCtaText = {
  __typename?: 'ComposeComponentRichTextCtaText';
  json: Scalars['JSON']['output'];
  links: ComposeComponentRichTextCtaTextLinks;
};

export type ComposeComponentRichTextCtaTextAssets = {
  __typename?: 'ComposeComponentRichTextCtaTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposeComponentRichTextCtaTextEntries = {
  __typename?: 'ComposeComponentRichTextCtaTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposeComponentRichTextCtaTextLinks = {
  __typename?: 'ComposeComponentRichTextCtaTextLinks';
  assets: ComposeComponentRichTextCtaTextAssets;
  entries: ComposeComponentRichTextCtaTextEntries;
  resources: ComposeComponentRichTextCtaTextResources;
};

export type ComposeComponentRichTextCtaTextResources = {
  __typename?: 'ComposeComponentRichTextCtaTextResources';
  block: Array<ComposeComponentRichTextCtaTextResourcesBlock>;
  hyperlink: Array<ComposeComponentRichTextCtaTextResourcesHyperlink>;
  inline: Array<ComposeComponentRichTextCtaTextResourcesInline>;
};

export type ComposeComponentRichTextCtaTextResourcesBlock = ResourceLink & {
  __typename?: 'ComposeComponentRichTextCtaTextResourcesBlock';
  sys: ResourceSys;
};

export type ComposeComponentRichTextCtaTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposeComponentRichTextCtaTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposeComponentRichTextCtaTextResourcesInline = ResourceLink & {
  __typename?: 'ComposeComponentRichTextCtaTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBanner) */
export type ComposeComponentStickyBanner = Entry & _Node & {
  __typename?: 'ComposeComponentStickyBanner';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  itemsCollection: Maybe<ComposeComponentStickyBannerItemsCollection>;
  itemsCursorCollection: Maybe<ComposeComponentStickyBannerItemsCursorCollection>;
  linkedFrom: Maybe<ComposeComponentStickyBannerLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBanner) */
export type ComposeComponentStickyBannerItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerItemsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentStickyBannerItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBanner) */
export type ComposeComponentStickyBannerItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerItemsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentStickyBannerItemFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBanner) */
export type ComposeComponentStickyBannerLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBanner) */
export type ComposeComponentStickyBannerNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentStickyBannerCollection = {
  __typename?: 'ComposeComponentStickyBannerCollection';
  items: Array<Maybe<ComposeComponentStickyBanner>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentStickyBannerCursorCollection = {
  __typename?: 'ComposeComponentStickyBannerCursorCollection';
  items: Array<Maybe<ComposeComponentStickyBanner>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentStickyBannerFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  items: InputMaybe<CfComposeComponentStickyBannerItemNestedFilter>;
  itemsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBannerItem) */
export type ComposeComponentStickyBannerItem = Entry & _Node & {
  __typename?: 'ComposeComponentStickyBannerItem';
  _id: Scalars['ID']['output'];
  body: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  heading: Maybe<Scalars['String']['output']>;
  link: Maybe<Link>;
  linkedFrom: Maybe<ComposeComponentStickyBannerItemLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBannerItem) */
export type ComposeComponentStickyBannerItemBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBannerItem) */
export type ComposeComponentStickyBannerItemHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBannerItem) */
export type ComposeComponentStickyBannerItemLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBannerItem) */
export type ComposeComponentStickyBannerItemLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentStickyBannerItem) */
export type ComposeComponentStickyBannerItemNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentStickyBannerItemCollection = {
  __typename?: 'ComposeComponentStickyBannerItemCollection';
  items: Array<Maybe<ComposeComponentStickyBannerItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentStickyBannerItemCursorCollection = {
  __typename?: 'ComposeComponentStickyBannerItemCursorCollection';
  items: Array<Maybe<ComposeComponentStickyBannerItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentStickyBannerItemFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerItemFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerItemFilter>>>;
  body: InputMaybe<Scalars['String']['input']>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not: InputMaybe<Scalars['String']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  body_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link: InputMaybe<CfLinkNestedFilter>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentStickyBannerItemLinkingCollections = {
  __typename?: 'ComposeComponentStickyBannerItemLinkingCollections';
  composeComponentStickyBannerCollection: Maybe<ComposeComponentStickyBannerCollection>;
  composeComponentStickyBannerCursorCollection: Maybe<ComposeComponentStickyBannerCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentStickyBannerItemLinkingCollectionsComposeComponentStickyBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerItemLinkingCollectionsComposeComponentStickyBannerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentStickyBannerItemLinkingCollectionsComposeComponentStickyBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerItemLinkingCollectionsComposeComponentStickyBannerCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentStickyBannerItemLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentStickyBannerItemLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentStickyBannerItemLinkingCollectionsComposeComponentStickyBannerCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentStickyBannerItemLinkingCollectionsComposeComponentStickyBannerCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentStickyBannerItemOrder {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentStickyBannerItemsCollection = {
  __typename?: 'ComposeComponentStickyBannerItemsCollection';
  items: Array<Maybe<ComposeComponentStickyBannerItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComposeComponentStickyBannerItemsCollectionOrder {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentStickyBannerItemsCursorCollection = {
  __typename?: 'ComposeComponentStickyBannerItemsCursorCollection';
  items: Array<Maybe<ComposeComponentStickyBannerItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComposeComponentStickyBannerItemsCursorCollectionOrder {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentStickyBannerLinkingCollections = {
  __typename?: 'ComposeComponentStickyBannerLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentStickyBannerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentStickyBannerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentStickyBannerOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTeacherSupportStatement) */
export type ComposeComponentTeacherSupportStatement = Entry & _Node & {
  __typename?: 'ComposeComponentTeacherSupportStatement';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  imageAndAdjacentText: Maybe<ComposeComponentImageAndAdjacentText>;
  linkedFrom: Maybe<ComposeComponentTeacherSupportStatementLinkingCollections>;
  list: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  listHeading: Maybe<Scalars['String']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTeacherSupportStatement) */
export type ComposeComponentTeacherSupportStatementImageAndAdjacentTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageAndAdjacentTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTeacherSupportStatement) */
export type ComposeComponentTeacherSupportStatementLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTeacherSupportStatement) */
export type ComposeComponentTeacherSupportStatementListArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTeacherSupportStatement) */
export type ComposeComponentTeacherSupportStatementListHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTeacherSupportStatement) */
export type ComposeComponentTeacherSupportStatementTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentTeacherSupportStatementCollection = {
  __typename?: 'ComposeComponentTeacherSupportStatementCollection';
  items: Array<Maybe<ComposeComponentTeacherSupportStatement>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentTeacherSupportStatementCursorCollection = {
  __typename?: 'ComposeComponentTeacherSupportStatementCursorCollection';
  items: Array<Maybe<ComposeComponentTeacherSupportStatement>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentTeacherSupportStatementFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentTeacherSupportStatementFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentTeacherSupportStatementFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  imageAndAdjacentText: InputMaybe<CfComposeComponentImageAndAdjacentTextNestedFilter>;
  imageAndAdjacentText_exists: InputMaybe<Scalars['Boolean']['input']>;
  listHeading: InputMaybe<Scalars['String']['input']>;
  listHeading_contains: InputMaybe<Scalars['String']['input']>;
  listHeading_exists: InputMaybe<Scalars['Boolean']['input']>;
  listHeading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listHeading_not: InputMaybe<Scalars['String']['input']>;
  listHeading_not_contains: InputMaybe<Scalars['String']['input']>;
  listHeading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  list_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  list_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  list_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  list_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComposeComponentTeacherSupportStatementLinkingCollections = {
  __typename?: 'ComposeComponentTeacherSupportStatementLinkingCollections';
  composePageWlMarketingHomePageCollection: Maybe<ComposePageWlMarketingHomePageCollection>;
  composePageWlMarketingHomePageCursorCollection: Maybe<ComposePageWlMarketingHomePageCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentTeacherSupportStatementLinkingCollectionsComposePageWlMarketingHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTeacherSupportStatementLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTeacherSupportStatementLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTeacherSupportStatementLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTeacherSupportStatementLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTeacherSupportStatementLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentTeacherSupportStatementLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentTeacherSupportStatementLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentTeacherSupportStatementOrder {
  ListHeadingAsc = 'listHeading_ASC',
  ListHeadingDesc = 'listHeading_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentText) */
export type ComposeComponentText = Entry & _Node & {
  __typename?: 'ComposeComponentText';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  divAlignment: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<ComposeComponentTextLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  text: Maybe<ComposeComponentTextText>;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentText) */
export type ComposeComponentTextDivAlignmentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentText) */
export type ComposeComponentTextLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentText) */
export type ComposeComponentTextNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentText) */
export type ComposeComponentTextTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentText) */
export type ComposeComponentTextTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentTextCollection = {
  __typename?: 'ComposeComponentTextCollection';
  items: Array<Maybe<ComposeComponentText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentTextCursorCollection = {
  __typename?: 'ComposeComponentTextCursorCollection';
  items: Array<Maybe<ComposeComponentText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentTextFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentTextFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentTextFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  divAlignment: InputMaybe<Scalars['String']['input']>;
  divAlignment_contains: InputMaybe<Scalars['String']['input']>;
  divAlignment_exists: InputMaybe<Scalars['Boolean']['input']>;
  divAlignment_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  divAlignment_not: InputMaybe<Scalars['String']['input']>;
  divAlignment_not_contains: InputMaybe<Scalars['String']['input']>;
  divAlignment_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComposeComponentTextLinkingCollections = {
  __typename?: 'ComposeComponentTextLinkingCollections';
  composeComponentTextListCollection: Maybe<ComposeComponentTextListCollection>;
  composeComponentTextListCursorCollection: Maybe<ComposeComponentTextListCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentTextLinkingCollectionsComposeComponentTextListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTextLinkingCollectionsComposeComponentTextListCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTextLinkingCollectionsComposeComponentTextListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTextLinkingCollectionsComposeComponentTextListCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentTextLinkingCollectionsComposeComponentTextListCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentTextLinkingCollectionsComposeComponentTextListCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTextList) */
export type ComposeComponentTextList = Entry & _Node & {
  __typename?: 'ComposeComponentTextList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentTextListLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  textItemsCollection: Maybe<ComposeComponentTextListTextItemsCollection>;
  textItemsCursorCollection: Maybe<ComposeComponentTextListTextItemsCursorCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTextList) */
export type ComposeComponentTextListLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTextList) */
export type ComposeComponentTextListNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTextList) */
export type ComposeComponentTextListTextItemsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTextListTextItemsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTextList) */
export type ComposeComponentTextListTextItemsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTextListTextItemsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTextFilter>;
};

export type ComposeComponentTextListCollection = {
  __typename?: 'ComposeComponentTextListCollection';
  items: Array<Maybe<ComposeComponentTextList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentTextListCursorCollection = {
  __typename?: 'ComposeComponentTextListCursorCollection';
  items: Array<Maybe<ComposeComponentTextList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentTextListFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentTextListFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentTextListFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  textItems: InputMaybe<CfComposeComponentTextNestedFilter>;
  textItemsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentTextListLinkingCollections = {
  __typename?: 'ComposeComponentTextListLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentTextListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTextListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentTextListOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentTextListTextItemsCollection = {
  __typename?: 'ComposeComponentTextListTextItemsCollection';
  items: Array<Maybe<ComposeComponentText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComposeComponentTextListTextItemsCollectionOrder {
  DivAlignmentAsc = 'divAlignment_ASC',
  DivAlignmentDesc = 'divAlignment_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComposeComponentTextListTextItemsCursorCollection = {
  __typename?: 'ComposeComponentTextListTextItemsCursorCollection';
  items: Array<Maybe<ComposeComponentText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComposeComponentTextListTextItemsCursorCollectionOrder {
  DivAlignmentAsc = 'divAlignment_ASC',
  DivAlignmentDesc = 'divAlignment_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentTextOrder {
  DivAlignmentAsc = 'divAlignment_ASC',
  DivAlignmentDesc = 'divAlignment_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type ComposeComponentTextText = {
  __typename?: 'ComposeComponentTextText';
  json: Scalars['JSON']['output'];
  links: ComposeComponentTextTextLinks;
};

export type ComposeComponentTextTextAssets = {
  __typename?: 'ComposeComponentTextTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposeComponentTextTextEntries = {
  __typename?: 'ComposeComponentTextTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposeComponentTextTextLinks = {
  __typename?: 'ComposeComponentTextTextLinks';
  assets: ComposeComponentTextTextAssets;
  entries: ComposeComponentTextTextEntries;
  resources: ComposeComponentTextTextResources;
};

export type ComposeComponentTextTextResources = {
  __typename?: 'ComposeComponentTextTextResources';
  block: Array<ComposeComponentTextTextResourcesBlock>;
  hyperlink: Array<ComposeComponentTextTextResourcesHyperlink>;
  inline: Array<ComposeComponentTextTextResourcesInline>;
};

export type ComposeComponentTextTextResourcesBlock = ResourceLink & {
  __typename?: 'ComposeComponentTextTextResourcesBlock';
  sys: ResourceSys;
};

export type ComposeComponentTextTextResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposeComponentTextTextResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposeComponentTextTextResourcesInline = ResourceLink & {
  __typename?: 'ComposeComponentTextTextResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopic) */
export type ComposeComponentTopic = Entry & _Node & {
  __typename?: 'ComposeComponentTopic';
  _id: Scalars['ID']['output'];
  background: Maybe<ComposeComponentTopicBackground>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentTopicLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopic) */
export type ComposeComponentTopicBackgroundArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicBackgroundFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopic) */
export type ComposeComponentTopicLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopic) */
export type ComposeComponentTopicNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopic) */
export type ComposeComponentTopicSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopicBackground) */
export type ComposeComponentTopicBackground = Entry & _Node & {
  __typename?: 'ComposeComponentTopicBackground';
  _id: Scalars['ID']['output'];
  colour: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<Asset>;
  linkedFrom: Maybe<ComposeComponentTopicBackgroundLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopicBackground) */
export type ComposeComponentTopicBackgroundColourArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopicBackground) */
export type ComposeComponentTopicBackgroundImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopicBackground) */
export type ComposeComponentTopicBackgroundLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopicBackground) */
export type ComposeComponentTopicBackgroundNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentTopicBackgroundCollection = {
  __typename?: 'ComposeComponentTopicBackgroundCollection';
  items: Array<Maybe<ComposeComponentTopicBackground>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentTopicBackgroundCursorCollection = {
  __typename?: 'ComposeComponentTopicBackgroundCursorCollection';
  items: Array<Maybe<ComposeComponentTopicBackground>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentTopicBackgroundFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentTopicBackgroundFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentTopicBackgroundFilter>>>;
  colour: InputMaybe<Scalars['String']['input']>;
  colour_contains: InputMaybe<Scalars['String']['input']>;
  colour_exists: InputMaybe<Scalars['Boolean']['input']>;
  colour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour_not: InputMaybe<Scalars['String']['input']>;
  colour_not_contains: InputMaybe<Scalars['String']['input']>;
  colour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentTopicBackgroundLinkingCollections = {
  __typename?: 'ComposeComponentTopicBackgroundLinkingCollections';
  composeComponentTopicCollection: Maybe<ComposeComponentTopicCollection>;
  composeComponentTopicCursorCollection: Maybe<ComposeComponentTopicCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentTopicBackgroundLinkingCollectionsComposeComponentTopicCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicBackgroundLinkingCollectionsComposeComponentTopicCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTopicBackgroundLinkingCollectionsComposeComponentTopicCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicBackgroundLinkingCollectionsComposeComponentTopicCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTopicBackgroundLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTopicBackgroundLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentTopicBackgroundLinkingCollectionsComposeComponentTopicCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentTopicBackgroundLinkingCollectionsComposeComponentTopicCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentTopicBackgroundOrder {
  ColourAsc = 'colour_ASC',
  ColourDesc = 'colour_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentTopicCollection = {
  __typename?: 'ComposeComponentTopicCollection';
  items: Array<Maybe<ComposeComponentTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentTopicCursorCollection = {
  __typename?: 'ComposeComponentTopicCursorCollection';
  items: Array<Maybe<ComposeComponentTopic>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentTopicFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentTopicFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentTopicFilter>>>;
  background: InputMaybe<CfComposeComponentTopicBackgroundNestedFilter>;
  background_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposeComponentTopicLinkingCollections = {
  __typename?: 'ComposeComponentTopicLinkingCollections';
  composeComponentTopicListCollection: Maybe<ComposeComponentTopicListCollection>;
  composeComponentTopicListCursorCollection: Maybe<ComposeComponentTopicListCursorCollection>;
  composePageArticleCollection: Maybe<ComposePageArticleCollection>;
  composePageArticleCursorCollection: Maybe<ComposePageArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentTopicLinkingCollectionsComposeComponentTopicListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicLinkingCollectionsComposeComponentTopicListCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTopicLinkingCollectionsComposeComponentTopicListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicLinkingCollectionsComposeComponentTopicListCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTopicLinkingCollectionsComposePageArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicLinkingCollectionsComposePageArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTopicLinkingCollectionsComposePageArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicLinkingCollectionsComposePageArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTopicLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTopicLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentTopicLinkingCollectionsComposeComponentTopicListCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentTopicLinkingCollectionsComposeComponentTopicListCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentTopicLinkingCollectionsComposePageArticleCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentTopicLinkingCollectionsComposePageArticleCursorCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopicList) */
export type ComposeComponentTopicList = Entry & _Node & {
  __typename?: 'ComposeComponentTopicList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentTopicListLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  topicsCollection: Maybe<ComposeComponentTopicListTopicsCollection>;
  topicsCursorCollection: Maybe<ComposeComponentTopicListTopicsCursorCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopicList) */
export type ComposeComponentTopicListLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopicList) */
export type ComposeComponentTopicListNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopicList) */
export type ComposeComponentTopicListTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicListTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentTopicList) */
export type ComposeComponentTopicListTopicsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicListTopicsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicFilter>;
};

export type ComposeComponentTopicListCollection = {
  __typename?: 'ComposeComponentTopicListCollection';
  items: Array<Maybe<ComposeComponentTopicList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentTopicListCursorCollection = {
  __typename?: 'ComposeComponentTopicListCursorCollection';
  items: Array<Maybe<ComposeComponentTopicList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentTopicListFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentTopicListFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentTopicListFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  topics: InputMaybe<CfComposeComponentTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentTopicListLinkingCollections = {
  __typename?: 'ComposeComponentTopicListLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentTopicListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentTopicListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentTopicListOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentTopicListTopicsCollection = {
  __typename?: 'ComposeComponentTopicListTopicsCollection';
  items: Array<Maybe<ComposeComponentTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComposeComponentTopicListTopicsCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentTopicListTopicsCursorCollection = {
  __typename?: 'ComposeComponentTopicListTopicsCursorCollection';
  items: Array<Maybe<ComposeComponentTopic>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComposeComponentTopicListTopicsCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentTopicOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentUrl) */
export type ComposeComponentUrl = Entry & _Node & {
  __typename?: 'ComposeComponentUrl';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentUrlLinkingCollections>;
  sys: Sys;
  url: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentUrl) */
export type ComposeComponentUrlLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentUrl) */
export type ComposeComponentUrlUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentUrlCollection = {
  __typename?: 'ComposeComponentUrlCollection';
  items: Array<Maybe<ComposeComponentUrl>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentUrlCursorCollection = {
  __typename?: 'ComposeComponentUrlCursorCollection';
  items: Array<Maybe<ComposeComponentUrl>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentUrlFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentUrlFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentUrlFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComposeComponentUrlLinkingCollections = {
  __typename?: 'ComposeComponentUrlLinkingCollections';
  composeComponentLinkCollection: Maybe<ComposeComponentLinkCollection>;
  composeComponentLinkCursorCollection: Maybe<ComposeComponentLinkCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  parentUiRichTextHyperlinkCollection: Maybe<ParentUiRichTextHyperlinkCollection>;
  parentUiRichTextHyperlinkCursorCollection: Maybe<ParentUiRichTextHyperlinkCursorCollection>;
};


export type ComposeComponentUrlLinkingCollectionsComposeComponentLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentUrlLinkingCollectionsComposeComponentLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentUrlLinkingCollectionsComposeComponentLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentUrlLinkingCollectionsComposeComponentLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentUrlLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentUrlLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentUrlLinkingCollectionsParentUiRichTextHyperlinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentUrlLinkingCollectionsParentUiRichTextHyperlinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentUrlLinkingCollectionsParentUiRichTextHyperlinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentUrlLinkingCollectionsParentUiRichTextHyperlinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentUrlLinkingCollectionsComposeComponentLinkCollectionOrder {
  OpensInANewTabAsc = 'opensInANewTab_ASC',
  OpensInANewTabDesc = 'opensInANewTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentUrlLinkingCollectionsComposeComponentLinkCursorCollectionOrder {
  OpensInANewTabAsc = 'opensInANewTab_ASC',
  OpensInANewTabDesc = 'opensInANewTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentUrlLinkingCollectionsParentUiRichTextHyperlinkCollectionOrder {
  OpensInANewTabAsc = 'opensInANewTab_ASC',
  OpensInANewTabDesc = 'opensInANewTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum ComposeComponentUrlLinkingCollectionsParentUiRichTextHyperlinkCursorCollectionOrder {
  OpensInANewTabAsc = 'opensInANewTab_ASC',
  OpensInANewTabDesc = 'opensInANewTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export enum ComposeComponentUrlOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentVerticalImageCta) */
export type ComposeComponentVerticalImageCta = Entry & _Node & {
  __typename?: 'ComposeComponentVerticalImageCta';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<ComposeComponentImage>;
  linkedFrom: Maybe<ComposeComponentVerticalImageCtaLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  url: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentVerticalImageCta) */
export type ComposeComponentVerticalImageCtaImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentVerticalImageCta) */
export type ComposeComponentVerticalImageCtaLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentVerticalImageCta) */
export type ComposeComponentVerticalImageCtaNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentVerticalImageCta) */
export type ComposeComponentVerticalImageCtaUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentVerticalImageCtaCollection = {
  __typename?: 'ComposeComponentVerticalImageCtaCollection';
  items: Array<Maybe<ComposeComponentVerticalImageCta>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentVerticalImageCtaCursorCollection = {
  __typename?: 'ComposeComponentVerticalImageCtaCursorCollection';
  items: Array<Maybe<ComposeComponentVerticalImageCta>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentVerticalImageCtaFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentVerticalImageCtaFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentVerticalImageCtaFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image: InputMaybe<CfComposeComponentImageNestedFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComposeComponentVerticalImageCtaLinkingCollections = {
  __typename?: 'ComposeComponentVerticalImageCtaLinkingCollections';
  composeComponentGlobalVerticalImageCtaCollection: Maybe<ComposeComponentGlobalVerticalImageCtaCollection>;
  composeComponentGlobalVerticalImageCtaCursorCollection: Maybe<ComposeComponentGlobalVerticalImageCtaCursorCollection>;
  composePageArticleCollection: Maybe<ComposePageArticleCollection>;
  composePageArticleCursorCollection: Maybe<ComposePageArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentVerticalImageCtaLinkingCollectionsComposeComponentGlobalVerticalImageCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentVerticalImageCtaLinkingCollectionsComposeComponentGlobalVerticalImageCtaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentVerticalImageCtaLinkingCollectionsComposeComponentGlobalVerticalImageCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentVerticalImageCtaLinkingCollectionsComposeComponentGlobalVerticalImageCtaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentVerticalImageCtaLinkingCollectionsComposePageArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentVerticalImageCtaLinkingCollectionsComposePageArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentVerticalImageCtaLinkingCollectionsComposePageArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentVerticalImageCtaLinkingCollectionsComposePageArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentVerticalImageCtaLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentVerticalImageCtaLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentVerticalImageCtaLinkingCollectionsComposeComponentGlobalVerticalImageCtaCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentVerticalImageCtaLinkingCollectionsComposeComponentGlobalVerticalImageCtaCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentVerticalImageCtaLinkingCollectionsComposePageArticleCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentVerticalImageCtaLinkingCollectionsComposePageArticleCursorCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentVerticalImageCtaOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentVideoAndAdjacentText) */
export type ComposeComponentVideoAndAdjacentText = Entry & _Node & {
  __typename?: 'ComposeComponentVideoAndAdjacentText';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<ComposeComponentVideoAndAdjacentTextDescription>;
  linkedFrom: Maybe<ComposeComponentVideoAndAdjacentTextLinkingCollections>;
  sys: Sys;
  video: Maybe<Asset>;
  videoAlignment: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentVideoAndAdjacentText) */
export type ComposeComponentVideoAndAdjacentTextDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentVideoAndAdjacentText) */
export type ComposeComponentVideoAndAdjacentTextLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentVideoAndAdjacentText) */
export type ComposeComponentVideoAndAdjacentTextVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentVideoAndAdjacentText) */
export type ComposeComponentVideoAndAdjacentTextVideoAlignmentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentVideoAndAdjacentTextCollection = {
  __typename?: 'ComposeComponentVideoAndAdjacentTextCollection';
  items: Array<Maybe<ComposeComponentVideoAndAdjacentText>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentVideoAndAdjacentTextCursorCollection = {
  __typename?: 'ComposeComponentVideoAndAdjacentTextCursorCollection';
  items: Array<Maybe<ComposeComponentVideoAndAdjacentText>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentVideoAndAdjacentTextDescription = {
  __typename?: 'ComposeComponentVideoAndAdjacentTextDescription';
  json: Scalars['JSON']['output'];
  links: ComposeComponentVideoAndAdjacentTextDescriptionLinks;
};

export type ComposeComponentVideoAndAdjacentTextDescriptionAssets = {
  __typename?: 'ComposeComponentVideoAndAdjacentTextDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposeComponentVideoAndAdjacentTextDescriptionEntries = {
  __typename?: 'ComposeComponentVideoAndAdjacentTextDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposeComponentVideoAndAdjacentTextDescriptionLinks = {
  __typename?: 'ComposeComponentVideoAndAdjacentTextDescriptionLinks';
  assets: ComposeComponentVideoAndAdjacentTextDescriptionAssets;
  entries: ComposeComponentVideoAndAdjacentTextDescriptionEntries;
  resources: ComposeComponentVideoAndAdjacentTextDescriptionResources;
};

export type ComposeComponentVideoAndAdjacentTextDescriptionResources = {
  __typename?: 'ComposeComponentVideoAndAdjacentTextDescriptionResources';
  block: Array<ComposeComponentVideoAndAdjacentTextDescriptionResourcesBlock>;
  hyperlink: Array<ComposeComponentVideoAndAdjacentTextDescriptionResourcesHyperlink>;
  inline: Array<ComposeComponentVideoAndAdjacentTextDescriptionResourcesInline>;
};

export type ComposeComponentVideoAndAdjacentTextDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'ComposeComponentVideoAndAdjacentTextDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type ComposeComponentVideoAndAdjacentTextDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposeComponentVideoAndAdjacentTextDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposeComponentVideoAndAdjacentTextDescriptionResourcesInline = ResourceLink & {
  __typename?: 'ComposeComponentVideoAndAdjacentTextDescriptionResourcesInline';
  sys: ResourceSys;
};

export type ComposeComponentVideoAndAdjacentTextFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentVideoAndAdjacentTextFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentVideoAndAdjacentTextFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  sys: InputMaybe<SysFilter>;
  videoAlignment: InputMaybe<Scalars['String']['input']>;
  videoAlignment_contains: InputMaybe<Scalars['String']['input']>;
  videoAlignment_exists: InputMaybe<Scalars['Boolean']['input']>;
  videoAlignment_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoAlignment_not: InputMaybe<Scalars['String']['input']>;
  videoAlignment_not_contains: InputMaybe<Scalars['String']['input']>;
  videoAlignment_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  video_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentVideoAndAdjacentTextLinkingCollections = {
  __typename?: 'ComposeComponentVideoAndAdjacentTextLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  writingLegendsMarketingSiteContactUsPageV2Collection: Maybe<WritingLegendsMarketingSiteContactUsPageV2Collection>;
  writingLegendsMarketingSiteContactUsPageV2CursorCollection: Maybe<WritingLegendsMarketingSiteContactUsPageV2CursorCollection>;
};


export type ComposeComponentVideoAndAdjacentTextLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentVideoAndAdjacentTextLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentVideoAndAdjacentTextLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentVideoAndAdjacentTextLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentVideoAndAdjacentTextLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentVideoAndAdjacentTextLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentVideoAndAdjacentTextLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CollectionOrder {
  DownloadSectionButtonTextAsc = 'downloadSectionButtonText_ASC',
  DownloadSectionButtonTextDesc = 'downloadSectionButtonText_DESC',
  DownloadSectionDescriptionAsc = 'downloadSectionDescription_ASC',
  DownloadSectionDescriptionDesc = 'downloadSectionDescription_DESC',
  DownloadSectionLinkAsc = 'downloadSectionLink_ASC',
  DownloadSectionLinkDesc = 'downloadSectionLink_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  FormLinkAsc = 'formLink_ASC',
  FormLinkDesc = 'formLink_DESC',
  FormTitleAsc = 'formTitle_ASC',
  FormTitleDesc = 'formTitle_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PhoneNumberAsc = 'phoneNumber_ASC',
  PhoneNumberDesc = 'phoneNumber_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentVideoAndAdjacentTextLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CursorCollectionOrder {
  DownloadSectionButtonTextAsc = 'downloadSectionButtonText_ASC',
  DownloadSectionButtonTextDesc = 'downloadSectionButtonText_DESC',
  DownloadSectionDescriptionAsc = 'downloadSectionDescription_ASC',
  DownloadSectionDescriptionDesc = 'downloadSectionDescription_DESC',
  DownloadSectionLinkAsc = 'downloadSectionLink_ASC',
  DownloadSectionLinkDesc = 'downloadSectionLink_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  FormLinkAsc = 'formLink_ASC',
  FormLinkDesc = 'formLink_DESC',
  FormTitleAsc = 'formTitle_ASC',
  FormTitleDesc = 'formTitle_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PhoneNumberAsc = 'phoneNumber_ASC',
  PhoneNumberDesc = 'phoneNumber_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentVideoAndAdjacentTextOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  VideoAlignmentAsc = 'videoAlignment_ASC',
  VideoAlignmentDesc = 'videoAlignment_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlock = Entry & _Node & {
  __typename?: 'ComposeComponentWlFooterBlock';
  _id: Scalars['ID']['output'];
  about3PLearning: Maybe<Scalars['String']['output']>;
  aboutUs: Maybe<Scalars['String']['output']>;
  blakeELearningLogo: Maybe<Asset>;
  collaborateWithUs: Maybe<Scalars['String']['output']>;
  contactUs: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  dataBreachResponsePlan: Maybe<Scalars['String']['output']>;
  facebook: Maybe<Scalars['String']['output']>;
  instagram: Maybe<Scalars['String']['output']>;
  kidSafeLogo: Maybe<Asset>;
  linkedFrom: Maybe<ComposeComponentWlFooterBlockLinkingCollections>;
  linkedIn: Maybe<Scalars['String']['output']>;
  pLearningLogo: Maybe<Asset>;
  pinterest: Maybe<Scalars['String']['output']>;
  privacyPolicy: Maybe<Scalars['String']['output']>;
  refundPolicy: Maybe<Scalars['String']['output']>;
  responsibleDisclosureProgram: Maybe<Scalars['String']['output']>;
  sys: Sys;
  termsOfUse: Maybe<Scalars['String']['output']>;
  tikTok: Maybe<Scalars['String']['output']>;
  twitter: Maybe<Scalars['String']['output']>;
  youtube: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockAbout3PLearningArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockAboutUsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockBlakeELearningLogoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockCollaborateWithUsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockContactUsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockDataBreachResponsePlanArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockFacebookArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockInstagramArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockKidSafeLogoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockLinkedInArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockPLearningLogoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockPinterestArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockPrivacyPolicyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockRefundPolicyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockResponsibleDisclosureProgramArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockTermsOfUseArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockTikTokArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockTwitterArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlFooterBlock) */
export type ComposeComponentWlFooterBlockYoutubeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentWlFooterBlockCollection = {
  __typename?: 'ComposeComponentWlFooterBlockCollection';
  items: Array<Maybe<ComposeComponentWlFooterBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentWlFooterBlockCursorCollection = {
  __typename?: 'ComposeComponentWlFooterBlockCursorCollection';
  items: Array<Maybe<ComposeComponentWlFooterBlock>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentWlFooterBlockFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentWlFooterBlockFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentWlFooterBlockFilter>>>;
  about3pLearning: InputMaybe<Scalars['String']['input']>;
  about3pLearning_contains: InputMaybe<Scalars['String']['input']>;
  about3pLearning_exists: InputMaybe<Scalars['Boolean']['input']>;
  about3pLearning_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  about3pLearning_not: InputMaybe<Scalars['String']['input']>;
  about3pLearning_not_contains: InputMaybe<Scalars['String']['input']>;
  about3pLearning_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aboutUs: InputMaybe<Scalars['String']['input']>;
  aboutUs_contains: InputMaybe<Scalars['String']['input']>;
  aboutUs_exists: InputMaybe<Scalars['Boolean']['input']>;
  aboutUs_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aboutUs_not: InputMaybe<Scalars['String']['input']>;
  aboutUs_not_contains: InputMaybe<Scalars['String']['input']>;
  aboutUs_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blakeELearningLogo_exists: InputMaybe<Scalars['Boolean']['input']>;
  collaborateWithUs: InputMaybe<Scalars['String']['input']>;
  collaborateWithUs_contains: InputMaybe<Scalars['String']['input']>;
  collaborateWithUs_exists: InputMaybe<Scalars['Boolean']['input']>;
  collaborateWithUs_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collaborateWithUs_not: InputMaybe<Scalars['String']['input']>;
  collaborateWithUs_not_contains: InputMaybe<Scalars['String']['input']>;
  collaborateWithUs_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactUs: InputMaybe<Scalars['String']['input']>;
  contactUs_contains: InputMaybe<Scalars['String']['input']>;
  contactUs_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactUs_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactUs_not: InputMaybe<Scalars['String']['input']>;
  contactUs_not_contains: InputMaybe<Scalars['String']['input']>;
  contactUs_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  dataBreachResponsePlan: InputMaybe<Scalars['String']['input']>;
  dataBreachResponsePlan_contains: InputMaybe<Scalars['String']['input']>;
  dataBreachResponsePlan_exists: InputMaybe<Scalars['Boolean']['input']>;
  dataBreachResponsePlan_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataBreachResponsePlan_not: InputMaybe<Scalars['String']['input']>;
  dataBreachResponsePlan_not_contains: InputMaybe<Scalars['String']['input']>;
  dataBreachResponsePlan_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook: InputMaybe<Scalars['String']['input']>;
  facebook_contains: InputMaybe<Scalars['String']['input']>;
  facebook_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook_not: InputMaybe<Scalars['String']['input']>;
  facebook_not_contains: InputMaybe<Scalars['String']['input']>;
  facebook_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram: InputMaybe<Scalars['String']['input']>;
  instagram_contains: InputMaybe<Scalars['String']['input']>;
  instagram_exists: InputMaybe<Scalars['Boolean']['input']>;
  instagram_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram_not: InputMaybe<Scalars['String']['input']>;
  instagram_not_contains: InputMaybe<Scalars['String']['input']>;
  instagram_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kidSafeLogo_exists: InputMaybe<Scalars['Boolean']['input']>;
  linkedIn: InputMaybe<Scalars['String']['input']>;
  linkedIn_contains: InputMaybe<Scalars['String']['input']>;
  linkedIn_exists: InputMaybe<Scalars['Boolean']['input']>;
  linkedIn_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkedIn_not: InputMaybe<Scalars['String']['input']>;
  linkedIn_not_contains: InputMaybe<Scalars['String']['input']>;
  linkedIn_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pLearningLogo_exists: InputMaybe<Scalars['Boolean']['input']>;
  pinterest: InputMaybe<Scalars['String']['input']>;
  pinterest_contains: InputMaybe<Scalars['String']['input']>;
  pinterest_exists: InputMaybe<Scalars['Boolean']['input']>;
  pinterest_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pinterest_not: InputMaybe<Scalars['String']['input']>;
  pinterest_not_contains: InputMaybe<Scalars['String']['input']>;
  pinterest_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacyPolicy: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_contains: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_exists: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacyPolicy_not: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_not_contains: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundPolicy: InputMaybe<Scalars['String']['input']>;
  refundPolicy_contains: InputMaybe<Scalars['String']['input']>;
  refundPolicy_exists: InputMaybe<Scalars['Boolean']['input']>;
  refundPolicy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundPolicy_not: InputMaybe<Scalars['String']['input']>;
  refundPolicy_not_contains: InputMaybe<Scalars['String']['input']>;
  refundPolicy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  responsibleDisclosureProgram: InputMaybe<Scalars['String']['input']>;
  responsibleDisclosureProgram_contains: InputMaybe<Scalars['String']['input']>;
  responsibleDisclosureProgram_exists: InputMaybe<Scalars['Boolean']['input']>;
  responsibleDisclosureProgram_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  responsibleDisclosureProgram_not: InputMaybe<Scalars['String']['input']>;
  responsibleDisclosureProgram_not_contains: InputMaybe<Scalars['String']['input']>;
  responsibleDisclosureProgram_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  termsOfUse: InputMaybe<Scalars['String']['input']>;
  termsOfUse_contains: InputMaybe<Scalars['String']['input']>;
  termsOfUse_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsOfUse_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsOfUse_not: InputMaybe<Scalars['String']['input']>;
  termsOfUse_not_contains: InputMaybe<Scalars['String']['input']>;
  termsOfUse_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tikTok: InputMaybe<Scalars['String']['input']>;
  tikTok_contains: InputMaybe<Scalars['String']['input']>;
  tikTok_exists: InputMaybe<Scalars['Boolean']['input']>;
  tikTok_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tikTok_not: InputMaybe<Scalars['String']['input']>;
  tikTok_not_contains: InputMaybe<Scalars['String']['input']>;
  tikTok_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter: InputMaybe<Scalars['String']['input']>;
  twitter_contains: InputMaybe<Scalars['String']['input']>;
  twitter_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter_not: InputMaybe<Scalars['String']['input']>;
  twitter_not_contains: InputMaybe<Scalars['String']['input']>;
  twitter_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtube: InputMaybe<Scalars['String']['input']>;
  youtube_contains: InputMaybe<Scalars['String']['input']>;
  youtube_exists: InputMaybe<Scalars['Boolean']['input']>;
  youtube_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtube_not: InputMaybe<Scalars['String']['input']>;
  youtube_not_contains: InputMaybe<Scalars['String']['input']>;
  youtube_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComposeComponentWlFooterBlockLinkingCollections = {
  __typename?: 'ComposeComponentWlFooterBlockLinkingCollections';
  composePageWlMarketingHomePageCollection: Maybe<ComposePageWlMarketingHomePageCollection>;
  composePageWlMarketingHomePageCursorCollection: Maybe<ComposePageWlMarketingHomePageCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentWlFooterBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlFooterBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentWlFooterBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlFooterBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentWlFooterBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentWlFooterBlockLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentWlFooterBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentWlFooterBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentWlFooterBlockOrder {
  About3pLearningAsc = 'about3pLearning_ASC',
  About3pLearningDesc = 'about3pLearning_DESC',
  AboutUsAsc = 'aboutUs_ASC',
  AboutUsDesc = 'aboutUs_DESC',
  CollaborateWithUsAsc = 'collaborateWithUs_ASC',
  CollaborateWithUsDesc = 'collaborateWithUs_DESC',
  ContactUsAsc = 'contactUs_ASC',
  ContactUsDesc = 'contactUs_DESC',
  DataBreachResponsePlanAsc = 'dataBreachResponsePlan_ASC',
  DataBreachResponsePlanDesc = 'dataBreachResponsePlan_DESC',
  FacebookAsc = 'facebook_ASC',
  FacebookDesc = 'facebook_DESC',
  InstagramAsc = 'instagram_ASC',
  InstagramDesc = 'instagram_DESC',
  LinkedInAsc = 'linkedIn_ASC',
  LinkedInDesc = 'linkedIn_DESC',
  PinterestAsc = 'pinterest_ASC',
  PinterestDesc = 'pinterest_DESC',
  PrivacyPolicyAsc = 'privacyPolicy_ASC',
  PrivacyPolicyDesc = 'privacyPolicy_DESC',
  RefundPolicyAsc = 'refundPolicy_ASC',
  RefundPolicyDesc = 'refundPolicy_DESC',
  ResponsibleDisclosureProgramAsc = 'responsibleDisclosureProgram_ASC',
  ResponsibleDisclosureProgramDesc = 'responsibleDisclosureProgram_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TermsOfUseAsc = 'termsOfUse_ASC',
  TermsOfUseDesc = 'termsOfUse_DESC',
  TikTokAsc = 'tikTok_ASC',
  TikTokDesc = 'tikTok_DESC',
  TwitterAsc = 'twitter_ASC',
  TwitterDesc = 'twitter_DESC',
  YoutubeAsc = 'youtube_ASC',
  YoutubeDesc = 'youtube_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlProductAimBlock) */
export type ComposeComponentWlProductAimBlock = Entry & _Node & {
  __typename?: 'ComposeComponentWlProductAimBlock';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  lessonTypesOutline: Maybe<ComposeComponentImageAndAdjacentText>;
  linkedFrom: Maybe<ComposeComponentWlProductAimBlockLinkingCollections>;
  skillsOutline: Maybe<ComposeComponentImageAndAdjacentText>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlProductAimBlock) */
export type ComposeComponentWlProductAimBlockLessonTypesOutlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageAndAdjacentTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlProductAimBlock) */
export type ComposeComponentWlProductAimBlockLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlProductAimBlock) */
export type ComposeComponentWlProductAimBlockSkillsOutlineArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageAndAdjacentTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlProductAimBlock) */
export type ComposeComponentWlProductAimBlockTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentWlProductAimBlockCollection = {
  __typename?: 'ComposeComponentWlProductAimBlockCollection';
  items: Array<Maybe<ComposeComponentWlProductAimBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentWlProductAimBlockCursorCollection = {
  __typename?: 'ComposeComponentWlProductAimBlockCursorCollection';
  items: Array<Maybe<ComposeComponentWlProductAimBlock>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentWlProductAimBlockFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentWlProductAimBlockFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentWlProductAimBlockFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  lessonTypesOutline: InputMaybe<CfComposeComponentImageAndAdjacentTextNestedFilter>;
  lessonTypesOutline_exists: InputMaybe<Scalars['Boolean']['input']>;
  skillsOutline: InputMaybe<CfComposeComponentImageAndAdjacentTextNestedFilter>;
  skillsOutline_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComposeComponentWlProductAimBlockLinkingCollections = {
  __typename?: 'ComposeComponentWlProductAimBlockLinkingCollections';
  composePageWlMarketingHomePageCollection: Maybe<ComposePageWlMarketingHomePageCollection>;
  composePageWlMarketingHomePageCursorCollection: Maybe<ComposePageWlMarketingHomePageCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentWlProductAimBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlProductAimBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentWlProductAimBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlProductAimBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentWlProductAimBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentWlProductAimBlockLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentWlProductAimBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentWlProductAimBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposeComponentWlProductAimBlockOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlTestimonialsBlock) */
export type ComposeComponentWlTestimonialsBlock = Entry & _Node & {
  __typename?: 'ComposeComponentWlTestimonialsBlock';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentWlTestimonialsBlockLinkingCollections>;
  schoolName: Maybe<Scalars['String']['output']>;
  submittedBy: Maybe<Scalars['String']['output']>;
  sys: Sys;
  testimonial: Maybe<ComposeComponentWlTestimonialsBlockTestimonial>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlTestimonialsBlock) */
export type ComposeComponentWlTestimonialsBlockLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlTestimonialsBlock) */
export type ComposeComponentWlTestimonialsBlockSchoolNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlTestimonialsBlock) */
export type ComposeComponentWlTestimonialsBlockSubmittedByArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentWlTestimonialsBlock) */
export type ComposeComponentWlTestimonialsBlockTestimonialArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentWlTestimonialsBlockCollection = {
  __typename?: 'ComposeComponentWlTestimonialsBlockCollection';
  items: Array<Maybe<ComposeComponentWlTestimonialsBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentWlTestimonialsBlockCursorCollection = {
  __typename?: 'ComposeComponentWlTestimonialsBlockCursorCollection';
  items: Array<Maybe<ComposeComponentWlTestimonialsBlock>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentWlTestimonialsBlockFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentWlTestimonialsBlockFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentWlTestimonialsBlockFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  schoolName: InputMaybe<Scalars['String']['input']>;
  schoolName_contains: InputMaybe<Scalars['String']['input']>;
  schoolName_exists: InputMaybe<Scalars['Boolean']['input']>;
  schoolName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schoolName_not: InputMaybe<Scalars['String']['input']>;
  schoolName_not_contains: InputMaybe<Scalars['String']['input']>;
  schoolName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submittedBy: InputMaybe<Scalars['String']['input']>;
  submittedBy_contains: InputMaybe<Scalars['String']['input']>;
  submittedBy_exists: InputMaybe<Scalars['Boolean']['input']>;
  submittedBy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submittedBy_not: InputMaybe<Scalars['String']['input']>;
  submittedBy_not_contains: InputMaybe<Scalars['String']['input']>;
  submittedBy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  testimonial_contains: InputMaybe<Scalars['String']['input']>;
  testimonial_exists: InputMaybe<Scalars['Boolean']['input']>;
  testimonial_not_contains: InputMaybe<Scalars['String']['input']>;
};

export type ComposeComponentWlTestimonialsBlockLinkingCollections = {
  __typename?: 'ComposeComponentWlTestimonialsBlockLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  teacherTestimonialBlockCollection: Maybe<TeacherTestimonialBlockCollection>;
  teacherTestimonialBlockCursorCollection: Maybe<TeacherTestimonialBlockCursorCollection>;
};


export type ComposeComponentWlTestimonialsBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentWlTestimonialsBlockLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentWlTestimonialsBlockLinkingCollectionsTeacherTestimonialBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlTestimonialsBlockLinkingCollectionsTeacherTestimonialBlockCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentWlTestimonialsBlockLinkingCollectionsTeacherTestimonialBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlTestimonialsBlockLinkingCollectionsTeacherTestimonialBlockCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentWlTestimonialsBlockLinkingCollectionsTeacherTestimonialBlockCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentWlTestimonialsBlockLinkingCollectionsTeacherTestimonialBlockCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposeComponentWlTestimonialsBlockOrder {
  SchoolNameAsc = 'schoolName_ASC',
  SchoolNameDesc = 'schoolName_DESC',
  SubmittedByAsc = 'submittedBy_ASC',
  SubmittedByDesc = 'submittedBy_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposeComponentWlTestimonialsBlockTestimonial = {
  __typename?: 'ComposeComponentWlTestimonialsBlockTestimonial';
  json: Scalars['JSON']['output'];
  links: ComposeComponentWlTestimonialsBlockTestimonialLinks;
};

export type ComposeComponentWlTestimonialsBlockTestimonialAssets = {
  __typename?: 'ComposeComponentWlTestimonialsBlockTestimonialAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposeComponentWlTestimonialsBlockTestimonialEntries = {
  __typename?: 'ComposeComponentWlTestimonialsBlockTestimonialEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposeComponentWlTestimonialsBlockTestimonialLinks = {
  __typename?: 'ComposeComponentWlTestimonialsBlockTestimonialLinks';
  assets: ComposeComponentWlTestimonialsBlockTestimonialAssets;
  entries: ComposeComponentWlTestimonialsBlockTestimonialEntries;
  resources: ComposeComponentWlTestimonialsBlockTestimonialResources;
};

export type ComposeComponentWlTestimonialsBlockTestimonialResources = {
  __typename?: 'ComposeComponentWlTestimonialsBlockTestimonialResources';
  block: Array<ComposeComponentWlTestimonialsBlockTestimonialResourcesBlock>;
  hyperlink: Array<ComposeComponentWlTestimonialsBlockTestimonialResourcesHyperlink>;
  inline: Array<ComposeComponentWlTestimonialsBlockTestimonialResourcesInline>;
};

export type ComposeComponentWlTestimonialsBlockTestimonialResourcesBlock = ResourceLink & {
  __typename?: 'ComposeComponentWlTestimonialsBlockTestimonialResourcesBlock';
  sys: ResourceSys;
};

export type ComposeComponentWlTestimonialsBlockTestimonialResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposeComponentWlTestimonialsBlockTestimonialResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposeComponentWlTestimonialsBlockTestimonialResourcesInline = ResourceLink & {
  __typename?: 'ComposeComponentWlTestimonialsBlockTestimonialResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentYoutubeVideo) */
export type ComposeComponentYoutubeVideo = Entry & _Node & {
  __typename?: 'ComposeComponentYoutubeVideo';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposeComponentYoutubeVideoLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
  url: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentYoutubeVideo) */
export type ComposeComponentYoutubeVideoLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentYoutubeVideo) */
export type ComposeComponentYoutubeVideoNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composeComponentYoutubeVideo) */
export type ComposeComponentYoutubeVideoUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposeComponentYoutubeVideoCollection = {
  __typename?: 'ComposeComponentYoutubeVideoCollection';
  items: Array<Maybe<ComposeComponentYoutubeVideo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposeComponentYoutubeVideoCursorCollection = {
  __typename?: 'ComposeComponentYoutubeVideoCursorCollection';
  items: Array<Maybe<ComposeComponentYoutubeVideo>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposeComponentYoutubeVideoFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposeComponentYoutubeVideoFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposeComponentYoutubeVideoFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComposeComponentYoutubeVideoLinkingCollections = {
  __typename?: 'ComposeComponentYoutubeVideoLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposeComponentYoutubeVideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposeComponentYoutubeVideoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposeComponentYoutubeVideoOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticle = Entry & _Node & {
  __typename?: 'ComposePageArticle';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  excerpt: Maybe<ComposePageArticleExcerpt>;
  heading: Maybe<Scalars['String']['output']>;
  heroImage: Maybe<ComposeComponentImage>;
  horizontalImageCtaOverride: Maybe<ComposeComponentHorizontalImageCta>;
  isIndexed: Maybe<Scalars['Boolean']['output']>;
  isNextJsRoutable: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<ComposePageArticleLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  relatedPagesCollection: Maybe<ComposePageArticleRelatedPagesCollection>;
  relatedPagesCursorCollection: Maybe<ComposePageArticleRelatedPagesCursorCollection>;
  richTextBody: Maybe<ComposePageArticleRichTextBody>;
  seoDescription: Maybe<Scalars['String']['output']>;
  seoKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  topic: Maybe<ComposeComponentTopic>;
  topicsCollection: Maybe<ComposePageArticleTopicsCollection>;
  topicsCursorCollection: Maybe<ComposePageArticleTopicsCursorCollection>;
  verticalImageCtaOverride: Maybe<ComposeComponentVerticalImageCta>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleExcerptArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleHeroImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleHorizontalImageCtaOverrideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentHorizontalImageCtaFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleIsIndexedArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleIsNextJsRoutableArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticlePublishedAtArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleRelatedPagesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleRelatedPagesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleRelatedPagesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleRelatedPagesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageArticleFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleRichTextBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleSeoDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleSeoKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleTopicArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleTopicsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleTopicsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleTopicsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleTopicsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticle) */
export type ComposePageArticleVerticalImageCtaOverrideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentVerticalImageCtaFilter>;
};

export type ComposePageArticleCollection = {
  __typename?: 'ComposePageArticleCollection';
  items: Array<Maybe<ComposePageArticle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposePageArticleCursorCollection = {
  __typename?: 'ComposePageArticleCursorCollection';
  items: Array<Maybe<ComposePageArticle>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposePageArticleExcerpt = {
  __typename?: 'ComposePageArticleExcerpt';
  json: Scalars['JSON']['output'];
  links: ComposePageArticleExcerptLinks;
};

export type ComposePageArticleExcerptAssets = {
  __typename?: 'ComposePageArticleExcerptAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposePageArticleExcerptEntries = {
  __typename?: 'ComposePageArticleExcerptEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposePageArticleExcerptLinks = {
  __typename?: 'ComposePageArticleExcerptLinks';
  assets: ComposePageArticleExcerptAssets;
  entries: ComposePageArticleExcerptEntries;
  resources: ComposePageArticleExcerptResources;
};

export type ComposePageArticleExcerptResources = {
  __typename?: 'ComposePageArticleExcerptResources';
  block: Array<ComposePageArticleExcerptResourcesBlock>;
  hyperlink: Array<ComposePageArticleExcerptResourcesHyperlink>;
  inline: Array<ComposePageArticleExcerptResourcesInline>;
};

export type ComposePageArticleExcerptResourcesBlock = ResourceLink & {
  __typename?: 'ComposePageArticleExcerptResourcesBlock';
  sys: ResourceSys;
};

export type ComposePageArticleExcerptResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposePageArticleExcerptResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposePageArticleExcerptResourcesInline = ResourceLink & {
  __typename?: 'ComposePageArticleExcerptResourcesInline';
  sys: ResourceSys;
};

export type ComposePageArticleFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposePageArticleFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposePageArticleFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  excerpt_contains: InputMaybe<Scalars['String']['input']>;
  excerpt_exists: InputMaybe<Scalars['Boolean']['input']>;
  excerpt_not_contains: InputMaybe<Scalars['String']['input']>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImage: InputMaybe<CfComposeComponentImageNestedFilter>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  horizontalImageCtaOverride: InputMaybe<CfComposeComponentHorizontalImageCtaNestedFilter>;
  horizontalImageCtaOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  isIndexed: InputMaybe<Scalars['Boolean']['input']>;
  isIndexed_exists: InputMaybe<Scalars['Boolean']['input']>;
  isIndexed_not: InputMaybe<Scalars['Boolean']['input']>;
  isNextJsRoutable: InputMaybe<Scalars['Boolean']['input']>;
  isNextJsRoutable_exists: InputMaybe<Scalars['Boolean']['input']>;
  isNextJsRoutable_not: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  relatedPages: InputMaybe<CfComposePageArticleNestedFilter>;
  relatedPagesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  richTextBody_contains: InputMaybe<Scalars['String']['input']>;
  richTextBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  richTextBody_not_contains: InputMaybe<Scalars['String']['input']>;
  seoDescription: InputMaybe<Scalars['String']['input']>;
  seoDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoDescription_not: InputMaybe<Scalars['String']['input']>;
  seoDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  topic: InputMaybe<CfComposeComponentTopicNestedFilter>;
  topic_exists: InputMaybe<Scalars['Boolean']['input']>;
  topics: InputMaybe<CfComposeComponentTopicNestedFilter>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  verticalImageCtaOverride: InputMaybe<CfComposeComponentVerticalImageCtaNestedFilter>;
  verticalImageCtaOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposePageArticleLinkingCollections = {
  __typename?: 'ComposePageArticleLinkingCollections';
  composeComponentFeaturedArticleCollection: Maybe<ComposeComponentFeaturedArticleCollection>;
  composeComponentFeaturedArticleCursorCollection: Maybe<ComposeComponentFeaturedArticleCursorCollection>;
  composeComponentLinkCollection: Maybe<ComposeComponentLinkCollection>;
  composeComponentLinkCursorCollection: Maybe<ComposeComponentLinkCursorCollection>;
  composeComponentPopularArticlesCollection: Maybe<ComposeComponentPopularArticlesCollection>;
  composeComponentPopularArticlesCursorCollection: Maybe<ComposeComponentPopularArticlesCursorCollection>;
  composePageArticleCollection: Maybe<ComposePageArticleCollection>;
  composePageArticleCursorCollection: Maybe<ComposePageArticleCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposePageArticleLinkingCollectionsComposeComponentFeaturedArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleLinkingCollectionsComposeComponentFeaturedArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageArticleLinkingCollectionsComposeComponentFeaturedArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleLinkingCollectionsComposeComponentFeaturedArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageArticleLinkingCollectionsComposeComponentLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleLinkingCollectionsComposeComponentLinkCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageArticleLinkingCollectionsComposeComponentLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleLinkingCollectionsComposeComponentLinkCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageArticleLinkingCollectionsComposeComponentPopularArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleLinkingCollectionsComposeComponentPopularArticlesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageArticleLinkingCollectionsComposeComponentPopularArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleLinkingCollectionsComposeComponentPopularArticlesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageArticleLinkingCollectionsComposePageArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleLinkingCollectionsComposePageArticleCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageArticleLinkingCollectionsComposePageArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleLinkingCollectionsComposePageArticleCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageArticleLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageArticleLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposePageArticleLinkingCollectionsComposeComponentFeaturedArticleCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposePageArticleLinkingCollectionsComposeComponentFeaturedArticleCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposePageArticleLinkingCollectionsComposeComponentLinkCollectionOrder {
  OpensInANewTabAsc = 'opensInANewTab_ASC',
  OpensInANewTabDesc = 'opensInANewTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposePageArticleLinkingCollectionsComposeComponentLinkCursorCollectionOrder {
  OpensInANewTabAsc = 'opensInANewTab_ASC',
  OpensInANewTabDesc = 'opensInANewTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum ComposePageArticleLinkingCollectionsComposeComponentPopularArticlesCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposePageArticleLinkingCollectionsComposeComponentPopularArticlesCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposePageArticleLinkingCollectionsComposePageArticleCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposePageArticleLinkingCollectionsComposePageArticleCursorCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ComposePageArticleOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposePageArticleRelatedPagesCollection = {
  __typename?: 'ComposePageArticleRelatedPagesCollection';
  items: Array<Maybe<ComposePageArticle>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComposePageArticleRelatedPagesCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposePageArticleRelatedPagesCursorCollection = {
  __typename?: 'ComposePageArticleRelatedPagesCursorCollection';
  items: Array<Maybe<ComposePageArticle>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComposePageArticleRelatedPagesCursorCollectionOrder {
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  IsIndexedAsc = 'isIndexed_ASC',
  IsIndexedDesc = 'isIndexed_DESC',
  IsNextJsRoutableAsc = 'isNextJsRoutable_ASC',
  IsNextJsRoutableDesc = 'isNextJsRoutable_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposePageArticleRichTextBody = {
  __typename?: 'ComposePageArticleRichTextBody';
  json: Scalars['JSON']['output'];
  links: ComposePageArticleRichTextBodyLinks;
};

export type ComposePageArticleRichTextBodyAssets = {
  __typename?: 'ComposePageArticleRichTextBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ComposePageArticleRichTextBodyEntries = {
  __typename?: 'ComposePageArticleRichTextBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ComposePageArticleRichTextBodyLinks = {
  __typename?: 'ComposePageArticleRichTextBodyLinks';
  assets: ComposePageArticleRichTextBodyAssets;
  entries: ComposePageArticleRichTextBodyEntries;
  resources: ComposePageArticleRichTextBodyResources;
};

export type ComposePageArticleRichTextBodyResources = {
  __typename?: 'ComposePageArticleRichTextBodyResources';
  block: Array<ComposePageArticleRichTextBodyResourcesBlock>;
  hyperlink: Array<ComposePageArticleRichTextBodyResourcesHyperlink>;
  inline: Array<ComposePageArticleRichTextBodyResourcesInline>;
};

export type ComposePageArticleRichTextBodyResourcesBlock = ResourceLink & {
  __typename?: 'ComposePageArticleRichTextBodyResourcesBlock';
  sys: ResourceSys;
};

export type ComposePageArticleRichTextBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'ComposePageArticleRichTextBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type ComposePageArticleRichTextBodyResourcesInline = ResourceLink & {
  __typename?: 'ComposePageArticleRichTextBodyResourcesInline';
  sys: ResourceSys;
};

export type ComposePageArticleTopicsCollection = {
  __typename?: 'ComposePageArticleTopicsCollection';
  items: Array<Maybe<ComposeComponentTopic>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum ComposePageArticleTopicsCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ComposePageArticleTopicsCursorCollection = {
  __typename?: 'ComposePageArticleTopicsCursorCollection';
  items: Array<Maybe<ComposeComponentTopic>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum ComposePageArticleTopicsCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticlesIndexPage) */
export type ComposePageArticlesIndexPage = Entry & _Node & {
  __typename?: 'ComposePageArticlesIndexPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<ComposePageArticlesIndexPageLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  seoDescription: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticlesIndexPage) */
export type ComposePageArticlesIndexPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticlesIndexPage) */
export type ComposePageArticlesIndexPageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageArticlesIndexPage) */
export type ComposePageArticlesIndexPageSeoDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposePageArticlesIndexPageCollection = {
  __typename?: 'ComposePageArticlesIndexPageCollection';
  items: Array<Maybe<ComposePageArticlesIndexPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposePageArticlesIndexPageCursorCollection = {
  __typename?: 'ComposePageArticlesIndexPageCursorCollection';
  items: Array<Maybe<ComposePageArticlesIndexPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposePageArticlesIndexPageFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposePageArticlesIndexPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposePageArticlesIndexPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoDescription: InputMaybe<Scalars['String']['input']>;
  seoDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoDescription_not: InputMaybe<Scalars['String']['input']>;
  seoDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ComposePageArticlesIndexPageLinkingCollections = {
  __typename?: 'ComposePageArticlesIndexPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposePageArticlesIndexPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageArticlesIndexPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposePageArticlesIndexPageOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SeoDescriptionAsc = 'seoDescription_ASC',
  SeoDescriptionDesc = 'seoDescription_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageWlMarketingHomePage) */
export type ComposePageWlMarketingHomePage = Entry & _Node & {
  __typename?: 'ComposePageWlMarketingHomePage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  footerBlock: Maybe<ComposeComponentWlFooterBlock>;
  freeTrialBlock: Maybe<WritingLegendsFreeTrialBlock>;
  linkedFrom: Maybe<ComposePageWlMarketingHomePageLinkingCollections>;
  missionStatementBlock: Maybe<ComposeComponentImageAndAdjacentText>;
  productAimBlock: Maybe<ComposeComponentWlProductAimBlock>;
  sys: Sys;
  teacherSupportStatementBlock: Maybe<ComposeComponentTeacherSupportStatement>;
  testimonialsBlock: Maybe<TeacherTestimonialBlock>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageWlMarketingHomePage) */
export type ComposePageWlMarketingHomePageFooterBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentWlFooterBlockFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageWlMarketingHomePage) */
export type ComposePageWlMarketingHomePageFreeTrialBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsFreeTrialBlockFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageWlMarketingHomePage) */
export type ComposePageWlMarketingHomePageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageWlMarketingHomePage) */
export type ComposePageWlMarketingHomePageMissionStatementBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageAndAdjacentTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageWlMarketingHomePage) */
export type ComposePageWlMarketingHomePageProductAimBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentWlProductAimBlockFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageWlMarketingHomePage) */
export type ComposePageWlMarketingHomePageTeacherSupportStatementBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTeacherSupportStatementFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/composePageWlMarketingHomePage) */
export type ComposePageWlMarketingHomePageTestimonialsBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TeacherTestimonialBlockFilter>;
};

export type ComposePageWlMarketingHomePageCollection = {
  __typename?: 'ComposePageWlMarketingHomePageCollection';
  items: Array<Maybe<ComposePageWlMarketingHomePage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ComposePageWlMarketingHomePageCursorCollection = {
  __typename?: 'ComposePageWlMarketingHomePageCursorCollection';
  items: Array<Maybe<ComposePageWlMarketingHomePage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ComposePageWlMarketingHomePageFilter = {
  AND: InputMaybe<Array<InputMaybe<ComposePageWlMarketingHomePageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ComposePageWlMarketingHomePageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  footerBlock: InputMaybe<CfComposeComponentWlFooterBlockNestedFilter>;
  footerBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  freeTrialBlock: InputMaybe<CfWritingLegendsFreeTrialBlockNestedFilter>;
  freeTrialBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  missionStatementBlock: InputMaybe<CfComposeComponentImageAndAdjacentTextNestedFilter>;
  missionStatementBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  productAimBlock: InputMaybe<CfComposeComponentWlProductAimBlockNestedFilter>;
  productAimBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  teacherSupportStatementBlock: InputMaybe<CfComposeComponentTeacherSupportStatementNestedFilter>;
  teacherSupportStatementBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  testimonialsBlock: InputMaybe<CfTeacherTestimonialBlockNestedFilter>;
  testimonialsBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type ComposePageWlMarketingHomePageLinkingCollections = {
  __typename?: 'ComposePageWlMarketingHomePageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ComposePageWlMarketingHomePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ComposePageWlMarketingHomePageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ComposePageWlMarketingHomePageOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type ContentfulMetadata = {
  __typename?: 'ContentfulMetadata';
  concepts: Array<Maybe<TaxonomyConcept>>;
  tags: Array<Maybe<ContentfulTag>>;
};

export type ContentfulMetadataConceptsDescendantsFilter = {
  id_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataConceptsFilter = {
  descendants: InputMaybe<ContentfulMetadataConceptsDescendantsFilter>;
  id_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ContentfulMetadataFilter = {
  concepts: InputMaybe<ContentfulMetadataConceptsFilter>;
  concepts_exists: InputMaybe<Scalars['Boolean']['input']>;
  tags: InputMaybe<ContentfulMetadataTagsFilter>;
  tags_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContentfulMetadataTagsFilter = {
  id_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/**
 * Represents a tag entity for finding and organizing content easily.
 *       Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-tags
 */
export type ContentfulTag = {
  __typename?: 'ContentfulTag';
  id: Maybe<Scalars['String']['output']>;
  name: Maybe<Scalars['String']['output']>;
};

export type CursorPages = {
  __typename?: 'CursorPages';
  next: Maybe<Scalars['String']['output']>;
  prev: Maybe<Scalars['String']['output']>;
};

export type Entry = {
  contentfulMetadata: ContentfulMetadata;
  sys: Sys;
};

export type EntryCollection = {
  __typename?: 'EntryCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type EntryCursorCollection = {
  __typename?: 'EntryCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type EntryFilter = {
  AND: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  OR: InputMaybe<Array<InputMaybe<EntryFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export enum EntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/getReadyForBigSchoolList) */
export type GetReadyForBigSchoolList = Entry & _Node & {
  __typename?: 'GetReadyForBigSchoolList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  groupsCollection: Maybe<GetReadyForBigSchoolListGroupsCollection>;
  groupsCursorCollection: Maybe<GetReadyForBigSchoolListGroupsCursorCollection>;
  linkedFrom: Maybe<GetReadyForBigSchoolListLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/getReadyForBigSchoolList) */
export type GetReadyForBigSchoolListGroupsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GetReadyForBigSchoolListGroupsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<BigSchoolResourceListFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/getReadyForBigSchoolList) */
export type GetReadyForBigSchoolListGroupsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GetReadyForBigSchoolListGroupsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<BigSchoolResourceListFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/getReadyForBigSchoolList) */
export type GetReadyForBigSchoolListLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/getReadyForBigSchoolList) */
export type GetReadyForBigSchoolListTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type GetReadyForBigSchoolListCollection = {
  __typename?: 'GetReadyForBigSchoolListCollection';
  items: Array<Maybe<GetReadyForBigSchoolList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type GetReadyForBigSchoolListCursorCollection = {
  __typename?: 'GetReadyForBigSchoolListCursorCollection';
  items: Array<Maybe<GetReadyForBigSchoolList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type GetReadyForBigSchoolListFilter = {
  AND: InputMaybe<Array<InputMaybe<GetReadyForBigSchoolListFilter>>>;
  OR: InputMaybe<Array<InputMaybe<GetReadyForBigSchoolListFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  groups: InputMaybe<CfBigSchoolResourceListNestedFilter>;
  groupsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetReadyForBigSchoolListGroupsCollection = {
  __typename?: 'GetReadyForBigSchoolListGroupsCollection';
  items: Array<Maybe<BigSchoolResourceList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum GetReadyForBigSchoolListGroupsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GetReadyForBigSchoolListGroupsCursorCollection = {
  __typename?: 'GetReadyForBigSchoolListGroupsCursorCollection';
  items: Array<Maybe<BigSchoolResourceList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum GetReadyForBigSchoolListGroupsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type GetReadyForBigSchoolListLinkingCollections = {
  __typename?: 'GetReadyForBigSchoolListLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type GetReadyForBigSchoolListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type GetReadyForBigSchoolListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum GetReadyForBigSchoolListOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxGuides) */
export type HomeschoolMaxGuides = Entry & _Node & {
  __typename?: 'HomeschoolMaxGuides';
  _id: Scalars['ID']['output'];
  assetDescription: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  internalAssetName: Maybe<Scalars['String']['output']>;
  isUserGuide: Maybe<Scalars['Boolean']['output']>;
  isVisible: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<HomeschoolMaxGuidesLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  pdf: Maybe<Asset>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  thumbnail: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxGuides) */
export type HomeschoolMaxGuidesAssetDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxGuides) */
export type HomeschoolMaxGuidesInternalAssetNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxGuides) */
export type HomeschoolMaxGuidesIsUserGuideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxGuides) */
export type HomeschoolMaxGuidesIsVisibleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxGuides) */
export type HomeschoolMaxGuidesLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxGuides) */
export type HomeschoolMaxGuidesNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxGuides) */
export type HomeschoolMaxGuidesPdfArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxGuides) */
export type HomeschoolMaxGuidesSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxGuides) */
export type HomeschoolMaxGuidesThumbnailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeschoolMaxGuidesCollection = {
  __typename?: 'HomeschoolMaxGuidesCollection';
  items: Array<Maybe<HomeschoolMaxGuides>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HomeschoolMaxGuidesCursorCollection = {
  __typename?: 'HomeschoolMaxGuidesCursorCollection';
  items: Array<Maybe<HomeschoolMaxGuides>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HomeschoolMaxGuidesFilter = {
  AND: InputMaybe<Array<InputMaybe<HomeschoolMaxGuidesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HomeschoolMaxGuidesFilter>>>;
  assetDescription: InputMaybe<Scalars['String']['input']>;
  assetDescription_contains: InputMaybe<Scalars['String']['input']>;
  assetDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  assetDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assetDescription_not: InputMaybe<Scalars['String']['input']>;
  assetDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  assetDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalAssetName: InputMaybe<Scalars['String']['input']>;
  internalAssetName_contains: InputMaybe<Scalars['String']['input']>;
  internalAssetName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalAssetName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalAssetName_not: InputMaybe<Scalars['String']['input']>;
  internalAssetName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalAssetName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isUserGuide: InputMaybe<Scalars['Boolean']['input']>;
  isUserGuide_exists: InputMaybe<Scalars['Boolean']['input']>;
  isUserGuide_not: InputMaybe<Scalars['Boolean']['input']>;
  isVisible: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_exists: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_not: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdf_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnail_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeschoolMaxGuidesLinkingCollections = {
  __typename?: 'HomeschoolMaxGuidesLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type HomeschoolMaxGuidesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HomeschoolMaxGuidesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HomeschoolMaxGuidesOrder {
  AssetDescriptionAsc = 'assetDescription_ASC',
  AssetDescriptionDesc = 'assetDescription_DESC',
  InternalAssetNameAsc = 'internalAssetName_ASC',
  InternalAssetNameDesc = 'internalAssetName_DESC',
  IsUserGuideAsc = 'isUserGuide_ASC',
  IsUserGuideDesc = 'isUserGuide_DESC',
  IsVisibleAsc = 'isVisible_ASC',
  IsVisibleDesc = 'isVisible_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxWebinar) */
export type HomeschoolMaxWebinar = Entry & _Node & {
  __typename?: 'HomeschoolMaxWebinar';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<HomeschoolMaxWebinarLinkingCollections>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  thumbnail: Maybe<Asset>;
  transcript: Maybe<Asset>;
  webinarOverview: Maybe<HomeschoolMaxWebinarWebinarOverview>;
  webinarTitle: Maybe<Scalars['String']['output']>;
  webinarVideo: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxWebinar) */
export type HomeschoolMaxWebinarInternalTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxWebinar) */
export type HomeschoolMaxWebinarLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxWebinar) */
export type HomeschoolMaxWebinarShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxWebinar) */
export type HomeschoolMaxWebinarSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxWebinar) */
export type HomeschoolMaxWebinarThumbnailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxWebinar) */
export type HomeschoolMaxWebinarTranscriptArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxWebinar) */
export type HomeschoolMaxWebinarWebinarOverviewArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxWebinar) */
export type HomeschoolMaxWebinarWebinarTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolMaxWebinar) */
export type HomeschoolMaxWebinarWebinarVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeschoolMaxWebinarCollection = {
  __typename?: 'HomeschoolMaxWebinarCollection';
  items: Array<Maybe<HomeschoolMaxWebinar>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HomeschoolMaxWebinarCursorCollection = {
  __typename?: 'HomeschoolMaxWebinarCursorCollection';
  items: Array<Maybe<HomeschoolMaxWebinar>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HomeschoolMaxWebinarFilter = {
  AND: InputMaybe<Array<InputMaybe<HomeschoolMaxWebinarFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HomeschoolMaxWebinarFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnail_exists: InputMaybe<Scalars['Boolean']['input']>;
  transcript_exists: InputMaybe<Scalars['Boolean']['input']>;
  webinarOverview_contains: InputMaybe<Scalars['String']['input']>;
  webinarOverview_exists: InputMaybe<Scalars['Boolean']['input']>;
  webinarOverview_not_contains: InputMaybe<Scalars['String']['input']>;
  webinarTitle: InputMaybe<Scalars['String']['input']>;
  webinarTitle_contains: InputMaybe<Scalars['String']['input']>;
  webinarTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  webinarTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  webinarTitle_not: InputMaybe<Scalars['String']['input']>;
  webinarTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  webinarTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  webinarVideo_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeschoolMaxWebinarLinkingCollections = {
  __typename?: 'HomeschoolMaxWebinarLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type HomeschoolMaxWebinarLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HomeschoolMaxWebinarLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HomeschoolMaxWebinarOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  WebinarTitleAsc = 'webinarTitle_ASC',
  WebinarTitleDesc = 'webinarTitle_DESC'
}

export type HomeschoolMaxWebinarWebinarOverview = {
  __typename?: 'HomeschoolMaxWebinarWebinarOverview';
  json: Scalars['JSON']['output'];
  links: HomeschoolMaxWebinarWebinarOverviewLinks;
};

export type HomeschoolMaxWebinarWebinarOverviewAssets = {
  __typename?: 'HomeschoolMaxWebinarWebinarOverviewAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HomeschoolMaxWebinarWebinarOverviewEntries = {
  __typename?: 'HomeschoolMaxWebinarWebinarOverviewEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HomeschoolMaxWebinarWebinarOverviewLinks = {
  __typename?: 'HomeschoolMaxWebinarWebinarOverviewLinks';
  assets: HomeschoolMaxWebinarWebinarOverviewAssets;
  entries: HomeschoolMaxWebinarWebinarOverviewEntries;
  resources: HomeschoolMaxWebinarWebinarOverviewResources;
};

export type HomeschoolMaxWebinarWebinarOverviewResources = {
  __typename?: 'HomeschoolMaxWebinarWebinarOverviewResources';
  block: Array<HomeschoolMaxWebinarWebinarOverviewResourcesBlock>;
  hyperlink: Array<HomeschoolMaxWebinarWebinarOverviewResourcesHyperlink>;
  inline: Array<HomeschoolMaxWebinarWebinarOverviewResourcesInline>;
};

export type HomeschoolMaxWebinarWebinarOverviewResourcesBlock = ResourceLink & {
  __typename?: 'HomeschoolMaxWebinarWebinarOverviewResourcesBlock';
  sys: ResourceSys;
};

export type HomeschoolMaxWebinarWebinarOverviewResourcesHyperlink = ResourceLink & {
  __typename?: 'HomeschoolMaxWebinarWebinarOverviewResourcesHyperlink';
  sys: ResourceSys;
};

export type HomeschoolMaxWebinarWebinarOverviewResourcesInline = ResourceLink & {
  __typename?: 'HomeschoolMaxWebinarWebinarOverviewResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusGuides) */
export type HomeschoolPlusGuides = Entry & _Node & {
  __typename?: 'HomeschoolPlusGuides';
  _id: Scalars['ID']['output'];
  assetDescription: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  internalAssetName: Maybe<Scalars['String']['output']>;
  isVisible: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<HomeschoolPlusGuidesLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  pdf: Maybe<Asset>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  thumbnail: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusGuides) */
export type HomeschoolPlusGuidesAssetDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusGuides) */
export type HomeschoolPlusGuidesInternalAssetNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusGuides) */
export type HomeschoolPlusGuidesIsVisibleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusGuides) */
export type HomeschoolPlusGuidesLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusGuides) */
export type HomeschoolPlusGuidesNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusGuides) */
export type HomeschoolPlusGuidesPdfArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusGuides) */
export type HomeschoolPlusGuidesSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusGuides) */
export type HomeschoolPlusGuidesThumbnailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeschoolPlusGuidesCollection = {
  __typename?: 'HomeschoolPlusGuidesCollection';
  items: Array<Maybe<HomeschoolPlusGuides>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HomeschoolPlusGuidesCursorCollection = {
  __typename?: 'HomeschoolPlusGuidesCursorCollection';
  items: Array<Maybe<HomeschoolPlusGuides>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HomeschoolPlusGuidesFilter = {
  AND: InputMaybe<Array<InputMaybe<HomeschoolPlusGuidesFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HomeschoolPlusGuidesFilter>>>;
  assetDescription: InputMaybe<Scalars['String']['input']>;
  assetDescription_contains: InputMaybe<Scalars['String']['input']>;
  assetDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  assetDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  assetDescription_not: InputMaybe<Scalars['String']['input']>;
  assetDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  assetDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalAssetName: InputMaybe<Scalars['String']['input']>;
  internalAssetName_contains: InputMaybe<Scalars['String']['input']>;
  internalAssetName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalAssetName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalAssetName_not: InputMaybe<Scalars['String']['input']>;
  internalAssetName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalAssetName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isVisible: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_exists: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_not: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdf_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnail_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeschoolPlusGuidesLinkingCollections = {
  __typename?: 'HomeschoolPlusGuidesLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type HomeschoolPlusGuidesLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HomeschoolPlusGuidesLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HomeschoolPlusGuidesOrder {
  AssetDescriptionAsc = 'assetDescription_ASC',
  AssetDescriptionDesc = 'assetDescription_DESC',
  InternalAssetNameAsc = 'internalAssetName_ASC',
  InternalAssetNameDesc = 'internalAssetName_DESC',
  IsVisibleAsc = 'isVisible_ASC',
  IsVisibleDesc = 'isVisible_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusWebinar) */
export type HomeschoolPlusWebinar = Entry & _Node & {
  __typename?: 'HomeschoolPlusWebinar';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<HomeschoolPlusWebinarLinkingCollections>;
  shortDescription: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  sys: Sys;
  thumbnail: Maybe<Asset>;
  transcript: Maybe<Asset>;
  webinarOverview: Maybe<HomeschoolPlusWebinarWebinarOverview>;
  webinarTitle: Maybe<Scalars['String']['output']>;
  webinarVideo: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusWebinar) */
export type HomeschoolPlusWebinarInternalTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusWebinar) */
export type HomeschoolPlusWebinarLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusWebinar) */
export type HomeschoolPlusWebinarShortDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusWebinar) */
export type HomeschoolPlusWebinarSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusWebinar) */
export type HomeschoolPlusWebinarThumbnailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusWebinar) */
export type HomeschoolPlusWebinarTranscriptArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusWebinar) */
export type HomeschoolPlusWebinarWebinarOverviewArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusWebinar) */
export type HomeschoolPlusWebinarWebinarTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolPlusWebinar) */
export type HomeschoolPlusWebinarWebinarVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeschoolPlusWebinarCollection = {
  __typename?: 'HomeschoolPlusWebinarCollection';
  items: Array<Maybe<HomeschoolPlusWebinar>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HomeschoolPlusWebinarCursorCollection = {
  __typename?: 'HomeschoolPlusWebinarCursorCollection';
  items: Array<Maybe<HomeschoolPlusWebinar>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HomeschoolPlusWebinarFilter = {
  AND: InputMaybe<Array<InputMaybe<HomeschoolPlusWebinarFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HomeschoolPlusWebinarFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription: InputMaybe<Scalars['String']['input']>;
  shortDescription_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  shortDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shortDescription_not: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  shortDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnail_exists: InputMaybe<Scalars['Boolean']['input']>;
  transcript_exists: InputMaybe<Scalars['Boolean']['input']>;
  webinarOverview_contains: InputMaybe<Scalars['String']['input']>;
  webinarOverview_exists: InputMaybe<Scalars['Boolean']['input']>;
  webinarOverview_not_contains: InputMaybe<Scalars['String']['input']>;
  webinarTitle: InputMaybe<Scalars['String']['input']>;
  webinarTitle_contains: InputMaybe<Scalars['String']['input']>;
  webinarTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  webinarTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  webinarTitle_not: InputMaybe<Scalars['String']['input']>;
  webinarTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  webinarTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  webinarVideo_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeschoolPlusWebinarLinkingCollections = {
  __typename?: 'HomeschoolPlusWebinarLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type HomeschoolPlusWebinarLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HomeschoolPlusWebinarLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HomeschoolPlusWebinarOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  ShortDescriptionAsc = 'shortDescription_ASC',
  ShortDescriptionDesc = 'shortDescription_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  WebinarTitleAsc = 'webinarTitle_ASC',
  WebinarTitleDesc = 'webinarTitle_DESC'
}

export type HomeschoolPlusWebinarWebinarOverview = {
  __typename?: 'HomeschoolPlusWebinarWebinarOverview';
  json: Scalars['JSON']['output'];
  links: HomeschoolPlusWebinarWebinarOverviewLinks;
};

export type HomeschoolPlusWebinarWebinarOverviewAssets = {
  __typename?: 'HomeschoolPlusWebinarWebinarOverviewAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type HomeschoolPlusWebinarWebinarOverviewEntries = {
  __typename?: 'HomeschoolPlusWebinarWebinarOverviewEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type HomeschoolPlusWebinarWebinarOverviewLinks = {
  __typename?: 'HomeschoolPlusWebinarWebinarOverviewLinks';
  assets: HomeschoolPlusWebinarWebinarOverviewAssets;
  entries: HomeschoolPlusWebinarWebinarOverviewEntries;
  resources: HomeschoolPlusWebinarWebinarOverviewResources;
};

export type HomeschoolPlusWebinarWebinarOverviewResources = {
  __typename?: 'HomeschoolPlusWebinarWebinarOverviewResources';
  block: Array<HomeschoolPlusWebinarWebinarOverviewResourcesBlock>;
  hyperlink: Array<HomeschoolPlusWebinarWebinarOverviewResourcesHyperlink>;
  inline: Array<HomeschoolPlusWebinarWebinarOverviewResourcesInline>;
};

export type HomeschoolPlusWebinarWebinarOverviewResourcesBlock = ResourceLink & {
  __typename?: 'HomeschoolPlusWebinarWebinarOverviewResourcesBlock';
  sys: ResourceSys;
};

export type HomeschoolPlusWebinarWebinarOverviewResourcesHyperlink = ResourceLink & {
  __typename?: 'HomeschoolPlusWebinarWebinarOverviewResourcesHyperlink';
  sys: ResourceSys;
};

export type HomeschoolPlusWebinarWebinarOverviewResourcesInline = ResourceLink & {
  __typename?: 'HomeschoolPlusWebinarWebinarOverviewResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolProgram) */
export type HomeschoolProgram = Entry & _Node & {
  __typename?: 'HomeschoolProgram';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  internalAssetName: Maybe<Scalars['String']['output']>;
  isVisible: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<HomeschoolProgramLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  pdf: Maybe<Asset>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  thumbnail: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolProgram) */
export type HomeschoolProgramInternalAssetNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolProgram) */
export type HomeschoolProgramIsVisibleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolProgram) */
export type HomeschoolProgramLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolProgram) */
export type HomeschoolProgramNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolProgram) */
export type HomeschoolProgramPdfArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolProgram) */
export type HomeschoolProgramSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/homeschoolProgram) */
export type HomeschoolProgramThumbnailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeschoolProgramCollection = {
  __typename?: 'HomeschoolProgramCollection';
  items: Array<Maybe<HomeschoolProgram>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type HomeschoolProgramCursorCollection = {
  __typename?: 'HomeschoolProgramCursorCollection';
  items: Array<Maybe<HomeschoolProgram>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type HomeschoolProgramFilter = {
  AND: InputMaybe<Array<InputMaybe<HomeschoolProgramFilter>>>;
  OR: InputMaybe<Array<InputMaybe<HomeschoolProgramFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalAssetName: InputMaybe<Scalars['String']['input']>;
  internalAssetName_contains: InputMaybe<Scalars['String']['input']>;
  internalAssetName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalAssetName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalAssetName_not: InputMaybe<Scalars['String']['input']>;
  internalAssetName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalAssetName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isVisible: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_exists: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_not: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdf_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnail_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeschoolProgramLinkingCollections = {
  __typename?: 'HomeschoolProgramLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type HomeschoolProgramLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type HomeschoolProgramLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum HomeschoolProgramOrder {
  InternalAssetNameAsc = 'internalAssetName_ASC',
  InternalAssetNameDesc = 'internalAssetName_DESC',
  IsVisibleAsc = 'isVisible_ASC',
  IsVisibleDesc = 'isVisible_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ImageFormat {
  /** AVIF image format. */
  Avif = 'AVIF',
  /** JPG image format. */
  Jpg = 'JPG',
  /**
   * Progressive JPG format stores multiple passes of an image in progressively higher detail.
   *         When a progressive image is loading, the viewer will first see a lower quality pixelated version which
   *         will gradually improve in detail, until the image is fully downloaded. This is to display an image as
   *         early as possible to make the layout look as designed.
   */
  JpgProgressive = 'JPG_PROGRESSIVE',
  /** PNG image format */
  Png = 'PNG',
  /**
   * 8-bit PNG images support up to 256 colors and weigh less than the standard 24-bit PNG equivalent.
   *         The 8-bit PNG format is mostly used for simple images, such as icons or logos.
   */
  Png8 = 'PNG8',
  /** WebP image format. */
  Webp = 'WEBP'
}

export enum ImageResizeFocus {
  /** Focus the resizing on the bottom. */
  Bottom = 'BOTTOM',
  /** Focus the resizing on the bottom left. */
  BottomLeft = 'BOTTOM_LEFT',
  /** Focus the resizing on the bottom right. */
  BottomRight = 'BOTTOM_RIGHT',
  /** Focus the resizing on the center. */
  Center = 'CENTER',
  /** Focus the resizing on the largest face. */
  Face = 'FACE',
  /** Focus the resizing on the area containing all the faces. */
  Faces = 'FACES',
  /** Focus the resizing on the left. */
  Left = 'LEFT',
  /** Focus the resizing on the right. */
  Right = 'RIGHT',
  /** Focus the resizing on the top. */
  Top = 'TOP',
  /** Focus the resizing on the top left. */
  TopLeft = 'TOP_LEFT',
  /** Focus the resizing on the top right. */
  TopRight = 'TOP_RIGHT'
}

export enum ImageResizeStrategy {
  /** Crops a part of the original image to fit into the specified dimensions. */
  Crop = 'CROP',
  /** Resizes the image to the specified dimensions, cropping the image if needed. */
  Fill = 'FILL',
  /** Resizes the image to fit into the specified dimensions. */
  Fit = 'FIT',
  /**
   * Resizes the image to the specified dimensions, padding the image if needed.
   *         Uses desired background color as padding color.
   */
  Pad = 'PAD',
  /** Resizes the image to the specified dimensions, changing the original aspect ratio if needed. */
  Scale = 'SCALE',
  /** Creates a thumbnail from the image. */
  Thumb = 'THUMB'
}

export type ImageTransformOptions = {
  /**
   * Desired background color, used with corner radius or `PAD` resize strategy.
   *         Defaults to transparent (for `PNG`, `PNG8` and `WEBP`) or white (for `JPG` and `JPG_PROGRESSIVE`).
   */
  backgroundColor: InputMaybe<Scalars['HexColor']['input']>;
  /**
   * Desired corner radius in pixels.
   *         Results in an image with rounded corners (pass `-1` for a full circle/ellipse).
   *         Defaults to `0`. Uses desired background color as padding color,
   *         unless the format is `JPG` or `JPG_PROGRESSIVE` and resize strategy is `PAD`, then defaults to white.
   */
  cornerRadius: InputMaybe<Scalars['Int']['input']>;
  /** Desired image format. Defaults to the original image format. */
  format: InputMaybe<ImageFormat>;
  /** Desired height in pixels. Defaults to the original image height. */
  height: InputMaybe<Scalars['Dimension']['input']>;
  /**
   * Desired quality of the image in percents.
   *         Used for `PNG8`, `JPG`, `JPG_PROGRESSIVE` and `WEBP` formats.
   */
  quality: InputMaybe<Scalars['Quality']['input']>;
  /** Desired resize focus area. Defaults to `CENTER`. */
  resizeFocus: InputMaybe<ImageResizeFocus>;
  /** Desired resize strategy. Defaults to `FIT`. */
  resizeStrategy: InputMaybe<ImageResizeStrategy>;
  /** Desired width in pixels. Defaults to the original image width. */
  width: InputMaybe<Scalars['Dimension']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/jumpLink) */
export type JumpLink = Entry & _Node & {
  __typename?: 'JumpLink';
  _id: Scalars['ID']['output'];
  componentName: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkIdentifier: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<JumpLinkLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/jumpLink) */
export type JumpLinkComponentNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/jumpLink) */
export type JumpLinkLinkIdentifierArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/jumpLink) */
export type JumpLinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type JumpLinkCollection = {
  __typename?: 'JumpLinkCollection';
  items: Array<Maybe<JumpLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type JumpLinkCursorCollection = {
  __typename?: 'JumpLinkCursorCollection';
  items: Array<Maybe<JumpLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type JumpLinkFilter = {
  AND: InputMaybe<Array<InputMaybe<JumpLinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<JumpLinkFilter>>>;
  componentName: InputMaybe<Scalars['String']['input']>;
  componentName_contains: InputMaybe<Scalars['String']['input']>;
  componentName_exists: InputMaybe<Scalars['Boolean']['input']>;
  componentName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  componentName_not: InputMaybe<Scalars['String']['input']>;
  componentName_not_contains: InputMaybe<Scalars['String']['input']>;
  componentName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  linkIdentifier: InputMaybe<Scalars['String']['input']>;
  linkIdentifier_contains: InputMaybe<Scalars['String']['input']>;
  linkIdentifier_exists: InputMaybe<Scalars['Boolean']['input']>;
  linkIdentifier_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkIdentifier_not: InputMaybe<Scalars['String']['input']>;
  linkIdentifier_not_contains: InputMaybe<Scalars['String']['input']>;
  linkIdentifier_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type JumpLinkLinkingCollections = {
  __typename?: 'JumpLinkLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type JumpLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type JumpLinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum JumpLinkOrder {
  ComponentNameAsc = 'componentName_ASC',
  ComponentNameDesc = 'componentName_DESC',
  LinkIdentifierAsc = 'linkIdentifier_ASC',
  LinkIdentifierDesc = 'linkIdentifier_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButton = Entry & _Node & {
  __typename?: 'LegoUiButton';
  _id: Scalars['ID']['output'];
  accentColour: Maybe<Scalars['String']['output']>;
  action: Maybe<Scalars['String']['output']>;
  appearance: Maybe<Scalars['String']['output']>;
  buttonSize: Maybe<Scalars['String']['output']>;
  buttonText: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  disclaimerMessage: Maybe<Scalars['String']['output']>;
  displayAs: Maybe<Scalars['String']['output']>;
  href: Maybe<Scalars['String']['output']>;
  icon: Maybe<Scalars['String']['output']>;
  iconDirection: Maybe<Scalars['String']['output']>;
  internalName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiButtonLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonAccentColourArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonActionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonAppearanceArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonButtonSizeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonButtonTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonDisclaimerMessageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonDisplayAsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonHrefArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonIconArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonIconDirectionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonInternalNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiButton) */
export type LegoUiButtonLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LegoUiButtonCollection = {
  __typename?: 'LegoUiButtonCollection';
  items: Array<Maybe<LegoUiButton>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiButtonCursorCollection = {
  __typename?: 'LegoUiButtonCursorCollection';
  items: Array<Maybe<LegoUiButton>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiButtonFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiButtonFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiButtonFilter>>>;
  accentColour: InputMaybe<Scalars['String']['input']>;
  accentColour_contains: InputMaybe<Scalars['String']['input']>;
  accentColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  accentColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accentColour_not: InputMaybe<Scalars['String']['input']>;
  accentColour_not_contains: InputMaybe<Scalars['String']['input']>;
  accentColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  action: InputMaybe<Scalars['String']['input']>;
  action_contains: InputMaybe<Scalars['String']['input']>;
  action_exists: InputMaybe<Scalars['Boolean']['input']>;
  action_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  action_not: InputMaybe<Scalars['String']['input']>;
  action_not_contains: InputMaybe<Scalars['String']['input']>;
  action_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appearance: InputMaybe<Scalars['String']['input']>;
  appearance_contains: InputMaybe<Scalars['String']['input']>;
  appearance_exists: InputMaybe<Scalars['Boolean']['input']>;
  appearance_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appearance_not: InputMaybe<Scalars['String']['input']>;
  appearance_not_contains: InputMaybe<Scalars['String']['input']>;
  appearance_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize: InputMaybe<Scalars['String']['input']>;
  buttonSize_contains: InputMaybe<Scalars['String']['input']>;
  buttonSize_exists: InputMaybe<Scalars['Boolean']['input']>;
  buttonSize_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize_not: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_contains: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText: InputMaybe<Scalars['String']['input']>;
  buttonText_contains: InputMaybe<Scalars['String']['input']>;
  buttonText_exists: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  disclaimerMessage: InputMaybe<Scalars['String']['input']>;
  disclaimerMessage_contains: InputMaybe<Scalars['String']['input']>;
  disclaimerMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  disclaimerMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimerMessage_not: InputMaybe<Scalars['String']['input']>;
  disclaimerMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  disclaimerMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayAs: InputMaybe<Scalars['String']['input']>;
  displayAs_contains: InputMaybe<Scalars['String']['input']>;
  displayAs_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayAs_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayAs_not: InputMaybe<Scalars['String']['input']>;
  displayAs_not_contains: InputMaybe<Scalars['String']['input']>;
  displayAs_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  href: InputMaybe<Scalars['String']['input']>;
  href_contains: InputMaybe<Scalars['String']['input']>;
  href_exists: InputMaybe<Scalars['Boolean']['input']>;
  href_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  href_not: InputMaybe<Scalars['String']['input']>;
  href_not_contains: InputMaybe<Scalars['String']['input']>;
  href_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon: InputMaybe<Scalars['String']['input']>;
  iconDirection: InputMaybe<Scalars['String']['input']>;
  iconDirection_contains: InputMaybe<Scalars['String']['input']>;
  iconDirection_exists: InputMaybe<Scalars['Boolean']['input']>;
  iconDirection_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconDirection_not: InputMaybe<Scalars['String']['input']>;
  iconDirection_not_contains: InputMaybe<Scalars['String']['input']>;
  iconDirection_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains: InputMaybe<Scalars['String']['input']>;
  icon_exists: InputMaybe<Scalars['Boolean']['input']>;
  icon_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not: InputMaybe<Scalars['String']['input']>;
  icon_not_contains: InputMaybe<Scalars['String']['input']>;
  icon_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiButtonLinkingCollections = {
  __typename?: 'LegoUiButtonLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiCallToActionBlockCollection: Maybe<LegoUiCallToActionBlockCollection>;
  legoUiCallToActionBlockCursorCollection: Maybe<LegoUiCallToActionBlockCursorCollection>;
  legoUiCarouselCollection: Maybe<LegoUiCarouselCollection>;
  legoUiCarouselCursorCollection: Maybe<LegoUiCarouselCursorCollection>;
  legoUiHeroCardCollection: Maybe<LegoUiHeroCardCollection>;
  legoUiHeroCardCursorCollection: Maybe<LegoUiHeroCardCursorCollection>;
  legoUiProgramCardCollection: Maybe<LegoUiProgramCardCollection>;
  legoUiProgramCardCursorCollection: Maybe<LegoUiProgramCardCursorCollection>;
};


export type LegoUiButtonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiButtonLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiButtonLinkingCollectionsLegoUiCallToActionBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiButtonLinkingCollectionsLegoUiCallToActionBlockCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiButtonLinkingCollectionsLegoUiCallToActionBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiButtonLinkingCollectionsLegoUiCallToActionBlockCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiButtonLinkingCollectionsLegoUiCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiButtonLinkingCollectionsLegoUiCarouselCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiButtonLinkingCollectionsLegoUiCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiButtonLinkingCollectionsLegoUiCarouselCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiButtonLinkingCollectionsLegoUiHeroCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiButtonLinkingCollectionsLegoUiHeroCardCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiButtonLinkingCollectionsLegoUiHeroCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiButtonLinkingCollectionsLegoUiHeroCardCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiButtonLinkingCollectionsLegoUiProgramCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiButtonLinkingCollectionsLegoUiProgramCardCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiButtonLinkingCollectionsLegoUiProgramCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiButtonLinkingCollectionsLegoUiProgramCardCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiButtonLinkingCollectionsLegoUiCallToActionBlockCollectionOrder {
  DirectionAsc = 'direction_ASC',
  DirectionDesc = 'direction_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LegoUiButtonLinkingCollectionsLegoUiCallToActionBlockCursorCollectionOrder {
  DirectionAsc = 'direction_ASC',
  DirectionDesc = 'direction_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LegoUiButtonLinkingCollectionsLegoUiCarouselCollectionOrder {
  CarouselDescriptionAsc = 'carouselDescription_ASC',
  CarouselDescriptionDesc = 'carouselDescription_DESC',
  CarouselHeadingAsc = 'carouselHeading_ASC',
  CarouselHeadingDesc = 'carouselHeading_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiButtonLinkingCollectionsLegoUiCarouselCursorCollectionOrder {
  CarouselDescriptionAsc = 'carouselDescription_ASC',
  CarouselDescriptionDesc = 'carouselDescription_DESC',
  CarouselHeadingAsc = 'carouselHeading_ASC',
  CarouselHeadingDesc = 'carouselHeading_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiButtonLinkingCollectionsLegoUiHeroCardCollectionOrder {
  ContentPositionAsc = 'contentPosition_ASC',
  ContentPositionDesc = 'contentPosition_DESC',
  ContentTitleAsc = 'contentTitle_ASC',
  ContentTitleDesc = 'contentTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiButtonLinkingCollectionsLegoUiHeroCardCursorCollectionOrder {
  ContentPositionAsc = 'contentPosition_ASC',
  ContentPositionDesc = 'contentPosition_DESC',
  ContentTitleAsc = 'contentTitle_ASC',
  ContentTitleDesc = 'contentTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiButtonLinkingCollectionsLegoUiProgramCardCollectionOrder {
  AgeRangeAsc = 'ageRange_ASC',
  AgeRangeDesc = 'ageRange_DESC',
  CodeAsc = 'code_ASC',
  CodeDesc = 'code_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LegoUiButtonLinkingCollectionsLegoUiProgramCardCursorCollectionOrder {
  AgeRangeAsc = 'ageRange_ASC',
  AgeRangeDesc = 'ageRange_DESC',
  CodeAsc = 'code_ASC',
  CodeDesc = 'code_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum LegoUiButtonOrder {
  AccentColourAsc = 'accentColour_ASC',
  AccentColourDesc = 'accentColour_DESC',
  ActionAsc = 'action_ASC',
  ActionDesc = 'action_DESC',
  AppearanceAsc = 'appearance_ASC',
  AppearanceDesc = 'appearance_DESC',
  ButtonSizeAsc = 'buttonSize_ASC',
  ButtonSizeDesc = 'buttonSize_DESC',
  ButtonTextAsc = 'buttonText_ASC',
  ButtonTextDesc = 'buttonText_DESC',
  DisclaimerMessageAsc = 'disclaimerMessage_ASC',
  DisclaimerMessageDesc = 'disclaimerMessage_DESC',
  DisplayAsAsc = 'displayAs_ASC',
  DisplayAsDesc = 'displayAs_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  IconDirectionAsc = 'iconDirection_ASC',
  IconDirectionDesc = 'iconDirection_DESC',
  IconAsc = 'icon_ASC',
  IconDesc = 'icon_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCallToActionBlock) */
export type LegoUiCallToActionBlock = Entry & _Node & {
  __typename?: 'LegoUiCallToActionBlock';
  _id: Scalars['ID']['output'];
  asideCtaButton: Maybe<LegoUiButton>;
  asideImage: Maybe<ComposeComponentImage>;
  bodyCtaButton: Maybe<LegoUiButton>;
  bodyText: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  direction: Maybe<Scalars['String']['output']>;
  internalName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiCallToActionBlockLinkingCollections>;
  sys: Sys;
  theme: Maybe<Scalars['String']['output']>;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCallToActionBlock) */
export type LegoUiCallToActionBlockAsideCtaButtonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCallToActionBlock) */
export type LegoUiCallToActionBlockAsideImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCallToActionBlock) */
export type LegoUiCallToActionBlockBodyCtaButtonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCallToActionBlock) */
export type LegoUiCallToActionBlockBodyTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCallToActionBlock) */
export type LegoUiCallToActionBlockDirectionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCallToActionBlock) */
export type LegoUiCallToActionBlockInternalNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCallToActionBlock) */
export type LegoUiCallToActionBlockLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCallToActionBlock) */
export type LegoUiCallToActionBlockThemeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCallToActionBlock) */
export type LegoUiCallToActionBlockTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegoUiCallToActionBlockCollection = {
  __typename?: 'LegoUiCallToActionBlockCollection';
  items: Array<Maybe<LegoUiCallToActionBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiCallToActionBlockCursorCollection = {
  __typename?: 'LegoUiCallToActionBlockCursorCollection';
  items: Array<Maybe<LegoUiCallToActionBlock>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiCallToActionBlockFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiCallToActionBlockFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiCallToActionBlockFilter>>>;
  asideCtaButton: InputMaybe<CfLegoUiButtonNestedFilter>;
  asideCtaButton_exists: InputMaybe<Scalars['Boolean']['input']>;
  asideImage: InputMaybe<CfComposeComponentImageNestedFilter>;
  asideImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyCtaButton: InputMaybe<CfLegoUiButtonNestedFilter>;
  bodyCtaButton_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyText: InputMaybe<Scalars['String']['input']>;
  bodyText_contains: InputMaybe<Scalars['String']['input']>;
  bodyText_exists: InputMaybe<Scalars['Boolean']['input']>;
  bodyText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  bodyText_not: InputMaybe<Scalars['String']['input']>;
  bodyText_not_contains: InputMaybe<Scalars['String']['input']>;
  bodyText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  direction: InputMaybe<Scalars['String']['input']>;
  direction_contains: InputMaybe<Scalars['String']['input']>;
  direction_exists: InputMaybe<Scalars['Boolean']['input']>;
  direction_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  direction_not: InputMaybe<Scalars['String']['input']>;
  direction_not_contains: InputMaybe<Scalars['String']['input']>;
  direction_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  theme: InputMaybe<Scalars['String']['input']>;
  theme_contains: InputMaybe<Scalars['String']['input']>;
  theme_exists: InputMaybe<Scalars['Boolean']['input']>;
  theme_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  theme_not: InputMaybe<Scalars['String']['input']>;
  theme_not_contains: InputMaybe<Scalars['String']['input']>;
  theme_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LegoUiCallToActionBlockLinkingCollections = {
  __typename?: 'LegoUiCallToActionBlockLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type LegoUiCallToActionBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiCallToActionBlockLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiCallToActionBlockOrder {
  DirectionAsc = 'direction_ASC',
  DirectionDesc = 'direction_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  ThemeAsc = 'theme_ASC',
  ThemeDesc = 'theme_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCarousel) */
export type LegoUiCarousel = Entry & _Node & {
  __typename?: 'LegoUiCarousel';
  _id: Scalars['ID']['output'];
  carouselCardsCollection: Maybe<LegoUiCarouselCarouselCardsCollection>;
  carouselCardsCursorCollection: Maybe<LegoUiCarouselCarouselCardsCursorCollection>;
  carouselCtaButton: Maybe<LegoUiButton>;
  carouselDescription: Maybe<Scalars['String']['output']>;
  carouselHeading: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  internalName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiCarouselLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCarousel) */
export type LegoUiCarouselCarouselCardsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiCarouselCarouselCardsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCarousel) */
export type LegoUiCarouselCarouselCardsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiCarouselCarouselCardsFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCarousel) */
export type LegoUiCarouselCarouselCtaButtonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCarousel) */
export type LegoUiCarouselCarouselDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCarousel) */
export type LegoUiCarouselCarouselHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCarousel) */
export type LegoUiCarouselInternalNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiCarousel) */
export type LegoUiCarouselLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LegoUiCarouselCarouselCardsCollection = {
  __typename?: 'LegoUiCarouselCarouselCardsCollection';
  items: Array<Maybe<LegoUiCarouselCarouselCardsItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiCarouselCarouselCardsCursorCollection = {
  __typename?: 'LegoUiCarouselCarouselCardsCursorCollection';
  items: Array<Maybe<LegoUiCarouselCarouselCardsItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiCarouselCarouselCardsFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiCarouselCarouselCardsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiCarouselCarouselCardsFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiCarouselCarouselCardsItem = LegoUiHeroCard | LegoUiProgramCard | LegoUiTestimonialCard;

export type LegoUiCarouselCollection = {
  __typename?: 'LegoUiCarouselCollection';
  items: Array<Maybe<LegoUiCarousel>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiCarouselCursorCollection = {
  __typename?: 'LegoUiCarouselCursorCollection';
  items: Array<Maybe<LegoUiCarousel>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiCarouselFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiCarouselFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiCarouselFilter>>>;
  carouselCards: InputMaybe<CfcarouselCardsMultiTypeNestedFilter>;
  carouselCardsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  carouselCtaButton: InputMaybe<CfLegoUiButtonNestedFilter>;
  carouselCtaButton_exists: InputMaybe<Scalars['Boolean']['input']>;
  carouselDescription: InputMaybe<Scalars['String']['input']>;
  carouselDescription_contains: InputMaybe<Scalars['String']['input']>;
  carouselDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  carouselDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  carouselDescription_not: InputMaybe<Scalars['String']['input']>;
  carouselDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  carouselDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  carouselHeading: InputMaybe<Scalars['String']['input']>;
  carouselHeading_contains: InputMaybe<Scalars['String']['input']>;
  carouselHeading_exists: InputMaybe<Scalars['Boolean']['input']>;
  carouselHeading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  carouselHeading_not: InputMaybe<Scalars['String']['input']>;
  carouselHeading_not_contains: InputMaybe<Scalars['String']['input']>;
  carouselHeading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiCarouselLinkingCollections = {
  __typename?: 'LegoUiCarouselLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type LegoUiCarouselLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiCarouselLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiCarouselOrder {
  CarouselDescriptionAsc = 'carouselDescription_ASC',
  CarouselDescriptionDesc = 'carouselDescription_DESC',
  CarouselHeadingAsc = 'carouselHeading_ASC',
  CarouselHeadingDesc = 'carouselHeading_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiColumn) */
export type LegoUiColumn = Entry & _Node & {
  __typename?: 'LegoUiColumn';
  _id: Scalars['ID']['output'];
  column: Maybe<LegoUiColumnColumn>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiColumnLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiColumn) */
export type LegoUiColumnColumnArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiColumn) */
export type LegoUiColumnInternalTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiColumn) */
export type LegoUiColumnLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LegoUiColumnCollection = {
  __typename?: 'LegoUiColumnCollection';
  items: Array<Maybe<LegoUiColumn>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiColumnColumn = {
  __typename?: 'LegoUiColumnColumn';
  json: Scalars['JSON']['output'];
  links: LegoUiColumnColumnLinks;
};

export type LegoUiColumnColumnAssets = {
  __typename?: 'LegoUiColumnColumnAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type LegoUiColumnColumnEntries = {
  __typename?: 'LegoUiColumnColumnEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type LegoUiColumnColumnLinks = {
  __typename?: 'LegoUiColumnColumnLinks';
  assets: LegoUiColumnColumnAssets;
  entries: LegoUiColumnColumnEntries;
  resources: LegoUiColumnColumnResources;
};

export type LegoUiColumnColumnResources = {
  __typename?: 'LegoUiColumnColumnResources';
  block: Array<LegoUiColumnColumnResourcesBlock>;
  hyperlink: Array<LegoUiColumnColumnResourcesHyperlink>;
  inline: Array<LegoUiColumnColumnResourcesInline>;
};

export type LegoUiColumnColumnResourcesBlock = ResourceLink & {
  __typename?: 'LegoUiColumnColumnResourcesBlock';
  sys: ResourceSys;
};

export type LegoUiColumnColumnResourcesHyperlink = ResourceLink & {
  __typename?: 'LegoUiColumnColumnResourcesHyperlink';
  sys: ResourceSys;
};

export type LegoUiColumnColumnResourcesInline = ResourceLink & {
  __typename?: 'LegoUiColumnColumnResourcesInline';
  sys: ResourceSys;
};

export type LegoUiColumnCursorCollection = {
  __typename?: 'LegoUiColumnCursorCollection';
  items: Array<Maybe<LegoUiColumn>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiColumnFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiColumnFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiColumnFilter>>>;
  column_contains: InputMaybe<Scalars['String']['input']>;
  column_exists: InputMaybe<Scalars['Boolean']['input']>;
  column_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiColumnLayout) */
export type LegoUiColumnLayout = Entry & _Node & {
  __typename?: 'LegoUiColumnLayout';
  _id: Scalars['ID']['output'];
  columnsCollection: Maybe<LegoUiColumnLayoutColumnsCollection>;
  columnsCursorCollection: Maybe<LegoUiColumnLayoutColumnsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  internalTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiColumnLayoutLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiColumnLayout) */
export type LegoUiColumnLayoutColumnsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiColumnLayoutColumnsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiColumnFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiColumnLayout) */
export type LegoUiColumnLayoutColumnsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiColumnLayoutColumnsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiColumnFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiColumnLayout) */
export type LegoUiColumnLayoutInternalTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiColumnLayout) */
export type LegoUiColumnLayoutLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LegoUiColumnLayoutCollection = {
  __typename?: 'LegoUiColumnLayoutCollection';
  items: Array<Maybe<LegoUiColumnLayout>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiColumnLayoutColumnsCollection = {
  __typename?: 'LegoUiColumnLayoutColumnsCollection';
  items: Array<Maybe<LegoUiColumn>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum LegoUiColumnLayoutColumnsCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LegoUiColumnLayoutColumnsCursorCollection = {
  __typename?: 'LegoUiColumnLayoutColumnsCursorCollection';
  items: Array<Maybe<LegoUiColumn>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum LegoUiColumnLayoutColumnsCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LegoUiColumnLayoutCursorCollection = {
  __typename?: 'LegoUiColumnLayoutCursorCollection';
  items: Array<Maybe<LegoUiColumnLayout>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiColumnLayoutFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiColumnLayoutFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiColumnLayoutFilter>>>;
  columns: InputMaybe<CfLegoUiColumnNestedFilter>;
  columnsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiColumnLayoutLinkingCollections = {
  __typename?: 'LegoUiColumnLayoutLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type LegoUiColumnLayoutLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiColumnLayoutLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiColumnLayoutOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LegoUiColumnLinkingCollections = {
  __typename?: 'LegoUiColumnLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiColumnLayoutCollection: Maybe<LegoUiColumnLayoutCollection>;
  legoUiColumnLayoutCursorCollection: Maybe<LegoUiColumnLayoutCursorCollection>;
};


export type LegoUiColumnLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiColumnLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiColumnLinkingCollectionsLegoUiColumnLayoutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiColumnLinkingCollectionsLegoUiColumnLayoutCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiColumnLinkingCollectionsLegoUiColumnLayoutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiColumnLinkingCollectionsLegoUiColumnLayoutCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiColumnLinkingCollectionsLegoUiColumnLayoutCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiColumnLinkingCollectionsLegoUiColumnLayoutCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiColumnOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooter = Entry & _Node & {
  __typename?: 'LegoUiFooter';
  _id: Scalars['ID']['output'];
  brandLogosCollection: Maybe<LegoUiFooterBrandLogosCollection>;
  brandLogosCursorCollection: Maybe<LegoUiFooterBrandLogosCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  copyrightNotice: Maybe<LegoUiFooterCopyrightNotice>;
  externalLogosCollection: Maybe<LegoUiFooterExternalLogosCollection>;
  externalLogosCursorCollection: Maybe<LegoUiFooterExternalLogosCursorCollection>;
  footerLinksCollection: Maybe<LegoUiFooterFooterLinksCollection>;
  footerLinksCursorCollection: Maybe<LegoUiFooterFooterLinksCursorCollection>;
  internalTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiFooterLinkingCollections>;
  signUpCtaSubtext: Maybe<Scalars['String']['output']>;
  signUpCtaTitle: Maybe<Scalars['String']['output']>;
  socialMediaCollection: Maybe<LegoUiFooterSocialMediaCollection>;
  socialMediaCursorCollection: Maybe<LegoUiFooterSocialMediaCursorCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterBrandLogosCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterBrandLogosFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterBrandLogosCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterBrandLogosFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterCopyrightNoticeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterExternalLogosCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterExternalLogosFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterExternalLogosCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterExternalLogosFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterFooterLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterFooterLinksCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterLinkGroupFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterFooterLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterFooterLinksCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterLinkGroupFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterInternalTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterSignUpCtaSubtextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterSignUpCtaTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterSocialMediaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterSocialMediaCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiSocialMediaLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooter) */
export type LegoUiFooterSocialMediaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterSocialMediaCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiSocialMediaLinkFilter>;
};

export type LegoUiFooterBrandLogosCollection = {
  __typename?: 'LegoUiFooterBrandLogosCollection';
  items: Array<Maybe<LegoUiFooterBrandLogosItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiFooterBrandLogosCursorCollection = {
  __typename?: 'LegoUiFooterBrandLogosCursorCollection';
  items: Array<Maybe<LegoUiFooterBrandLogosItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiFooterBrandLogosFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiFooterBrandLogosFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiFooterBrandLogosFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiFooterBrandLogosItem = ComposeComponentImage | LegoUiImageWithLink;

export type LegoUiFooterCollection = {
  __typename?: 'LegoUiFooterCollection';
  items: Array<Maybe<LegoUiFooter>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiFooterCopyrightNotice = {
  __typename?: 'LegoUiFooterCopyrightNotice';
  json: Scalars['JSON']['output'];
  links: LegoUiFooterCopyrightNoticeLinks;
};

export type LegoUiFooterCopyrightNoticeAssets = {
  __typename?: 'LegoUiFooterCopyrightNoticeAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type LegoUiFooterCopyrightNoticeEntries = {
  __typename?: 'LegoUiFooterCopyrightNoticeEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type LegoUiFooterCopyrightNoticeLinks = {
  __typename?: 'LegoUiFooterCopyrightNoticeLinks';
  assets: LegoUiFooterCopyrightNoticeAssets;
  entries: LegoUiFooterCopyrightNoticeEntries;
  resources: LegoUiFooterCopyrightNoticeResources;
};

export type LegoUiFooterCopyrightNoticeResources = {
  __typename?: 'LegoUiFooterCopyrightNoticeResources';
  block: Array<LegoUiFooterCopyrightNoticeResourcesBlock>;
  hyperlink: Array<LegoUiFooterCopyrightNoticeResourcesHyperlink>;
  inline: Array<LegoUiFooterCopyrightNoticeResourcesInline>;
};

export type LegoUiFooterCopyrightNoticeResourcesBlock = ResourceLink & {
  __typename?: 'LegoUiFooterCopyrightNoticeResourcesBlock';
  sys: ResourceSys;
};

export type LegoUiFooterCopyrightNoticeResourcesHyperlink = ResourceLink & {
  __typename?: 'LegoUiFooterCopyrightNoticeResourcesHyperlink';
  sys: ResourceSys;
};

export type LegoUiFooterCopyrightNoticeResourcesInline = ResourceLink & {
  __typename?: 'LegoUiFooterCopyrightNoticeResourcesInline';
  sys: ResourceSys;
};

export type LegoUiFooterCursorCollection = {
  __typename?: 'LegoUiFooterCursorCollection';
  items: Array<Maybe<LegoUiFooter>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiFooterExternalLogosCollection = {
  __typename?: 'LegoUiFooterExternalLogosCollection';
  items: Array<Maybe<LegoUiFooterExternalLogosItem>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiFooterExternalLogosCursorCollection = {
  __typename?: 'LegoUiFooterExternalLogosCursorCollection';
  items: Array<Maybe<LegoUiFooterExternalLogosItem>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiFooterExternalLogosFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiFooterExternalLogosFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiFooterExternalLogosFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiFooterExternalLogosItem = ComposeComponentImage | LegoUiImageWithLink;

export type LegoUiFooterFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiFooterFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiFooterFilter>>>;
  brandLogos: InputMaybe<CfbrandLogosMultiTypeNestedFilter>;
  brandLogosCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  copyrightNotice_contains: InputMaybe<Scalars['String']['input']>;
  copyrightNotice_exists: InputMaybe<Scalars['Boolean']['input']>;
  copyrightNotice_not_contains: InputMaybe<Scalars['String']['input']>;
  externalLogos: InputMaybe<CfexternalLogosMultiTypeNestedFilter>;
  externalLogosCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  footerLinks: InputMaybe<CfLegoUiFooterLinkGroupNestedFilter>;
  footerLinksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signUpCtaSubtext: InputMaybe<Scalars['String']['input']>;
  signUpCtaSubtext_contains: InputMaybe<Scalars['String']['input']>;
  signUpCtaSubtext_exists: InputMaybe<Scalars['Boolean']['input']>;
  signUpCtaSubtext_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signUpCtaSubtext_not: InputMaybe<Scalars['String']['input']>;
  signUpCtaSubtext_not_contains: InputMaybe<Scalars['String']['input']>;
  signUpCtaSubtext_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signUpCtaTitle: InputMaybe<Scalars['String']['input']>;
  signUpCtaTitle_contains: InputMaybe<Scalars['String']['input']>;
  signUpCtaTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  signUpCtaTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  signUpCtaTitle_not: InputMaybe<Scalars['String']['input']>;
  signUpCtaTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  signUpCtaTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialMedia: InputMaybe<CfLegoUiSocialMediaLinkNestedFilter>;
  socialMediaCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiFooterFooterLinksCollection = {
  __typename?: 'LegoUiFooterFooterLinksCollection';
  items: Array<Maybe<LegoUiFooterLinkGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum LegoUiFooterFooterLinksCollectionOrder {
  GroupTitleAsc = 'groupTitle_ASC',
  GroupTitleDesc = 'groupTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LegoUiFooterFooterLinksCursorCollection = {
  __typename?: 'LegoUiFooterFooterLinksCursorCollection';
  items: Array<Maybe<LegoUiFooterLinkGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum LegoUiFooterFooterLinksCursorCollectionOrder {
  GroupTitleAsc = 'groupTitle_ASC',
  GroupTitleDesc = 'groupTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooterLink) */
export type LegoUiFooterLink = Entry & _Node & {
  __typename?: 'LegoUiFooterLink';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<LegoUiFooterLinkLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooterLink) */
export type LegoUiFooterLinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooterLink) */
export type LegoUiFooterLinkTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooterLink) */
export type LegoUiFooterLinkUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegoUiFooterLinkCollection = {
  __typename?: 'LegoUiFooterLinkCollection';
  items: Array<Maybe<LegoUiFooterLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiFooterLinkCursorCollection = {
  __typename?: 'LegoUiFooterLinkCursorCollection';
  items: Array<Maybe<LegoUiFooterLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiFooterLinkFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiFooterLinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiFooterLinkFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooterLinkGroup) */
export type LegoUiFooterLinkGroup = Entry & _Node & {
  __typename?: 'LegoUiFooterLinkGroup';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  groupLinksCollection: Maybe<LegoUiFooterLinkGroupGroupLinksCollection>;
  groupLinksCursorCollection: Maybe<LegoUiFooterLinkGroupGroupLinksCursorCollection>;
  groupTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiFooterLinkGroupLinkingCollections>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooterLinkGroup) */
export type LegoUiFooterLinkGroupGroupLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterLinkGroupGroupLinksCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooterLinkGroup) */
export type LegoUiFooterLinkGroupGroupLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterLinkGroupGroupLinksCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterLinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooterLinkGroup) */
export type LegoUiFooterLinkGroupGroupTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiFooterLinkGroup) */
export type LegoUiFooterLinkGroupLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LegoUiFooterLinkGroupCollection = {
  __typename?: 'LegoUiFooterLinkGroupCollection';
  items: Array<Maybe<LegoUiFooterLinkGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiFooterLinkGroupCursorCollection = {
  __typename?: 'LegoUiFooterLinkGroupCursorCollection';
  items: Array<Maybe<LegoUiFooterLinkGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiFooterLinkGroupFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiFooterLinkGroupFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiFooterLinkGroupFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  groupLinks: InputMaybe<CfLegoUiFooterLinkNestedFilter>;
  groupLinksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  groupTitle: InputMaybe<Scalars['String']['input']>;
  groupTitle_contains: InputMaybe<Scalars['String']['input']>;
  groupTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  groupTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupTitle_not: InputMaybe<Scalars['String']['input']>;
  groupTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  groupTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiFooterLinkGroupGroupLinksCollection = {
  __typename?: 'LegoUiFooterLinkGroupGroupLinksCollection';
  items: Array<Maybe<LegoUiFooterLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum LegoUiFooterLinkGroupGroupLinksCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type LegoUiFooterLinkGroupGroupLinksCursorCollection = {
  __typename?: 'LegoUiFooterLinkGroupGroupLinksCursorCollection';
  items: Array<Maybe<LegoUiFooterLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum LegoUiFooterLinkGroupGroupLinksCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type LegoUiFooterLinkGroupLinkingCollections = {
  __typename?: 'LegoUiFooterLinkGroupLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiFooterCollection: Maybe<LegoUiFooterCollection>;
  legoUiFooterCursorCollection: Maybe<LegoUiFooterCursorCollection>;
};


export type LegoUiFooterLinkGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiFooterLinkGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiFooterLinkGroupLinkingCollectionsLegoUiFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterLinkGroupLinkingCollectionsLegoUiFooterCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiFooterLinkGroupLinkingCollectionsLegoUiFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterLinkGroupLinkingCollectionsLegoUiFooterCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiFooterLinkGroupLinkingCollectionsLegoUiFooterCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SignUpCtaSubtextAsc = 'signUpCtaSubtext_ASC',
  SignUpCtaSubtextDesc = 'signUpCtaSubtext_DESC',
  SignUpCtaTitleAsc = 'signUpCtaTitle_ASC',
  SignUpCtaTitleDesc = 'signUpCtaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiFooterLinkGroupLinkingCollectionsLegoUiFooterCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SignUpCtaSubtextAsc = 'signUpCtaSubtext_ASC',
  SignUpCtaSubtextDesc = 'signUpCtaSubtext_DESC',
  SignUpCtaTitleAsc = 'signUpCtaTitle_ASC',
  SignUpCtaTitleDesc = 'signUpCtaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiFooterLinkGroupOrder {
  GroupTitleAsc = 'groupTitle_ASC',
  GroupTitleDesc = 'groupTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LegoUiFooterLinkLinkingCollections = {
  __typename?: 'LegoUiFooterLinkLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiFooterLinkGroupCollection: Maybe<LegoUiFooterLinkGroupCollection>;
  legoUiFooterLinkGroupCursorCollection: Maybe<LegoUiFooterLinkGroupCursorCollection>;
};


export type LegoUiFooterLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiFooterLinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiFooterLinkLinkingCollectionsLegoUiFooterLinkGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterLinkLinkingCollectionsLegoUiFooterLinkGroupCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiFooterLinkLinkingCollectionsLegoUiFooterLinkGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterLinkLinkingCollectionsLegoUiFooterLinkGroupCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiFooterLinkLinkingCollectionsLegoUiFooterLinkGroupCollectionOrder {
  GroupTitleAsc = 'groupTitle_ASC',
  GroupTitleDesc = 'groupTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiFooterLinkLinkingCollectionsLegoUiFooterLinkGroupCursorCollectionOrder {
  GroupTitleAsc = 'groupTitle_ASC',
  GroupTitleDesc = 'groupTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiFooterLinkOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type LegoUiFooterLinkingCollections = {
  __typename?: 'LegoUiFooterLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type LegoUiFooterLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiFooterLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiFooterOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SignUpCtaSubtextAsc = 'signUpCtaSubtext_ASC',
  SignUpCtaSubtextDesc = 'signUpCtaSubtext_DESC',
  SignUpCtaTitleAsc = 'signUpCtaTitle_ASC',
  SignUpCtaTitleDesc = 'signUpCtaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LegoUiFooterSocialMediaCollection = {
  __typename?: 'LegoUiFooterSocialMediaCollection';
  items: Array<Maybe<LegoUiSocialMediaLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum LegoUiFooterSocialMediaCollectionOrder {
  PlatformUrlAsc = 'platformUrl_ASC',
  PlatformUrlDesc = 'platformUrl_DESC',
  PlatformAsc = 'platform_ASC',
  PlatformDesc = 'platform_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LegoUiFooterSocialMediaCursorCollection = {
  __typename?: 'LegoUiFooterSocialMediaCursorCollection';
  items: Array<Maybe<LegoUiSocialMediaLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum LegoUiFooterSocialMediaCursorCollectionOrder {
  PlatformUrlAsc = 'platformUrl_ASC',
  PlatformUrlDesc = 'platformUrl_DESC',
  PlatformAsc = 'platform_ASC',
  PlatformDesc = 'platform_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiHeroCard) */
export type LegoUiHeroCard = Entry & _Node & {
  __typename?: 'LegoUiHeroCard';
  _id: Scalars['ID']['output'];
  backgroundAsset: Maybe<LegoUiHeroCardBackgroundAsset>;
  contentPosition: Maybe<Scalars['String']['output']>;
  contentTitle: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaButton: Maybe<LegoUiButton>;
  internalName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiHeroCardLinkingCollections>;
  mobileBackgroundAsset: Maybe<ComposeComponentImage>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiHeroCard) */
export type LegoUiHeroCardBackgroundAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiHeroCard) */
export type LegoUiHeroCardContentPositionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiHeroCard) */
export type LegoUiHeroCardContentTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiHeroCard) */
export type LegoUiHeroCardCtaButtonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiHeroCard) */
export type LegoUiHeroCardInternalNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiHeroCard) */
export type LegoUiHeroCardLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiHeroCard) */
export type LegoUiHeroCardMobileBackgroundAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};

export type LegoUiHeroCardBackgroundAsset = ComposeComponentImage | LegoUiVideo;

export type LegoUiHeroCardCollection = {
  __typename?: 'LegoUiHeroCardCollection';
  items: Array<Maybe<LegoUiHeroCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiHeroCardCursorCollection = {
  __typename?: 'LegoUiHeroCardCursorCollection';
  items: Array<Maybe<LegoUiHeroCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiHeroCardFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiHeroCardFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiHeroCardFilter>>>;
  backgroundAsset_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentPosition: InputMaybe<Scalars['String']['input']>;
  contentPosition_contains: InputMaybe<Scalars['String']['input']>;
  contentPosition_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentPosition_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentPosition_not: InputMaybe<Scalars['String']['input']>;
  contentPosition_not_contains: InputMaybe<Scalars['String']['input']>;
  contentPosition_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTitle: InputMaybe<Scalars['String']['input']>;
  contentTitle_contains: InputMaybe<Scalars['String']['input']>;
  contentTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentTitle_not: InputMaybe<Scalars['String']['input']>;
  contentTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  contentTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaButton: InputMaybe<CfLegoUiButtonNestedFilter>;
  ctaButton_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileBackgroundAsset: InputMaybe<CfComposeComponentImageNestedFilter>;
  mobileBackgroundAsset_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiHeroCardLinkingCollections = {
  __typename?: 'LegoUiHeroCardLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiCarouselCollection: Maybe<LegoUiCarouselCollection>;
  legoUiCarouselCursorCollection: Maybe<LegoUiCarouselCursorCollection>;
};


export type LegoUiHeroCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiHeroCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiHeroCardLinkingCollectionsLegoUiCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiHeroCardLinkingCollectionsLegoUiCarouselCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiHeroCardLinkingCollectionsLegoUiCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiHeroCardLinkingCollectionsLegoUiCarouselCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiHeroCardLinkingCollectionsLegoUiCarouselCollectionOrder {
  CarouselDescriptionAsc = 'carouselDescription_ASC',
  CarouselDescriptionDesc = 'carouselDescription_DESC',
  CarouselHeadingAsc = 'carouselHeading_ASC',
  CarouselHeadingDesc = 'carouselHeading_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiHeroCardLinkingCollectionsLegoUiCarouselCursorCollectionOrder {
  CarouselDescriptionAsc = 'carouselDescription_ASC',
  CarouselDescriptionDesc = 'carouselDescription_DESC',
  CarouselHeadingAsc = 'carouselHeading_ASC',
  CarouselHeadingDesc = 'carouselHeading_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiHeroCardOrder {
  ContentPositionAsc = 'contentPosition_ASC',
  ContentPositionDesc = 'contentPosition_DESC',
  ContentTitleAsc = 'contentTitle_ASC',
  ContentTitleDesc = 'contentTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiImageWithLink) */
export type LegoUiImageWithLink = Entry & _Node & {
  __typename?: 'LegoUiImageWithLink';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<ComposeComponentImage>;
  internalTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiImageWithLinkLinkingCollections>;
  sys: Sys;
  url: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiImageWithLink) */
export type LegoUiImageWithLinkImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiImageWithLink) */
export type LegoUiImageWithLinkInternalTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiImageWithLink) */
export type LegoUiImageWithLinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiImageWithLink) */
export type LegoUiImageWithLinkUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegoUiImageWithLinkCollection = {
  __typename?: 'LegoUiImageWithLinkCollection';
  items: Array<Maybe<LegoUiImageWithLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiImageWithLinkCursorCollection = {
  __typename?: 'LegoUiImageWithLinkCursorCollection';
  items: Array<Maybe<LegoUiImageWithLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiImageWithLinkFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiImageWithLinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiImageWithLinkFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image: InputMaybe<CfComposeComponentImageNestedFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LegoUiImageWithLinkLinkingCollections = {
  __typename?: 'LegoUiImageWithLinkLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiFooterCollection: Maybe<LegoUiFooterCollection>;
  legoUiFooterCursorCollection: Maybe<LegoUiFooterCursorCollection>;
  legoUiPageDividerCollection: Maybe<LegoUiPageDividerCollection>;
  legoUiPageDividerCursorCollection: Maybe<LegoUiPageDividerCursorCollection>;
};


export type LegoUiImageWithLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiImageWithLinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiImageWithLinkLinkingCollectionsLegoUiFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiImageWithLinkLinkingCollectionsLegoUiFooterCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiImageWithLinkLinkingCollectionsLegoUiFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiImageWithLinkLinkingCollectionsLegoUiFooterCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiImageWithLinkLinkingCollectionsLegoUiPageDividerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiImageWithLinkLinkingCollectionsLegoUiPageDividerCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiImageWithLinkLinkingCollectionsLegoUiPageDividerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiImageWithLinkLinkingCollectionsLegoUiPageDividerCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiImageWithLinkLinkingCollectionsLegoUiFooterCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SignUpCtaSubtextAsc = 'signUpCtaSubtext_ASC',
  SignUpCtaSubtextDesc = 'signUpCtaSubtext_DESC',
  SignUpCtaTitleAsc = 'signUpCtaTitle_ASC',
  SignUpCtaTitleDesc = 'signUpCtaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiImageWithLinkLinkingCollectionsLegoUiFooterCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SignUpCtaSubtextAsc = 'signUpCtaSubtext_ASC',
  SignUpCtaSubtextDesc = 'signUpCtaSubtext_DESC',
  SignUpCtaTitleAsc = 'signUpCtaTitle_ASC',
  SignUpCtaTitleDesc = 'signUpCtaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiImageWithLinkLinkingCollectionsLegoUiPageDividerCollectionOrder {
  DisplayAsAsc = 'displayAs_ASC',
  DisplayAsDesc = 'displayAs_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiImageWithLinkLinkingCollectionsLegoUiPageDividerCursorCollectionOrder {
  DisplayAsAsc = 'displayAs_ASC',
  DisplayAsDesc = 'displayAs_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiImageWithLinkOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiPageDivider) */
export type LegoUiPageDivider = Entry & _Node & {
  __typename?: 'LegoUiPageDivider';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  displayAs: Maybe<Scalars['String']['output']>;
  href: Maybe<Scalars['String']['output']>;
  internalName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiPageDividerLinkingCollections>;
  mobilePageDividerAsset: Maybe<LegoUiPageDividerMobilePageDividerAsset>;
  pageDividerImageAsset: Maybe<LegoUiPageDividerPageDividerImageAsset>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiPageDivider) */
export type LegoUiPageDividerDisplayAsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiPageDivider) */
export type LegoUiPageDividerHrefArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiPageDivider) */
export type LegoUiPageDividerInternalNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiPageDivider) */
export type LegoUiPageDividerLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiPageDivider) */
export type LegoUiPageDividerMobilePageDividerAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiPageDividerMobilePageDividerAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiPageDivider) */
export type LegoUiPageDividerPageDividerImageAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiPageDividerPageDividerImageAssetFilter>;
};

export type LegoUiPageDividerCollection = {
  __typename?: 'LegoUiPageDividerCollection';
  items: Array<Maybe<LegoUiPageDivider>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiPageDividerCursorCollection = {
  __typename?: 'LegoUiPageDividerCursorCollection';
  items: Array<Maybe<LegoUiPageDivider>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiPageDividerFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiPageDividerFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiPageDividerFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  displayAs: InputMaybe<Scalars['String']['input']>;
  displayAs_contains: InputMaybe<Scalars['String']['input']>;
  displayAs_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayAs_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayAs_not: InputMaybe<Scalars['String']['input']>;
  displayAs_not_contains: InputMaybe<Scalars['String']['input']>;
  displayAs_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  href: InputMaybe<Scalars['String']['input']>;
  href_contains: InputMaybe<Scalars['String']['input']>;
  href_exists: InputMaybe<Scalars['Boolean']['input']>;
  href_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  href_not: InputMaybe<Scalars['String']['input']>;
  href_not_contains: InputMaybe<Scalars['String']['input']>;
  href_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobilePageDividerAsset: InputMaybe<CfmobilePageDividerAssetMultiTypeNestedFilter>;
  mobilePageDividerAsset_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageDividerImageAsset: InputMaybe<CfpageDividerImageAssetMultiTypeNestedFilter>;
  pageDividerImageAsset_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiPageDividerLinkingCollections = {
  __typename?: 'LegoUiPageDividerLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type LegoUiPageDividerLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiPageDividerLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegoUiPageDividerMobilePageDividerAsset = ComposeComponentImage | LegoUiImageWithLink;

export type LegoUiPageDividerMobilePageDividerAssetFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiPageDividerMobilePageDividerAssetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiPageDividerMobilePageDividerAssetFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export enum LegoUiPageDividerOrder {
  DisplayAsAsc = 'displayAs_ASC',
  DisplayAsDesc = 'displayAs_DESC',
  HrefAsc = 'href_ASC',
  HrefDesc = 'href_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type LegoUiPageDividerPageDividerImageAsset = ComposeComponentImage | LegoUiImageWithLink;

export type LegoUiPageDividerPageDividerImageAssetFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiPageDividerPageDividerImageAssetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiPageDividerPageDividerImageAssetFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiProgramCard) */
export type LegoUiProgramCard = Entry & _Node & {
  __typename?: 'LegoUiProgramCard';
  _id: Scalars['ID']['output'];
  ageRange: Maybe<Scalars['String']['output']>;
  code: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  ctaButton: Maybe<LegoUiButton>;
  description: Maybe<Scalars['String']['output']>;
  imageAsset: Maybe<ComposeComponentImage>;
  internalName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiProgramCardLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiProgramCard) */
export type LegoUiProgramCardAgeRangeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiProgramCard) */
export type LegoUiProgramCardCodeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiProgramCard) */
export type LegoUiProgramCardCtaButtonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiButtonFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiProgramCard) */
export type LegoUiProgramCardDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiProgramCard) */
export type LegoUiProgramCardImageAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiProgramCard) */
export type LegoUiProgramCardInternalNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiProgramCard) */
export type LegoUiProgramCardLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiProgramCard) */
export type LegoUiProgramCardTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegoUiProgramCardCollection = {
  __typename?: 'LegoUiProgramCardCollection';
  items: Array<Maybe<LegoUiProgramCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiProgramCardCursorCollection = {
  __typename?: 'LegoUiProgramCardCursorCollection';
  items: Array<Maybe<LegoUiProgramCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiProgramCardFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiProgramCardFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiProgramCardFilter>>>;
  ageRange: InputMaybe<Scalars['String']['input']>;
  ageRange_contains: InputMaybe<Scalars['String']['input']>;
  ageRange_exists: InputMaybe<Scalars['Boolean']['input']>;
  ageRange_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ageRange_not: InputMaybe<Scalars['String']['input']>;
  ageRange_not_contains: InputMaybe<Scalars['String']['input']>;
  ageRange_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code: InputMaybe<Scalars['String']['input']>;
  code_contains: InputMaybe<Scalars['String']['input']>;
  code_exists: InputMaybe<Scalars['Boolean']['input']>;
  code_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code_not: InputMaybe<Scalars['String']['input']>;
  code_not_contains: InputMaybe<Scalars['String']['input']>;
  code_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  ctaButton: InputMaybe<CfLegoUiButtonNestedFilter>;
  ctaButton_exists: InputMaybe<Scalars['Boolean']['input']>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAsset: InputMaybe<CfComposeComponentImageNestedFilter>;
  imageAsset_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LegoUiProgramCardLinkingCollections = {
  __typename?: 'LegoUiProgramCardLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiCarouselCollection: Maybe<LegoUiCarouselCollection>;
  legoUiCarouselCursorCollection: Maybe<LegoUiCarouselCursorCollection>;
};


export type LegoUiProgramCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiProgramCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiProgramCardLinkingCollectionsLegoUiCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiProgramCardLinkingCollectionsLegoUiCarouselCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiProgramCardLinkingCollectionsLegoUiCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiProgramCardLinkingCollectionsLegoUiCarouselCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiProgramCardLinkingCollectionsLegoUiCarouselCollectionOrder {
  CarouselDescriptionAsc = 'carouselDescription_ASC',
  CarouselDescriptionDesc = 'carouselDescription_DESC',
  CarouselHeadingAsc = 'carouselHeading_ASC',
  CarouselHeadingDesc = 'carouselHeading_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiProgramCardLinkingCollectionsLegoUiCarouselCursorCollectionOrder {
  CarouselDescriptionAsc = 'carouselDescription_ASC',
  CarouselDescriptionDesc = 'carouselDescription_DESC',
  CarouselHeadingAsc = 'carouselHeading_ASC',
  CarouselHeadingDesc = 'carouselHeading_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiProgramCardOrder {
  AgeRangeAsc = 'ageRange_ASC',
  AgeRangeDesc = 'ageRange_DESC',
  CodeAsc = 'code_ASC',
  CodeDesc = 'code_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiSocialMediaLink) */
export type LegoUiSocialMediaLink = Entry & _Node & {
  __typename?: 'LegoUiSocialMediaLink';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<LegoUiSocialMediaLinkLinkingCollections>;
  platform: Maybe<Scalars['String']['output']>;
  platformUrl: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiSocialMediaLink) */
export type LegoUiSocialMediaLinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiSocialMediaLink) */
export type LegoUiSocialMediaLinkPlatformArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiSocialMediaLink) */
export type LegoUiSocialMediaLinkPlatformUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegoUiSocialMediaLinkCollection = {
  __typename?: 'LegoUiSocialMediaLinkCollection';
  items: Array<Maybe<LegoUiSocialMediaLink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiSocialMediaLinkCursorCollection = {
  __typename?: 'LegoUiSocialMediaLinkCursorCollection';
  items: Array<Maybe<LegoUiSocialMediaLink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiSocialMediaLinkFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiSocialMediaLinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiSocialMediaLinkFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  platform: InputMaybe<Scalars['String']['input']>;
  platformUrl: InputMaybe<Scalars['String']['input']>;
  platformUrl_contains: InputMaybe<Scalars['String']['input']>;
  platformUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  platformUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platformUrl_not: InputMaybe<Scalars['String']['input']>;
  platformUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  platformUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platform_contains: InputMaybe<Scalars['String']['input']>;
  platform_exists: InputMaybe<Scalars['Boolean']['input']>;
  platform_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platform_not: InputMaybe<Scalars['String']['input']>;
  platform_not_contains: InputMaybe<Scalars['String']['input']>;
  platform_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiSocialMediaLinkLinkingCollections = {
  __typename?: 'LegoUiSocialMediaLinkLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiFooterCollection: Maybe<LegoUiFooterCollection>;
  legoUiFooterCursorCollection: Maybe<LegoUiFooterCursorCollection>;
};


export type LegoUiSocialMediaLinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiSocialMediaLinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiSocialMediaLinkLinkingCollectionsLegoUiFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiSocialMediaLinkLinkingCollectionsLegoUiFooterCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiSocialMediaLinkLinkingCollectionsLegoUiFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiSocialMediaLinkLinkingCollectionsLegoUiFooterCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiSocialMediaLinkLinkingCollectionsLegoUiFooterCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SignUpCtaSubtextAsc = 'signUpCtaSubtext_ASC',
  SignUpCtaSubtextDesc = 'signUpCtaSubtext_DESC',
  SignUpCtaTitleAsc = 'signUpCtaTitle_ASC',
  SignUpCtaTitleDesc = 'signUpCtaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiSocialMediaLinkLinkingCollectionsLegoUiFooterCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SignUpCtaSubtextAsc = 'signUpCtaSubtext_ASC',
  SignUpCtaSubtextDesc = 'signUpCtaSubtext_DESC',
  SignUpCtaTitleAsc = 'signUpCtaTitle_ASC',
  SignUpCtaTitleDesc = 'signUpCtaTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiSocialMediaLinkOrder {
  PlatformUrlAsc = 'platformUrl_ASC',
  PlatformUrlDesc = 'platformUrl_DESC',
  PlatformAsc = 'platform_ASC',
  PlatformDesc = 'platform_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiTestimonialCard) */
export type LegoUiTestimonialCard = Entry & _Node & {
  __typename?: 'LegoUiTestimonialCard';
  _id: Scalars['ID']['output'];
  author: Maybe<Scalars['String']['output']>;
  avatar: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  date: Maybe<Scalars['DateTime']['output']>;
  internalTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiTestimonialCardLinkingCollections>;
  quote: Maybe<Scalars['String']['output']>;
  rating: Maybe<Scalars['Int']['output']>;
  stacked: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiTestimonialCard) */
export type LegoUiTestimonialCardAuthorArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiTestimonialCard) */
export type LegoUiTestimonialCardAvatarArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiTestimonialCard) */
export type LegoUiTestimonialCardDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiTestimonialCard) */
export type LegoUiTestimonialCardInternalTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiTestimonialCard) */
export type LegoUiTestimonialCardLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiTestimonialCard) */
export type LegoUiTestimonialCardQuoteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiTestimonialCard) */
export type LegoUiTestimonialCardRatingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiTestimonialCard) */
export type LegoUiTestimonialCardStackedArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegoUiTestimonialCardCollection = {
  __typename?: 'LegoUiTestimonialCardCollection';
  items: Array<Maybe<LegoUiTestimonialCard>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiTestimonialCardCursorCollection = {
  __typename?: 'LegoUiTestimonialCardCursorCollection';
  items: Array<Maybe<LegoUiTestimonialCard>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiTestimonialCardFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiTestimonialCardFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiTestimonialCardFilter>>>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar: InputMaybe<Scalars['String']['input']>;
  avatar_contains: InputMaybe<Scalars['String']['input']>;
  avatar_exists: InputMaybe<Scalars['Boolean']['input']>;
  avatar_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_not: InputMaybe<Scalars['String']['input']>;
  avatar_not_contains: InputMaybe<Scalars['String']['input']>;
  avatar_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quote: InputMaybe<Scalars['String']['input']>;
  quote_contains: InputMaybe<Scalars['String']['input']>;
  quote_exists: InputMaybe<Scalars['Boolean']['input']>;
  quote_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quote_not: InputMaybe<Scalars['String']['input']>;
  quote_not_contains: InputMaybe<Scalars['String']['input']>;
  quote_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rating: InputMaybe<Scalars['Int']['input']>;
  rating_exists: InputMaybe<Scalars['Boolean']['input']>;
  rating_gt: InputMaybe<Scalars['Int']['input']>;
  rating_gte: InputMaybe<Scalars['Int']['input']>;
  rating_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rating_lt: InputMaybe<Scalars['Int']['input']>;
  rating_lte: InputMaybe<Scalars['Int']['input']>;
  rating_not: InputMaybe<Scalars['Int']['input']>;
  rating_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stacked: InputMaybe<Scalars['Boolean']['input']>;
  stacked_exists: InputMaybe<Scalars['Boolean']['input']>;
  stacked_not: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type LegoUiTestimonialCardLinkingCollections = {
  __typename?: 'LegoUiTestimonialCardLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiCarouselCollection: Maybe<LegoUiCarouselCollection>;
  legoUiCarouselCursorCollection: Maybe<LegoUiCarouselCursorCollection>;
  writingLegendsMarketingSiteContactUsPageV2Collection: Maybe<WritingLegendsMarketingSiteContactUsPageV2Collection>;
  writingLegendsMarketingSiteContactUsPageV2CursorCollection: Maybe<WritingLegendsMarketingSiteContactUsPageV2CursorCollection>;
};


export type LegoUiTestimonialCardLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiTestimonialCardLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiTestimonialCardLinkingCollectionsLegoUiCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiTestimonialCardLinkingCollectionsLegoUiCarouselCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiTestimonialCardLinkingCollectionsLegoUiCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiTestimonialCardLinkingCollectionsLegoUiCarouselCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiTestimonialCardLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiTestimonialCardLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiTestimonialCardLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiTestimonialCardLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiTestimonialCardLinkingCollectionsLegoUiCarouselCollectionOrder {
  CarouselDescriptionAsc = 'carouselDescription_ASC',
  CarouselDescriptionDesc = 'carouselDescription_DESC',
  CarouselHeadingAsc = 'carouselHeading_ASC',
  CarouselHeadingDesc = 'carouselHeading_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiTestimonialCardLinkingCollectionsLegoUiCarouselCursorCollectionOrder {
  CarouselDescriptionAsc = 'carouselDescription_ASC',
  CarouselDescriptionDesc = 'carouselDescription_DESC',
  CarouselHeadingAsc = 'carouselHeading_ASC',
  CarouselHeadingDesc = 'carouselHeading_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiTestimonialCardLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CollectionOrder {
  DownloadSectionButtonTextAsc = 'downloadSectionButtonText_ASC',
  DownloadSectionButtonTextDesc = 'downloadSectionButtonText_DESC',
  DownloadSectionDescriptionAsc = 'downloadSectionDescription_ASC',
  DownloadSectionDescriptionDesc = 'downloadSectionDescription_DESC',
  DownloadSectionLinkAsc = 'downloadSectionLink_ASC',
  DownloadSectionLinkDesc = 'downloadSectionLink_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  FormLinkAsc = 'formLink_ASC',
  FormLinkDesc = 'formLink_DESC',
  FormTitleAsc = 'formTitle_ASC',
  FormTitleDesc = 'formTitle_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PhoneNumberAsc = 'phoneNumber_ASC',
  PhoneNumberDesc = 'phoneNumber_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiTestimonialCardLinkingCollectionsWritingLegendsMarketingSiteContactUsPageV2CursorCollectionOrder {
  DownloadSectionButtonTextAsc = 'downloadSectionButtonText_ASC',
  DownloadSectionButtonTextDesc = 'downloadSectionButtonText_DESC',
  DownloadSectionDescriptionAsc = 'downloadSectionDescription_ASC',
  DownloadSectionDescriptionDesc = 'downloadSectionDescription_DESC',
  DownloadSectionLinkAsc = 'downloadSectionLink_ASC',
  DownloadSectionLinkDesc = 'downloadSectionLink_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  FormLinkAsc = 'formLink_ASC',
  FormLinkDesc = 'formLink_DESC',
  FormTitleAsc = 'formTitle_ASC',
  FormTitleDesc = 'formTitle_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PhoneNumberAsc = 'phoneNumber_ASC',
  PhoneNumberDesc = 'phoneNumber_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiTestimonialCardOrder {
  AuthorAsc = 'author_ASC',
  AuthorDesc = 'author_DESC',
  AvatarAsc = 'avatar_ASC',
  AvatarDesc = 'avatar_DESC',
  DateAsc = 'date_ASC',
  DateDesc = 'date_DESC',
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  RatingAsc = 'rating_ASC',
  RatingDesc = 'rating_DESC',
  StackedAsc = 'stacked_ASC',
  StackedDesc = 'stacked_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideo) */
export type LegoUiVideo = Entry & _Node & {
  __typename?: 'LegoUiVideo';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  internalName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiVideoLinkingCollections>;
  sys: Sys;
  video: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideo) */
export type LegoUiVideoInternalNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideo) */
export type LegoUiVideoLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideo) */
export type LegoUiVideoVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlock = Entry & _Node & {
  __typename?: 'LegoUiVideoBlock';
  _id: Scalars['ID']['output'];
  backgroundAsset: Maybe<ComposeComponentImage>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  duration: Maybe<Scalars['String']['output']>;
  internalName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LegoUiVideoBlockLinkingCollections>;
  mobileBackgroundAsset: Maybe<ComposeComponentImage>;
  posterImage: Maybe<Asset>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  uploadDate: Maybe<Scalars['DateTime']['output']>;
  videoUrl: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlockBackgroundAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlockDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlockDurationArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlockInternalNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlockLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlockMobileBackgroundAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlockPosterImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlockTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlockUploadDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/legoUiVideoBlock) */
export type LegoUiVideoBlockVideoUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegoUiVideoBlockCollection = {
  __typename?: 'LegoUiVideoBlockCollection';
  items: Array<Maybe<LegoUiVideoBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiVideoBlockCursorCollection = {
  __typename?: 'LegoUiVideoBlockCursorCollection';
  items: Array<Maybe<LegoUiVideoBlock>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiVideoBlockFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiVideoBlockFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiVideoBlockFilter>>>;
  backgroundAsset: InputMaybe<CfComposeComponentImageNestedFilter>;
  backgroundAsset_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  duration: InputMaybe<Scalars['String']['input']>;
  duration_contains: InputMaybe<Scalars['String']['input']>;
  duration_exists: InputMaybe<Scalars['Boolean']['input']>;
  duration_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  duration_not: InputMaybe<Scalars['String']['input']>;
  duration_not_contains: InputMaybe<Scalars['String']['input']>;
  duration_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobileBackgroundAsset: InputMaybe<CfComposeComponentImageNestedFilter>;
  mobileBackgroundAsset_exists: InputMaybe<Scalars['Boolean']['input']>;
  posterImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uploadDate: InputMaybe<Scalars['DateTime']['input']>;
  uploadDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  uploadDate_gt: InputMaybe<Scalars['DateTime']['input']>;
  uploadDate_gte: InputMaybe<Scalars['DateTime']['input']>;
  uploadDate_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  uploadDate_lt: InputMaybe<Scalars['DateTime']['input']>;
  uploadDate_lte: InputMaybe<Scalars['DateTime']['input']>;
  uploadDate_not: InputMaybe<Scalars['DateTime']['input']>;
  uploadDate_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  videoUrl: InputMaybe<Scalars['String']['input']>;
  videoUrl_contains: InputMaybe<Scalars['String']['input']>;
  videoUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  videoUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoUrl_not: InputMaybe<Scalars['String']['input']>;
  videoUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  videoUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LegoUiVideoBlockLinkingCollections = {
  __typename?: 'LegoUiVideoBlockLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type LegoUiVideoBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiVideoBlockLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiVideoBlockOrder {
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  DurationAsc = 'duration_ASC',
  DurationDesc = 'duration_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UploadDateAsc = 'uploadDate_ASC',
  UploadDateDesc = 'uploadDate_DESC',
  VideoUrlAsc = 'videoUrl_ASC',
  VideoUrlDesc = 'videoUrl_DESC'
}

export type LegoUiVideoCollection = {
  __typename?: 'LegoUiVideoCollection';
  items: Array<Maybe<LegoUiVideo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LegoUiVideoCursorCollection = {
  __typename?: 'LegoUiVideoCursorCollection';
  items: Array<Maybe<LegoUiVideo>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LegoUiVideoFilter = {
  AND: InputMaybe<Array<InputMaybe<LegoUiVideoFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LegoUiVideoFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  video_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type LegoUiVideoLinkingCollections = {
  __typename?: 'LegoUiVideoLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  legoUiHeroCardCollection: Maybe<LegoUiHeroCardCollection>;
  legoUiHeroCardCursorCollection: Maybe<LegoUiHeroCardCursorCollection>;
};


export type LegoUiVideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiVideoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiVideoLinkingCollectionsLegoUiHeroCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiVideoLinkingCollectionsLegoUiHeroCardCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LegoUiVideoLinkingCollectionsLegoUiHeroCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiVideoLinkingCollectionsLegoUiHeroCardCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LegoUiVideoLinkingCollectionsLegoUiHeroCardCollectionOrder {
  ContentPositionAsc = 'contentPosition_ASC',
  ContentPositionDesc = 'contentPosition_DESC',
  ContentTitleAsc = 'contentTitle_ASC',
  ContentTitleDesc = 'contentTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiVideoLinkingCollectionsLegoUiHeroCardCursorCollectionOrder {
  ContentPositionAsc = 'contentPosition_ASC',
  ContentPositionDesc = 'contentPosition_DESC',
  ContentTitleAsc = 'contentTitle_ASC',
  ContentTitleDesc = 'contentTitle_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LegoUiVideoOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/lessonOverview) */
export type LessonOverview = Entry & _Node & {
  __typename?: 'LessonOverview';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<LessonOverviewLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  pdf: Maybe<Asset>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  thumbnail: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/lessonOverview) */
export type LessonOverviewLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/lessonOverview) */
export type LessonOverviewNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/lessonOverview) */
export type LessonOverviewPdfArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/lessonOverview) */
export type LessonOverviewSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/lessonOverview) */
export type LessonOverviewThumbnailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type LessonOverviewCollection = {
  __typename?: 'LessonOverviewCollection';
  items: Array<Maybe<LessonOverview>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LessonOverviewCursorCollection = {
  __typename?: 'LessonOverviewCursorCollection';
  items: Array<Maybe<LessonOverview>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LessonOverviewFilter = {
  AND: InputMaybe<Array<InputMaybe<LessonOverviewFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LessonOverviewFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdf_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnail_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type LessonOverviewLinkingCollections = {
  __typename?: 'LessonOverviewLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type LessonOverviewLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LessonOverviewLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LessonOverviewOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/link) */
export type Link = Entry & _Node & {
  __typename?: 'Link';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  id: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<LinkLinkingCollections>;
  sys: Sys;
  text: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/link) */
export type LinkIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/link) */
export type LinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/link) */
export type LinkTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/link) */
export type LinkUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type LinkCollection = {
  __typename?: 'LinkCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type LinkCursorCollection = {
  __typename?: 'LinkCursorCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type LinkFilter = {
  AND: InputMaybe<Array<InputMaybe<LinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<LinkFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  text: InputMaybe<Scalars['String']['input']>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not: InputMaybe<Scalars['String']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
  text_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type LinkLinkingCollections = {
  __typename?: 'LinkLinkingCollections';
  composeComponentStickyBannerItemCollection: Maybe<ComposeComponentStickyBannerItemCollection>;
  composeComponentStickyBannerItemCursorCollection: Maybe<ComposeComponentStickyBannerItemCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  sampleLessonCollection: Maybe<SampleLessonCollection>;
  sampleLessonCursorCollection: Maybe<SampleLessonCursorCollection>;
};


export type LinkLinkingCollectionsComposeComponentStickyBannerItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsComposeComponentStickyBannerItemCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkLinkingCollectionsComposeComponentStickyBannerItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsComposeComponentStickyBannerItemCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkLinkingCollectionsSampleLessonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsSampleLessonCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkLinkingCollectionsSampleLessonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LinkLinkingCollectionsSampleLessonCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LinkLinkingCollectionsComposeComponentStickyBannerItemCollectionOrder {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LinkLinkingCollectionsComposeComponentStickyBannerItemCursorCollectionOrder {
  BodyAsc = 'body_ASC',
  BodyDesc = 'body_DESC',
  HeadingAsc = 'heading_ASC',
  HeadingDesc = 'heading_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LinkLinkingCollectionsSampleLessonCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LinkLinkingCollectionsSampleLessonCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum LinkOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/marketingBlogGlobalRegionalEdits) */
export type MarketingBlogGlobalRegionalEdits = Entry & _Node & {
  __typename?: 'MarketingBlogGlobalRegionalEdits';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<MarketingBlogGlobalRegionalEditsLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  regionalEditsCollection: Maybe<MarketingBlogGlobalRegionalEditsRegionalEditsCollection>;
  regionalEditsCursorCollection: Maybe<MarketingBlogGlobalRegionalEditsRegionalEditsCursorCollection>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/marketingBlogGlobalRegionalEdits) */
export type MarketingBlogGlobalRegionalEditsLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/marketingBlogGlobalRegionalEdits) */
export type MarketingBlogGlobalRegionalEditsNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/marketingBlogGlobalRegionalEdits) */
export type MarketingBlogGlobalRegionalEditsRegionalEditsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MarketingBlogGlobalRegionalEditsRegionalEditsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MarketingBlogRegionalEditFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/marketingBlogGlobalRegionalEdits) */
export type MarketingBlogGlobalRegionalEditsRegionalEditsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MarketingBlogGlobalRegionalEditsRegionalEditsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MarketingBlogRegionalEditFilter>;
};

export type MarketingBlogGlobalRegionalEditsCollection = {
  __typename?: 'MarketingBlogGlobalRegionalEditsCollection';
  items: Array<Maybe<MarketingBlogGlobalRegionalEdits>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MarketingBlogGlobalRegionalEditsCursorCollection = {
  __typename?: 'MarketingBlogGlobalRegionalEditsCursorCollection';
  items: Array<Maybe<MarketingBlogGlobalRegionalEdits>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MarketingBlogGlobalRegionalEditsFilter = {
  AND: InputMaybe<Array<InputMaybe<MarketingBlogGlobalRegionalEditsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<MarketingBlogGlobalRegionalEditsFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regionalEdits: InputMaybe<CfMarketingBlogRegionalEditNestedFilter>;
  regionalEditsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type MarketingBlogGlobalRegionalEditsLinkingCollections = {
  __typename?: 'MarketingBlogGlobalRegionalEditsLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type MarketingBlogGlobalRegionalEditsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarketingBlogGlobalRegionalEditsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MarketingBlogGlobalRegionalEditsOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type MarketingBlogGlobalRegionalEditsRegionalEditsCollection = {
  __typename?: 'MarketingBlogGlobalRegionalEditsRegionalEditsCollection';
  items: Array<Maybe<MarketingBlogRegionalEdit>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum MarketingBlogGlobalRegionalEditsRegionalEditsCollectionOrder {
  SnippetKeywordAsc = 'snippetKeyword_ASC',
  SnippetKeywordDesc = 'snippetKeyword_DESC',
  SnippetTextAsc = 'snippetText_ASC',
  SnippetTextDesc = 'snippetText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type MarketingBlogGlobalRegionalEditsRegionalEditsCursorCollection = {
  __typename?: 'MarketingBlogGlobalRegionalEditsRegionalEditsCursorCollection';
  items: Array<Maybe<MarketingBlogRegionalEdit>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum MarketingBlogGlobalRegionalEditsRegionalEditsCursorCollectionOrder {
  SnippetKeywordAsc = 'snippetKeyword_ASC',
  SnippetKeywordDesc = 'snippetKeyword_DESC',
  SnippetTextAsc = 'snippetText_ASC',
  SnippetTextDesc = 'snippetText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/marketingBlogRegionalEdit) */
export type MarketingBlogRegionalEdit = Entry & _Node & {
  __typename?: 'MarketingBlogRegionalEdit';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<MarketingBlogRegionalEditLinkingCollections>;
  snippetKeyword: Maybe<Scalars['String']['output']>;
  snippetText: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/marketingBlogRegionalEdit) */
export type MarketingBlogRegionalEditLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/marketingBlogRegionalEdit) */
export type MarketingBlogRegionalEditSnippetKeywordArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/marketingBlogRegionalEdit) */
export type MarketingBlogRegionalEditSnippetTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type MarketingBlogRegionalEditCollection = {
  __typename?: 'MarketingBlogRegionalEditCollection';
  items: Array<Maybe<MarketingBlogRegionalEdit>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type MarketingBlogRegionalEditCursorCollection = {
  __typename?: 'MarketingBlogRegionalEditCursorCollection';
  items: Array<Maybe<MarketingBlogRegionalEdit>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type MarketingBlogRegionalEditFilter = {
  AND: InputMaybe<Array<InputMaybe<MarketingBlogRegionalEditFilter>>>;
  OR: InputMaybe<Array<InputMaybe<MarketingBlogRegionalEditFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  snippetKeyword: InputMaybe<Scalars['String']['input']>;
  snippetKeyword_contains: InputMaybe<Scalars['String']['input']>;
  snippetKeyword_exists: InputMaybe<Scalars['Boolean']['input']>;
  snippetKeyword_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  snippetKeyword_not: InputMaybe<Scalars['String']['input']>;
  snippetKeyword_not_contains: InputMaybe<Scalars['String']['input']>;
  snippetKeyword_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  snippetText: InputMaybe<Scalars['String']['input']>;
  snippetText_contains: InputMaybe<Scalars['String']['input']>;
  snippetText_exists: InputMaybe<Scalars['Boolean']['input']>;
  snippetText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  snippetText_not: InputMaybe<Scalars['String']['input']>;
  snippetText_not_contains: InputMaybe<Scalars['String']['input']>;
  snippetText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type MarketingBlogRegionalEditLinkingCollections = {
  __typename?: 'MarketingBlogRegionalEditLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  marketingBlogGlobalRegionalEditsCollection: Maybe<MarketingBlogGlobalRegionalEditsCollection>;
  marketingBlogGlobalRegionalEditsCursorCollection: Maybe<MarketingBlogGlobalRegionalEditsCursorCollection>;
};


export type MarketingBlogRegionalEditLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarketingBlogRegionalEditLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarketingBlogRegionalEditLinkingCollectionsMarketingBlogGlobalRegionalEditsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MarketingBlogRegionalEditLinkingCollectionsMarketingBlogGlobalRegionalEditsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type MarketingBlogRegionalEditLinkingCollectionsMarketingBlogGlobalRegionalEditsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MarketingBlogRegionalEditLinkingCollectionsMarketingBlogGlobalRegionalEditsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum MarketingBlogRegionalEditLinkingCollectionsMarketingBlogGlobalRegionalEditsCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum MarketingBlogRegionalEditLinkingCollectionsMarketingBlogGlobalRegionalEditsCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum MarketingBlogRegionalEditOrder {
  SnippetKeywordAsc = 'snippetKeyword_ASC',
  SnippetKeywordDesc = 'snippetKeyword_DESC',
  SnippetTextAsc = 'snippetText_ASC',
  SnippetTextDesc = 'snippetText_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaign) */
export type PCampaign = Entry & _Node & {
  __typename?: 'PCampaign';
  _id: Scalars['ID']['output'];
  assetReferencesCollection: Maybe<AssetCollection>;
  assetReferencesCursorCollection: Maybe<AssetCursorCollection>;
  campaignName: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<PCampaignLinkingCollections>;
  seoIndexOverride: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
  variants: Maybe<Scalars['JSON']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaign) */
export type PCampaignAssetReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaign) */
export type PCampaignAssetReferencesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaign) */
export type PCampaignCampaignNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaign) */
export type PCampaignLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaign) */
export type PCampaignSeoIndexOverrideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaign) */
export type PCampaignVariantsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaignB2b) */
export type PCampaignB2B = Entry & _Node & {
  __typename?: 'PCampaignB2B';
  _id: Scalars['ID']['output'];
  assetReferencesCollection: Maybe<AssetCollection>;
  assetReferencesCursorCollection: Maybe<AssetCursorCollection>;
  campaignName: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<PCampaignB2BLinkingCollections>;
  seoIndexOverride: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
  variants: Maybe<Scalars['JSON']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaignB2b) */
export type PCampaignB2BAssetReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaignB2b) */
export type PCampaignB2BAssetReferencesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaignB2b) */
export type PCampaignB2BCampaignNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaignB2b) */
export type PCampaignB2BLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaignB2b) */
export type PCampaignB2BSeoIndexOverrideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pCampaignB2b) */
export type PCampaignB2BVariantsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PCampaignB2BCollection = {
  __typename?: 'PCampaignB2BCollection';
  items: Array<Maybe<PCampaignB2B>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PCampaignB2BCursorCollection = {
  __typename?: 'PCampaignB2BCursorCollection';
  items: Array<Maybe<PCampaignB2B>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PCampaignB2BFilter = {
  AND: InputMaybe<Array<InputMaybe<PCampaignB2BFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PCampaignB2BFilter>>>;
  assetReferencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  campaignName: InputMaybe<Scalars['String']['input']>;
  campaignName_contains: InputMaybe<Scalars['String']['input']>;
  campaignName_exists: InputMaybe<Scalars['Boolean']['input']>;
  campaignName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignName_not: InputMaybe<Scalars['String']['input']>;
  campaignName_not_contains: InputMaybe<Scalars['String']['input']>;
  campaignName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  seoIndexOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  variants_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type PCampaignB2BLinkingCollections = {
  __typename?: 'PCampaignB2BLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  pContentPageCollection: Maybe<PContentPageCollection>;
  pContentPageCursorCollection: Maybe<PContentPageCursorCollection>;
};


export type PCampaignB2BLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PCampaignB2BLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PCampaignB2BLinkingCollectionsPContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PCampaignB2BLinkingCollectionsPContentPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PCampaignB2BLinkingCollectionsPContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PCampaignB2BLinkingCollectionsPContentPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PCampaignB2BLinkingCollectionsPContentPageCollectionOrder {
  CanonicalOverrideAsc = 'canonicalOverride_ASC',
  CanonicalOverrideDesc = 'canonicalOverride_DESC',
  ExpiryAsc = 'expiry_ASC',
  ExpiryDesc = 'expiry_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  RealPageAsc = 'realPage_ASC',
  RealPageDesc = 'realPage_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PCampaignB2BLinkingCollectionsPContentPageCursorCollectionOrder {
  CanonicalOverrideAsc = 'canonicalOverride_ASC',
  CanonicalOverrideDesc = 'canonicalOverride_DESC',
  ExpiryAsc = 'expiry_ASC',
  ExpiryDesc = 'expiry_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  RealPageAsc = 'realPage_ASC',
  RealPageDesc = 'realPage_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PCampaignB2BOrder {
  CampaignNameAsc = 'campaignName_ASC',
  CampaignNameDesc = 'campaignName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type PCampaignCollection = {
  __typename?: 'PCampaignCollection';
  items: Array<Maybe<PCampaign>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PCampaignCursorCollection = {
  __typename?: 'PCampaignCursorCollection';
  items: Array<Maybe<PCampaign>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PCampaignFilter = {
  AND: InputMaybe<Array<InputMaybe<PCampaignFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PCampaignFilter>>>;
  assetReferencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  campaignName: InputMaybe<Scalars['String']['input']>;
  campaignName_contains: InputMaybe<Scalars['String']['input']>;
  campaignName_exists: InputMaybe<Scalars['Boolean']['input']>;
  campaignName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  campaignName_not: InputMaybe<Scalars['String']['input']>;
  campaignName_not_contains: InputMaybe<Scalars['String']['input']>;
  campaignName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  seoIndexOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  variants_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type PCampaignLinkingCollections = {
  __typename?: 'PCampaignLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  pContentPageCollection: Maybe<PContentPageCollection>;
  pContentPageCursorCollection: Maybe<PContentPageCursorCollection>;
};


export type PCampaignLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PCampaignLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PCampaignLinkingCollectionsPContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PCampaignLinkingCollectionsPContentPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PCampaignLinkingCollectionsPContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PCampaignLinkingCollectionsPContentPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PCampaignLinkingCollectionsPContentPageCollectionOrder {
  CanonicalOverrideAsc = 'canonicalOverride_ASC',
  CanonicalOverrideDesc = 'canonicalOverride_DESC',
  ExpiryAsc = 'expiry_ASC',
  ExpiryDesc = 'expiry_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  RealPageAsc = 'realPage_ASC',
  RealPageDesc = 'realPage_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PCampaignLinkingCollectionsPContentPageCursorCollectionOrder {
  CanonicalOverrideAsc = 'canonicalOverride_ASC',
  CanonicalOverrideDesc = 'canonicalOverride_DESC',
  ExpiryAsc = 'expiry_ASC',
  ExpiryDesc = 'expiry_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  RealPageAsc = 'realPage_ASC',
  RealPageDesc = 'realPage_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum PCampaignOrder {
  CampaignNameAsc = 'campaignName_ASC',
  CampaignNameDesc = 'campaignName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPage = Entry & _Node & {
  __typename?: 'PContentPage';
  _id: Scalars['ID']['output'];
  assetReferencesCollection: Maybe<AssetCollection>;
  assetReferencesCursorCollection: Maybe<AssetCursorCollection>;
  campaign: Maybe<PContentPageCampaign>;
  canonicalOverride: Maybe<Scalars['String']['output']>;
  category: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentfulMetadata: ContentfulMetadata;
  dynamicTokens: Maybe<Scalars['JSON']['output']>;
  entryReferencesCollection: Maybe<PContentPageEntryReferencesCollection>;
  entryReferencesCursorCollection: Maybe<PContentPageEntryReferencesCursorCollection>;
  expiry: Maybe<Scalars['DateTime']['output']>;
  linkedFrom: Maybe<PContentPageLinkingCollections>;
  metaDescription: Maybe<Scalars['String']['output']>;
  metaTitle: Maybe<Scalars['String']['output']>;
  pageAttributes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  podPress: Maybe<Scalars['JSON']['output']>;
  realPage: Maybe<Scalars['Boolean']['output']>;
  site: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  slug: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageAssetReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageAssetReferencesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageCampaignArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageCanonicalOverrideArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageCategoryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageDynamicTokensArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageEntryReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageEntryReferencesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageExpiryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageMetaDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageMetaTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPagePageAttributesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPagePodPressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageRealPageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageSiteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pContentPage) */
export type PContentPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PContentPageCampaign = PCampaign | PCampaignB2B;

export type PContentPageCollection = {
  __typename?: 'PContentPageCollection';
  items: Array<Maybe<PContentPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PContentPageCursorCollection = {
  __typename?: 'PContentPageCursorCollection';
  items: Array<Maybe<PContentPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PContentPageEntryReferencesCollection = {
  __typename?: 'PContentPageEntryReferencesCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PContentPageEntryReferencesCursorCollection = {
  __typename?: 'PContentPageEntryReferencesCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PContentPageFilter = {
  AND: InputMaybe<Array<InputMaybe<PContentPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PContentPageFilter>>>;
  assetReferencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  campaign_exists: InputMaybe<Scalars['Boolean']['input']>;
  canonicalOverride: InputMaybe<Scalars['String']['input']>;
  canonicalOverride_contains: InputMaybe<Scalars['String']['input']>;
  canonicalOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  canonicalOverride_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  canonicalOverride_not: InputMaybe<Scalars['String']['input']>;
  canonicalOverride_not_contains: InputMaybe<Scalars['String']['input']>;
  canonicalOverride_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  dynamicTokens_exists: InputMaybe<Scalars['Boolean']['input']>;
  entryReferencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  expiry: InputMaybe<Scalars['DateTime']['input']>;
  expiry_exists: InputMaybe<Scalars['Boolean']['input']>;
  expiry_gt: InputMaybe<Scalars['DateTime']['input']>;
  expiry_gte: InputMaybe<Scalars['DateTime']['input']>;
  expiry_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  expiry_lt: InputMaybe<Scalars['DateTime']['input']>;
  expiry_lte: InputMaybe<Scalars['DateTime']['input']>;
  expiry_not: InputMaybe<Scalars['DateTime']['input']>;
  expiry_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  metaDescription: InputMaybe<Scalars['String']['input']>;
  metaDescription_contains: InputMaybe<Scalars['String']['input']>;
  metaDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  metaDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaDescription_not: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  metaDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle: InputMaybe<Scalars['String']['input']>;
  metaTitle_contains: InputMaybe<Scalars['String']['input']>;
  metaTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  metaTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  metaTitle_not: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  metaTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageAttributes_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageAttributes_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageAttributes_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageAttributes_exists: InputMaybe<Scalars['Boolean']['input']>;
  podPress_exists: InputMaybe<Scalars['Boolean']['input']>;
  realPage: InputMaybe<Scalars['Boolean']['input']>;
  realPage_exists: InputMaybe<Scalars['Boolean']['input']>;
  realPage_not: InputMaybe<Scalars['Boolean']['input']>;
  site_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PContentPageLinkingCollections = {
  __typename?: 'PContentPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type PContentPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PContentPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PContentPageOrder {
  CanonicalOverrideAsc = 'canonicalOverride_ASC',
  CanonicalOverrideDesc = 'canonicalOverride_DESC',
  ExpiryAsc = 'expiry_ASC',
  ExpiryDesc = 'expiry_DESC',
  MetaDescriptionAsc = 'metaDescription_ASC',
  MetaDescriptionDesc = 'metaDescription_DESC',
  MetaTitleAsc = 'metaTitle_ASC',
  MetaTitleDesc = 'metaTitle_DESC',
  RealPageAsc = 'realPage_ASC',
  RealPageDesc = 'realPage_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResource = Entry & _Node & {
  __typename?: 'PFreeResource';
  _id: Scalars['ID']['output'];
  category: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  contentfulMetadata: ContentfulMetadata;
  enabledLocales: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  focusSkill: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  linkedFrom: Maybe<PFreeResourceLinkingCollections>;
  resource: Maybe<Asset>;
  resourceAnswers: Maybe<Asset>;
  resourceName: Maybe<Scalars['String']['output']>;
  resourcePreview: Maybe<Asset>;
  site: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  subjectArea: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  yearLevel: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceCategoryArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceEnabledLocalesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceFocusSkillArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceResourceArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceResourceAnswersArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceResourceNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceResourcePreviewArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceSiteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceSubjectAreaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pFreeResource) */
export type PFreeResourceYearLevelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PFreeResourceCollection = {
  __typename?: 'PFreeResourceCollection';
  items: Array<Maybe<PFreeResource>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PFreeResourceCursorCollection = {
  __typename?: 'PFreeResourceCursorCollection';
  items: Array<Maybe<PFreeResource>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PFreeResourceFilter = {
  AND: InputMaybe<Array<InputMaybe<PFreeResourceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PFreeResourceFilter>>>;
  category_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  enabledLocales_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enabledLocales_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enabledLocales_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enabledLocales_exists: InputMaybe<Scalars['Boolean']['input']>;
  focusSkill_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focusSkill_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focusSkill_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  focusSkill_exists: InputMaybe<Scalars['Boolean']['input']>;
  resourceAnswers_exists: InputMaybe<Scalars['Boolean']['input']>;
  resourceName: InputMaybe<Scalars['String']['input']>;
  resourceName_contains: InputMaybe<Scalars['String']['input']>;
  resourceName_exists: InputMaybe<Scalars['Boolean']['input']>;
  resourceName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resourceName_not: InputMaybe<Scalars['String']['input']>;
  resourceName_not_contains: InputMaybe<Scalars['String']['input']>;
  resourceName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resourcePreview_exists: InputMaybe<Scalars['Boolean']['input']>;
  resource_exists: InputMaybe<Scalars['Boolean']['input']>;
  site_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site_exists: InputMaybe<Scalars['Boolean']['input']>;
  subjectArea_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subjectArea_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subjectArea_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subjectArea_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  yearLevel_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  yearLevel_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  yearLevel_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  yearLevel_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type PFreeResourceLinkingCollections = {
  __typename?: 'PFreeResourceLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type PFreeResourceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PFreeResourceLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PFreeResourceOrder {
  ResourceNameAsc = 'resourceName_ASC',
  ResourceNameDesc = 'resourceName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJson = Entry & _Node & {
  __typename?: 'PJson';
  _id: Scalars['ID']['output'];
  archive: Maybe<Scalars['JSON']['output']>;
  assetReferencesCollection: Maybe<AssetCollection>;
  assetReferencesCursorCollection: Maybe<AssetCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  editInGreenhouse: Maybe<Scalars['Boolean']['output']>;
  json: Maybe<Scalars['JSON']['output']>;
  label: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<PJsonLinkingCollections>;
  public: Maybe<Scalars['Boolean']['output']>;
  schema: Maybe<Scalars['JSON']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJsonArchiveArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJsonAssetReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJsonAssetReferencesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJsonDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJsonEditInGreenhouseArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJsonJsonArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJsonLabelArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJsonLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJsonPublicArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pJson) */
export type PJsonSchemaArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PJsonCollection = {
  __typename?: 'PJsonCollection';
  items: Array<Maybe<PJson>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PJsonCursorCollection = {
  __typename?: 'PJsonCursorCollection';
  items: Array<Maybe<PJson>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PJsonFilter = {
  AND: InputMaybe<Array<InputMaybe<PJsonFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PJsonFilter>>>;
  archive_exists: InputMaybe<Scalars['Boolean']['input']>;
  assetReferencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  editInGreenhouse: InputMaybe<Scalars['Boolean']['input']>;
  editInGreenhouse_exists: InputMaybe<Scalars['Boolean']['input']>;
  editInGreenhouse_not: InputMaybe<Scalars['Boolean']['input']>;
  json_exists: InputMaybe<Scalars['Boolean']['input']>;
  label: InputMaybe<Scalars['String']['input']>;
  label_contains: InputMaybe<Scalars['String']['input']>;
  label_exists: InputMaybe<Scalars['Boolean']['input']>;
  label_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label_not: InputMaybe<Scalars['String']['input']>;
  label_not_contains: InputMaybe<Scalars['String']['input']>;
  label_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  public: InputMaybe<Scalars['Boolean']['input']>;
  public_exists: InputMaybe<Scalars['Boolean']['input']>;
  public_not: InputMaybe<Scalars['Boolean']['input']>;
  schema_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type PJsonLinkingCollections = {
  __typename?: 'PJsonLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type PJsonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PJsonLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PJsonOrder {
  EditInGreenhouseAsc = 'editInGreenhouse_ASC',
  EditInGreenhouseDesc = 'editInGreenhouse_DESC',
  LabelAsc = 'label_ASC',
  LabelDesc = 'label_DESC',
  PublicAsc = 'public_ASC',
  PublicDesc = 'public_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntry = Entry & _Node & {
  __typename?: 'PLinkedEntry';
  _id: Scalars['ID']['output'];
  assetReferencesCollection: Maybe<AssetCollection>;
  assetReferencesCursorCollection: Maybe<AssetCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  dynamicTokens: Maybe<Scalars['JSON']['output']>;
  entryAttributes: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entryMode: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  entryReferencesCollection: Maybe<PLinkedEntryEntryReferencesCollection>;
  entryReferencesCursorCollection: Maybe<PLinkedEntryEntryReferencesCursorCollection>;
  entrySettings: Maybe<Scalars['JSON']['output']>;
  linkedFrom: Maybe<PLinkedEntryLinkingCollections>;
  podPress: Maybe<Scalars['JSON']['output']>;
  site: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sys: Sys;
  templateType: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryAssetReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryAssetReferencesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryDynamicTokensArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryEntryAttributesArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryEntryModeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryEntryReferencesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryEntryReferencesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryEntrySettingsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryPodPressArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntrySiteArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryTemplateTypeArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/pLinkedEntry) */
export type PLinkedEntryTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PLinkedEntryCollection = {
  __typename?: 'PLinkedEntryCollection';
  items: Array<Maybe<PLinkedEntry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PLinkedEntryCursorCollection = {
  __typename?: 'PLinkedEntryCursorCollection';
  items: Array<Maybe<PLinkedEntry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PLinkedEntryEntryReferencesCollection = {
  __typename?: 'PLinkedEntryEntryReferencesCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PLinkedEntryEntryReferencesCursorCollection = {
  __typename?: 'PLinkedEntryEntryReferencesCursorCollection';
  items: Array<Maybe<Entry>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PLinkedEntryFilter = {
  AND: InputMaybe<Array<InputMaybe<PLinkedEntryFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PLinkedEntryFilter>>>;
  assetReferencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  dynamicTokens_exists: InputMaybe<Scalars['Boolean']['input']>;
  entryAttributes_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryAttributes_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryAttributes_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryAttributes_exists: InputMaybe<Scalars['Boolean']['input']>;
  entryMode_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryMode_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryMode_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  entryMode_exists: InputMaybe<Scalars['Boolean']['input']>;
  entryReferencesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  entrySettings_exists: InputMaybe<Scalars['Boolean']['input']>;
  podPress_exists: InputMaybe<Scalars['Boolean']['input']>;
  site_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  site_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  templateType_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateType_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateType_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  templateType_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type PLinkedEntryLinkingCollections = {
  __typename?: 'PLinkedEntryLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type PLinkedEntryLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PLinkedEntryLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PLinkedEntryOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/parentUiRichTextHyperlink) */
export type ParentUiRichTextHyperlink = Entry & _Node & {
  __typename?: 'ParentUiRichTextHyperlink';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  link: Maybe<ComposeComponentUrl>;
  linkedFrom: Maybe<ParentUiRichTextHyperlinkLinkingCollections>;
  opensInANewTab: Maybe<Scalars['Boolean']['output']>;
  sys: Sys;
  text: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/parentUiRichTextHyperlink) */
export type ParentUiRichTextHyperlinkLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentUrlFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/parentUiRichTextHyperlink) */
export type ParentUiRichTextHyperlinkLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/parentUiRichTextHyperlink) */
export type ParentUiRichTextHyperlinkOpensInANewTabArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/parentUiRichTextHyperlink) */
export type ParentUiRichTextHyperlinkTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParentUiRichTextHyperlinkCollection = {
  __typename?: 'ParentUiRichTextHyperlinkCollection';
  items: Array<Maybe<ParentUiRichTextHyperlink>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ParentUiRichTextHyperlinkCursorCollection = {
  __typename?: 'ParentUiRichTextHyperlinkCursorCollection';
  items: Array<Maybe<ParentUiRichTextHyperlink>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ParentUiRichTextHyperlinkFilter = {
  AND: InputMaybe<Array<InputMaybe<ParentUiRichTextHyperlinkFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ParentUiRichTextHyperlinkFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  link: InputMaybe<CfComposeComponentUrlNestedFilter>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  opensInANewTab: InputMaybe<Scalars['Boolean']['input']>;
  opensInANewTab_exists: InputMaybe<Scalars['Boolean']['input']>;
  opensInANewTab_not: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  text: InputMaybe<Scalars['String']['input']>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not: InputMaybe<Scalars['String']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
  text_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ParentUiRichTextHyperlinkLinkingCollections = {
  __typename?: 'ParentUiRichTextHyperlinkLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ParentUiRichTextHyperlinkLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ParentUiRichTextHyperlinkLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ParentUiRichTextHyperlinkOrder {
  OpensInANewTabAsc = 'opensInANewTab_ASC',
  OpensInANewTabDesc = 'opensInANewTab_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/parentUserGuide) */
export type ParentUserGuide = Entry & _Node & {
  __typename?: 'ParentUserGuide';
  _id: Scalars['ID']['output'];
  content: Maybe<ParentUserGuideContent>;
  contentfulMetadata: ContentfulMetadata;
  id: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<ParentUserGuideLinkingCollections>;
  product: Maybe<Product>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/parentUserGuide) */
export type ParentUserGuideContentArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/parentUserGuide) */
export type ParentUserGuideIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/parentUserGuide) */
export type ParentUserGuideLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/parentUserGuide) */
export type ParentUserGuideProductArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ProductFilter>;
};

export type ParentUserGuideCollection = {
  __typename?: 'ParentUserGuideCollection';
  items: Array<Maybe<ParentUserGuide>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ParentUserGuideContent = {
  __typename?: 'ParentUserGuideContent';
  json: Scalars['JSON']['output'];
  links: ParentUserGuideContentLinks;
};

export type ParentUserGuideContentAssets = {
  __typename?: 'ParentUserGuideContentAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type ParentUserGuideContentEntries = {
  __typename?: 'ParentUserGuideContentEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type ParentUserGuideContentLinks = {
  __typename?: 'ParentUserGuideContentLinks';
  assets: ParentUserGuideContentAssets;
  entries: ParentUserGuideContentEntries;
  resources: ParentUserGuideContentResources;
};

export type ParentUserGuideContentResources = {
  __typename?: 'ParentUserGuideContentResources';
  block: Array<ParentUserGuideContentResourcesBlock>;
  hyperlink: Array<ParentUserGuideContentResourcesHyperlink>;
  inline: Array<ParentUserGuideContentResourcesInline>;
};

export type ParentUserGuideContentResourcesBlock = ResourceLink & {
  __typename?: 'ParentUserGuideContentResourcesBlock';
  sys: ResourceSys;
};

export type ParentUserGuideContentResourcesHyperlink = ResourceLink & {
  __typename?: 'ParentUserGuideContentResourcesHyperlink';
  sys: ResourceSys;
};

export type ParentUserGuideContentResourcesInline = ResourceLink & {
  __typename?: 'ParentUserGuideContentResourcesInline';
  sys: ResourceSys;
};

export type ParentUserGuideCursorCollection = {
  __typename?: 'ParentUserGuideCursorCollection';
  items: Array<Maybe<ParentUserGuide>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ParentUserGuideFilter = {
  AND: InputMaybe<Array<InputMaybe<ParentUserGuideFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ParentUserGuideFilter>>>;
  content_contains: InputMaybe<Scalars['String']['input']>;
  content_exists: InputMaybe<Scalars['Boolean']['input']>;
  content_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product: InputMaybe<CfProductNestedFilter>;
  product_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type ParentUserGuideLinkingCollections = {
  __typename?: 'ParentUserGuideLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type ParentUserGuideLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ParentUserGuideLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ParentUserGuideOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/placementTestOverview) */
export type PlacementTestOverview = Entry & _Node & {
  __typename?: 'PlacementTestOverview';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<PlacementTestOverviewLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  pdf: Maybe<Asset>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  thumbnail: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/placementTestOverview) */
export type PlacementTestOverviewLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/placementTestOverview) */
export type PlacementTestOverviewNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/placementTestOverview) */
export type PlacementTestOverviewPdfArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/placementTestOverview) */
export type PlacementTestOverviewSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/placementTestOverview) */
export type PlacementTestOverviewThumbnailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlacementTestOverviewCollection = {
  __typename?: 'PlacementTestOverviewCollection';
  items: Array<Maybe<PlacementTestOverview>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PlacementTestOverviewCursorCollection = {
  __typename?: 'PlacementTestOverviewCursorCollection';
  items: Array<Maybe<PlacementTestOverview>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PlacementTestOverviewFilter = {
  AND: InputMaybe<Array<InputMaybe<PlacementTestOverviewFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PlacementTestOverviewFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pdf_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnail_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type PlacementTestOverviewLinkingCollections = {
  __typename?: 'PlacementTestOverviewLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type PlacementTestOverviewLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PlacementTestOverviewLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PlacementTestOverviewOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/product) */
export type Product = Entry & _Node & {
  __typename?: 'Product';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  id: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<ProductLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/product) */
export type ProductIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/product) */
export type ProductLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/product) */
export type ProductNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProductCollection = {
  __typename?: 'ProductCollection';
  items: Array<Maybe<Product>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ProductCursorCollection = {
  __typename?: 'ProductCursorCollection';
  items: Array<Maybe<Product>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type ProductFilter = {
  AND: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  OR: InputMaybe<Array<InputMaybe<ProductFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type ProductLinkingCollections = {
  __typename?: 'ProductLinkingCollections';
  activitySheetSectionCollection: Maybe<ActivitySheetSectionCollection>;
  activitySheetSectionCursorCollection: Maybe<ActivitySheetSectionCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  parentUserGuideCollection: Maybe<ParentUserGuideCollection>;
  parentUserGuideCursorCollection: Maybe<ParentUserGuideCursorCollection>;
  sampleLessonCollection: Maybe<SampleLessonCollection>;
  sampleLessonCursorCollection: Maybe<SampleLessonCursorCollection>;
  spanishActivitySheetSectionCollection: Maybe<SpanishActivitySheetSectionCollection>;
  spanishActivitySheetSectionCursorCollection: Maybe<SpanishActivitySheetSectionCursorCollection>;
};


export type ProductLinkingCollectionsActivitySheetSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsActivitySheetSectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductLinkingCollectionsActivitySheetSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsActivitySheetSectionCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductLinkingCollectionsParentUserGuideCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsParentUserGuideCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductLinkingCollectionsParentUserGuideCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsParentUserGuideCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductLinkingCollectionsSampleLessonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsSampleLessonCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductLinkingCollectionsSampleLessonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsSampleLessonCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductLinkingCollectionsSpanishActivitySheetSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsSpanishActivitySheetSectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProductLinkingCollectionsSpanishActivitySheetSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ProductLinkingCollectionsSpanishActivitySheetSectionCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProductLinkingCollectionsActivitySheetSectionCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ProductLinkingCollectionsActivitySheetSectionCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ProductLinkingCollectionsParentUserGuideCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ProductLinkingCollectionsParentUserGuideCursorCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ProductLinkingCollectionsSampleLessonCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ProductLinkingCollectionsSampleLessonCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ProductLinkingCollectionsSpanishActivitySheetSectionCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ProductLinkingCollectionsSpanishActivitySheetSectionCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum ProductOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/puiDashboardRedesignIntroVideo) */
export type PuiDashboardRedesignIntroVideo = Entry & _Node & {
  __typename?: 'PuiDashboardRedesignIntroVideo';
  _id: Scalars['ID']['output'];
  altText: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  internalName: Maybe<Scalars['String']['output']>;
  introVideoAsset: Maybe<Asset>;
  linkedFrom: Maybe<PuiDashboardRedesignIntroVideoLinkingCollections>;
  programId: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/puiDashboardRedesignIntroVideo) */
export type PuiDashboardRedesignIntroVideoAltTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/puiDashboardRedesignIntroVideo) */
export type PuiDashboardRedesignIntroVideoInternalNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/puiDashboardRedesignIntroVideo) */
export type PuiDashboardRedesignIntroVideoIntroVideoAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/puiDashboardRedesignIntroVideo) */
export type PuiDashboardRedesignIntroVideoLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/puiDashboardRedesignIntroVideo) */
export type PuiDashboardRedesignIntroVideoProgramIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type PuiDashboardRedesignIntroVideoCollection = {
  __typename?: 'PuiDashboardRedesignIntroVideoCollection';
  items: Array<Maybe<PuiDashboardRedesignIntroVideo>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PuiDashboardRedesignIntroVideoCursorCollection = {
  __typename?: 'PuiDashboardRedesignIntroVideoCursorCollection';
  items: Array<Maybe<PuiDashboardRedesignIntroVideo>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type PuiDashboardRedesignIntroVideoFilter = {
  AND: InputMaybe<Array<InputMaybe<PuiDashboardRedesignIntroVideoFilter>>>;
  OR: InputMaybe<Array<InputMaybe<PuiDashboardRedesignIntroVideoFilter>>>;
  altText: InputMaybe<Scalars['String']['input']>;
  altText_contains: InputMaybe<Scalars['String']['input']>;
  altText_exists: InputMaybe<Scalars['Boolean']['input']>;
  altText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not: InputMaybe<Scalars['String']['input']>;
  altText_not_contains: InputMaybe<Scalars['String']['input']>;
  altText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introVideoAsset_exists: InputMaybe<Scalars['Boolean']['input']>;
  programId: InputMaybe<Scalars['String']['input']>;
  programId_contains: InputMaybe<Scalars['String']['input']>;
  programId_exists: InputMaybe<Scalars['Boolean']['input']>;
  programId_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  programId_not: InputMaybe<Scalars['String']['input']>;
  programId_not_contains: InputMaybe<Scalars['String']['input']>;
  programId_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type PuiDashboardRedesignIntroVideoLinkingCollections = {
  __typename?: 'PuiDashboardRedesignIntroVideoLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type PuiDashboardRedesignIntroVideoLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type PuiDashboardRedesignIntroVideoLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PuiDashboardRedesignIntroVideoOrder {
  AltTextAsc = 'altText_ASC',
  AltTextDesc = 'altText_DESC',
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  ProgramIdAsc = 'programId_ASC',
  ProgramIdDesc = 'programId_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type Query = {
  __typename?: 'Query';
  _node: Maybe<_Node>;
  _nodes: Array<Maybe<_Node>>;
  activitySheetAsset: Maybe<ActivitySheetAsset>;
  activitySheetAssetCollection: Maybe<ActivitySheetAssetCollection>;
  activitySheetAssetCursorCollection: Maybe<ActivitySheetAssetCursorCollection>;
  activitySheetAssetGroup: Maybe<ActivitySheetAssetGroup>;
  activitySheetAssetGroupCollection: Maybe<ActivitySheetAssetGroupCollection>;
  activitySheetAssetGroupCursorCollection: Maybe<ActivitySheetAssetGroupCursorCollection>;
  activitySheetSection: Maybe<ActivitySheetSection>;
  activitySheetSectionCollection: Maybe<ActivitySheetSectionCollection>;
  activitySheetSectionCursorCollection: Maybe<ActivitySheetSectionCursorCollection>;
  asset: Maybe<Asset>;
  assetCollection: Maybe<AssetCollection>;
  assetCursorCollection: Maybe<AssetCursorCollection>;
  bigSchoolResourceList: Maybe<BigSchoolResourceList>;
  bigSchoolResourceListCollection: Maybe<BigSchoolResourceListCollection>;
  bigSchoolResourceListCursorCollection: Maybe<BigSchoolResourceListCursorCollection>;
  composeComponentArticleBody: Maybe<ComposeComponentArticleBody>;
  composeComponentArticleBodyCollection: Maybe<ComposeComponentArticleBodyCollection>;
  composeComponentArticleBodyCursorCollection: Maybe<ComposeComponentArticleBodyCursorCollection>;
  composeComponentBlockQuote: Maybe<ComposeComponentBlockQuote>;
  composeComponentBlockQuoteCollection: Maybe<ComposeComponentBlockQuoteCollection>;
  composeComponentBlockQuoteCursorCollection: Maybe<ComposeComponentBlockQuoteCursorCollection>;
  composeComponentDownloadableAsset: Maybe<ComposeComponentDownloadableAsset>;
  composeComponentDownloadableAssetCollection: Maybe<ComposeComponentDownloadableAssetCollection>;
  composeComponentDownloadableAssetCursorCollection: Maybe<ComposeComponentDownloadableAssetCursorCollection>;
  composeComponentFeaturedArticle: Maybe<ComposeComponentFeaturedArticle>;
  composeComponentFeaturedArticleCollection: Maybe<ComposeComponentFeaturedArticleCollection>;
  composeComponentFeaturedArticleCursorCollection: Maybe<ComposeComponentFeaturedArticleCursorCollection>;
  composeComponentGlobalHorizontalImageCta: Maybe<ComposeComponentGlobalHorizontalImageCta>;
  composeComponentGlobalHorizontalImageCtaCollection: Maybe<ComposeComponentGlobalHorizontalImageCtaCollection>;
  composeComponentGlobalHorizontalImageCtaCursorCollection: Maybe<ComposeComponentGlobalHorizontalImageCtaCursorCollection>;
  composeComponentGlobalVerticalImageCta: Maybe<ComposeComponentGlobalVerticalImageCta>;
  composeComponentGlobalVerticalImageCtaCollection: Maybe<ComposeComponentGlobalVerticalImageCtaCollection>;
  composeComponentGlobalVerticalImageCtaCursorCollection: Maybe<ComposeComponentGlobalVerticalImageCtaCursorCollection>;
  composeComponentHorizontalImageCta: Maybe<ComposeComponentHorizontalImageCta>;
  composeComponentHorizontalImageCtaCollection: Maybe<ComposeComponentHorizontalImageCtaCollection>;
  composeComponentHorizontalImageCtaCursorCollection: Maybe<ComposeComponentHorizontalImageCtaCursorCollection>;
  composeComponentImage: Maybe<ComposeComponentImage>;
  composeComponentImageAndAdjacentText: Maybe<ComposeComponentImageAndAdjacentText>;
  composeComponentImageAndAdjacentTextCollection: Maybe<ComposeComponentImageAndAdjacentTextCollection>;
  composeComponentImageAndAdjacentTextCursorCollection: Maybe<ComposeComponentImageAndAdjacentTextCursorCollection>;
  composeComponentImageAndAdjacentTextList: Maybe<ComposeComponentImageAndAdjacentTextList>;
  composeComponentImageAndAdjacentTextListCollection: Maybe<ComposeComponentImageAndAdjacentTextListCollection>;
  composeComponentImageAndAdjacentTextListCursorCollection: Maybe<ComposeComponentImageAndAdjacentTextListCursorCollection>;
  composeComponentImageCollection: Maybe<ComposeComponentImageCollection>;
  composeComponentImageCursorCollection: Maybe<ComposeComponentImageCursorCollection>;
  composeComponentLink: Maybe<ComposeComponentLink>;
  composeComponentLinkCollection: Maybe<ComposeComponentLinkCollection>;
  composeComponentLinkCursorCollection: Maybe<ComposeComponentLinkCursorCollection>;
  composeComponentMissionStatement: Maybe<ComposeComponentMissionStatement>;
  composeComponentMissionStatementCollection: Maybe<ComposeComponentMissionStatementCollection>;
  composeComponentMissionStatementCursorCollection: Maybe<ComposeComponentMissionStatementCursorCollection>;
  composeComponentPopularArticles: Maybe<ComposeComponentPopularArticles>;
  composeComponentPopularArticlesCollection: Maybe<ComposeComponentPopularArticlesCollection>;
  composeComponentPopularArticlesCursorCollection: Maybe<ComposeComponentPopularArticlesCursorCollection>;
  composeComponentRichTextColouredBackground: Maybe<ComposeComponentRichTextColouredBackground>;
  composeComponentRichTextColouredBackgroundCollection: Maybe<ComposeComponentRichTextColouredBackgroundCollection>;
  composeComponentRichTextColouredBackgroundCursorCollection: Maybe<ComposeComponentRichTextColouredBackgroundCursorCollection>;
  composeComponentRichTextCta: Maybe<ComposeComponentRichTextCta>;
  composeComponentRichTextCtaCollection: Maybe<ComposeComponentRichTextCtaCollection>;
  composeComponentRichTextCtaCursorCollection: Maybe<ComposeComponentRichTextCtaCursorCollection>;
  composeComponentStickyBanner: Maybe<ComposeComponentStickyBanner>;
  composeComponentStickyBannerCollection: Maybe<ComposeComponentStickyBannerCollection>;
  composeComponentStickyBannerCursorCollection: Maybe<ComposeComponentStickyBannerCursorCollection>;
  composeComponentStickyBannerItem: Maybe<ComposeComponentStickyBannerItem>;
  composeComponentStickyBannerItemCollection: Maybe<ComposeComponentStickyBannerItemCollection>;
  composeComponentStickyBannerItemCursorCollection: Maybe<ComposeComponentStickyBannerItemCursorCollection>;
  composeComponentTeacherSupportStatement: Maybe<ComposeComponentTeacherSupportStatement>;
  composeComponentTeacherSupportStatementCollection: Maybe<ComposeComponentTeacherSupportStatementCollection>;
  composeComponentTeacherSupportStatementCursorCollection: Maybe<ComposeComponentTeacherSupportStatementCursorCollection>;
  composeComponentText: Maybe<ComposeComponentText>;
  composeComponentTextCollection: Maybe<ComposeComponentTextCollection>;
  composeComponentTextCursorCollection: Maybe<ComposeComponentTextCursorCollection>;
  composeComponentTextList: Maybe<ComposeComponentTextList>;
  composeComponentTextListCollection: Maybe<ComposeComponentTextListCollection>;
  composeComponentTextListCursorCollection: Maybe<ComposeComponentTextListCursorCollection>;
  composeComponentTopic: Maybe<ComposeComponentTopic>;
  composeComponentTopicBackground: Maybe<ComposeComponentTopicBackground>;
  composeComponentTopicBackgroundCollection: Maybe<ComposeComponentTopicBackgroundCollection>;
  composeComponentTopicBackgroundCursorCollection: Maybe<ComposeComponentTopicBackgroundCursorCollection>;
  composeComponentTopicCollection: Maybe<ComposeComponentTopicCollection>;
  composeComponentTopicCursorCollection: Maybe<ComposeComponentTopicCursorCollection>;
  composeComponentTopicList: Maybe<ComposeComponentTopicList>;
  composeComponentTopicListCollection: Maybe<ComposeComponentTopicListCollection>;
  composeComponentTopicListCursorCollection: Maybe<ComposeComponentTopicListCursorCollection>;
  composeComponentUrl: Maybe<ComposeComponentUrl>;
  composeComponentUrlCollection: Maybe<ComposeComponentUrlCollection>;
  composeComponentUrlCursorCollection: Maybe<ComposeComponentUrlCursorCollection>;
  composeComponentVerticalImageCta: Maybe<ComposeComponentVerticalImageCta>;
  composeComponentVerticalImageCtaCollection: Maybe<ComposeComponentVerticalImageCtaCollection>;
  composeComponentVerticalImageCtaCursorCollection: Maybe<ComposeComponentVerticalImageCtaCursorCollection>;
  composeComponentVideoAndAdjacentText: Maybe<ComposeComponentVideoAndAdjacentText>;
  composeComponentVideoAndAdjacentTextCollection: Maybe<ComposeComponentVideoAndAdjacentTextCollection>;
  composeComponentVideoAndAdjacentTextCursorCollection: Maybe<ComposeComponentVideoAndAdjacentTextCursorCollection>;
  composeComponentWlFooterBlock: Maybe<ComposeComponentWlFooterBlock>;
  composeComponentWlFooterBlockCollection: Maybe<ComposeComponentWlFooterBlockCollection>;
  composeComponentWlFooterBlockCursorCollection: Maybe<ComposeComponentWlFooterBlockCursorCollection>;
  composeComponentWlProductAimBlock: Maybe<ComposeComponentWlProductAimBlock>;
  composeComponentWlProductAimBlockCollection: Maybe<ComposeComponentWlProductAimBlockCollection>;
  composeComponentWlProductAimBlockCursorCollection: Maybe<ComposeComponentWlProductAimBlockCursorCollection>;
  composeComponentWlTestimonialsBlock: Maybe<ComposeComponentWlTestimonialsBlock>;
  composeComponentWlTestimonialsBlockCollection: Maybe<ComposeComponentWlTestimonialsBlockCollection>;
  composeComponentWlTestimonialsBlockCursorCollection: Maybe<ComposeComponentWlTestimonialsBlockCursorCollection>;
  composeComponentYoutubeVideo: Maybe<ComposeComponentYoutubeVideo>;
  composeComponentYoutubeVideoCollection: Maybe<ComposeComponentYoutubeVideoCollection>;
  composeComponentYoutubeVideoCursorCollection: Maybe<ComposeComponentYoutubeVideoCursorCollection>;
  composePageArticle: Maybe<ComposePageArticle>;
  composePageArticleCollection: Maybe<ComposePageArticleCollection>;
  composePageArticleCursorCollection: Maybe<ComposePageArticleCursorCollection>;
  composePageArticlesIndexPage: Maybe<ComposePageArticlesIndexPage>;
  composePageArticlesIndexPageCollection: Maybe<ComposePageArticlesIndexPageCollection>;
  composePageArticlesIndexPageCursorCollection: Maybe<ComposePageArticlesIndexPageCursorCollection>;
  composePageWlMarketingHomePage: Maybe<ComposePageWlMarketingHomePage>;
  composePageWlMarketingHomePageCollection: Maybe<ComposePageWlMarketingHomePageCollection>;
  composePageWlMarketingHomePageCursorCollection: Maybe<ComposePageWlMarketingHomePageCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  getReadyForBigSchoolList: Maybe<GetReadyForBigSchoolList>;
  getReadyForBigSchoolListCollection: Maybe<GetReadyForBigSchoolListCollection>;
  getReadyForBigSchoolListCursorCollection: Maybe<GetReadyForBigSchoolListCursorCollection>;
  homeschoolMaxGuides: Maybe<HomeschoolMaxGuides>;
  homeschoolMaxGuidesCollection: Maybe<HomeschoolMaxGuidesCollection>;
  homeschoolMaxGuidesCursorCollection: Maybe<HomeschoolMaxGuidesCursorCollection>;
  homeschoolMaxWebinar: Maybe<HomeschoolMaxWebinar>;
  homeschoolMaxWebinarCollection: Maybe<HomeschoolMaxWebinarCollection>;
  homeschoolMaxWebinarCursorCollection: Maybe<HomeschoolMaxWebinarCursorCollection>;
  homeschoolPlusGuides: Maybe<HomeschoolPlusGuides>;
  homeschoolPlusGuidesCollection: Maybe<HomeschoolPlusGuidesCollection>;
  homeschoolPlusGuidesCursorCollection: Maybe<HomeschoolPlusGuidesCursorCollection>;
  homeschoolPlusWebinar: Maybe<HomeschoolPlusWebinar>;
  homeschoolPlusWebinarCollection: Maybe<HomeschoolPlusWebinarCollection>;
  homeschoolPlusWebinarCursorCollection: Maybe<HomeschoolPlusWebinarCursorCollection>;
  homeschoolProgram: Maybe<HomeschoolProgram>;
  homeschoolProgramCollection: Maybe<HomeschoolProgramCollection>;
  homeschoolProgramCursorCollection: Maybe<HomeschoolProgramCursorCollection>;
  jumpLink: Maybe<JumpLink>;
  jumpLinkCollection: Maybe<JumpLinkCollection>;
  jumpLinkCursorCollection: Maybe<JumpLinkCursorCollection>;
  legoUiButton: Maybe<LegoUiButton>;
  legoUiButtonCollection: Maybe<LegoUiButtonCollection>;
  legoUiButtonCursorCollection: Maybe<LegoUiButtonCursorCollection>;
  legoUiCallToActionBlock: Maybe<LegoUiCallToActionBlock>;
  legoUiCallToActionBlockCollection: Maybe<LegoUiCallToActionBlockCollection>;
  legoUiCallToActionBlockCursorCollection: Maybe<LegoUiCallToActionBlockCursorCollection>;
  legoUiCarousel: Maybe<LegoUiCarousel>;
  legoUiCarouselCollection: Maybe<LegoUiCarouselCollection>;
  legoUiCarouselCursorCollection: Maybe<LegoUiCarouselCursorCollection>;
  legoUiColumn: Maybe<LegoUiColumn>;
  legoUiColumnCollection: Maybe<LegoUiColumnCollection>;
  legoUiColumnCursorCollection: Maybe<LegoUiColumnCursorCollection>;
  legoUiColumnLayout: Maybe<LegoUiColumnLayout>;
  legoUiColumnLayoutCollection: Maybe<LegoUiColumnLayoutCollection>;
  legoUiColumnLayoutCursorCollection: Maybe<LegoUiColumnLayoutCursorCollection>;
  legoUiFooter: Maybe<LegoUiFooter>;
  legoUiFooterCollection: Maybe<LegoUiFooterCollection>;
  legoUiFooterCursorCollection: Maybe<LegoUiFooterCursorCollection>;
  legoUiFooterLink: Maybe<LegoUiFooterLink>;
  legoUiFooterLinkCollection: Maybe<LegoUiFooterLinkCollection>;
  legoUiFooterLinkCursorCollection: Maybe<LegoUiFooterLinkCursorCollection>;
  legoUiFooterLinkGroup: Maybe<LegoUiFooterLinkGroup>;
  legoUiFooterLinkGroupCollection: Maybe<LegoUiFooterLinkGroupCollection>;
  legoUiFooterLinkGroupCursorCollection: Maybe<LegoUiFooterLinkGroupCursorCollection>;
  legoUiHeroCard: Maybe<LegoUiHeroCard>;
  legoUiHeroCardCollection: Maybe<LegoUiHeroCardCollection>;
  legoUiHeroCardCursorCollection: Maybe<LegoUiHeroCardCursorCollection>;
  legoUiImageWithLink: Maybe<LegoUiImageWithLink>;
  legoUiImageWithLinkCollection: Maybe<LegoUiImageWithLinkCollection>;
  legoUiImageWithLinkCursorCollection: Maybe<LegoUiImageWithLinkCursorCollection>;
  legoUiPageDivider: Maybe<LegoUiPageDivider>;
  legoUiPageDividerCollection: Maybe<LegoUiPageDividerCollection>;
  legoUiPageDividerCursorCollection: Maybe<LegoUiPageDividerCursorCollection>;
  legoUiProgramCard: Maybe<LegoUiProgramCard>;
  legoUiProgramCardCollection: Maybe<LegoUiProgramCardCollection>;
  legoUiProgramCardCursorCollection: Maybe<LegoUiProgramCardCursorCollection>;
  legoUiSocialMediaLink: Maybe<LegoUiSocialMediaLink>;
  legoUiSocialMediaLinkCollection: Maybe<LegoUiSocialMediaLinkCollection>;
  legoUiSocialMediaLinkCursorCollection: Maybe<LegoUiSocialMediaLinkCursorCollection>;
  legoUiTestimonialCard: Maybe<LegoUiTestimonialCard>;
  legoUiTestimonialCardCollection: Maybe<LegoUiTestimonialCardCollection>;
  legoUiTestimonialCardCursorCollection: Maybe<LegoUiTestimonialCardCursorCollection>;
  legoUiVideo: Maybe<LegoUiVideo>;
  legoUiVideoBlock: Maybe<LegoUiVideoBlock>;
  legoUiVideoBlockCollection: Maybe<LegoUiVideoBlockCollection>;
  legoUiVideoBlockCursorCollection: Maybe<LegoUiVideoBlockCursorCollection>;
  legoUiVideoCollection: Maybe<LegoUiVideoCollection>;
  legoUiVideoCursorCollection: Maybe<LegoUiVideoCursorCollection>;
  lessonOverview: Maybe<LessonOverview>;
  lessonOverviewCollection: Maybe<LessonOverviewCollection>;
  lessonOverviewCursorCollection: Maybe<LessonOverviewCursorCollection>;
  link: Maybe<Link>;
  linkCollection: Maybe<LinkCollection>;
  linkCursorCollection: Maybe<LinkCursorCollection>;
  marketingBlogGlobalRegionalEdits: Maybe<MarketingBlogGlobalRegionalEdits>;
  marketingBlogGlobalRegionalEditsCollection: Maybe<MarketingBlogGlobalRegionalEditsCollection>;
  marketingBlogGlobalRegionalEditsCursorCollection: Maybe<MarketingBlogGlobalRegionalEditsCursorCollection>;
  marketingBlogRegionalEdit: Maybe<MarketingBlogRegionalEdit>;
  marketingBlogRegionalEditCollection: Maybe<MarketingBlogRegionalEditCollection>;
  marketingBlogRegionalEditCursorCollection: Maybe<MarketingBlogRegionalEditCursorCollection>;
  pCampaign: Maybe<PCampaign>;
  pCampaignB2B: Maybe<PCampaignB2B>;
  pCampaignB2BCollection: Maybe<PCampaignB2BCollection>;
  pCampaignB2BCursorCollection: Maybe<PCampaignB2BCursorCollection>;
  pCampaignCollection: Maybe<PCampaignCollection>;
  pCampaignCursorCollection: Maybe<PCampaignCursorCollection>;
  pContentPage: Maybe<PContentPage>;
  pContentPageCollection: Maybe<PContentPageCollection>;
  pContentPageCursorCollection: Maybe<PContentPageCursorCollection>;
  pFreeResource: Maybe<PFreeResource>;
  pFreeResourceCollection: Maybe<PFreeResourceCollection>;
  pFreeResourceCursorCollection: Maybe<PFreeResourceCursorCollection>;
  pJson: Maybe<PJson>;
  pJsonCollection: Maybe<PJsonCollection>;
  pJsonCursorCollection: Maybe<PJsonCursorCollection>;
  pLinkedEntry: Maybe<PLinkedEntry>;
  pLinkedEntryCollection: Maybe<PLinkedEntryCollection>;
  pLinkedEntryCursorCollection: Maybe<PLinkedEntryCursorCollection>;
  parentUiRichTextHyperlink: Maybe<ParentUiRichTextHyperlink>;
  parentUiRichTextHyperlinkCollection: Maybe<ParentUiRichTextHyperlinkCollection>;
  parentUiRichTextHyperlinkCursorCollection: Maybe<ParentUiRichTextHyperlinkCursorCollection>;
  parentUserGuide: Maybe<ParentUserGuide>;
  parentUserGuideCollection: Maybe<ParentUserGuideCollection>;
  parentUserGuideCursorCollection: Maybe<ParentUserGuideCursorCollection>;
  placementTestOverview: Maybe<PlacementTestOverview>;
  placementTestOverviewCollection: Maybe<PlacementTestOverviewCollection>;
  placementTestOverviewCursorCollection: Maybe<PlacementTestOverviewCursorCollection>;
  product: Maybe<Product>;
  productCollection: Maybe<ProductCollection>;
  productCursorCollection: Maybe<ProductCursorCollection>;
  puiDashboardRedesignIntroVideo: Maybe<PuiDashboardRedesignIntroVideo>;
  puiDashboardRedesignIntroVideoCollection: Maybe<PuiDashboardRedesignIntroVideoCollection>;
  puiDashboardRedesignIntroVideoCursorCollection: Maybe<PuiDashboardRedesignIntroVideoCursorCollection>;
  rewardMap: Maybe<RewardMap>;
  rewardMapCollection: Maybe<RewardMapCollection>;
  rewardMapCursorCollection: Maybe<RewardMapCursorCollection>;
  rolePermissions: Maybe<RolePermissions>;
  rolePermissionsCollection: Maybe<RolePermissionsCollection>;
  rolePermissionsCursorCollection: Maybe<RolePermissionsCursorCollection>;
  sampleLesson: Maybe<SampleLesson>;
  sampleLessonCollection: Maybe<SampleLessonCollection>;
  sampleLessonCursorCollection: Maybe<SampleLessonCursorCollection>;
  spanishActivitySheetAsset: Maybe<SpanishActivitySheetAsset>;
  spanishActivitySheetAssetCollection: Maybe<SpanishActivitySheetAssetCollection>;
  spanishActivitySheetAssetCursorCollection: Maybe<SpanishActivitySheetAssetCursorCollection>;
  spanishActivitySheetAssetGroup: Maybe<SpanishActivitySheetAssetGroup>;
  spanishActivitySheetAssetGroupCollection: Maybe<SpanishActivitySheetAssetGroupCollection>;
  spanishActivitySheetAssetGroupCursorCollection: Maybe<SpanishActivitySheetAssetGroupCursorCollection>;
  spanishActivitySheetSection: Maybe<SpanishActivitySheetSection>;
  spanishActivitySheetSectionCollection: Maybe<SpanishActivitySheetSectionCollection>;
  spanishActivitySheetSectionCursorCollection: Maybe<SpanishActivitySheetSectionCursorCollection>;
  summerSchoolFaq: Maybe<SummerSchoolFaq>;
  summerSchoolFaqCollection: Maybe<SummerSchoolFaqCollection>;
  summerSchoolFaqCursorCollection: Maybe<SummerSchoolFaqCursorCollection>;
  summerSchoolFaqList: Maybe<SummerSchoolFaqList>;
  summerSchoolFaqListCollection: Maybe<SummerSchoolFaqListCollection>;
  summerSchoolFaqListCursorCollection: Maybe<SummerSchoolFaqListCursorCollection>;
  summerSchoolPage: Maybe<SummerSchoolPage>;
  summerSchoolPageCollection: Maybe<SummerSchoolPageCollection>;
  summerSchoolPageCursorCollection: Maybe<SummerSchoolPageCursorCollection>;
  summerSchoolPlaceholder: Maybe<SummerSchoolPlaceholder>;
  summerSchoolPlaceholderCollection: Maybe<SummerSchoolPlaceholderCollection>;
  summerSchoolPlaceholderCursorCollection: Maybe<SummerSchoolPlaceholderCursorCollection>;
  summerSchoolResource: Maybe<SummerSchoolResource>;
  summerSchoolResourceCollection: Maybe<SummerSchoolResourceCollection>;
  summerSchoolResourceCursorCollection: Maybe<SummerSchoolResourceCursorCollection>;
  summerSchoolResourceGroup: Maybe<SummerSchoolResourceGroup>;
  summerSchoolResourceGroupCollection: Maybe<SummerSchoolResourceGroupCollection>;
  summerSchoolResourceGroupCursorCollection: Maybe<SummerSchoolResourceGroupCursorCollection>;
  summerSchoolResourceGroupList: Maybe<SummerSchoolResourceGroupList>;
  summerSchoolResourceGroupListCollection: Maybe<SummerSchoolResourceGroupListCollection>;
  summerSchoolResourceGroupListCursorCollection: Maybe<SummerSchoolResourceGroupListCursorCollection>;
  summerSchoolResourceList: Maybe<SummerSchoolResourceList>;
  summerSchoolResourceListCollection: Maybe<SummerSchoolResourceListCollection>;
  summerSchoolResourceListCursorCollection: Maybe<SummerSchoolResourceListCursorCollection>;
  summerSchoolSection: Maybe<SummerSchoolSection>;
  summerSchoolSectionCollection: Maybe<SummerSchoolSectionCollection>;
  summerSchoolSectionCursorCollection: Maybe<SummerSchoolSectionCursorCollection>;
  summerSchoolWebinar: Maybe<SummerSchoolWebinar>;
  summerSchoolWebinarCollection: Maybe<SummerSchoolWebinarCollection>;
  summerSchoolWebinarCursorCollection: Maybe<SummerSchoolWebinarCursorCollection>;
  summerSchoolWebinarList: Maybe<SummerSchoolWebinarList>;
  summerSchoolWebinarListCollection: Maybe<SummerSchoolWebinarListCollection>;
  summerSchoolWebinarListCursorCollection: Maybe<SummerSchoolWebinarListCursorCollection>;
  teacherTestimonialBlock: Maybe<TeacherTestimonialBlock>;
  teacherTestimonialBlockCollection: Maybe<TeacherTestimonialBlockCollection>;
  teacherTestimonialBlockCursorCollection: Maybe<TeacherTestimonialBlockCursorCollection>;
  writingLegendsFreeTrialBlock: Maybe<WritingLegendsFreeTrialBlock>;
  writingLegendsFreeTrialBlockCollection: Maybe<WritingLegendsFreeTrialBlockCollection>;
  writingLegendsFreeTrialBlockCursorCollection: Maybe<WritingLegendsFreeTrialBlockCursorCollection>;
  writingLegendsMarketingSiteAboutUsPage: Maybe<WritingLegendsMarketingSiteAboutUsPage>;
  writingLegendsMarketingSiteAboutUsPageCollection: Maybe<WritingLegendsMarketingSiteAboutUsPageCollection>;
  writingLegendsMarketingSiteAboutUsPageCursorCollection: Maybe<WritingLegendsMarketingSiteAboutUsPageCursorCollection>;
  writingLegendsMarketingSiteAccessibilityPage: Maybe<WritingLegendsMarketingSiteAccessibilityPage>;
  writingLegendsMarketingSiteAccessibilityPageCollection: Maybe<WritingLegendsMarketingSiteAccessibilityPageCollection>;
  writingLegendsMarketingSiteAccessibilityPageCursorCollection: Maybe<WritingLegendsMarketingSiteAccessibilityPageCursorCollection>;
  writingLegendsMarketingSiteContactUsPage: Maybe<WritingLegendsMarketingSiteContactUsPage>;
  writingLegendsMarketingSiteContactUsPageCollection: Maybe<WritingLegendsMarketingSiteContactUsPageCollection>;
  writingLegendsMarketingSiteContactUsPageCursorCollection: Maybe<WritingLegendsMarketingSiteContactUsPageCursorCollection>;
  writingLegendsMarketingSiteContactUsPageV2: Maybe<WritingLegendsMarketingSiteContactUsPageV2>;
  writingLegendsMarketingSiteContactUsPageV2Collection: Maybe<WritingLegendsMarketingSiteContactUsPageV2Collection>;
  writingLegendsMarketingSiteContactUsPageV2CursorCollection: Maybe<WritingLegendsMarketingSiteContactUsPageV2CursorCollection>;
  writingLegendsMarketingSiteFaQsPage: Maybe<WritingLegendsMarketingSiteFaQsPage>;
  writingLegendsMarketingSiteFaQsPageCollection: Maybe<WritingLegendsMarketingSiteFaQsPageCollection>;
  writingLegendsMarketingSiteFaQsPageCursorCollection: Maybe<WritingLegendsMarketingSiteFaQsPageCursorCollection>;
  writingLegendsMarketingSiteIndexPage: Maybe<WritingLegendsMarketingSiteIndexPage>;
  writingLegendsMarketingSiteIndexPageCollection: Maybe<WritingLegendsMarketingSiteIndexPageCollection>;
  writingLegendsMarketingSiteIndexPageCursorCollection: Maybe<WritingLegendsMarketingSiteIndexPageCursorCollection>;
  writingLegendsMarketingSitePrivacyPolicyPage: Maybe<WritingLegendsMarketingSitePrivacyPolicyPage>;
  writingLegendsMarketingSitePrivacyPolicyPageCollection: Maybe<WritingLegendsMarketingSitePrivacyPolicyPageCollection>;
  writingLegendsMarketingSitePrivacyPolicyPageCursorCollection: Maybe<WritingLegendsMarketingSitePrivacyPolicyPageCursorCollection>;
  writingLegendsMarketingSiteTechReqPage: Maybe<WritingLegendsMarketingSiteTechReqPage>;
  writingLegendsMarketingSiteTechReqPageCollection: Maybe<WritingLegendsMarketingSiteTechReqPageCollection>;
  writingLegendsMarketingSiteTechReqPageCursorCollection: Maybe<WritingLegendsMarketingSiteTechReqPageCursorCollection>;
  writingLegendsMarketingSiteTermsOfUsePage: Maybe<WritingLegendsMarketingSiteTermsOfUsePage>;
  writingLegendsMarketingSiteTermsOfUsePageCollection: Maybe<WritingLegendsMarketingSiteTermsOfUsePageCollection>;
  writingLegendsMarketingSiteTermsOfUsePageCursorCollection: Maybe<WritingLegendsMarketingSiteTermsOfUsePageCursorCollection>;
};


export type Query_NodeArgs = {
  id: Scalars['ID']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type Query_NodesArgs = {
  ids: Array<Scalars['ID']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryActivitySheetAssetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryActivitySheetAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetAssetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ActivitySheetAssetFilter>;
};


export type QueryActivitySheetAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetAssetOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ActivitySheetAssetFilter>;
};


export type QueryActivitySheetAssetGroupArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryActivitySheetAssetGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetAssetGroupOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ActivitySheetAssetGroupFilter>;
};


export type QueryActivitySheetAssetGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetAssetGroupOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ActivitySheetAssetGroupFilter>;
};


export type QueryActivitySheetSectionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryActivitySheetSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetSectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ActivitySheetSectionFilter>;
};


export type QueryActivitySheetSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ActivitySheetSectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ActivitySheetSectionFilter>;
};


export type QueryAssetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AssetFilter>;
};


export type QueryAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<AssetOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<AssetFilter>;
};


export type QueryBigSchoolResourceListArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBigSchoolResourceListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<BigSchoolResourceListOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<BigSchoolResourceListFilter>;
};


export type QueryBigSchoolResourceListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<BigSchoolResourceListOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<BigSchoolResourceListFilter>;
};


export type QueryComposeComponentArticleBodyArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentArticleBodyCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentArticleBodyOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentArticleBodyFilter>;
};


export type QueryComposeComponentArticleBodyCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentArticleBodyOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentArticleBodyFilter>;
};


export type QueryComposeComponentBlockQuoteArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentBlockQuoteCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentBlockQuoteOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentBlockQuoteFilter>;
};


export type QueryComposeComponentBlockQuoteCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentBlockQuoteOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentBlockQuoteFilter>;
};


export type QueryComposeComponentDownloadableAssetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentDownloadableAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentDownloadableAssetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentDownloadableAssetFilter>;
};


export type QueryComposeComponentDownloadableAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentDownloadableAssetOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentDownloadableAssetFilter>;
};


export type QueryComposeComponentFeaturedArticleArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentFeaturedArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentFeaturedArticleOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentFeaturedArticleFilter>;
};


export type QueryComposeComponentFeaturedArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentFeaturedArticleOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentFeaturedArticleFilter>;
};


export type QueryComposeComponentGlobalHorizontalImageCtaArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentGlobalHorizontalImageCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentGlobalHorizontalImageCtaOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentGlobalHorizontalImageCtaFilter>;
};


export type QueryComposeComponentGlobalHorizontalImageCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentGlobalHorizontalImageCtaOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentGlobalHorizontalImageCtaFilter>;
};


export type QueryComposeComponentGlobalVerticalImageCtaArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentGlobalVerticalImageCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentGlobalVerticalImageCtaOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentGlobalVerticalImageCtaFilter>;
};


export type QueryComposeComponentGlobalVerticalImageCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentGlobalVerticalImageCtaOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentGlobalVerticalImageCtaFilter>;
};


export type QueryComposeComponentHorizontalImageCtaArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentHorizontalImageCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentHorizontalImageCtaOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentHorizontalImageCtaFilter>;
};


export type QueryComposeComponentHorizontalImageCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentHorizontalImageCtaOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentHorizontalImageCtaFilter>;
};


export type QueryComposeComponentImageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentImageAndAdjacentTextArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentImageAndAdjacentTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageAndAdjacentTextFilter>;
};


export type QueryComposeComponentImageAndAdjacentTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageAndAdjacentTextFilter>;
};


export type QueryComposeComponentImageAndAdjacentTextListArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentImageAndAdjacentTextListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextListOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageAndAdjacentTextListFilter>;
};


export type QueryComposeComponentImageAndAdjacentTextListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageAndAdjacentTextListOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageAndAdjacentTextListFilter>;
};


export type QueryComposeComponentImageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


export type QueryComposeComponentImageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentImageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


export type QueryComposeComponentLinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentLinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentLinkFilter>;
};


export type QueryComposeComponentLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentLinkOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentLinkFilter>;
};


export type QueryComposeComponentMissionStatementArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentMissionStatementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentMissionStatementOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentMissionStatementFilter>;
};


export type QueryComposeComponentMissionStatementCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentMissionStatementOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentMissionStatementFilter>;
};


export type QueryComposeComponentPopularArticlesArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentPopularArticlesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentPopularArticlesOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentPopularArticlesFilter>;
};


export type QueryComposeComponentPopularArticlesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentPopularArticlesOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentPopularArticlesFilter>;
};


export type QueryComposeComponentRichTextColouredBackgroundArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentRichTextColouredBackgroundCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentRichTextColouredBackgroundOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentRichTextColouredBackgroundFilter>;
};


export type QueryComposeComponentRichTextColouredBackgroundCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentRichTextColouredBackgroundOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentRichTextColouredBackgroundFilter>;
};


export type QueryComposeComponentRichTextCtaArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentRichTextCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentRichTextCtaOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentRichTextCtaFilter>;
};


export type QueryComposeComponentRichTextCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentRichTextCtaOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentRichTextCtaFilter>;
};


export type QueryComposeComponentStickyBannerArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentStickyBannerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentStickyBannerFilter>;
};


export type QueryComposeComponentStickyBannerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentStickyBannerFilter>;
};


export type QueryComposeComponentStickyBannerItemArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentStickyBannerItemCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerItemOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentStickyBannerItemFilter>;
};


export type QueryComposeComponentStickyBannerItemCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentStickyBannerItemOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentStickyBannerItemFilter>;
};


export type QueryComposeComponentTeacherSupportStatementArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentTeacherSupportStatementCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTeacherSupportStatementOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTeacherSupportStatementFilter>;
};


export type QueryComposeComponentTeacherSupportStatementCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTeacherSupportStatementOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTeacherSupportStatementFilter>;
};


export type QueryComposeComponentTextArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTextOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTextFilter>;
};


export type QueryComposeComponentTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTextOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTextFilter>;
};


export type QueryComposeComponentTextListArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentTextListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTextListOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTextListFilter>;
};


export type QueryComposeComponentTextListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTextListOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTextListFilter>;
};


export type QueryComposeComponentTopicArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentTopicBackgroundArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentTopicBackgroundCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicBackgroundOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicBackgroundFilter>;
};


export type QueryComposeComponentTopicBackgroundCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicBackgroundOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicBackgroundFilter>;
};


export type QueryComposeComponentTopicCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicFilter>;
};


export type QueryComposeComponentTopicCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicFilter>;
};


export type QueryComposeComponentTopicListArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentTopicListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicListOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicListFilter>;
};


export type QueryComposeComponentTopicListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentTopicListOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentTopicListFilter>;
};


export type QueryComposeComponentUrlArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentUrlCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentUrlOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentUrlFilter>;
};


export type QueryComposeComponentUrlCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentUrlOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentUrlFilter>;
};


export type QueryComposeComponentVerticalImageCtaArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentVerticalImageCtaCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentVerticalImageCtaOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentVerticalImageCtaFilter>;
};


export type QueryComposeComponentVerticalImageCtaCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentVerticalImageCtaOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentVerticalImageCtaFilter>;
};


export type QueryComposeComponentVideoAndAdjacentTextArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentVideoAndAdjacentTextCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentVideoAndAdjacentTextOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentVideoAndAdjacentTextFilter>;
};


export type QueryComposeComponentVideoAndAdjacentTextCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentVideoAndAdjacentTextOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentVideoAndAdjacentTextFilter>;
};


export type QueryComposeComponentWlFooterBlockArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentWlFooterBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlFooterBlockOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentWlFooterBlockFilter>;
};


export type QueryComposeComponentWlFooterBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlFooterBlockOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentWlFooterBlockFilter>;
};


export type QueryComposeComponentWlProductAimBlockArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentWlProductAimBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlProductAimBlockOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentWlProductAimBlockFilter>;
};


export type QueryComposeComponentWlProductAimBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlProductAimBlockOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentWlProductAimBlockFilter>;
};


export type QueryComposeComponentWlTestimonialsBlockArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentWlTestimonialsBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlTestimonialsBlockOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentWlTestimonialsBlockFilter>;
};


export type QueryComposeComponentWlTestimonialsBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentWlTestimonialsBlockOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentWlTestimonialsBlockFilter>;
};


export type QueryComposeComponentYoutubeVideoArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposeComponentYoutubeVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentYoutubeVideoOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentYoutubeVideoFilter>;
};


export type QueryComposeComponentYoutubeVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposeComponentYoutubeVideoOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentYoutubeVideoFilter>;
};


export type QueryComposePageArticleArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposePageArticleCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageArticleFilter>;
};


export type QueryComposePageArticleCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticleOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageArticleFilter>;
};


export type QueryComposePageArticlesIndexPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposePageArticlesIndexPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticlesIndexPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageArticlesIndexPageFilter>;
};


export type QueryComposePageArticlesIndexPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageArticlesIndexPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageArticlesIndexPageFilter>;
};


export type QueryComposePageWlMarketingHomePageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryComposePageWlMarketingHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageWlMarketingHomePageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageWlMarketingHomePageFilter>;
};


export type QueryComposePageWlMarketingHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ComposePageWlMarketingHomePageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposePageWlMarketingHomePageFilter>;
};


export type QueryEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<EntryFilter>;
};


export type QueryEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<EntryOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<EntryFilter>;
};


export type QueryGetReadyForBigSchoolListArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetReadyForBigSchoolListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GetReadyForBigSchoolListOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GetReadyForBigSchoolListFilter>;
};


export type QueryGetReadyForBigSchoolListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<GetReadyForBigSchoolListOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<GetReadyForBigSchoolListFilter>;
};


export type QueryHomeschoolMaxGuidesArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHomeschoolMaxGuidesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomeschoolMaxGuidesOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomeschoolMaxGuidesFilter>;
};


export type QueryHomeschoolMaxGuidesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomeschoolMaxGuidesOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomeschoolMaxGuidesFilter>;
};


export type QueryHomeschoolMaxWebinarArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHomeschoolMaxWebinarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomeschoolMaxWebinarOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomeschoolMaxWebinarFilter>;
};


export type QueryHomeschoolMaxWebinarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomeschoolMaxWebinarOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomeschoolMaxWebinarFilter>;
};


export type QueryHomeschoolPlusGuidesArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHomeschoolPlusGuidesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomeschoolPlusGuidesOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomeschoolPlusGuidesFilter>;
};


export type QueryHomeschoolPlusGuidesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomeschoolPlusGuidesOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomeschoolPlusGuidesFilter>;
};


export type QueryHomeschoolPlusWebinarArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHomeschoolPlusWebinarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomeschoolPlusWebinarOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomeschoolPlusWebinarFilter>;
};


export type QueryHomeschoolPlusWebinarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomeschoolPlusWebinarOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomeschoolPlusWebinarFilter>;
};


export type QueryHomeschoolProgramArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryHomeschoolProgramCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomeschoolProgramOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomeschoolProgramFilter>;
};


export type QueryHomeschoolProgramCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<HomeschoolProgramOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<HomeschoolProgramFilter>;
};


export type QueryJumpLinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryJumpLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<JumpLinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<JumpLinkFilter>;
};


export type QueryJumpLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<JumpLinkOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<JumpLinkFilter>;
};


export type QueryLegoUiButtonArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiButtonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiButtonOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiButtonFilter>;
};


export type QueryLegoUiButtonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiButtonOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiButtonFilter>;
};


export type QueryLegoUiCallToActionBlockArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiCallToActionBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiCallToActionBlockOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiCallToActionBlockFilter>;
};


export type QueryLegoUiCallToActionBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiCallToActionBlockOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiCallToActionBlockFilter>;
};


export type QueryLegoUiCarouselArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiCarouselCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiCarouselOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiCarouselFilter>;
};


export type QueryLegoUiCarouselCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiCarouselOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiCarouselFilter>;
};


export type QueryLegoUiColumnArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiColumnCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiColumnOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiColumnFilter>;
};


export type QueryLegoUiColumnCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiColumnOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiColumnFilter>;
};


export type QueryLegoUiColumnLayoutArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiColumnLayoutCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiColumnLayoutOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiColumnLayoutFilter>;
};


export type QueryLegoUiColumnLayoutCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiColumnLayoutOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiColumnLayoutFilter>;
};


export type QueryLegoUiFooterArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiFooterCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterFilter>;
};


export type QueryLegoUiFooterCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterFilter>;
};


export type QueryLegoUiFooterLinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiFooterLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterLinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterLinkFilter>;
};


export type QueryLegoUiFooterLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterLinkOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterLinkFilter>;
};


export type QueryLegoUiFooterLinkGroupArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiFooterLinkGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterLinkGroupOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterLinkGroupFilter>;
};


export type QueryLegoUiFooterLinkGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiFooterLinkGroupOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiFooterLinkGroupFilter>;
};


export type QueryLegoUiHeroCardArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiHeroCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiHeroCardOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiHeroCardFilter>;
};


export type QueryLegoUiHeroCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiHeroCardOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiHeroCardFilter>;
};


export type QueryLegoUiImageWithLinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiImageWithLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiImageWithLinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiImageWithLinkFilter>;
};


export type QueryLegoUiImageWithLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiImageWithLinkOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiImageWithLinkFilter>;
};


export type QueryLegoUiPageDividerArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiPageDividerCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiPageDividerOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiPageDividerFilter>;
};


export type QueryLegoUiPageDividerCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiPageDividerOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiPageDividerFilter>;
};


export type QueryLegoUiProgramCardArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiProgramCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiProgramCardOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiProgramCardFilter>;
};


export type QueryLegoUiProgramCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiProgramCardOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiProgramCardFilter>;
};


export type QueryLegoUiSocialMediaLinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiSocialMediaLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiSocialMediaLinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiSocialMediaLinkFilter>;
};


export type QueryLegoUiSocialMediaLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiSocialMediaLinkOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiSocialMediaLinkFilter>;
};


export type QueryLegoUiTestimonialCardArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiTestimonialCardCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiTestimonialCardOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiTestimonialCardFilter>;
};


export type QueryLegoUiTestimonialCardCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiTestimonialCardOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiTestimonialCardFilter>;
};


export type QueryLegoUiVideoArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiVideoBlockArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLegoUiVideoBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiVideoBlockOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiVideoBlockFilter>;
};


export type QueryLegoUiVideoBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiVideoBlockOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiVideoBlockFilter>;
};


export type QueryLegoUiVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiVideoOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiVideoFilter>;
};


export type QueryLegoUiVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LegoUiVideoOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiVideoFilter>;
};


export type QueryLessonOverviewArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLessonOverviewCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LessonOverviewOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LessonOverviewFilter>;
};


export type QueryLessonOverviewCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LessonOverviewOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LessonOverviewFilter>;
};


export type QueryLinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LinkFilter>;
};


export type QueryLinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<LinkOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LinkFilter>;
};


export type QueryMarketingBlogGlobalRegionalEditsArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarketingBlogGlobalRegionalEditsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MarketingBlogGlobalRegionalEditsOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MarketingBlogGlobalRegionalEditsFilter>;
};


export type QueryMarketingBlogGlobalRegionalEditsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MarketingBlogGlobalRegionalEditsOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MarketingBlogGlobalRegionalEditsFilter>;
};


export type QueryMarketingBlogRegionalEditArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryMarketingBlogRegionalEditCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MarketingBlogRegionalEditOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MarketingBlogRegionalEditFilter>;
};


export type QueryMarketingBlogRegionalEditCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<MarketingBlogRegionalEditOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<MarketingBlogRegionalEditFilter>;
};


export type QueryPCampaignArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPCampaignB2BArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPCampaignB2BCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PCampaignB2BOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PCampaignB2BFilter>;
};


export type QueryPCampaignB2BCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PCampaignB2BOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PCampaignB2BFilter>;
};


export type QueryPCampaignCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PCampaignOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PCampaignFilter>;
};


export type QueryPCampaignCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PCampaignOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PCampaignFilter>;
};


export type QueryPContentPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPContentPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PContentPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PContentPageFilter>;
};


export type QueryPContentPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PContentPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PContentPageFilter>;
};


export type QueryPFreeResourceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPFreeResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PFreeResourceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PFreeResourceFilter>;
};


export type QueryPFreeResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PFreeResourceOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PFreeResourceFilter>;
};


export type QueryPJsonArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPJsonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PJsonOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PJsonFilter>;
};


export type QueryPJsonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PJsonOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PJsonFilter>;
};


export type QueryPLinkedEntryArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPLinkedEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PLinkedEntryOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PLinkedEntryFilter>;
};


export type QueryPLinkedEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PLinkedEntryOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PLinkedEntryFilter>;
};


export type QueryParentUiRichTextHyperlinkArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryParentUiRichTextHyperlinkCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ParentUiRichTextHyperlinkOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ParentUiRichTextHyperlinkFilter>;
};


export type QueryParentUiRichTextHyperlinkCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ParentUiRichTextHyperlinkOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ParentUiRichTextHyperlinkFilter>;
};


export type QueryParentUserGuideArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryParentUserGuideCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ParentUserGuideOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ParentUserGuideFilter>;
};


export type QueryParentUserGuideCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ParentUserGuideOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ParentUserGuideFilter>;
};


export type QueryPlacementTestOverviewArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPlacementTestOverviewCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PlacementTestOverviewOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PlacementTestOverviewFilter>;
};


export type QueryPlacementTestOverviewCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PlacementTestOverviewOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PlacementTestOverviewFilter>;
};


export type QueryProductArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProductCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ProductOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ProductFilter>;
};


export type QueryProductCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<ProductOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ProductFilter>;
};


export type QueryPuiDashboardRedesignIntroVideoArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPuiDashboardRedesignIntroVideoCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PuiDashboardRedesignIntroVideoOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PuiDashboardRedesignIntroVideoFilter>;
};


export type QueryPuiDashboardRedesignIntroVideoCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<PuiDashboardRedesignIntroVideoOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<PuiDashboardRedesignIntroVideoFilter>;
};


export type QueryRewardMapArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRewardMapCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<RewardMapOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<RewardMapFilter>;
};


export type QueryRewardMapCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<RewardMapOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<RewardMapFilter>;
};


export type QueryRolePermissionsArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRolePermissionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<RolePermissionsOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<RolePermissionsFilter>;
};


export type QueryRolePermissionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<RolePermissionsOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<RolePermissionsFilter>;
};


export type QuerySampleLessonArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySampleLessonCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SampleLessonOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SampleLessonFilter>;
};


export type QuerySampleLessonCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SampleLessonOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SampleLessonFilter>;
};


export type QuerySpanishActivitySheetAssetArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySpanishActivitySheetAssetCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpanishActivitySheetAssetFilter>;
};


export type QuerySpanishActivitySheetAssetCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpanishActivitySheetAssetFilter>;
};


export type QuerySpanishActivitySheetAssetGroupArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySpanishActivitySheetAssetGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetGroupOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpanishActivitySheetAssetGroupFilter>;
};


export type QuerySpanishActivitySheetAssetGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetGroupOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpanishActivitySheetAssetGroupFilter>;
};


export type QuerySpanishActivitySheetSectionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySpanishActivitySheetSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetSectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpanishActivitySheetSectionFilter>;
};


export type QuerySpanishActivitySheetSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetSectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpanishActivitySheetSectionFilter>;
};


export type QuerySummerSchoolFaqArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolFaqCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolFaqOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolFaqFilter>;
};


export type QuerySummerSchoolFaqCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolFaqOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolFaqFilter>;
};


export type QuerySummerSchoolFaqListArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolFaqListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolFaqListOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolFaqListFilter>;
};


export type QuerySummerSchoolFaqListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolFaqListOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolFaqListFilter>;
};


export type QuerySummerSchoolPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolPageFilter>;
};


export type QuerySummerSchoolPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolPageFilter>;
};


export type QuerySummerSchoolPlaceholderArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolPlaceholderCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolPlaceholderOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolPlaceholderFilter>;
};


export type QuerySummerSchoolPlaceholderCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolPlaceholderOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolPlaceholderFilter>;
};


export type QuerySummerSchoolResourceArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolResourceCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceFilter>;
};


export type QuerySummerSchoolResourceCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceFilter>;
};


export type QuerySummerSchoolResourceGroupArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolResourceGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceGroupFilter>;
};


export type QuerySummerSchoolResourceGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceGroupFilter>;
};


export type QuerySummerSchoolResourceGroupListArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolResourceGroupListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupListOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceGroupListFilter>;
};


export type QuerySummerSchoolResourceGroupListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupListOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceGroupListFilter>;
};


export type QuerySummerSchoolResourceListArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolResourceListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceListOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceListFilter>;
};


export type QuerySummerSchoolResourceListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceListOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceListFilter>;
};


export type QuerySummerSchoolSectionArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolSectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolSectionFilter>;
};


export type QuerySummerSchoolSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolSectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolSectionFilter>;
};


export type QuerySummerSchoolWebinarArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolWebinarCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolWebinarOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolWebinarFilter>;
};


export type QuerySummerSchoolWebinarCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolWebinarOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolWebinarFilter>;
};


export type QuerySummerSchoolWebinarListArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySummerSchoolWebinarListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolWebinarListOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolWebinarListFilter>;
};


export type QuerySummerSchoolWebinarListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolWebinarListOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolWebinarListFilter>;
};


export type QueryTeacherTestimonialBlockArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTeacherTestimonialBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TeacherTestimonialBlockOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TeacherTestimonialBlockFilter>;
};


export type QueryTeacherTestimonialBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TeacherTestimonialBlockOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<TeacherTestimonialBlockFilter>;
};


export type QueryWritingLegendsFreeTrialBlockArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWritingLegendsFreeTrialBlockCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsFreeTrialBlockOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsFreeTrialBlockFilter>;
};


export type QueryWritingLegendsFreeTrialBlockCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsFreeTrialBlockOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsFreeTrialBlockFilter>;
};


export type QueryWritingLegendsMarketingSiteAboutUsPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWritingLegendsMarketingSiteAboutUsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteAboutUsPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteAboutUsPageFilter>;
};


export type QueryWritingLegendsMarketingSiteAboutUsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteAboutUsPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteAboutUsPageFilter>;
};


export type QueryWritingLegendsMarketingSiteAccessibilityPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWritingLegendsMarketingSiteAccessibilityPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteAccessibilityPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteAccessibilityPageFilter>;
};


export type QueryWritingLegendsMarketingSiteAccessibilityPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteAccessibilityPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteAccessibilityPageFilter>;
};


export type QueryWritingLegendsMarketingSiteContactUsPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWritingLegendsMarketingSiteContactUsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteContactUsPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteContactUsPageFilter>;
};


export type QueryWritingLegendsMarketingSiteContactUsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteContactUsPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteContactUsPageFilter>;
};


export type QueryWritingLegendsMarketingSiteContactUsPageV2Args = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWritingLegendsMarketingSiteContactUsPageV2CollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteContactUsPageV2Order>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteContactUsPageV2Filter>;
};


export type QueryWritingLegendsMarketingSiteContactUsPageV2CursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteContactUsPageV2Order>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteContactUsPageV2Filter>;
};


export type QueryWritingLegendsMarketingSiteFaQsPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWritingLegendsMarketingSiteFaQsPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteFaQsPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteFaQsPageFilter>;
};


export type QueryWritingLegendsMarketingSiteFaQsPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteFaQsPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteFaQsPageFilter>;
};


export type QueryWritingLegendsMarketingSiteIndexPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWritingLegendsMarketingSiteIndexPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteIndexPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteIndexPageFilter>;
};


export type QueryWritingLegendsMarketingSiteIndexPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteIndexPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteIndexPageFilter>;
};


export type QueryWritingLegendsMarketingSitePrivacyPolicyPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWritingLegendsMarketingSitePrivacyPolicyPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSitePrivacyPolicyPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSitePrivacyPolicyPageFilter>;
};


export type QueryWritingLegendsMarketingSitePrivacyPolicyPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSitePrivacyPolicyPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSitePrivacyPolicyPageFilter>;
};


export type QueryWritingLegendsMarketingSiteTechReqPageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWritingLegendsMarketingSiteTechReqPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteTechReqPageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteTechReqPageFilter>;
};


export type QueryWritingLegendsMarketingSiteTechReqPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteTechReqPageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteTechReqPageFilter>;
};


export type QueryWritingLegendsMarketingSiteTermsOfUsePageArgs = {
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryWritingLegendsMarketingSiteTermsOfUsePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteTermsOfUsePageOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteTermsOfUsePageFilter>;
};


export type QueryWritingLegendsMarketingSiteTermsOfUsePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteTermsOfUsePageOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<WritingLegendsMarketingSiteTermsOfUsePageFilter>;
};

export type ResourceLink = {
  sys: ResourceSys;
};

export type ResourceSys = {
  __typename?: 'ResourceSys';
  linkType: Scalars['String']['output'];
  urn: Scalars['String']['output'];
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/rewardMap) */
export type RewardMap = Entry & _Node & {
  __typename?: 'RewardMap';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<RewardMapLinkingCollections>;
  mapNumber: Maybe<Scalars['Int']['output']>;
  pdf: Maybe<Asset>;
  sys: Sys;
  thumbnail: Maybe<Asset>;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/rewardMap) */
export type RewardMapLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/rewardMap) */
export type RewardMapMapNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/rewardMap) */
export type RewardMapPdfArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/rewardMap) */
export type RewardMapThumbnailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/rewardMap) */
export type RewardMapTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type RewardMapCollection = {
  __typename?: 'RewardMapCollection';
  items: Array<Maybe<RewardMap>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RewardMapCursorCollection = {
  __typename?: 'RewardMapCursorCollection';
  items: Array<Maybe<RewardMap>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type RewardMapFilter = {
  AND: InputMaybe<Array<InputMaybe<RewardMapFilter>>>;
  OR: InputMaybe<Array<InputMaybe<RewardMapFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  mapNumber: InputMaybe<Scalars['Int']['input']>;
  mapNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  mapNumber_gt: InputMaybe<Scalars['Int']['input']>;
  mapNumber_gte: InputMaybe<Scalars['Int']['input']>;
  mapNumber_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  mapNumber_lt: InputMaybe<Scalars['Int']['input']>;
  mapNumber_lte: InputMaybe<Scalars['Int']['input']>;
  mapNumber_not: InputMaybe<Scalars['Int']['input']>;
  mapNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  pdf_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  thumbnail_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RewardMapLinkingCollections = {
  __typename?: 'RewardMapLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type RewardMapLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type RewardMapLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RewardMapOrder {
  MapNumberAsc = 'mapNumber_ASC',
  MapNumberDesc = 'mapNumber_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/rolePermissions) */
export type RolePermissions = Entry & _Node & {
  __typename?: 'RolePermissions';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<RolePermissionsLinkingCollections>;
  roleName: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/rolePermissions) */
export type RolePermissionsDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/rolePermissions) */
export type RolePermissionsLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/rolePermissions) */
export type RolePermissionsRoleNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type RolePermissionsCollection = {
  __typename?: 'RolePermissionsCollection';
  items: Array<Maybe<RolePermissions>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RolePermissionsCursorCollection = {
  __typename?: 'RolePermissionsCursorCollection';
  items: Array<Maybe<RolePermissions>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type RolePermissionsFilter = {
  AND: InputMaybe<Array<InputMaybe<RolePermissionsFilter>>>;
  OR: InputMaybe<Array<InputMaybe<RolePermissionsFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description: InputMaybe<Scalars['String']['input']>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description_not: InputMaybe<Scalars['String']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  description_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleName: InputMaybe<Scalars['String']['input']>;
  roleName_contains: InputMaybe<Scalars['String']['input']>;
  roleName_exists: InputMaybe<Scalars['Boolean']['input']>;
  roleName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleName_not: InputMaybe<Scalars['String']['input']>;
  roleName_not_contains: InputMaybe<Scalars['String']['input']>;
  roleName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type RolePermissionsLinkingCollections = {
  __typename?: 'RolePermissionsLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type RolePermissionsLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type RolePermissionsLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RolePermissionsOrder {
  RoleNameAsc = 'roleName_ASC',
  RoleNameDesc = 'roleName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/sampleLesson) */
export type SampleLesson = Entry & _Node & {
  __typename?: 'SampleLesson';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  description: Maybe<SampleLessonDescription>;
  linkedFrom: Maybe<SampleLessonLinkingCollections>;
  linksCollection: Maybe<SampleLessonLinksCollection>;
  linksCursorCollection: Maybe<SampleLessonLinksCursorCollection>;
  name: Maybe<Scalars['String']['output']>;
  product: Maybe<Product>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
  thumbnail: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/sampleLesson) */
export type SampleLessonDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/sampleLesson) */
export type SampleLessonLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/sampleLesson) */
export type SampleLessonLinksCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SampleLessonLinksCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/sampleLesson) */
export type SampleLessonLinksCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SampleLessonLinksCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LinkFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/sampleLesson) */
export type SampleLessonNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/sampleLesson) */
export type SampleLessonProductArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ProductFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/sampleLesson) */
export type SampleLessonSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/sampleLesson) */
export type SampleLessonThumbnailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SampleLessonCollection = {
  __typename?: 'SampleLessonCollection';
  items: Array<Maybe<SampleLesson>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SampleLessonCursorCollection = {
  __typename?: 'SampleLessonCursorCollection';
  items: Array<Maybe<SampleLesson>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SampleLessonDescription = {
  __typename?: 'SampleLessonDescription';
  json: Scalars['JSON']['output'];
  links: SampleLessonDescriptionLinks;
};

export type SampleLessonDescriptionAssets = {
  __typename?: 'SampleLessonDescriptionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SampleLessonDescriptionEntries = {
  __typename?: 'SampleLessonDescriptionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SampleLessonDescriptionLinks = {
  __typename?: 'SampleLessonDescriptionLinks';
  assets: SampleLessonDescriptionAssets;
  entries: SampleLessonDescriptionEntries;
  resources: SampleLessonDescriptionResources;
};

export type SampleLessonDescriptionResources = {
  __typename?: 'SampleLessonDescriptionResources';
  block: Array<SampleLessonDescriptionResourcesBlock>;
  hyperlink: Array<SampleLessonDescriptionResourcesHyperlink>;
  inline: Array<SampleLessonDescriptionResourcesInline>;
};

export type SampleLessonDescriptionResourcesBlock = ResourceLink & {
  __typename?: 'SampleLessonDescriptionResourcesBlock';
  sys: ResourceSys;
};

export type SampleLessonDescriptionResourcesHyperlink = ResourceLink & {
  __typename?: 'SampleLessonDescriptionResourcesHyperlink';
  sys: ResourceSys;
};

export type SampleLessonDescriptionResourcesInline = ResourceLink & {
  __typename?: 'SampleLessonDescriptionResourcesInline';
  sys: ResourceSys;
};

export type SampleLessonFilter = {
  AND: InputMaybe<Array<InputMaybe<SampleLessonFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SampleLessonFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  links: InputMaybe<CfLinkNestedFilter>;
  linksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product: InputMaybe<CfProductNestedFilter>;
  product_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
  thumbnail_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type SampleLessonLinkingCollections = {
  __typename?: 'SampleLessonLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type SampleLessonLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SampleLessonLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SampleLessonLinksCollection = {
  __typename?: 'SampleLessonLinksCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SampleLessonLinksCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type SampleLessonLinksCursorCollection = {
  __typename?: 'SampleLessonLinksCursorCollection';
  items: Array<Maybe<Link>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum SampleLessonLinksCursorCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum SampleLessonOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAsset) */
export type SpanishActivitySheetAsset = Entry & _Node & {
  __typename?: 'SpanishActivitySheetAsset';
  _id: Scalars['ID']['output'];
  asset: Maybe<Asset>;
  contentfulMetadata: ContentfulMetadata;
  id: Maybe<Scalars['String']['output']>;
  isVisible: Maybe<Scalars['Boolean']['output']>;
  linkedFrom: Maybe<SpanishActivitySheetAssetLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAsset) */
export type SpanishActivitySheetAssetAssetArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAsset) */
export type SpanishActivitySheetAssetIdArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAsset) */
export type SpanishActivitySheetAssetIsVisibleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAsset) */
export type SpanishActivitySheetAssetLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAsset) */
export type SpanishActivitySheetAssetNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAsset) */
export type SpanishActivitySheetAssetSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpanishActivitySheetAssetCollection = {
  __typename?: 'SpanishActivitySheetAssetCollection';
  items: Array<Maybe<SpanishActivitySheetAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SpanishActivitySheetAssetCursorCollection = {
  __typename?: 'SpanishActivitySheetAssetCursorCollection';
  items: Array<Maybe<SpanishActivitySheetAsset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SpanishActivitySheetAssetFilter = {
  AND: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetFilter>>>;
  asset_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isVisible: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_exists: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_not: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAssetGroup) */
export type SpanishActivitySheetAssetGroup = Entry & _Node & {
  __typename?: 'SpanishActivitySheetAssetGroup';
  _id: Scalars['ID']['output'];
  activitySheetSection: Maybe<SpanishActivitySheetSection>;
  assetsCollection: Maybe<SpanishActivitySheetAssetGroupAssetsCollection>;
  assetsCursorCollection: Maybe<SpanishActivitySheetAssetGroupAssetsCursorCollection>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<SpanishActivitySheetAssetGroupLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAssetGroup) */
export type SpanishActivitySheetAssetGroupActivitySheetSectionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpanishActivitySheetSectionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAssetGroup) */
export type SpanishActivitySheetAssetGroupAssetsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetGroupAssetsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpanishActivitySheetAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAssetGroup) */
export type SpanishActivitySheetAssetGroupAssetsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetGroupAssetsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SpanishActivitySheetAssetFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAssetGroup) */
export type SpanishActivitySheetAssetGroupLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAssetGroup) */
export type SpanishActivitySheetAssetGroupNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetAssetGroup) */
export type SpanishActivitySheetAssetGroupSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpanishActivitySheetAssetGroupAssetsCollection = {
  __typename?: 'SpanishActivitySheetAssetGroupAssetsCollection';
  items: Array<Maybe<SpanishActivitySheetAsset>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SpanishActivitySheetAssetGroupAssetsCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsVisibleAsc = 'isVisible_ASC',
  IsVisibleDesc = 'isVisible_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type SpanishActivitySheetAssetGroupAssetsCursorCollection = {
  __typename?: 'SpanishActivitySheetAssetGroupAssetsCursorCollection';
  items: Array<Maybe<SpanishActivitySheetAsset>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum SpanishActivitySheetAssetGroupAssetsCursorCollectionOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsVisibleAsc = 'isVisible_ASC',
  IsVisibleDesc = 'isVisible_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type SpanishActivitySheetAssetGroupCollection = {
  __typename?: 'SpanishActivitySheetAssetGroupCollection';
  items: Array<Maybe<SpanishActivitySheetAssetGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SpanishActivitySheetAssetGroupCursorCollection = {
  __typename?: 'SpanishActivitySheetAssetGroupCursorCollection';
  items: Array<Maybe<SpanishActivitySheetAssetGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SpanishActivitySheetAssetGroupFilter = {
  AND: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetGroupFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetGroupFilter>>>;
  activitySheetSection: InputMaybe<CfSpanishActivitySheetSectionNestedFilter>;
  activitySheetSection_exists: InputMaybe<Scalars['Boolean']['input']>;
  assets: InputMaybe<CfSpanishActivitySheetAssetNestedFilter>;
  assetsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type SpanishActivitySheetAssetGroupLinkingCollections = {
  __typename?: 'SpanishActivitySheetAssetGroupLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type SpanishActivitySheetAssetGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpanishActivitySheetAssetGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SpanishActivitySheetAssetGroupOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type SpanishActivitySheetAssetLinkingCollections = {
  __typename?: 'SpanishActivitySheetAssetLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  spanishActivitySheetAssetGroupCollection: Maybe<SpanishActivitySheetAssetGroupCollection>;
  spanishActivitySheetAssetGroupCursorCollection: Maybe<SpanishActivitySheetAssetGroupCursorCollection>;
};


export type SpanishActivitySheetAssetLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpanishActivitySheetAssetLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpanishActivitySheetAssetLinkingCollectionsSpanishActivitySheetAssetGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetLinkingCollectionsSpanishActivitySheetAssetGroupCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpanishActivitySheetAssetLinkingCollectionsSpanishActivitySheetAssetGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetAssetLinkingCollectionsSpanishActivitySheetAssetGroupCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SpanishActivitySheetAssetLinkingCollectionsSpanishActivitySheetAssetGroupCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpanishActivitySheetAssetLinkingCollectionsSpanishActivitySheetAssetGroupCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpanishActivitySheetAssetOrder {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  IsVisibleAsc = 'isVisible_ASC',
  IsVisibleDesc = 'isVisible_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetSection) */
export type SpanishActivitySheetSection = Entry & _Node & {
  __typename?: 'SpanishActivitySheetSection';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<SpanishActivitySheetSectionLinkingCollections>;
  name: Maybe<Scalars['String']['output']>;
  product: Maybe<Product>;
  sortOrder: Maybe<Scalars['Int']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetSection) */
export type SpanishActivitySheetSectionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetSection) */
export type SpanishActivitySheetSectionNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetSection) */
export type SpanishActivitySheetSectionProductArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ProductFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/spanishActivitySheetSection) */
export type SpanishActivitySheetSectionSortOrderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SpanishActivitySheetSectionCollection = {
  __typename?: 'SpanishActivitySheetSectionCollection';
  items: Array<Maybe<SpanishActivitySheetSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SpanishActivitySheetSectionCursorCollection = {
  __typename?: 'SpanishActivitySheetSectionCursorCollection';
  items: Array<Maybe<SpanishActivitySheetSection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SpanishActivitySheetSectionFilter = {
  AND: InputMaybe<Array<InputMaybe<SpanishActivitySheetSectionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SpanishActivitySheetSectionFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product: InputMaybe<CfProductNestedFilter>;
  product_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type SpanishActivitySheetSectionLinkingCollections = {
  __typename?: 'SpanishActivitySheetSectionLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  spanishActivitySheetAssetGroupCollection: Maybe<SpanishActivitySheetAssetGroupCollection>;
  spanishActivitySheetAssetGroupCursorCollection: Maybe<SpanishActivitySheetAssetGroupCursorCollection>;
};


export type SpanishActivitySheetSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpanishActivitySheetSectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpanishActivitySheetSectionLinkingCollectionsSpanishActivitySheetAssetGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetSectionLinkingCollectionsSpanishActivitySheetAssetGroupCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SpanishActivitySheetSectionLinkingCollectionsSpanishActivitySheetAssetGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SpanishActivitySheetSectionLinkingCollectionsSpanishActivitySheetAssetGroupCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SpanishActivitySheetSectionLinkingCollectionsSpanishActivitySheetAssetGroupCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpanishActivitySheetSectionLinkingCollectionsSpanishActivitySheetAssetGroupCursorCollectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum SpanishActivitySheetSectionOrder {
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SortOrderAsc = 'sortOrder_ASC',
  SortOrderDesc = 'sortOrder_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolFaq) */
export type SummerSchoolFaq = Entry & _Node & {
  __typename?: 'SummerSchoolFaq';
  _id: Scalars['ID']['output'];
  body: Maybe<SummerSchoolFaqBody>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<SummerSchoolFaqLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolFaq) */
export type SummerSchoolFaqBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolFaq) */
export type SummerSchoolFaqLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolFaq) */
export type SummerSchoolFaqTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolFaqBody = {
  __typename?: 'SummerSchoolFaqBody';
  json: Scalars['JSON']['output'];
  links: SummerSchoolFaqBodyLinks;
};

export type SummerSchoolFaqBodyAssets = {
  __typename?: 'SummerSchoolFaqBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SummerSchoolFaqBodyEntries = {
  __typename?: 'SummerSchoolFaqBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SummerSchoolFaqBodyLinks = {
  __typename?: 'SummerSchoolFaqBodyLinks';
  assets: SummerSchoolFaqBodyAssets;
  entries: SummerSchoolFaqBodyEntries;
  resources: SummerSchoolFaqBodyResources;
};

export type SummerSchoolFaqBodyResources = {
  __typename?: 'SummerSchoolFaqBodyResources';
  block: Array<SummerSchoolFaqBodyResourcesBlock>;
  hyperlink: Array<SummerSchoolFaqBodyResourcesHyperlink>;
  inline: Array<SummerSchoolFaqBodyResourcesInline>;
};

export type SummerSchoolFaqBodyResourcesBlock = ResourceLink & {
  __typename?: 'SummerSchoolFaqBodyResourcesBlock';
  sys: ResourceSys;
};

export type SummerSchoolFaqBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'SummerSchoolFaqBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type SummerSchoolFaqBodyResourcesInline = ResourceLink & {
  __typename?: 'SummerSchoolFaqBodyResourcesInline';
  sys: ResourceSys;
};

export type SummerSchoolFaqCollection = {
  __typename?: 'SummerSchoolFaqCollection';
  items: Array<Maybe<SummerSchoolFaq>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolFaqCursorCollection = {
  __typename?: 'SummerSchoolFaqCursorCollection';
  items: Array<Maybe<SummerSchoolFaq>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolFaqFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolFaqFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolFaqFilter>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SummerSchoolFaqLinkingCollections = {
  __typename?: 'SummerSchoolFaqLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  summerSchoolFaqListCollection: Maybe<SummerSchoolFaqListCollection>;
  summerSchoolFaqListCursorCollection: Maybe<SummerSchoolFaqListCursorCollection>;
};


export type SummerSchoolFaqLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolFaqLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolFaqLinkingCollectionsSummerSchoolFaqListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolFaqLinkingCollectionsSummerSchoolFaqListCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolFaqLinkingCollectionsSummerSchoolFaqListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolFaqLinkingCollectionsSummerSchoolFaqListCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolFaqLinkingCollectionsSummerSchoolFaqListCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolFaqLinkingCollectionsSummerSchoolFaqListCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolFaqList) */
export type SummerSchoolFaqList = Entry & _Node & {
  __typename?: 'SummerSchoolFaqList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  faqsCollection: Maybe<SummerSchoolFaqListFaqsCollection>;
  faqsCursorCollection: Maybe<SummerSchoolFaqListFaqsCursorCollection>;
  linkedFrom: Maybe<SummerSchoolFaqListLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolFaqList) */
export type SummerSchoolFaqListFaqsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolFaqListFaqsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolFaqFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolFaqList) */
export type SummerSchoolFaqListFaqsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolFaqListFaqsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolFaqFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolFaqList) */
export type SummerSchoolFaqListLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolFaqList) */
export type SummerSchoolFaqListTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolFaqListCollection = {
  __typename?: 'SummerSchoolFaqListCollection';
  items: Array<Maybe<SummerSchoolFaqList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolFaqListCursorCollection = {
  __typename?: 'SummerSchoolFaqListCursorCollection';
  items: Array<Maybe<SummerSchoolFaqList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolFaqListFaqsCollection = {
  __typename?: 'SummerSchoolFaqListFaqsCollection';
  items: Array<Maybe<SummerSchoolFaq>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SummerSchoolFaqListFaqsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolFaqListFaqsCursorCollection = {
  __typename?: 'SummerSchoolFaqListFaqsCursorCollection';
  items: Array<Maybe<SummerSchoolFaq>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum SummerSchoolFaqListFaqsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolFaqListFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolFaqListFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolFaqListFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  faqs: InputMaybe<CfSummerSchoolFaqNestedFilter>;
  faqsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SummerSchoolFaqListLinkingCollections = {
  __typename?: 'SummerSchoolFaqListLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  summerSchoolSectionCollection: Maybe<SummerSchoolSectionCollection>;
  summerSchoolSectionCursorCollection: Maybe<SummerSchoolSectionCursorCollection>;
};


export type SummerSchoolFaqListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolFaqListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolFaqListLinkingCollectionsSummerSchoolSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolFaqListLinkingCollectionsSummerSchoolSectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolFaqListLinkingCollectionsSummerSchoolSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolFaqListLinkingCollectionsSummerSchoolSectionCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolFaqListLinkingCollectionsSummerSchoolSectionCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolFaqListLinkingCollectionsSummerSchoolSectionCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolFaqListOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolFaqOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPage = Entry & _Node & {
  __typename?: 'SummerSchoolPage';
  _id: Scalars['ID']['output'];
  afterEndDatePlaceholder: Maybe<SummerSchoolPlaceholder>;
  beforeStartDatePlaceholder: Maybe<SummerSchoolPlaceholder>;
  contentfulMetadata: ContentfulMetadata;
  endDate: Maybe<Scalars['DateTime']['output']>;
  introduction: Maybe<SummerSchoolPageIntroduction>;
  linkedFrom: Maybe<SummerSchoolPageLinkingCollections>;
  path: Maybe<Scalars['String']['output']>;
  sectionsCollection: Maybe<SummerSchoolPageSectionsCollection>;
  sectionsCursorCollection: Maybe<SummerSchoolPageSectionsCursorCollection>;
  startDate: Maybe<Scalars['DateTime']['output']>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPageAfterEndDatePlaceholderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolPlaceholderFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPageBeforeStartDatePlaceholderArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolPlaceholderFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPageEndDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPageIntroductionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPagePathArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPageSectionsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolPageSectionsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolSectionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPageSectionsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolPageSectionsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolSectionFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPageStartDateArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPage) */
export type SummerSchoolPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolPageCollection = {
  __typename?: 'SummerSchoolPageCollection';
  items: Array<Maybe<SummerSchoolPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolPageCursorCollection = {
  __typename?: 'SummerSchoolPageCursorCollection';
  items: Array<Maybe<SummerSchoolPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolPageFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolPageFilter>>>;
  afterEndDatePlaceholder: InputMaybe<CfSummerSchoolPlaceholderNestedFilter>;
  afterEndDatePlaceholder_exists: InputMaybe<Scalars['Boolean']['input']>;
  beforeStartDatePlaceholder: InputMaybe<CfSummerSchoolPlaceholderNestedFilter>;
  beforeStartDatePlaceholder_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  endDate: InputMaybe<Scalars['DateTime']['input']>;
  endDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  endDate_gt: InputMaybe<Scalars['DateTime']['input']>;
  endDate_gte: InputMaybe<Scalars['DateTime']['input']>;
  endDate_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  endDate_lt: InputMaybe<Scalars['DateTime']['input']>;
  endDate_lte: InputMaybe<Scalars['DateTime']['input']>;
  endDate_not: InputMaybe<Scalars['DateTime']['input']>;
  endDate_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  introduction_contains: InputMaybe<Scalars['String']['input']>;
  introduction_exists: InputMaybe<Scalars['Boolean']['input']>;
  introduction_not_contains: InputMaybe<Scalars['String']['input']>;
  path: InputMaybe<Scalars['String']['input']>;
  path_contains: InputMaybe<Scalars['String']['input']>;
  path_exists: InputMaybe<Scalars['Boolean']['input']>;
  path_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  path_not: InputMaybe<Scalars['String']['input']>;
  path_not_contains: InputMaybe<Scalars['String']['input']>;
  path_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sections: InputMaybe<CfSummerSchoolSectionNestedFilter>;
  sectionsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  startDate: InputMaybe<Scalars['DateTime']['input']>;
  startDate_exists: InputMaybe<Scalars['Boolean']['input']>;
  startDate_gt: InputMaybe<Scalars['DateTime']['input']>;
  startDate_gte: InputMaybe<Scalars['DateTime']['input']>;
  startDate_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startDate_lt: InputMaybe<Scalars['DateTime']['input']>;
  startDate_lte: InputMaybe<Scalars['DateTime']['input']>;
  startDate_not: InputMaybe<Scalars['DateTime']['input']>;
  startDate_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SummerSchoolPageIntroduction = {
  __typename?: 'SummerSchoolPageIntroduction';
  json: Scalars['JSON']['output'];
  links: SummerSchoolPageIntroductionLinks;
};

export type SummerSchoolPageIntroductionAssets = {
  __typename?: 'SummerSchoolPageIntroductionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SummerSchoolPageIntroductionEntries = {
  __typename?: 'SummerSchoolPageIntroductionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SummerSchoolPageIntroductionLinks = {
  __typename?: 'SummerSchoolPageIntroductionLinks';
  assets: SummerSchoolPageIntroductionAssets;
  entries: SummerSchoolPageIntroductionEntries;
  resources: SummerSchoolPageIntroductionResources;
};

export type SummerSchoolPageIntroductionResources = {
  __typename?: 'SummerSchoolPageIntroductionResources';
  block: Array<SummerSchoolPageIntroductionResourcesBlock>;
  hyperlink: Array<SummerSchoolPageIntroductionResourcesHyperlink>;
  inline: Array<SummerSchoolPageIntroductionResourcesInline>;
};

export type SummerSchoolPageIntroductionResourcesBlock = ResourceLink & {
  __typename?: 'SummerSchoolPageIntroductionResourcesBlock';
  sys: ResourceSys;
};

export type SummerSchoolPageIntroductionResourcesHyperlink = ResourceLink & {
  __typename?: 'SummerSchoolPageIntroductionResourcesHyperlink';
  sys: ResourceSys;
};

export type SummerSchoolPageIntroductionResourcesInline = ResourceLink & {
  __typename?: 'SummerSchoolPageIntroductionResourcesInline';
  sys: ResourceSys;
};

export type SummerSchoolPageLinkingCollections = {
  __typename?: 'SummerSchoolPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type SummerSchoolPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolPageOrder {
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolPageSectionsCollection = {
  __typename?: 'SummerSchoolPageSectionsCollection';
  items: Array<Maybe<SummerSchoolSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SummerSchoolPageSectionsCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolPageSectionsCursorCollection = {
  __typename?: 'SummerSchoolPageSectionsCursorCollection';
  items: Array<Maybe<SummerSchoolSection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum SummerSchoolPageSectionsCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPlaceholder) */
export type SummerSchoolPlaceholder = Entry & _Node & {
  __typename?: 'SummerSchoolPlaceholder';
  _id: Scalars['ID']['output'];
  body: Maybe<SummerSchoolPlaceholderBody>;
  contentfulMetadata: ContentfulMetadata;
  finePrint: Maybe<SummerSchoolPlaceholderFinePrint>;
  internalName: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<SummerSchoolPlaceholderLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPlaceholder) */
export type SummerSchoolPlaceholderBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPlaceholder) */
export type SummerSchoolPlaceholderFinePrintArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPlaceholder) */
export type SummerSchoolPlaceholderInternalNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPlaceholder) */
export type SummerSchoolPlaceholderLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolPlaceholder) */
export type SummerSchoolPlaceholderTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolPlaceholderBody = {
  __typename?: 'SummerSchoolPlaceholderBody';
  json: Scalars['JSON']['output'];
  links: SummerSchoolPlaceholderBodyLinks;
};

export type SummerSchoolPlaceholderBodyAssets = {
  __typename?: 'SummerSchoolPlaceholderBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SummerSchoolPlaceholderBodyEntries = {
  __typename?: 'SummerSchoolPlaceholderBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SummerSchoolPlaceholderBodyLinks = {
  __typename?: 'SummerSchoolPlaceholderBodyLinks';
  assets: SummerSchoolPlaceholderBodyAssets;
  entries: SummerSchoolPlaceholderBodyEntries;
  resources: SummerSchoolPlaceholderBodyResources;
};

export type SummerSchoolPlaceholderBodyResources = {
  __typename?: 'SummerSchoolPlaceholderBodyResources';
  block: Array<SummerSchoolPlaceholderBodyResourcesBlock>;
  hyperlink: Array<SummerSchoolPlaceholderBodyResourcesHyperlink>;
  inline: Array<SummerSchoolPlaceholderBodyResourcesInline>;
};

export type SummerSchoolPlaceholderBodyResourcesBlock = ResourceLink & {
  __typename?: 'SummerSchoolPlaceholderBodyResourcesBlock';
  sys: ResourceSys;
};

export type SummerSchoolPlaceholderBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'SummerSchoolPlaceholderBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type SummerSchoolPlaceholderBodyResourcesInline = ResourceLink & {
  __typename?: 'SummerSchoolPlaceholderBodyResourcesInline';
  sys: ResourceSys;
};

export type SummerSchoolPlaceholderCollection = {
  __typename?: 'SummerSchoolPlaceholderCollection';
  items: Array<Maybe<SummerSchoolPlaceholder>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolPlaceholderCursorCollection = {
  __typename?: 'SummerSchoolPlaceholderCursorCollection';
  items: Array<Maybe<SummerSchoolPlaceholder>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolPlaceholderFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolPlaceholderFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolPlaceholderFilter>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  finePrint_contains: InputMaybe<Scalars['String']['input']>;
  finePrint_exists: InputMaybe<Scalars['Boolean']['input']>;
  finePrint_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SummerSchoolPlaceholderFinePrint = {
  __typename?: 'SummerSchoolPlaceholderFinePrint';
  json: Scalars['JSON']['output'];
  links: SummerSchoolPlaceholderFinePrintLinks;
};

export type SummerSchoolPlaceholderFinePrintAssets = {
  __typename?: 'SummerSchoolPlaceholderFinePrintAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SummerSchoolPlaceholderFinePrintEntries = {
  __typename?: 'SummerSchoolPlaceholderFinePrintEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SummerSchoolPlaceholderFinePrintLinks = {
  __typename?: 'SummerSchoolPlaceholderFinePrintLinks';
  assets: SummerSchoolPlaceholderFinePrintAssets;
  entries: SummerSchoolPlaceholderFinePrintEntries;
  resources: SummerSchoolPlaceholderFinePrintResources;
};

export type SummerSchoolPlaceholderFinePrintResources = {
  __typename?: 'SummerSchoolPlaceholderFinePrintResources';
  block: Array<SummerSchoolPlaceholderFinePrintResourcesBlock>;
  hyperlink: Array<SummerSchoolPlaceholderFinePrintResourcesHyperlink>;
  inline: Array<SummerSchoolPlaceholderFinePrintResourcesInline>;
};

export type SummerSchoolPlaceholderFinePrintResourcesBlock = ResourceLink & {
  __typename?: 'SummerSchoolPlaceholderFinePrintResourcesBlock';
  sys: ResourceSys;
};

export type SummerSchoolPlaceholderFinePrintResourcesHyperlink = ResourceLink & {
  __typename?: 'SummerSchoolPlaceholderFinePrintResourcesHyperlink';
  sys: ResourceSys;
};

export type SummerSchoolPlaceholderFinePrintResourcesInline = ResourceLink & {
  __typename?: 'SummerSchoolPlaceholderFinePrintResourcesInline';
  sys: ResourceSys;
};

export type SummerSchoolPlaceholderLinkingCollections = {
  __typename?: 'SummerSchoolPlaceholderLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  summerSchoolPageCollection: Maybe<SummerSchoolPageCollection>;
  summerSchoolPageCursorCollection: Maybe<SummerSchoolPageCursorCollection>;
};


export type SummerSchoolPlaceholderLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolPlaceholderLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolPlaceholderLinkingCollectionsSummerSchoolPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolPlaceholderLinkingCollectionsSummerSchoolPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolPlaceholderLinkingCollectionsSummerSchoolPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolPlaceholderLinkingCollectionsSummerSchoolPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolPlaceholderLinkingCollectionsSummerSchoolPageCollectionOrder {
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolPlaceholderLinkingCollectionsSummerSchoolPageCursorCollectionOrder {
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolPlaceholderOrder {
  InternalNameAsc = 'internalName_ASC',
  InternalNameDesc = 'internalName_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResource) */
export type SummerSchoolResource = Entry & _Node & {
  __typename?: 'SummerSchoolResource';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  image: Maybe<Asset>;
  linkedFrom: Maybe<SummerSchoolResourceLinkingCollections>;
  pdf: Maybe<Asset>;
  richTextTitle: Maybe<SummerSchoolResourceRichTextTitle>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResource) */
export type SummerSchoolResourceImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResource) */
export type SummerSchoolResourceLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResource) */
export type SummerSchoolResourcePdfArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResource) */
export type SummerSchoolResourceRichTextTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResource) */
export type SummerSchoolResourceTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolResourceCollection = {
  __typename?: 'SummerSchoolResourceCollection';
  items: Array<Maybe<SummerSchoolResource>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolResourceCursorCollection = {
  __typename?: 'SummerSchoolResourceCursorCollection';
  items: Array<Maybe<SummerSchoolResource>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolResourceFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolResourceFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolResourceFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  pdf_exists: InputMaybe<Scalars['Boolean']['input']>;
  richTextTitle_contains: InputMaybe<Scalars['String']['input']>;
  richTextTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  richTextTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceGroup) */
export type SummerSchoolResourceGroup = Entry & _Node & {
  __typename?: 'SummerSchoolResourceGroup';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<SummerSchoolResourceGroupLinkingCollections>;
  resourceListsCollection: Maybe<SummerSchoolResourceGroupResourceListsCollection>;
  resourceListsCursorCollection: Maybe<SummerSchoolResourceGroupResourceListsCursorCollection>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceGroup) */
export type SummerSchoolResourceGroupLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceGroup) */
export type SummerSchoolResourceGroupResourceListsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupResourceListsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceListFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceGroup) */
export type SummerSchoolResourceGroupResourceListsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupResourceListsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceListFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceGroup) */
export type SummerSchoolResourceGroupTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolResourceGroupCollection = {
  __typename?: 'SummerSchoolResourceGroupCollection';
  items: Array<Maybe<SummerSchoolResourceGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolResourceGroupCursorCollection = {
  __typename?: 'SummerSchoolResourceGroupCursorCollection';
  items: Array<Maybe<SummerSchoolResourceGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolResourceGroupFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  resourceLists: InputMaybe<CfSummerSchoolResourceListNestedFilter>;
  resourceListsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SummerSchoolResourceGroupLinkingCollections = {
  __typename?: 'SummerSchoolResourceGroupLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  summerSchoolResourceGroupListCollection: Maybe<SummerSchoolResourceGroupListCollection>;
  summerSchoolResourceGroupListCursorCollection: Maybe<SummerSchoolResourceGroupListCursorCollection>;
};


export type SummerSchoolResourceGroupLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceGroupLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceGroupLinkingCollectionsSummerSchoolResourceGroupListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupLinkingCollectionsSummerSchoolResourceGroupListCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceGroupLinkingCollectionsSummerSchoolResourceGroupListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupLinkingCollectionsSummerSchoolResourceGroupListCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolResourceGroupLinkingCollectionsSummerSchoolResourceGroupListCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolResourceGroupLinkingCollectionsSummerSchoolResourceGroupListCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceGroupList) */
export type SummerSchoolResourceGroupList = Entry & _Node & {
  __typename?: 'SummerSchoolResourceGroupList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  groupsCollection: Maybe<SummerSchoolResourceGroupListGroupsCollection>;
  groupsCursorCollection: Maybe<SummerSchoolResourceGroupListGroupsCursorCollection>;
  linkedFrom: Maybe<SummerSchoolResourceGroupListLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceGroupList) */
export type SummerSchoolResourceGroupListGroupsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupListGroupsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceGroupFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceGroupList) */
export type SummerSchoolResourceGroupListGroupsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupListGroupsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceGroupFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceGroupList) */
export type SummerSchoolResourceGroupListLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceGroupList) */
export type SummerSchoolResourceGroupListTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolResourceGroupListCollection = {
  __typename?: 'SummerSchoolResourceGroupListCollection';
  items: Array<Maybe<SummerSchoolResourceGroupList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolResourceGroupListCursorCollection = {
  __typename?: 'SummerSchoolResourceGroupListCursorCollection';
  items: Array<Maybe<SummerSchoolResourceGroupList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolResourceGroupListFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupListFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupListFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  groups: InputMaybe<CfSummerSchoolResourceGroupNestedFilter>;
  groupsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SummerSchoolResourceGroupListGroupsCollection = {
  __typename?: 'SummerSchoolResourceGroupListGroupsCollection';
  items: Array<Maybe<SummerSchoolResourceGroup>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SummerSchoolResourceGroupListGroupsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolResourceGroupListGroupsCursorCollection = {
  __typename?: 'SummerSchoolResourceGroupListGroupsCursorCollection';
  items: Array<Maybe<SummerSchoolResourceGroup>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum SummerSchoolResourceGroupListGroupsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolResourceGroupListLinkingCollections = {
  __typename?: 'SummerSchoolResourceGroupListLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  summerSchoolSectionCollection: Maybe<SummerSchoolSectionCollection>;
  summerSchoolSectionCursorCollection: Maybe<SummerSchoolSectionCursorCollection>;
};


export type SummerSchoolResourceGroupListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceGroupListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceGroupListLinkingCollectionsSummerSchoolSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupListLinkingCollectionsSummerSchoolSectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceGroupListLinkingCollectionsSummerSchoolSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceGroupListLinkingCollectionsSummerSchoolSectionCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolResourceGroupListLinkingCollectionsSummerSchoolSectionCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolResourceGroupListLinkingCollectionsSummerSchoolSectionCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolResourceGroupListOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolResourceGroupOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolResourceGroupResourceListsCollection = {
  __typename?: 'SummerSchoolResourceGroupResourceListsCollection';
  items: Array<Maybe<SummerSchoolResourceList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SummerSchoolResourceGroupResourceListsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolResourceGroupResourceListsCursorCollection = {
  __typename?: 'SummerSchoolResourceGroupResourceListsCursorCollection';
  items: Array<Maybe<SummerSchoolResourceList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum SummerSchoolResourceGroupResourceListsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolResourceLinkingCollections = {
  __typename?: 'SummerSchoolResourceLinkingCollections';
  bigSchoolResourceListCollection: Maybe<BigSchoolResourceListCollection>;
  bigSchoolResourceListCursorCollection: Maybe<BigSchoolResourceListCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  summerSchoolResourceListCollection: Maybe<SummerSchoolResourceListCollection>;
  summerSchoolResourceListCursorCollection: Maybe<SummerSchoolResourceListCursorCollection>;
};


export type SummerSchoolResourceLinkingCollectionsBigSchoolResourceListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceLinkingCollectionsBigSchoolResourceListCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceLinkingCollectionsBigSchoolResourceListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceLinkingCollectionsBigSchoolResourceListCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceLinkingCollectionsSummerSchoolResourceListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceLinkingCollectionsSummerSchoolResourceListCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceLinkingCollectionsSummerSchoolResourceListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceLinkingCollectionsSummerSchoolResourceListCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolResourceLinkingCollectionsBigSchoolResourceListCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolResourceLinkingCollectionsBigSchoolResourceListCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolResourceLinkingCollectionsSummerSchoolResourceListCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolResourceLinkingCollectionsSummerSchoolResourceListCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceList) */
export type SummerSchoolResourceList = Entry & _Node & {
  __typename?: 'SummerSchoolResourceList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<SummerSchoolResourceListLinkingCollections>;
  resourcesCollection: Maybe<SummerSchoolResourceListResourcesCollection>;
  resourcesCursorCollection: Maybe<SummerSchoolResourceListResourcesCursorCollection>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceList) */
export type SummerSchoolResourceListLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceList) */
export type SummerSchoolResourceListResourcesCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceListResourcesCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceList) */
export type SummerSchoolResourceListResourcesCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceListResourcesCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolResourceFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolResourceList) */
export type SummerSchoolResourceListTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolResourceListCollection = {
  __typename?: 'SummerSchoolResourceListCollection';
  items: Array<Maybe<SummerSchoolResourceList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolResourceListCursorCollection = {
  __typename?: 'SummerSchoolResourceListCursorCollection';
  items: Array<Maybe<SummerSchoolResourceList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolResourceListFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolResourceListFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolResourceListFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  resources: InputMaybe<CfSummerSchoolResourceNestedFilter>;
  resourcesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SummerSchoolResourceListLinkingCollections = {
  __typename?: 'SummerSchoolResourceListLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  summerSchoolResourceGroupCollection: Maybe<SummerSchoolResourceGroupCollection>;
  summerSchoolResourceGroupCursorCollection: Maybe<SummerSchoolResourceGroupCursorCollection>;
};


export type SummerSchoolResourceListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceListLinkingCollectionsSummerSchoolResourceGroupCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceListLinkingCollectionsSummerSchoolResourceGroupCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolResourceListLinkingCollectionsSummerSchoolResourceGroupCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolResourceListLinkingCollectionsSummerSchoolResourceGroupCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolResourceListLinkingCollectionsSummerSchoolResourceGroupCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolResourceListLinkingCollectionsSummerSchoolResourceGroupCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolResourceListOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolResourceListResourcesCollection = {
  __typename?: 'SummerSchoolResourceListResourcesCollection';
  items: Array<Maybe<SummerSchoolResource>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SummerSchoolResourceListResourcesCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolResourceListResourcesCursorCollection = {
  __typename?: 'SummerSchoolResourceListResourcesCursorCollection';
  items: Array<Maybe<SummerSchoolResource>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum SummerSchoolResourceListResourcesCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolResourceOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolResourceRichTextTitle = {
  __typename?: 'SummerSchoolResourceRichTextTitle';
  json: Scalars['JSON']['output'];
  links: SummerSchoolResourceRichTextTitleLinks;
};

export type SummerSchoolResourceRichTextTitleAssets = {
  __typename?: 'SummerSchoolResourceRichTextTitleAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SummerSchoolResourceRichTextTitleEntries = {
  __typename?: 'SummerSchoolResourceRichTextTitleEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SummerSchoolResourceRichTextTitleLinks = {
  __typename?: 'SummerSchoolResourceRichTextTitleLinks';
  assets: SummerSchoolResourceRichTextTitleAssets;
  entries: SummerSchoolResourceRichTextTitleEntries;
  resources: SummerSchoolResourceRichTextTitleResources;
};

export type SummerSchoolResourceRichTextTitleResources = {
  __typename?: 'SummerSchoolResourceRichTextTitleResources';
  block: Array<SummerSchoolResourceRichTextTitleResourcesBlock>;
  hyperlink: Array<SummerSchoolResourceRichTextTitleResourcesHyperlink>;
  inline: Array<SummerSchoolResourceRichTextTitleResourcesInline>;
};

export type SummerSchoolResourceRichTextTitleResourcesBlock = ResourceLink & {
  __typename?: 'SummerSchoolResourceRichTextTitleResourcesBlock';
  sys: ResourceSys;
};

export type SummerSchoolResourceRichTextTitleResourcesHyperlink = ResourceLink & {
  __typename?: 'SummerSchoolResourceRichTextTitleResourcesHyperlink';
  sys: ResourceSys;
};

export type SummerSchoolResourceRichTextTitleResourcesInline = ResourceLink & {
  __typename?: 'SummerSchoolResourceRichTextTitleResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolSection) */
export type SummerSchoolSection = Entry & _Node & {
  __typename?: 'SummerSchoolSection';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  internalTitle: Maybe<Scalars['String']['output']>;
  introduction: Maybe<SummerSchoolSectionIntroduction>;
  linkedFrom: Maybe<SummerSchoolSectionLinkingCollections>;
  list: Maybe<SummerSchoolSectionList>;
  postscript: Maybe<SummerSchoolSectionPostscript>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolSection) */
export type SummerSchoolSectionInternalTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolSection) */
export type SummerSchoolSectionIntroductionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolSection) */
export type SummerSchoolSectionLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolSection) */
export type SummerSchoolSectionListArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolSection) */
export type SummerSchoolSectionPostscriptArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolSection) */
export type SummerSchoolSectionTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolSectionCollection = {
  __typename?: 'SummerSchoolSectionCollection';
  items: Array<Maybe<SummerSchoolSection>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolSectionCursorCollection = {
  __typename?: 'SummerSchoolSectionCursorCollection';
  items: Array<Maybe<SummerSchoolSection>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolSectionFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolSectionFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolSectionFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introduction_contains: InputMaybe<Scalars['String']['input']>;
  introduction_exists: InputMaybe<Scalars['Boolean']['input']>;
  introduction_not_contains: InputMaybe<Scalars['String']['input']>;
  list_exists: InputMaybe<Scalars['Boolean']['input']>;
  postscript_contains: InputMaybe<Scalars['String']['input']>;
  postscript_exists: InputMaybe<Scalars['Boolean']['input']>;
  postscript_not_contains: InputMaybe<Scalars['String']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SummerSchoolSectionIntroduction = {
  __typename?: 'SummerSchoolSectionIntroduction';
  json: Scalars['JSON']['output'];
  links: SummerSchoolSectionIntroductionLinks;
};

export type SummerSchoolSectionIntroductionAssets = {
  __typename?: 'SummerSchoolSectionIntroductionAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SummerSchoolSectionIntroductionEntries = {
  __typename?: 'SummerSchoolSectionIntroductionEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SummerSchoolSectionIntroductionLinks = {
  __typename?: 'SummerSchoolSectionIntroductionLinks';
  assets: SummerSchoolSectionIntroductionAssets;
  entries: SummerSchoolSectionIntroductionEntries;
  resources: SummerSchoolSectionIntroductionResources;
};

export type SummerSchoolSectionIntroductionResources = {
  __typename?: 'SummerSchoolSectionIntroductionResources';
  block: Array<SummerSchoolSectionIntroductionResourcesBlock>;
  hyperlink: Array<SummerSchoolSectionIntroductionResourcesHyperlink>;
  inline: Array<SummerSchoolSectionIntroductionResourcesInline>;
};

export type SummerSchoolSectionIntroductionResourcesBlock = ResourceLink & {
  __typename?: 'SummerSchoolSectionIntroductionResourcesBlock';
  sys: ResourceSys;
};

export type SummerSchoolSectionIntroductionResourcesHyperlink = ResourceLink & {
  __typename?: 'SummerSchoolSectionIntroductionResourcesHyperlink';
  sys: ResourceSys;
};

export type SummerSchoolSectionIntroductionResourcesInline = ResourceLink & {
  __typename?: 'SummerSchoolSectionIntroductionResourcesInline';
  sys: ResourceSys;
};

export type SummerSchoolSectionLinkingCollections = {
  __typename?: 'SummerSchoolSectionLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  summerSchoolPageCollection: Maybe<SummerSchoolPageCollection>;
  summerSchoolPageCursorCollection: Maybe<SummerSchoolPageCursorCollection>;
};


export type SummerSchoolSectionLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolSectionLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolSectionLinkingCollectionsSummerSchoolPageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolSectionLinkingCollectionsSummerSchoolPageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolSectionLinkingCollectionsSummerSchoolPageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolSectionLinkingCollectionsSummerSchoolPageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolSectionLinkingCollectionsSummerSchoolPageCollectionOrder {
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolSectionLinkingCollectionsSummerSchoolPageCursorCollectionOrder {
  EndDateAsc = 'endDate_ASC',
  EndDateDesc = 'endDate_DESC',
  PathAsc = 'path_ASC',
  PathDesc = 'path_DESC',
  StartDateAsc = 'startDate_ASC',
  StartDateDesc = 'startDate_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolSectionList = SummerSchoolFaqList | SummerSchoolResourceGroupList | SummerSchoolWebinarList;

export enum SummerSchoolSectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolSectionPostscript = {
  __typename?: 'SummerSchoolSectionPostscript';
  json: Scalars['JSON']['output'];
  links: SummerSchoolSectionPostscriptLinks;
};

export type SummerSchoolSectionPostscriptAssets = {
  __typename?: 'SummerSchoolSectionPostscriptAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SummerSchoolSectionPostscriptEntries = {
  __typename?: 'SummerSchoolSectionPostscriptEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SummerSchoolSectionPostscriptLinks = {
  __typename?: 'SummerSchoolSectionPostscriptLinks';
  assets: SummerSchoolSectionPostscriptAssets;
  entries: SummerSchoolSectionPostscriptEntries;
  resources: SummerSchoolSectionPostscriptResources;
};

export type SummerSchoolSectionPostscriptResources = {
  __typename?: 'SummerSchoolSectionPostscriptResources';
  block: Array<SummerSchoolSectionPostscriptResourcesBlock>;
  hyperlink: Array<SummerSchoolSectionPostscriptResourcesHyperlink>;
  inline: Array<SummerSchoolSectionPostscriptResourcesInline>;
};

export type SummerSchoolSectionPostscriptResourcesBlock = ResourceLink & {
  __typename?: 'SummerSchoolSectionPostscriptResourcesBlock';
  sys: ResourceSys;
};

export type SummerSchoolSectionPostscriptResourcesHyperlink = ResourceLink & {
  __typename?: 'SummerSchoolSectionPostscriptResourcesHyperlink';
  sys: ResourceSys;
};

export type SummerSchoolSectionPostscriptResourcesInline = ResourceLink & {
  __typename?: 'SummerSchoolSectionPostscriptResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinar) */
export type SummerSchoolWebinar = Entry & _Node & {
  __typename?: 'SummerSchoolWebinar';
  _id: Scalars['ID']['output'];
  body: Maybe<SummerSchoolWebinarBody>;
  contentfulMetadata: ContentfulMetadata;
  heading: Maybe<SummerSchoolWebinarHeading>;
  image: Maybe<Asset>;
  linkedFrom: Maybe<SummerSchoolWebinarLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  url: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinar) */
export type SummerSchoolWebinarBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinar) */
export type SummerSchoolWebinarHeadingArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinar) */
export type SummerSchoolWebinarImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinar) */
export type SummerSchoolWebinarLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinar) */
export type SummerSchoolWebinarTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinar) */
export type SummerSchoolWebinarUrlArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolWebinarBody = {
  __typename?: 'SummerSchoolWebinarBody';
  json: Scalars['JSON']['output'];
  links: SummerSchoolWebinarBodyLinks;
};

export type SummerSchoolWebinarBodyAssets = {
  __typename?: 'SummerSchoolWebinarBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SummerSchoolWebinarBodyEntries = {
  __typename?: 'SummerSchoolWebinarBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SummerSchoolWebinarBodyLinks = {
  __typename?: 'SummerSchoolWebinarBodyLinks';
  assets: SummerSchoolWebinarBodyAssets;
  entries: SummerSchoolWebinarBodyEntries;
  resources: SummerSchoolWebinarBodyResources;
};

export type SummerSchoolWebinarBodyResources = {
  __typename?: 'SummerSchoolWebinarBodyResources';
  block: Array<SummerSchoolWebinarBodyResourcesBlock>;
  hyperlink: Array<SummerSchoolWebinarBodyResourcesHyperlink>;
  inline: Array<SummerSchoolWebinarBodyResourcesInline>;
};

export type SummerSchoolWebinarBodyResourcesBlock = ResourceLink & {
  __typename?: 'SummerSchoolWebinarBodyResourcesBlock';
  sys: ResourceSys;
};

export type SummerSchoolWebinarBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'SummerSchoolWebinarBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type SummerSchoolWebinarBodyResourcesInline = ResourceLink & {
  __typename?: 'SummerSchoolWebinarBodyResourcesInline';
  sys: ResourceSys;
};

export type SummerSchoolWebinarCollection = {
  __typename?: 'SummerSchoolWebinarCollection';
  items: Array<Maybe<SummerSchoolWebinar>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolWebinarCursorCollection = {
  __typename?: 'SummerSchoolWebinarCursorCollection';
  items: Array<Maybe<SummerSchoolWebinar>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolWebinarFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolWebinarFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolWebinarFilter>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SummerSchoolWebinarHeading = {
  __typename?: 'SummerSchoolWebinarHeading';
  json: Scalars['JSON']['output'];
  links: SummerSchoolWebinarHeadingLinks;
};

export type SummerSchoolWebinarHeadingAssets = {
  __typename?: 'SummerSchoolWebinarHeadingAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type SummerSchoolWebinarHeadingEntries = {
  __typename?: 'SummerSchoolWebinarHeadingEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type SummerSchoolWebinarHeadingLinks = {
  __typename?: 'SummerSchoolWebinarHeadingLinks';
  assets: SummerSchoolWebinarHeadingAssets;
  entries: SummerSchoolWebinarHeadingEntries;
  resources: SummerSchoolWebinarHeadingResources;
};

export type SummerSchoolWebinarHeadingResources = {
  __typename?: 'SummerSchoolWebinarHeadingResources';
  block: Array<SummerSchoolWebinarHeadingResourcesBlock>;
  hyperlink: Array<SummerSchoolWebinarHeadingResourcesHyperlink>;
  inline: Array<SummerSchoolWebinarHeadingResourcesInline>;
};

export type SummerSchoolWebinarHeadingResourcesBlock = ResourceLink & {
  __typename?: 'SummerSchoolWebinarHeadingResourcesBlock';
  sys: ResourceSys;
};

export type SummerSchoolWebinarHeadingResourcesHyperlink = ResourceLink & {
  __typename?: 'SummerSchoolWebinarHeadingResourcesHyperlink';
  sys: ResourceSys;
};

export type SummerSchoolWebinarHeadingResourcesInline = ResourceLink & {
  __typename?: 'SummerSchoolWebinarHeadingResourcesInline';
  sys: ResourceSys;
};

export type SummerSchoolWebinarLinkingCollections = {
  __typename?: 'SummerSchoolWebinarLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  summerSchoolWebinarListCollection: Maybe<SummerSchoolWebinarListCollection>;
  summerSchoolWebinarListCursorCollection: Maybe<SummerSchoolWebinarListCursorCollection>;
};


export type SummerSchoolWebinarLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolWebinarLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolWebinarLinkingCollectionsSummerSchoolWebinarListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolWebinarLinkingCollectionsSummerSchoolWebinarListCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolWebinarLinkingCollectionsSummerSchoolWebinarListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolWebinarLinkingCollectionsSummerSchoolWebinarListCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolWebinarLinkingCollectionsSummerSchoolWebinarListCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolWebinarLinkingCollectionsSummerSchoolWebinarListCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinarList) */
export type SummerSchoolWebinarList = Entry & _Node & {
  __typename?: 'SummerSchoolWebinarList';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<SummerSchoolWebinarListLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  webinarsCollection: Maybe<SummerSchoolWebinarListWebinarsCollection>;
  webinarsCursorCollection: Maybe<SummerSchoolWebinarListWebinarsCursorCollection>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinarList) */
export type SummerSchoolWebinarListLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinarList) */
export type SummerSchoolWebinarListTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinarList) */
export type SummerSchoolWebinarListWebinarsCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolWebinarListWebinarsCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolWebinarFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/summerSchoolWebinarList) */
export type SummerSchoolWebinarListWebinarsCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolWebinarListWebinarsCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<SummerSchoolWebinarFilter>;
};

export type SummerSchoolWebinarListCollection = {
  __typename?: 'SummerSchoolWebinarListCollection';
  items: Array<Maybe<SummerSchoolWebinarList>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type SummerSchoolWebinarListCursorCollection = {
  __typename?: 'SummerSchoolWebinarListCursorCollection';
  items: Array<Maybe<SummerSchoolWebinarList>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type SummerSchoolWebinarListFilter = {
  AND: InputMaybe<Array<InputMaybe<SummerSchoolWebinarListFilter>>>;
  OR: InputMaybe<Array<InputMaybe<SummerSchoolWebinarListFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  webinars: InputMaybe<CfSummerSchoolWebinarNestedFilter>;
  webinarsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type SummerSchoolWebinarListLinkingCollections = {
  __typename?: 'SummerSchoolWebinarListLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
  summerSchoolSectionCollection: Maybe<SummerSchoolSectionCollection>;
  summerSchoolSectionCursorCollection: Maybe<SummerSchoolSectionCursorCollection>;
};


export type SummerSchoolWebinarListLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolWebinarListLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolWebinarListLinkingCollectionsSummerSchoolSectionCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolWebinarListLinkingCollectionsSummerSchoolSectionCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type SummerSchoolWebinarListLinkingCollectionsSummerSchoolSectionCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<SummerSchoolWebinarListLinkingCollectionsSummerSchoolSectionCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SummerSchoolWebinarListLinkingCollectionsSummerSchoolSectionCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolWebinarListLinkingCollectionsSummerSchoolSectionCursorCollectionOrder {
  InternalTitleAsc = 'internalTitle_ASC',
  InternalTitleDesc = 'internalTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export enum SummerSchoolWebinarListOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type SummerSchoolWebinarListWebinarsCollection = {
  __typename?: 'SummerSchoolWebinarListWebinarsCollection';
  items: Array<Maybe<SummerSchoolWebinar>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum SummerSchoolWebinarListWebinarsCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type SummerSchoolWebinarListWebinarsCursorCollection = {
  __typename?: 'SummerSchoolWebinarListWebinarsCursorCollection';
  items: Array<Maybe<SummerSchoolWebinar>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum SummerSchoolWebinarListWebinarsCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum SummerSchoolWebinarOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export type Sys = {
  __typename?: 'Sys';
  environmentId: Scalars['String']['output'];
  firstPublishedAt: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  /** The locale that was requested. */
  locale: Maybe<Scalars['String']['output']>;
  publishedAt: Maybe<Scalars['DateTime']['output']>;
  publishedVersion: Maybe<Scalars['Int']['output']>;
  spaceId: Scalars['String']['output'];
};

export type SysFilter = {
  firstPublishedAt: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  firstPublishedAt_gt: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_gte: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  firstPublishedAt_lt: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_lte: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not: InputMaybe<Scalars['DateTime']['input']>;
  firstPublishedAt_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedVersion: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishedVersion_gt: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_gte: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  publishedVersion_lt: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_lte: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not: InputMaybe<Scalars['Float']['input']>;
  publishedVersion_not_in: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

/**
 * Represents a taxonomy concept entity for finding and organizing content easily.
 *         Find out more here: https://www.contentful.com/developers/docs/references/content-delivery-api/#/reference/content-concepts
 */
export type TaxonomyConcept = {
  __typename?: 'TaxonomyConcept';
  id: Maybe<Scalars['String']['output']>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/teacherTestimonialBlock) */
export type TeacherTestimonialBlock = Entry & _Node & {
  __typename?: 'TeacherTestimonialBlock';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<TeacherTestimonialBlockLinkingCollections>;
  sys: Sys;
  testimonialsListCollection: Maybe<TeacherTestimonialBlockTestimonialsListCollection>;
  testimonialsListCursorCollection: Maybe<TeacherTestimonialBlockTestimonialsListCursorCollection>;
  title: Maybe<Scalars['String']['output']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/teacherTestimonialBlock) */
export type TeacherTestimonialBlockLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/teacherTestimonialBlock) */
export type TeacherTestimonialBlockTestimonialsListCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TeacherTestimonialBlockTestimonialsListCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentWlTestimonialsBlockFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/teacherTestimonialBlock) */
export type TeacherTestimonialBlockTestimonialsListCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TeacherTestimonialBlockTestimonialsListCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentWlTestimonialsBlockFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/teacherTestimonialBlock) */
export type TeacherTestimonialBlockTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type TeacherTestimonialBlockCollection = {
  __typename?: 'TeacherTestimonialBlockCollection';
  items: Array<Maybe<TeacherTestimonialBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type TeacherTestimonialBlockCursorCollection = {
  __typename?: 'TeacherTestimonialBlockCursorCollection';
  items: Array<Maybe<TeacherTestimonialBlock>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type TeacherTestimonialBlockFilter = {
  AND: InputMaybe<Array<InputMaybe<TeacherTestimonialBlockFilter>>>;
  OR: InputMaybe<Array<InputMaybe<TeacherTestimonialBlockFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  testimonialsList: InputMaybe<CfComposeComponentWlTestimonialsBlockNestedFilter>;
  testimonialsListCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type TeacherTestimonialBlockLinkingCollections = {
  __typename?: 'TeacherTestimonialBlockLinkingCollections';
  composePageWlMarketingHomePageCollection: Maybe<ComposePageWlMarketingHomePageCollection>;
  composePageWlMarketingHomePageCursorCollection: Maybe<ComposePageWlMarketingHomePageCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type TeacherTestimonialBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TeacherTestimonialBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TeacherTestimonialBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<TeacherTestimonialBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TeacherTestimonialBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type TeacherTestimonialBlockLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TeacherTestimonialBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TeacherTestimonialBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum TeacherTestimonialBlockOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC'
}

export type TeacherTestimonialBlockTestimonialsListCollection = {
  __typename?: 'TeacherTestimonialBlockTestimonialsListCollection';
  items: Array<Maybe<ComposeComponentWlTestimonialsBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export enum TeacherTestimonialBlockTestimonialsListCollectionOrder {
  SchoolNameAsc = 'schoolName_ASC',
  SchoolNameDesc = 'schoolName_DESC',
  SubmittedByAsc = 'submittedBy_ASC',
  SubmittedByDesc = 'submittedBy_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type TeacherTestimonialBlockTestimonialsListCursorCollection = {
  __typename?: 'TeacherTestimonialBlockTestimonialsListCursorCollection';
  items: Array<Maybe<ComposeComponentWlTestimonialsBlock>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export enum TeacherTestimonialBlockTestimonialsListCursorCollectionOrder {
  SchoolNameAsc = 'schoolName_ASC',
  SchoolNameDesc = 'schoolName_DESC',
  SubmittedByAsc = 'submittedBy_ASC',
  SubmittedByDesc = 'submittedBy_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type TimelineFilterInput = {
  /** Preview content starting from a given release date */
  release_lte: InputMaybe<Scalars['String']['input']>;
  /** Preview content starting from a given timestamp */
  timestamp_lte: InputMaybe<Scalars['DateTime']['input']>;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsFreeTrialBlock) */
export type WritingLegendsFreeTrialBlock = Entry & _Node & {
  __typename?: 'WritingLegendsFreeTrialBlock';
  _id: Scalars['ID']['output'];
  callToActionText: Maybe<Scalars['String']['output']>;
  contactEmail: Maybe<Scalars['String']['output']>;
  contactNumber: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<WritingLegendsFreeTrialBlockLinkingCollections>;
  sys: Sys;
  title: Maybe<Scalars['String']['output']>;
  writingLegendsIntroVideo: Maybe<Asset>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsFreeTrialBlock) */
export type WritingLegendsFreeTrialBlockCallToActionTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsFreeTrialBlock) */
export type WritingLegendsFreeTrialBlockContactEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsFreeTrialBlock) */
export type WritingLegendsFreeTrialBlockContactNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsFreeTrialBlock) */
export type WritingLegendsFreeTrialBlockLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsFreeTrialBlock) */
export type WritingLegendsFreeTrialBlockTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsFreeTrialBlock) */
export type WritingLegendsFreeTrialBlockWritingLegendsIntroVideoArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsFreeTrialBlockCollection = {
  __typename?: 'WritingLegendsFreeTrialBlockCollection';
  items: Array<Maybe<WritingLegendsFreeTrialBlock>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WritingLegendsFreeTrialBlockCursorCollection = {
  __typename?: 'WritingLegendsFreeTrialBlockCursorCollection';
  items: Array<Maybe<WritingLegendsFreeTrialBlock>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WritingLegendsFreeTrialBlockFilter = {
  AND: InputMaybe<Array<InputMaybe<WritingLegendsFreeTrialBlockFilter>>>;
  OR: InputMaybe<Array<InputMaybe<WritingLegendsFreeTrialBlockFilter>>>;
  callToActionText: InputMaybe<Scalars['String']['input']>;
  callToActionText_contains: InputMaybe<Scalars['String']['input']>;
  callToActionText_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionText_not: InputMaybe<Scalars['String']['input']>;
  callToActionText_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactEmail: InputMaybe<Scalars['String']['input']>;
  contactEmail_contains: InputMaybe<Scalars['String']['input']>;
  contactEmail_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactEmail_not: InputMaybe<Scalars['String']['input']>;
  contactEmail_not_contains: InputMaybe<Scalars['String']['input']>;
  contactEmail_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber: InputMaybe<Scalars['String']['input']>;
  contactNumber_contains: InputMaybe<Scalars['String']['input']>;
  contactNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber_not: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  writingLegendsIntroVideo_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsFreeTrialBlockLinkingCollections = {
  __typename?: 'WritingLegendsFreeTrialBlockLinkingCollections';
  composePageWlMarketingHomePageCollection: Maybe<ComposePageWlMarketingHomePageCollection>;
  composePageWlMarketingHomePageCursorCollection: Maybe<ComposePageWlMarketingHomePageCursorCollection>;
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type WritingLegendsFreeTrialBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsFreeTrialBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder>>>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsFreeTrialBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  order: InputMaybe<Array<InputMaybe<WritingLegendsFreeTrialBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder>>>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsFreeTrialBlockLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsFreeTrialBlockLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WritingLegendsFreeTrialBlockLinkingCollectionsComposePageWlMarketingHomePageCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WritingLegendsFreeTrialBlockLinkingCollectionsComposePageWlMarketingHomePageCursorCollectionOrder {
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export enum WritingLegendsFreeTrialBlockOrder {
  ContactEmailAsc = 'contactEmail_ASC',
  ContactEmailDesc = 'contactEmail_DESC',
  ContactNumberAsc = 'contactNumber_ASC',
  ContactNumberDesc = 'contactNumber_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAboutUsPage) */
export type WritingLegendsMarketingSiteAboutUsPage = Entry & _Node & {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPage';
  _id: Scalars['ID']['output'];
  aboutUsText: Maybe<WritingLegendsMarketingSiteAboutUsPageAboutUsText>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<WritingLegendsMarketingSiteAboutUsPageLinkingCollections>;
  pageName: Maybe<Scalars['String']['output']>;
  seoKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seoPageDescription: Maybe<Scalars['String']['output']>;
  seoPageTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAboutUsPage) */
export type WritingLegendsMarketingSiteAboutUsPageAboutUsTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAboutUsPage) */
export type WritingLegendsMarketingSiteAboutUsPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAboutUsPage) */
export type WritingLegendsMarketingSiteAboutUsPagePageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAboutUsPage) */
export type WritingLegendsMarketingSiteAboutUsPageSeoKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAboutUsPage) */
export type WritingLegendsMarketingSiteAboutUsPageSeoPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAboutUsPage) */
export type WritingLegendsMarketingSiteAboutUsPageSeoPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsMarketingSiteAboutUsPageAboutUsText = {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageAboutUsText';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteAboutUsPageAboutUsTextLinks;
};

export type WritingLegendsMarketingSiteAboutUsPageAboutUsTextAssets = {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageAboutUsTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteAboutUsPageAboutUsTextEntries = {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageAboutUsTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteAboutUsPageAboutUsTextLinks = {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageAboutUsTextLinks';
  assets: WritingLegendsMarketingSiteAboutUsPageAboutUsTextAssets;
  entries: WritingLegendsMarketingSiteAboutUsPageAboutUsTextEntries;
  resources: WritingLegendsMarketingSiteAboutUsPageAboutUsTextResources;
};

export type WritingLegendsMarketingSiteAboutUsPageAboutUsTextResources = {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageAboutUsTextResources';
  block: Array<WritingLegendsMarketingSiteAboutUsPageAboutUsTextResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteAboutUsPageAboutUsTextResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteAboutUsPageAboutUsTextResourcesInline>;
};

export type WritingLegendsMarketingSiteAboutUsPageAboutUsTextResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageAboutUsTextResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteAboutUsPageAboutUsTextResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageAboutUsTextResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteAboutUsPageAboutUsTextResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageAboutUsTextResourcesInline';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteAboutUsPageCollection = {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteAboutUsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WritingLegendsMarketingSiteAboutUsPageCursorCollection = {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageCursorCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteAboutUsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WritingLegendsMarketingSiteAboutUsPageFilter = {
  AND: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteAboutUsPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteAboutUsPageFilter>>>;
  aboutUsText_contains: InputMaybe<Scalars['String']['input']>;
  aboutUsText_exists: InputMaybe<Scalars['Boolean']['input']>;
  aboutUsText_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  pageName: InputMaybe<Scalars['String']['input']>;
  pageName_contains: InputMaybe<Scalars['String']['input']>;
  pageName_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains: InputMaybe<Scalars['String']['input']>;
  pageName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageDescription_not: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle_not: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type WritingLegendsMarketingSiteAboutUsPageLinkingCollections = {
  __typename?: 'WritingLegendsMarketingSiteAboutUsPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type WritingLegendsMarketingSiteAboutUsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsMarketingSiteAboutUsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WritingLegendsMarketingSiteAboutUsPageOrder {
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAccessibilityPage) */
export type WritingLegendsMarketingSiteAccessibilityPage = Entry & _Node & {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPage';
  _id: Scalars['ID']['output'];
  accessibilityText: Maybe<WritingLegendsMarketingSiteAccessibilityPageAccessibilityText>;
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<WritingLegendsMarketingSiteAccessibilityPageLinkingCollections>;
  pageName: Maybe<Scalars['String']['output']>;
  seoKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seoPageDescription: Maybe<Scalars['String']['output']>;
  seoPageTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAccessibilityPage) */
export type WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAccessibilityPage) */
export type WritingLegendsMarketingSiteAccessibilityPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAccessibilityPage) */
export type WritingLegendsMarketingSiteAccessibilityPagePageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAccessibilityPage) */
export type WritingLegendsMarketingSiteAccessibilityPageSeoKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAccessibilityPage) */
export type WritingLegendsMarketingSiteAccessibilityPageSeoPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteAccessibilityPage) */
export type WritingLegendsMarketingSiteAccessibilityPageSeoPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsMarketingSiteAccessibilityPageAccessibilityText = {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageAccessibilityText';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextLinks;
};

export type WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextAssets = {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextEntries = {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextLinks = {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextLinks';
  assets: WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextAssets;
  entries: WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextEntries;
  resources: WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResources;
};

export type WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResources = {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResources';
  block: Array<WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResourcesInline>;
};

export type WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageAccessibilityTextResourcesInline';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteAccessibilityPageCollection = {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteAccessibilityPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WritingLegendsMarketingSiteAccessibilityPageCursorCollection = {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageCursorCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteAccessibilityPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WritingLegendsMarketingSiteAccessibilityPageFilter = {
  AND: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteAccessibilityPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteAccessibilityPageFilter>>>;
  accessibilityText_contains: InputMaybe<Scalars['String']['input']>;
  accessibilityText_exists: InputMaybe<Scalars['Boolean']['input']>;
  accessibilityText_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  pageName: InputMaybe<Scalars['String']['input']>;
  pageName_contains: InputMaybe<Scalars['String']['input']>;
  pageName_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains: InputMaybe<Scalars['String']['input']>;
  pageName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageDescription_not: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle_not: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type WritingLegendsMarketingSiteAccessibilityPageLinkingCollections = {
  __typename?: 'WritingLegendsMarketingSiteAccessibilityPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type WritingLegendsMarketingSiteAccessibilityPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsMarketingSiteAccessibilityPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WritingLegendsMarketingSiteAccessibilityPageOrder {
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPage) */
export type WritingLegendsMarketingSiteContactUsPage = Entry & _Node & {
  __typename?: 'WritingLegendsMarketingSiteContactUsPage';
  _id: Scalars['ID']['output'];
  contactUsText: Maybe<WritingLegendsMarketingSiteContactUsPageContactUsText>;
  contentfulMetadata: ContentfulMetadata;
  formLink: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<WritingLegendsMarketingSiteContactUsPageLinkingCollections>;
  pageName: Maybe<Scalars['String']['output']>;
  seoKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seoPageDescription: Maybe<Scalars['String']['output']>;
  seoPageTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPage) */
export type WritingLegendsMarketingSiteContactUsPageContactUsTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPage) */
export type WritingLegendsMarketingSiteContactUsPageFormLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPage) */
export type WritingLegendsMarketingSiteContactUsPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPage) */
export type WritingLegendsMarketingSiteContactUsPagePageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPage) */
export type WritingLegendsMarketingSiteContactUsPageSeoKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPage) */
export type WritingLegendsMarketingSiteContactUsPageSeoPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPage) */
export type WritingLegendsMarketingSiteContactUsPageSeoPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsMarketingSiteContactUsPageCollection = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteContactUsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WritingLegendsMarketingSiteContactUsPageContactUsText = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageContactUsText';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteContactUsPageContactUsTextLinks;
};

export type WritingLegendsMarketingSiteContactUsPageContactUsTextAssets = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageContactUsTextAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteContactUsPageContactUsTextEntries = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageContactUsTextEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteContactUsPageContactUsTextLinks = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageContactUsTextLinks';
  assets: WritingLegendsMarketingSiteContactUsPageContactUsTextAssets;
  entries: WritingLegendsMarketingSiteContactUsPageContactUsTextEntries;
  resources: WritingLegendsMarketingSiteContactUsPageContactUsTextResources;
};

export type WritingLegendsMarketingSiteContactUsPageContactUsTextResources = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageContactUsTextResources';
  block: Array<WritingLegendsMarketingSiteContactUsPageContactUsTextResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteContactUsPageContactUsTextResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteContactUsPageContactUsTextResourcesInline>;
};

export type WritingLegendsMarketingSiteContactUsPageContactUsTextResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageContactUsTextResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteContactUsPageContactUsTextResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageContactUsTextResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteContactUsPageContactUsTextResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageContactUsTextResourcesInline';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteContactUsPageCursorCollection = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageCursorCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteContactUsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WritingLegendsMarketingSiteContactUsPageFilter = {
  AND: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteContactUsPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteContactUsPageFilter>>>;
  contactUsText_contains: InputMaybe<Scalars['String']['input']>;
  contactUsText_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactUsText_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  formLink: InputMaybe<Scalars['String']['input']>;
  formLink_contains: InputMaybe<Scalars['String']['input']>;
  formLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  formLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formLink_not: InputMaybe<Scalars['String']['input']>;
  formLink_not_contains: InputMaybe<Scalars['String']['input']>;
  formLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName: InputMaybe<Scalars['String']['input']>;
  pageName_contains: InputMaybe<Scalars['String']['input']>;
  pageName_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains: InputMaybe<Scalars['String']['input']>;
  pageName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageDescription_not: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle_not: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type WritingLegendsMarketingSiteContactUsPageLinkingCollections = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type WritingLegendsMarketingSiteContactUsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsMarketingSiteContactUsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WritingLegendsMarketingSiteContactUsPageOrder {
  FormLinkAsc = 'formLink_ASC',
  FormLinkDesc = 'formLink_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2 = Entry & _Node & {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2';
  _id: Scalars['ID']['output'];
  contactUsVideoAndAdjacentText: Maybe<ComposeComponentVideoAndAdjacentText>;
  contentfulMetadata: ContentfulMetadata;
  customerTestimonial: Maybe<LegoUiTestimonialCard>;
  downloadSectionButtonText: Maybe<Scalars['String']['output']>;
  downloadSectionDescription: Maybe<Scalars['String']['output']>;
  downloadSectionImage: Maybe<ComposeComponentImage>;
  downloadSectionLink: Maybe<Scalars['String']['output']>;
  email: Maybe<Scalars['String']['output']>;
  formLink: Maybe<Scalars['String']['output']>;
  formTitle: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<WritingLegendsMarketingSiteContactUsPageV2LinkingCollections>;
  pageName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  productInfoBlock: Maybe<WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlock>;
  seoKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seoPageDescription: Maybe<Scalars['String']['output']>;
  seoPageTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2ContactUsVideoAndAdjacentTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentVideoAndAdjacentTextFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2CustomerTestimonialArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<LegoUiTestimonialCardFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2DownloadSectionButtonTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2DownloadSectionDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2DownloadSectionImageArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
  where: InputMaybe<ComposeComponentImageFilter>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2DownloadSectionLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2EmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2FormLinkArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2FormTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2LinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2PageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2PhoneNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2SeoKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2SeoPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteContactUsPageV2) */
export type WritingLegendsMarketingSiteContactUsPageV2SeoPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsMarketingSiteContactUsPageV2Collection = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2Collection';
  items: Array<Maybe<WritingLegendsMarketingSiteContactUsPageV2>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WritingLegendsMarketingSiteContactUsPageV2CursorCollection = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2CursorCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteContactUsPageV2>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WritingLegendsMarketingSiteContactUsPageV2Filter = {
  AND: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteContactUsPageV2Filter>>>;
  OR: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteContactUsPageV2Filter>>>;
  contactUsVideoAndAdjacentText: InputMaybe<CfComposeComponentVideoAndAdjacentTextNestedFilter>;
  contactUsVideoAndAdjacentText_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  customerTestimonial: InputMaybe<CfLegoUiTestimonialCardNestedFilter>;
  customerTestimonial_exists: InputMaybe<Scalars['Boolean']['input']>;
  downloadSectionButtonText: InputMaybe<Scalars['String']['input']>;
  downloadSectionButtonText_contains: InputMaybe<Scalars['String']['input']>;
  downloadSectionButtonText_exists: InputMaybe<Scalars['Boolean']['input']>;
  downloadSectionButtonText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  downloadSectionButtonText_not: InputMaybe<Scalars['String']['input']>;
  downloadSectionButtonText_not_contains: InputMaybe<Scalars['String']['input']>;
  downloadSectionButtonText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  downloadSectionDescription: InputMaybe<Scalars['String']['input']>;
  downloadSectionDescription_contains: InputMaybe<Scalars['String']['input']>;
  downloadSectionDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  downloadSectionDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  downloadSectionDescription_not: InputMaybe<Scalars['String']['input']>;
  downloadSectionDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  downloadSectionDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  downloadSectionImage: InputMaybe<CfComposeComponentImageNestedFilter>;
  downloadSectionImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  downloadSectionLink: InputMaybe<Scalars['String']['input']>;
  downloadSectionLink_contains: InputMaybe<Scalars['String']['input']>;
  downloadSectionLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  downloadSectionLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  downloadSectionLink_not: InputMaybe<Scalars['String']['input']>;
  downloadSectionLink_not_contains: InputMaybe<Scalars['String']['input']>;
  downloadSectionLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email: InputMaybe<Scalars['String']['input']>;
  email_contains: InputMaybe<Scalars['String']['input']>;
  email_exists: InputMaybe<Scalars['Boolean']['input']>;
  email_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_not: InputMaybe<Scalars['String']['input']>;
  email_not_contains: InputMaybe<Scalars['String']['input']>;
  email_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formLink: InputMaybe<Scalars['String']['input']>;
  formLink_contains: InputMaybe<Scalars['String']['input']>;
  formLink_exists: InputMaybe<Scalars['Boolean']['input']>;
  formLink_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formLink_not: InputMaybe<Scalars['String']['input']>;
  formLink_not_contains: InputMaybe<Scalars['String']['input']>;
  formLink_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formTitle: InputMaybe<Scalars['String']['input']>;
  formTitle_contains: InputMaybe<Scalars['String']['input']>;
  formTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  formTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formTitle_not: InputMaybe<Scalars['String']['input']>;
  formTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  formTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName: InputMaybe<Scalars['String']['input']>;
  pageName_contains: InputMaybe<Scalars['String']['input']>;
  pageName_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains: InputMaybe<Scalars['String']['input']>;
  pageName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  phoneNumber_contains: InputMaybe<Scalars['String']['input']>;
  phoneNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber_not: InputMaybe<Scalars['String']['input']>;
  phoneNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  phoneNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productInfoBlock_contains: InputMaybe<Scalars['String']['input']>;
  productInfoBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  productInfoBlock_not_contains: InputMaybe<Scalars['String']['input']>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageDescription_not: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle_not: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type WritingLegendsMarketingSiteContactUsPageV2LinkingCollections = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2LinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type WritingLegendsMarketingSiteContactUsPageV2LinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsMarketingSiteContactUsPageV2LinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WritingLegendsMarketingSiteContactUsPageV2Order {
  DownloadSectionButtonTextAsc = 'downloadSectionButtonText_ASC',
  DownloadSectionButtonTextDesc = 'downloadSectionButtonText_DESC',
  DownloadSectionDescriptionAsc = 'downloadSectionDescription_ASC',
  DownloadSectionDescriptionDesc = 'downloadSectionDescription_DESC',
  DownloadSectionLinkAsc = 'downloadSectionLink_ASC',
  DownloadSectionLinkDesc = 'downloadSectionLink_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  FormLinkAsc = 'formLink_ASC',
  FormLinkDesc = 'formLink_DESC',
  FormTitleAsc = 'formTitle_ASC',
  FormTitleDesc = 'formTitle_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PhoneNumberAsc = 'phoneNumber_ASC',
  PhoneNumberDesc = 'phoneNumber_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlock = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlock';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockLinks;
};

export type WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockAssets = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockEntries = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockLinks = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockLinks';
  assets: WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockAssets;
  entries: WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockEntries;
  resources: WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResources;
};

export type WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResources = {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResources';
  block: Array<WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResourcesInline>;
};

export type WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlockResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteFaQsPage) */
export type WritingLegendsMarketingSiteFaQsPage = Entry & _Node & {
  __typename?: 'WritingLegendsMarketingSiteFaQsPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  frequentlyAskedQuestions: Maybe<WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestions>;
  linkedFrom: Maybe<WritingLegendsMarketingSiteFaQsPageLinkingCollections>;
  pageName: Maybe<Scalars['String']['output']>;
  seoKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seoPageDescription: Maybe<Scalars['String']['output']>;
  seoPageTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteFaQsPage) */
export type WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteFaQsPage) */
export type WritingLegendsMarketingSiteFaQsPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteFaQsPage) */
export type WritingLegendsMarketingSiteFaQsPagePageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteFaQsPage) */
export type WritingLegendsMarketingSiteFaQsPageSeoKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteFaQsPage) */
export type WritingLegendsMarketingSiteFaQsPageSeoPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteFaQsPage) */
export type WritingLegendsMarketingSiteFaQsPageSeoPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsMarketingSiteFaQsPageCollection = {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteFaQsPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WritingLegendsMarketingSiteFaQsPageCursorCollection = {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageCursorCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteFaQsPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WritingLegendsMarketingSiteFaQsPageFilter = {
  AND: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteFaQsPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteFaQsPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  frequentlyAskedQuestions_contains: InputMaybe<Scalars['String']['input']>;
  frequentlyAskedQuestions_exists: InputMaybe<Scalars['Boolean']['input']>;
  frequentlyAskedQuestions_not_contains: InputMaybe<Scalars['String']['input']>;
  pageName: InputMaybe<Scalars['String']['input']>;
  pageName_contains: InputMaybe<Scalars['String']['input']>;
  pageName_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains: InputMaybe<Scalars['String']['input']>;
  pageName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageDescription_not: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle_not: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestions = {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestions';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsLinks;
};

export type WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsAssets = {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsEntries = {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsLinks = {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsLinks';
  assets: WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsAssets;
  entries: WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsEntries;
  resources: WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResources;
};

export type WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResources = {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResources';
  block: Array<WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResourcesInline>;
};

export type WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsResourcesInline';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteFaQsPageLinkingCollections = {
  __typename?: 'WritingLegendsMarketingSiteFaQsPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type WritingLegendsMarketingSiteFaQsPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsMarketingSiteFaQsPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WritingLegendsMarketingSiteFaQsPageOrder {
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPage = Entry & _Node & {
  __typename?: 'WritingLegendsMarketingSiteIndexPage';
  _id: Scalars['ID']['output'];
  buttonCtaText: Maybe<Scalars['String']['output']>;
  contentfulMetadata: ContentfulMetadata;
  email: Maybe<Scalars['String']['output']>;
  linkedFrom: Maybe<WritingLegendsMarketingSiteIndexPageLinkingCollections>;
  pageName: Maybe<Scalars['String']['output']>;
  phoneNumber: Maybe<Scalars['String']['output']>;
  productOwnersBlock: Maybe<Entry>;
  seoKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seoPageDescription: Maybe<Scalars['String']['output']>;
  seoPageTitle: Maybe<Scalars['String']['output']>;
  slug: Maybe<Scalars['String']['output']>;
  studentOutcomesBlock: Maybe<WritingLegendsMarketingSiteIndexPageStudentOutcomesBlock>;
  summaryBlock: Maybe<WritingLegendsMarketingSiteIndexPageSummaryBlock>;
  sys: Sys;
  teacherSupportBlock: Maybe<WritingLegendsMarketingSiteIndexPageTeacherSupportBlock>;
  videoBlock: Maybe<WritingLegendsMarketingSiteIndexPageVideoBlock>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageButtonCtaTextArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageEmailArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPagePageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPagePhoneNumberArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageProductOwnersBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageSeoKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageSeoPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageSeoPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageSlugArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageSummaryBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageTeacherSupportBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteIndexPage) */
export type WritingLegendsMarketingSiteIndexPageVideoBlockArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsMarketingSiteIndexPageCollection = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteIndexPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WritingLegendsMarketingSiteIndexPageCursorCollection = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageCursorCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteIndexPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WritingLegendsMarketingSiteIndexPageFilter = {
  AND: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteIndexPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteIndexPageFilter>>>;
  buttonCtaText: InputMaybe<Scalars['String']['input']>;
  buttonCtaText_contains: InputMaybe<Scalars['String']['input']>;
  buttonCtaText_exists: InputMaybe<Scalars['Boolean']['input']>;
  buttonCtaText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonCtaText_not: InputMaybe<Scalars['String']['input']>;
  buttonCtaText_not_contains: InputMaybe<Scalars['String']['input']>;
  buttonCtaText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  email: InputMaybe<Scalars['String']['input']>;
  email_contains: InputMaybe<Scalars['String']['input']>;
  email_exists: InputMaybe<Scalars['Boolean']['input']>;
  email_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_not: InputMaybe<Scalars['String']['input']>;
  email_not_contains: InputMaybe<Scalars['String']['input']>;
  email_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName: InputMaybe<Scalars['String']['input']>;
  pageName_contains: InputMaybe<Scalars['String']['input']>;
  pageName_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains: InputMaybe<Scalars['String']['input']>;
  pageName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber: InputMaybe<Scalars['String']['input']>;
  phoneNumber_contains: InputMaybe<Scalars['String']['input']>;
  phoneNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber_not: InputMaybe<Scalars['String']['input']>;
  phoneNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  phoneNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  productOwnersBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageDescription_not: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle_not: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  studentOutcomesBlock_contains: InputMaybe<Scalars['String']['input']>;
  studentOutcomesBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  studentOutcomesBlock_not_contains: InputMaybe<Scalars['String']['input']>;
  summaryBlock_contains: InputMaybe<Scalars['String']['input']>;
  summaryBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  summaryBlock_not_contains: InputMaybe<Scalars['String']['input']>;
  sys: InputMaybe<SysFilter>;
  teacherSupportBlock_contains: InputMaybe<Scalars['String']['input']>;
  teacherSupportBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  teacherSupportBlock_not_contains: InputMaybe<Scalars['String']['input']>;
  videoBlock_contains: InputMaybe<Scalars['String']['input']>;
  videoBlock_exists: InputMaybe<Scalars['Boolean']['input']>;
  videoBlock_not_contains: InputMaybe<Scalars['String']['input']>;
};

export type WritingLegendsMarketingSiteIndexPageLinkingCollections = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type WritingLegendsMarketingSiteIndexPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsMarketingSiteIndexPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WritingLegendsMarketingSiteIndexPageOrder {
  ButtonCtaTextAsc = 'buttonCtaText_ASC',
  ButtonCtaTextDesc = 'buttonCtaText_DESC',
  EmailAsc = 'email_ASC',
  EmailDesc = 'email_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  PhoneNumberAsc = 'phoneNumber_ASC',
  PhoneNumberDesc = 'phoneNumber_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type WritingLegendsMarketingSiteIndexPageStudentOutcomesBlock = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlock';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockLinks;
};

export type WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockAssets = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockEntries = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockLinks = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockLinks';
  assets: WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockAssets;
  entries: WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockEntries;
  resources: WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResources;
};

export type WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResources = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResources';
  block: Array<WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResourcesInline>;
};

export type WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockResourcesInline';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageSummaryBlock = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlock';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteIndexPageSummaryBlockLinks;
};

export type WritingLegendsMarketingSiteIndexPageSummaryBlockAssets = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlockAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteIndexPageSummaryBlockEntries = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlockEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteIndexPageSummaryBlockLinks = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlockLinks';
  assets: WritingLegendsMarketingSiteIndexPageSummaryBlockAssets;
  entries: WritingLegendsMarketingSiteIndexPageSummaryBlockEntries;
  resources: WritingLegendsMarketingSiteIndexPageSummaryBlockResources;
};

export type WritingLegendsMarketingSiteIndexPageSummaryBlockResources = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlockResources';
  block: Array<WritingLegendsMarketingSiteIndexPageSummaryBlockResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteIndexPageSummaryBlockResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteIndexPageSummaryBlockResourcesInline>;
};

export type WritingLegendsMarketingSiteIndexPageSummaryBlockResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlockResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageSummaryBlockResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlockResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageSummaryBlockResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlockResourcesInline';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageTeacherSupportBlock = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlock';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteIndexPageTeacherSupportBlockLinks;
};

export type WritingLegendsMarketingSiteIndexPageTeacherSupportBlockAssets = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlockAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteIndexPageTeacherSupportBlockEntries = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlockEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteIndexPageTeacherSupportBlockLinks = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlockLinks';
  assets: WritingLegendsMarketingSiteIndexPageTeacherSupportBlockAssets;
  entries: WritingLegendsMarketingSiteIndexPageTeacherSupportBlockEntries;
  resources: WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResources;
};

export type WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResources = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResources';
  block: Array<WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResourcesInline>;
};

export type WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlockResourcesInline';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageVideoBlock = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlock';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteIndexPageVideoBlockLinks;
};

export type WritingLegendsMarketingSiteIndexPageVideoBlockAssets = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlockAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteIndexPageVideoBlockEntries = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlockEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteIndexPageVideoBlockLinks = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlockLinks';
  assets: WritingLegendsMarketingSiteIndexPageVideoBlockAssets;
  entries: WritingLegendsMarketingSiteIndexPageVideoBlockEntries;
  resources: WritingLegendsMarketingSiteIndexPageVideoBlockResources;
};

export type WritingLegendsMarketingSiteIndexPageVideoBlockResources = {
  __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlockResources';
  block: Array<WritingLegendsMarketingSiteIndexPageVideoBlockResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteIndexPageVideoBlockResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteIndexPageVideoBlockResourcesInline>;
};

export type WritingLegendsMarketingSiteIndexPageVideoBlockResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlockResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageVideoBlockResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlockResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteIndexPageVideoBlockResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlockResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSitePrivacyPolicyPage) */
export type WritingLegendsMarketingSitePrivacyPolicyPage = Entry & _Node & {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<WritingLegendsMarketingSitePrivacyPolicyPageLinkingCollections>;
  pageName: Maybe<Scalars['String']['output']>;
  privacyPolicyBody: Maybe<WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBody>;
  seoKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seoPageDescription: Maybe<Scalars['String']['output']>;
  seoPageTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSitePrivacyPolicyPage) */
export type WritingLegendsMarketingSitePrivacyPolicyPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSitePrivacyPolicyPage) */
export type WritingLegendsMarketingSitePrivacyPolicyPagePageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSitePrivacyPolicyPage) */
export type WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSitePrivacyPolicyPage) */
export type WritingLegendsMarketingSitePrivacyPolicyPageSeoKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSitePrivacyPolicyPage) */
export type WritingLegendsMarketingSitePrivacyPolicyPageSeoPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSitePrivacyPolicyPage) */
export type WritingLegendsMarketingSitePrivacyPolicyPageSeoPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsMarketingSitePrivacyPolicyPageCollection = {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPageCollection';
  items: Array<Maybe<WritingLegendsMarketingSitePrivacyPolicyPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WritingLegendsMarketingSitePrivacyPolicyPageCursorCollection = {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPageCursorCollection';
  items: Array<Maybe<WritingLegendsMarketingSitePrivacyPolicyPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WritingLegendsMarketingSitePrivacyPolicyPageFilter = {
  AND: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSitePrivacyPolicyPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSitePrivacyPolicyPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  pageName: InputMaybe<Scalars['String']['input']>;
  pageName_contains: InputMaybe<Scalars['String']['input']>;
  pageName_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains: InputMaybe<Scalars['String']['input']>;
  pageName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacyPolicyBody_contains: InputMaybe<Scalars['String']['input']>;
  privacyPolicyBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicyBody_not_contains: InputMaybe<Scalars['String']['input']>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageDescription_not: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle_not: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type WritingLegendsMarketingSitePrivacyPolicyPageLinkingCollections = {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type WritingLegendsMarketingSitePrivacyPolicyPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsMarketingSitePrivacyPolicyPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WritingLegendsMarketingSitePrivacyPolicyPageOrder {
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBody = {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBody';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyLinks;
};

export type WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyAssets = {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyEntries = {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyLinks = {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyLinks';
  assets: WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyAssets;
  entries: WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyEntries;
  resources: WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResources;
};

export type WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResources = {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResources';
  block: Array<WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResourcesInline>;
};

export type WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBodyResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTechReqPage) */
export type WritingLegendsMarketingSiteTechReqPage = Entry & _Node & {
  __typename?: 'WritingLegendsMarketingSiteTechReqPage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<WritingLegendsMarketingSiteTechReqPageLinkingCollections>;
  pageName: Maybe<Scalars['String']['output']>;
  seoKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seoPageDescription: Maybe<Scalars['String']['output']>;
  seoPageTitle: Maybe<Scalars['String']['output']>;
  softwareRequirements: Maybe<WritingLegendsMarketingSiteTechReqPageSoftwareRequirements>;
  sys: Sys;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTechReqPage) */
export type WritingLegendsMarketingSiteTechReqPageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTechReqPage) */
export type WritingLegendsMarketingSiteTechReqPagePageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTechReqPage) */
export type WritingLegendsMarketingSiteTechReqPageSeoKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTechReqPage) */
export type WritingLegendsMarketingSiteTechReqPageSeoPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTechReqPage) */
export type WritingLegendsMarketingSiteTechReqPageSeoPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTechReqPage) */
export type WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsMarketingSiteTechReqPageCollection = {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteTechReqPage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WritingLegendsMarketingSiteTechReqPageCursorCollection = {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageCursorCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteTechReqPage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WritingLegendsMarketingSiteTechReqPageFilter = {
  AND: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteTechReqPageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteTechReqPageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  pageName: InputMaybe<Scalars['String']['input']>;
  pageName_contains: InputMaybe<Scalars['String']['input']>;
  pageName_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains: InputMaybe<Scalars['String']['input']>;
  pageName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageDescription_not: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle_not: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  softwareRequirements_contains: InputMaybe<Scalars['String']['input']>;
  softwareRequirements_exists: InputMaybe<Scalars['Boolean']['input']>;
  softwareRequirements_not_contains: InputMaybe<Scalars['String']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type WritingLegendsMarketingSiteTechReqPageLinkingCollections = {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type WritingLegendsMarketingSiteTechReqPageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsMarketingSiteTechReqPageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WritingLegendsMarketingSiteTechReqPageOrder {
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type WritingLegendsMarketingSiteTechReqPageSoftwareRequirements = {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirements';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsLinks;
};

export type WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsAssets = {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsEntries = {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsLinks = {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsLinks';
  assets: WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsAssets;
  entries: WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsEntries;
  resources: WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResources;
};

export type WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResources = {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResources';
  block: Array<WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResourcesInline>;
};

export type WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsResourcesInline';
  sys: ResourceSys;
};

/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTermsOfUsePage) */
export type WritingLegendsMarketingSiteTermsOfUsePage = Entry & _Node & {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePage';
  _id: Scalars['ID']['output'];
  contentfulMetadata: ContentfulMetadata;
  linkedFrom: Maybe<WritingLegendsMarketingSiteTermsOfUsePageLinkingCollections>;
  pageName: Maybe<Scalars['String']['output']>;
  seoKeywords: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  seoPageDescription: Maybe<Scalars['String']['output']>;
  seoPageTitle: Maybe<Scalars['String']['output']>;
  sys: Sys;
  termsOfUse: Maybe<WritingLegendsMarketingSiteTermsOfUsePageTermsOfUse>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTermsOfUsePage) */
export type WritingLegendsMarketingSiteTermsOfUsePageLinkedFromArgs = {
  allowedLocales: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTermsOfUsePage) */
export type WritingLegendsMarketingSiteTermsOfUsePagePageNameArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTermsOfUsePage) */
export type WritingLegendsMarketingSiteTermsOfUsePageSeoKeywordsArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTermsOfUsePage) */
export type WritingLegendsMarketingSiteTermsOfUsePageSeoPageDescriptionArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTermsOfUsePage) */
export type WritingLegendsMarketingSiteTermsOfUsePageSeoPageTitleArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


/** [See type definition](https://app.contentful.com/spaces/lhzh8coidz9i/content_types/writingLegendsMarketingSiteTermsOfUsePage) */
export type WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseArgs = {
  locale: InputMaybe<Scalars['String']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export type WritingLegendsMarketingSiteTermsOfUsePageCollection = {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteTermsOfUsePage>>;
  limit: Scalars['Int']['output'];
  skip: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type WritingLegendsMarketingSiteTermsOfUsePageCursorCollection = {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageCursorCollection';
  items: Array<Maybe<WritingLegendsMarketingSiteTermsOfUsePage>>;
  limit: Scalars['Int']['output'];
  pages: CursorPages;
};

export type WritingLegendsMarketingSiteTermsOfUsePageFilter = {
  AND: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteTermsOfUsePageFilter>>>;
  OR: InputMaybe<Array<InputMaybe<WritingLegendsMarketingSiteTermsOfUsePageFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  pageName: InputMaybe<Scalars['String']['input']>;
  pageName_contains: InputMaybe<Scalars['String']['input']>;
  pageName_exists: InputMaybe<Scalars['Boolean']['input']>;
  pageName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pageName_not: InputMaybe<Scalars['String']['input']>;
  pageName_not_contains: InputMaybe<Scalars['String']['input']>;
  pageName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageDescription_not: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoPageTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoPageTitle_not: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  seoPageTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  termsOfUse_contains: InputMaybe<Scalars['String']['input']>;
  termsOfUse_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsOfUse_not_contains: InputMaybe<Scalars['String']['input']>;
};

export type WritingLegendsMarketingSiteTermsOfUsePageLinkingCollections = {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageLinkingCollections';
  entryCollection: Maybe<EntryCollection>;
  entryCursorCollection: Maybe<EntryCursorCollection>;
};


export type WritingLegendsMarketingSiteTermsOfUsePageLinkingCollectionsEntryCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};


export type WritingLegendsMarketingSiteTermsOfUsePageLinkingCollectionsEntryCursorCollectionArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: InputMaybe<Scalars['String']['input']>;
  pageNext: InputMaybe<Scalars['String']['input']>;
  pagePrev: InputMaybe<Scalars['String']['input']>;
  preview: InputMaybe<Scalars['Boolean']['input']>;
  useFallbackLocale: InputMaybe<Scalars['Boolean']['input']>;
};

export enum WritingLegendsMarketingSiteTermsOfUsePageOrder {
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  SeoPageDescriptionAsc = 'seoPageDescription_ASC',
  SeoPageDescriptionDesc = 'seoPageDescription_DESC',
  SeoPageTitleAsc = 'seoPageTitle_ASC',
  SeoPageTitleDesc = 'seoPageTitle_DESC',
  SysFirstPublishedAtAsc = 'sys_firstPublishedAt_ASC',
  SysFirstPublishedAtDesc = 'sys_firstPublishedAt_DESC',
  SysIdAsc = 'sys_id_ASC',
  SysIdDesc = 'sys_id_DESC',
  SysPublishedAtAsc = 'sys_publishedAt_ASC',
  SysPublishedAtDesc = 'sys_publishedAt_DESC',
  SysPublishedVersionAsc = 'sys_publishedVersion_ASC',
  SysPublishedVersionDesc = 'sys_publishedVersion_DESC'
}

export type WritingLegendsMarketingSiteTermsOfUsePageTermsOfUse = {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageTermsOfUse';
  json: Scalars['JSON']['output'];
  links: WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseLinks;
};

export type WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseAssets = {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseAssets';
  block: Array<Maybe<Asset>>;
  hyperlink: Array<Maybe<Asset>>;
};

export type WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseEntries = {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseEntries';
  block: Array<Maybe<Entry>>;
  hyperlink: Array<Maybe<Entry>>;
  inline: Array<Maybe<Entry>>;
};

export type WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseLinks = {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseLinks';
  assets: WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseAssets;
  entries: WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseEntries;
  resources: WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResources;
};

export type WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResources = {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResources';
  block: Array<WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResourcesBlock>;
  hyperlink: Array<WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResourcesHyperlink>;
  inline: Array<WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResourcesInline>;
};

export type WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResourcesBlock = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResourcesBlock';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResourcesHyperlink = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResourcesHyperlink';
  sys: ResourceSys;
};

export type WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResourcesInline = ResourceLink & {
  __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageTermsOfUseResourcesInline';
  sys: ResourceSys;
};

export type _Node = {
  _id: Scalars['ID']['output'];
};

export type CfActivitySheetAssetNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfActivitySheetAssetNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfActivitySheetAssetNestedFilter>>>;
  asset_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isVisible: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_exists: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_not: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfActivitySheetSectionNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfActivitySheetSectionNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfActivitySheetSectionNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfBigSchoolResourceListNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfBigSchoolResourceListNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfBigSchoolResourceListNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  resourceListsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComposeComponentHorizontalImageCtaNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentHorizontalImageCtaNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentHorizontalImageCtaNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  largeImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComposeComponentImageAndAdjacentTextNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentImageAndAdjacentTextNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentImageAndAdjacentTextNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  imageAlignment: InputMaybe<Scalars['String']['input']>;
  imageAlignment_contains: InputMaybe<Scalars['String']['input']>;
  imageAlignment_exists: InputMaybe<Scalars['Boolean']['input']>;
  imageAlignment_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  imageAlignment_not: InputMaybe<Scalars['String']['input']>;
  imageAlignment_not_contains: InputMaybe<Scalars['String']['input']>;
  imageAlignment_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
};

export type CfComposeComponentImageNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentImageNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentImageNestedFilter>>>;
  altText: InputMaybe<Scalars['String']['input']>;
  altText_contains: InputMaybe<Scalars['String']['input']>;
  altText_exists: InputMaybe<Scalars['Boolean']['input']>;
  altText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  altText_not: InputMaybe<Scalars['String']['input']>;
  altText_not_contains: InputMaybe<Scalars['String']['input']>;
  altText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caption_contains: InputMaybe<Scalars['String']['input']>;
  caption_exists: InputMaybe<Scalars['Boolean']['input']>;
  caption_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  imageAsset_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfComposeComponentLinkNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentLinkNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentLinkNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  opensInANewTab: InputMaybe<Scalars['Boolean']['input']>;
  opensInANewTab_exists: InputMaybe<Scalars['Boolean']['input']>;
  opensInANewTab_not: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  text: InputMaybe<Scalars['String']['input']>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not: InputMaybe<Scalars['String']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
  text_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComposeComponentStickyBannerItemNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentStickyBannerItemNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentStickyBannerItemNestedFilter>>>;
  body: InputMaybe<Scalars['String']['input']>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  body_not: InputMaybe<Scalars['String']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  body_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  link_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfComposeComponentTeacherSupportStatementNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentTeacherSupportStatementNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentTeacherSupportStatementNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  imageAndAdjacentText_exists: InputMaybe<Scalars['Boolean']['input']>;
  listHeading: InputMaybe<Scalars['String']['input']>;
  listHeading_contains: InputMaybe<Scalars['String']['input']>;
  listHeading_exists: InputMaybe<Scalars['Boolean']['input']>;
  listHeading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  listHeading_not: InputMaybe<Scalars['String']['input']>;
  listHeading_not_contains: InputMaybe<Scalars['String']['input']>;
  listHeading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  list_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  list_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  list_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  list_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComposeComponentTextNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentTextNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentTextNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  divAlignment: InputMaybe<Scalars['String']['input']>;
  divAlignment_contains: InputMaybe<Scalars['String']['input']>;
  divAlignment_exists: InputMaybe<Scalars['Boolean']['input']>;
  divAlignment_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  divAlignment_not: InputMaybe<Scalars['String']['input']>;
  divAlignment_not_contains: InputMaybe<Scalars['String']['input']>;
  divAlignment_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComposeComponentTopicBackgroundNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentTopicBackgroundNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentTopicBackgroundNestedFilter>>>;
  colour: InputMaybe<Scalars['String']['input']>;
  colour_contains: InputMaybe<Scalars['String']['input']>;
  colour_exists: InputMaybe<Scalars['Boolean']['input']>;
  colour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour_not: InputMaybe<Scalars['String']['input']>;
  colour_not_contains: InputMaybe<Scalars['String']['input']>;
  colour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfComposeComponentTopicNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentTopicNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentTopicNestedFilter>>>;
  background_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfComposeComponentUrlNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentUrlNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentUrlNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComposeComponentVerticalImageCtaNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentVerticalImageCtaNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentVerticalImageCtaNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComposeComponentVideoAndAdjacentTextNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentVideoAndAdjacentTextNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentVideoAndAdjacentTextNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  description_contains: InputMaybe<Scalars['String']['input']>;
  description_exists: InputMaybe<Scalars['Boolean']['input']>;
  description_not_contains: InputMaybe<Scalars['String']['input']>;
  sys: InputMaybe<SysFilter>;
  videoAlignment: InputMaybe<Scalars['String']['input']>;
  videoAlignment_contains: InputMaybe<Scalars['String']['input']>;
  videoAlignment_exists: InputMaybe<Scalars['Boolean']['input']>;
  videoAlignment_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  videoAlignment_not: InputMaybe<Scalars['String']['input']>;
  videoAlignment_not_contains: InputMaybe<Scalars['String']['input']>;
  videoAlignment_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  video_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfComposeComponentWlFooterBlockNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentWlFooterBlockNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentWlFooterBlockNestedFilter>>>;
  about3pLearning: InputMaybe<Scalars['String']['input']>;
  about3pLearning_contains: InputMaybe<Scalars['String']['input']>;
  about3pLearning_exists: InputMaybe<Scalars['Boolean']['input']>;
  about3pLearning_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  about3pLearning_not: InputMaybe<Scalars['String']['input']>;
  about3pLearning_not_contains: InputMaybe<Scalars['String']['input']>;
  about3pLearning_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aboutUs: InputMaybe<Scalars['String']['input']>;
  aboutUs_contains: InputMaybe<Scalars['String']['input']>;
  aboutUs_exists: InputMaybe<Scalars['Boolean']['input']>;
  aboutUs_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  aboutUs_not: InputMaybe<Scalars['String']['input']>;
  aboutUs_not_contains: InputMaybe<Scalars['String']['input']>;
  aboutUs_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  blakeELearningLogo_exists: InputMaybe<Scalars['Boolean']['input']>;
  collaborateWithUs: InputMaybe<Scalars['String']['input']>;
  collaborateWithUs_contains: InputMaybe<Scalars['String']['input']>;
  collaborateWithUs_exists: InputMaybe<Scalars['Boolean']['input']>;
  collaborateWithUs_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  collaborateWithUs_not: InputMaybe<Scalars['String']['input']>;
  collaborateWithUs_not_contains: InputMaybe<Scalars['String']['input']>;
  collaborateWithUs_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactUs: InputMaybe<Scalars['String']['input']>;
  contactUs_contains: InputMaybe<Scalars['String']['input']>;
  contactUs_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactUs_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactUs_not: InputMaybe<Scalars['String']['input']>;
  contactUs_not_contains: InputMaybe<Scalars['String']['input']>;
  contactUs_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  dataBreachResponsePlan: InputMaybe<Scalars['String']['input']>;
  dataBreachResponsePlan_contains: InputMaybe<Scalars['String']['input']>;
  dataBreachResponsePlan_exists: InputMaybe<Scalars['Boolean']['input']>;
  dataBreachResponsePlan_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dataBreachResponsePlan_not: InputMaybe<Scalars['String']['input']>;
  dataBreachResponsePlan_not_contains: InputMaybe<Scalars['String']['input']>;
  dataBreachResponsePlan_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook: InputMaybe<Scalars['String']['input']>;
  facebook_contains: InputMaybe<Scalars['String']['input']>;
  facebook_exists: InputMaybe<Scalars['Boolean']['input']>;
  facebook_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  facebook_not: InputMaybe<Scalars['String']['input']>;
  facebook_not_contains: InputMaybe<Scalars['String']['input']>;
  facebook_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram: InputMaybe<Scalars['String']['input']>;
  instagram_contains: InputMaybe<Scalars['String']['input']>;
  instagram_exists: InputMaybe<Scalars['Boolean']['input']>;
  instagram_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  instagram_not: InputMaybe<Scalars['String']['input']>;
  instagram_not_contains: InputMaybe<Scalars['String']['input']>;
  instagram_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kidSafeLogo_exists: InputMaybe<Scalars['Boolean']['input']>;
  linkedIn: InputMaybe<Scalars['String']['input']>;
  linkedIn_contains: InputMaybe<Scalars['String']['input']>;
  linkedIn_exists: InputMaybe<Scalars['Boolean']['input']>;
  linkedIn_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  linkedIn_not: InputMaybe<Scalars['String']['input']>;
  linkedIn_not_contains: InputMaybe<Scalars['String']['input']>;
  linkedIn_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pLearningLogo_exists: InputMaybe<Scalars['Boolean']['input']>;
  pinterest: InputMaybe<Scalars['String']['input']>;
  pinterest_contains: InputMaybe<Scalars['String']['input']>;
  pinterest_exists: InputMaybe<Scalars['Boolean']['input']>;
  pinterest_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pinterest_not: InputMaybe<Scalars['String']['input']>;
  pinterest_not_contains: InputMaybe<Scalars['String']['input']>;
  pinterest_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacyPolicy: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_contains: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_exists: InputMaybe<Scalars['Boolean']['input']>;
  privacyPolicy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  privacyPolicy_not: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_not_contains: InputMaybe<Scalars['String']['input']>;
  privacyPolicy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundPolicy: InputMaybe<Scalars['String']['input']>;
  refundPolicy_contains: InputMaybe<Scalars['String']['input']>;
  refundPolicy_exists: InputMaybe<Scalars['Boolean']['input']>;
  refundPolicy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  refundPolicy_not: InputMaybe<Scalars['String']['input']>;
  refundPolicy_not_contains: InputMaybe<Scalars['String']['input']>;
  refundPolicy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  responsibleDisclosureProgram: InputMaybe<Scalars['String']['input']>;
  responsibleDisclosureProgram_contains: InputMaybe<Scalars['String']['input']>;
  responsibleDisclosureProgram_exists: InputMaybe<Scalars['Boolean']['input']>;
  responsibleDisclosureProgram_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  responsibleDisclosureProgram_not: InputMaybe<Scalars['String']['input']>;
  responsibleDisclosureProgram_not_contains: InputMaybe<Scalars['String']['input']>;
  responsibleDisclosureProgram_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  termsOfUse: InputMaybe<Scalars['String']['input']>;
  termsOfUse_contains: InputMaybe<Scalars['String']['input']>;
  termsOfUse_exists: InputMaybe<Scalars['Boolean']['input']>;
  termsOfUse_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  termsOfUse_not: InputMaybe<Scalars['String']['input']>;
  termsOfUse_not_contains: InputMaybe<Scalars['String']['input']>;
  termsOfUse_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tikTok: InputMaybe<Scalars['String']['input']>;
  tikTok_contains: InputMaybe<Scalars['String']['input']>;
  tikTok_exists: InputMaybe<Scalars['Boolean']['input']>;
  tikTok_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tikTok_not: InputMaybe<Scalars['String']['input']>;
  tikTok_not_contains: InputMaybe<Scalars['String']['input']>;
  tikTok_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter: InputMaybe<Scalars['String']['input']>;
  twitter_contains: InputMaybe<Scalars['String']['input']>;
  twitter_exists: InputMaybe<Scalars['Boolean']['input']>;
  twitter_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  twitter_not: InputMaybe<Scalars['String']['input']>;
  twitter_not_contains: InputMaybe<Scalars['String']['input']>;
  twitter_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtube: InputMaybe<Scalars['String']['input']>;
  youtube_contains: InputMaybe<Scalars['String']['input']>;
  youtube_exists: InputMaybe<Scalars['Boolean']['input']>;
  youtube_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  youtube_not: InputMaybe<Scalars['String']['input']>;
  youtube_not_contains: InputMaybe<Scalars['String']['input']>;
  youtube_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComposeComponentWlProductAimBlockNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentWlProductAimBlockNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentWlProductAimBlockNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  lessonTypesOutline_exists: InputMaybe<Scalars['Boolean']['input']>;
  skillsOutline_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfComposeComponentWlTestimonialsBlockNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposeComponentWlTestimonialsBlockNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposeComponentWlTestimonialsBlockNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  schoolName: InputMaybe<Scalars['String']['input']>;
  schoolName_contains: InputMaybe<Scalars['String']['input']>;
  schoolName_exists: InputMaybe<Scalars['Boolean']['input']>;
  schoolName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  schoolName_not: InputMaybe<Scalars['String']['input']>;
  schoolName_not_contains: InputMaybe<Scalars['String']['input']>;
  schoolName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submittedBy: InputMaybe<Scalars['String']['input']>;
  submittedBy_contains: InputMaybe<Scalars['String']['input']>;
  submittedBy_exists: InputMaybe<Scalars['Boolean']['input']>;
  submittedBy_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submittedBy_not: InputMaybe<Scalars['String']['input']>;
  submittedBy_not_contains: InputMaybe<Scalars['String']['input']>;
  submittedBy_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  testimonial_contains: InputMaybe<Scalars['String']['input']>;
  testimonial_exists: InputMaybe<Scalars['Boolean']['input']>;
  testimonial_not_contains: InputMaybe<Scalars['String']['input']>;
};

export type CfComposePageArticleNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfComposePageArticleNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfComposePageArticleNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  excerpt_contains: InputMaybe<Scalars['String']['input']>;
  excerpt_exists: InputMaybe<Scalars['Boolean']['input']>;
  excerpt_not_contains: InputMaybe<Scalars['String']['input']>;
  heading: InputMaybe<Scalars['String']['input']>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heading_not: InputMaybe<Scalars['String']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  heading_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  heroImage_exists: InputMaybe<Scalars['Boolean']['input']>;
  horizontalImageCtaOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
  isIndexed: InputMaybe<Scalars['Boolean']['input']>;
  isIndexed_exists: InputMaybe<Scalars['Boolean']['input']>;
  isIndexed_not: InputMaybe<Scalars['Boolean']['input']>;
  isNextJsRoutable: InputMaybe<Scalars['Boolean']['input']>;
  isNextJsRoutable_exists: InputMaybe<Scalars['Boolean']['input']>;
  isNextJsRoutable_not: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  publishedAt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_exists: InputMaybe<Scalars['Boolean']['input']>;
  publishedAt_gt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_gte: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  publishedAt_lt: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_lte: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not: InputMaybe<Scalars['DateTime']['input']>;
  publishedAt_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  relatedPagesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  richTextBody_contains: InputMaybe<Scalars['String']['input']>;
  richTextBody_exists: InputMaybe<Scalars['Boolean']['input']>;
  richTextBody_not_contains: InputMaybe<Scalars['String']['input']>;
  seoDescription: InputMaybe<Scalars['String']['input']>;
  seoDescription_contains: InputMaybe<Scalars['String']['input']>;
  seoDescription_exists: InputMaybe<Scalars['Boolean']['input']>;
  seoDescription_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoDescription_not: InputMaybe<Scalars['String']['input']>;
  seoDescription_not_contains: InputMaybe<Scalars['String']['input']>;
  seoDescription_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_all: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_none: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_contains_some: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  seoKeywords_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug: InputMaybe<Scalars['String']['input']>;
  slug_contains: InputMaybe<Scalars['String']['input']>;
  slug_exists: InputMaybe<Scalars['Boolean']['input']>;
  slug_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_not: InputMaybe<Scalars['String']['input']>;
  slug_not_contains: InputMaybe<Scalars['String']['input']>;
  slug_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  topic_exists: InputMaybe<Scalars['Boolean']['input']>;
  topicsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  verticalImageCtaOverride_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfLegoUiButtonNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfLegoUiButtonNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfLegoUiButtonNestedFilter>>>;
  accentColour: InputMaybe<Scalars['String']['input']>;
  accentColour_contains: InputMaybe<Scalars['String']['input']>;
  accentColour_exists: InputMaybe<Scalars['Boolean']['input']>;
  accentColour_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  accentColour_not: InputMaybe<Scalars['String']['input']>;
  accentColour_not_contains: InputMaybe<Scalars['String']['input']>;
  accentColour_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  action: InputMaybe<Scalars['String']['input']>;
  action_contains: InputMaybe<Scalars['String']['input']>;
  action_exists: InputMaybe<Scalars['Boolean']['input']>;
  action_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  action_not: InputMaybe<Scalars['String']['input']>;
  action_not_contains: InputMaybe<Scalars['String']['input']>;
  action_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appearance: InputMaybe<Scalars['String']['input']>;
  appearance_contains: InputMaybe<Scalars['String']['input']>;
  appearance_exists: InputMaybe<Scalars['Boolean']['input']>;
  appearance_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  appearance_not: InputMaybe<Scalars['String']['input']>;
  appearance_not_contains: InputMaybe<Scalars['String']['input']>;
  appearance_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize: InputMaybe<Scalars['String']['input']>;
  buttonSize_contains: InputMaybe<Scalars['String']['input']>;
  buttonSize_exists: InputMaybe<Scalars['Boolean']['input']>;
  buttonSize_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonSize_not: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_contains: InputMaybe<Scalars['String']['input']>;
  buttonSize_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText: InputMaybe<Scalars['String']['input']>;
  buttonText_contains: InputMaybe<Scalars['String']['input']>;
  buttonText_exists: InputMaybe<Scalars['Boolean']['input']>;
  buttonText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  buttonText_not: InputMaybe<Scalars['String']['input']>;
  buttonText_not_contains: InputMaybe<Scalars['String']['input']>;
  buttonText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  disclaimerMessage: InputMaybe<Scalars['String']['input']>;
  disclaimerMessage_contains: InputMaybe<Scalars['String']['input']>;
  disclaimerMessage_exists: InputMaybe<Scalars['Boolean']['input']>;
  disclaimerMessage_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  disclaimerMessage_not: InputMaybe<Scalars['String']['input']>;
  disclaimerMessage_not_contains: InputMaybe<Scalars['String']['input']>;
  disclaimerMessage_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayAs: InputMaybe<Scalars['String']['input']>;
  displayAs_contains: InputMaybe<Scalars['String']['input']>;
  displayAs_exists: InputMaybe<Scalars['Boolean']['input']>;
  displayAs_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayAs_not: InputMaybe<Scalars['String']['input']>;
  displayAs_not_contains: InputMaybe<Scalars['String']['input']>;
  displayAs_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  href: InputMaybe<Scalars['String']['input']>;
  href_contains: InputMaybe<Scalars['String']['input']>;
  href_exists: InputMaybe<Scalars['Boolean']['input']>;
  href_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  href_not: InputMaybe<Scalars['String']['input']>;
  href_not_contains: InputMaybe<Scalars['String']['input']>;
  href_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon: InputMaybe<Scalars['String']['input']>;
  iconDirection: InputMaybe<Scalars['String']['input']>;
  iconDirection_contains: InputMaybe<Scalars['String']['input']>;
  iconDirection_exists: InputMaybe<Scalars['Boolean']['input']>;
  iconDirection_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iconDirection_not: InputMaybe<Scalars['String']['input']>;
  iconDirection_not_contains: InputMaybe<Scalars['String']['input']>;
  iconDirection_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_contains: InputMaybe<Scalars['String']['input']>;
  icon_exists: InputMaybe<Scalars['Boolean']['input']>;
  icon_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  icon_not: InputMaybe<Scalars['String']['input']>;
  icon_not_contains: InputMaybe<Scalars['String']['input']>;
  icon_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfLegoUiColumnNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfLegoUiColumnNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfLegoUiColumnNestedFilter>>>;
  column_contains: InputMaybe<Scalars['String']['input']>;
  column_exists: InputMaybe<Scalars['Boolean']['input']>;
  column_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfLegoUiFooterLinkGroupNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfLegoUiFooterLinkGroupNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfLegoUiFooterLinkGroupNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  groupLinksCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  groupTitle: InputMaybe<Scalars['String']['input']>;
  groupTitle_contains: InputMaybe<Scalars['String']['input']>;
  groupTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  groupTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupTitle_not: InputMaybe<Scalars['String']['input']>;
  groupTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  groupTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfLegoUiFooterLinkNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfLegoUiFooterLinkNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfLegoUiFooterLinkNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfLegoUiSocialMediaLinkNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfLegoUiSocialMediaLinkNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfLegoUiSocialMediaLinkNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  platform: InputMaybe<Scalars['String']['input']>;
  platformUrl: InputMaybe<Scalars['String']['input']>;
  platformUrl_contains: InputMaybe<Scalars['String']['input']>;
  platformUrl_exists: InputMaybe<Scalars['Boolean']['input']>;
  platformUrl_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platformUrl_not: InputMaybe<Scalars['String']['input']>;
  platformUrl_not_contains: InputMaybe<Scalars['String']['input']>;
  platformUrl_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platform_contains: InputMaybe<Scalars['String']['input']>;
  platform_exists: InputMaybe<Scalars['Boolean']['input']>;
  platform_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platform_not: InputMaybe<Scalars['String']['input']>;
  platform_not_contains: InputMaybe<Scalars['String']['input']>;
  platform_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfLegoUiTestimonialCardNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfLegoUiTestimonialCardNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfLegoUiTestimonialCardNestedFilter>>>;
  author: InputMaybe<Scalars['String']['input']>;
  author_contains: InputMaybe<Scalars['String']['input']>;
  author_exists: InputMaybe<Scalars['Boolean']['input']>;
  author_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author_not: InputMaybe<Scalars['String']['input']>;
  author_not_contains: InputMaybe<Scalars['String']['input']>;
  author_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar: InputMaybe<Scalars['String']['input']>;
  avatar_contains: InputMaybe<Scalars['String']['input']>;
  avatar_exists: InputMaybe<Scalars['Boolean']['input']>;
  avatar_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar_not: InputMaybe<Scalars['String']['input']>;
  avatar_not_contains: InputMaybe<Scalars['String']['input']>;
  avatar_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  date: InputMaybe<Scalars['DateTime']['input']>;
  date_exists: InputMaybe<Scalars['Boolean']['input']>;
  date_gt: InputMaybe<Scalars['DateTime']['input']>;
  date_gte: InputMaybe<Scalars['DateTime']['input']>;
  date_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  date_lt: InputMaybe<Scalars['DateTime']['input']>;
  date_lte: InputMaybe<Scalars['DateTime']['input']>;
  date_not: InputMaybe<Scalars['DateTime']['input']>;
  date_not_in: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quote: InputMaybe<Scalars['String']['input']>;
  quote_contains: InputMaybe<Scalars['String']['input']>;
  quote_exists: InputMaybe<Scalars['Boolean']['input']>;
  quote_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  quote_not: InputMaybe<Scalars['String']['input']>;
  quote_not_contains: InputMaybe<Scalars['String']['input']>;
  quote_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rating: InputMaybe<Scalars['Int']['input']>;
  rating_exists: InputMaybe<Scalars['Boolean']['input']>;
  rating_gt: InputMaybe<Scalars['Int']['input']>;
  rating_gte: InputMaybe<Scalars['Int']['input']>;
  rating_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  rating_lt: InputMaybe<Scalars['Int']['input']>;
  rating_lte: InputMaybe<Scalars['Int']['input']>;
  rating_not: InputMaybe<Scalars['Int']['input']>;
  rating_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  stacked: InputMaybe<Scalars['Boolean']['input']>;
  stacked_exists: InputMaybe<Scalars['Boolean']['input']>;
  stacked_not: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
};

export type CfLinkNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfLinkNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfLinkNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  text: InputMaybe<Scalars['String']['input']>;
  text_contains: InputMaybe<Scalars['String']['input']>;
  text_exists: InputMaybe<Scalars['Boolean']['input']>;
  text_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text_not: InputMaybe<Scalars['String']['input']>;
  text_not_contains: InputMaybe<Scalars['String']['input']>;
  text_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfMarketingBlogRegionalEditNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfMarketingBlogRegionalEditNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfMarketingBlogRegionalEditNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  snippetKeyword: InputMaybe<Scalars['String']['input']>;
  snippetKeyword_contains: InputMaybe<Scalars['String']['input']>;
  snippetKeyword_exists: InputMaybe<Scalars['Boolean']['input']>;
  snippetKeyword_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  snippetKeyword_not: InputMaybe<Scalars['String']['input']>;
  snippetKeyword_not_contains: InputMaybe<Scalars['String']['input']>;
  snippetKeyword_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  snippetText: InputMaybe<Scalars['String']['input']>;
  snippetText_contains: InputMaybe<Scalars['String']['input']>;
  snippetText_exists: InputMaybe<Scalars['Boolean']['input']>;
  snippetText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  snippetText_not: InputMaybe<Scalars['String']['input']>;
  snippetText_not_contains: InputMaybe<Scalars['String']['input']>;
  snippetText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfProductNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfProductNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfProductNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfSpanishActivitySheetAssetNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSpanishActivitySheetAssetNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSpanishActivitySheetAssetNestedFilter>>>;
  asset_exists: InputMaybe<Scalars['Boolean']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  id: InputMaybe<Scalars['String']['input']>;
  id_contains: InputMaybe<Scalars['String']['input']>;
  id_exists: InputMaybe<Scalars['Boolean']['input']>;
  id_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_not: InputMaybe<Scalars['String']['input']>;
  id_not_contains: InputMaybe<Scalars['String']['input']>;
  id_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isVisible: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_exists: InputMaybe<Scalars['Boolean']['input']>;
  isVisible_not: InputMaybe<Scalars['Boolean']['input']>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfSpanishActivitySheetSectionNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSpanishActivitySheetSectionNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSpanishActivitySheetSectionNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  name: InputMaybe<Scalars['String']['input']>;
  name_contains: InputMaybe<Scalars['String']['input']>;
  name_exists: InputMaybe<Scalars['Boolean']['input']>;
  name_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name_not: InputMaybe<Scalars['String']['input']>;
  name_not_contains: InputMaybe<Scalars['String']['input']>;
  name_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder: InputMaybe<Scalars['Int']['input']>;
  sortOrder_exists: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder_gt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_gte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sortOrder_lt: InputMaybe<Scalars['Int']['input']>;
  sortOrder_lte: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not: InputMaybe<Scalars['Int']['input']>;
  sortOrder_not_in: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sys: InputMaybe<SysFilter>;
};

export type CfSummerSchoolFaqNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSummerSchoolFaqNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSummerSchoolFaqNestedFilter>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSummerSchoolPlaceholderNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSummerSchoolPlaceholderNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSummerSchoolPlaceholderNestedFilter>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  finePrint_contains: InputMaybe<Scalars['String']['input']>;
  finePrint_exists: InputMaybe<Scalars['Boolean']['input']>;
  finePrint_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName: InputMaybe<Scalars['String']['input']>;
  internalName_contains: InputMaybe<Scalars['String']['input']>;
  internalName_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalName_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalName_not: InputMaybe<Scalars['String']['input']>;
  internalName_not_contains: InputMaybe<Scalars['String']['input']>;
  internalName_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSummerSchoolResourceGroupNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSummerSchoolResourceGroupNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSummerSchoolResourceGroupNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  resourceListsCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSummerSchoolResourceListNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSummerSchoolResourceListNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSummerSchoolResourceListNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  resourcesCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSummerSchoolResourceNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSummerSchoolResourceNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSummerSchoolResourceNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  pdf_exists: InputMaybe<Scalars['Boolean']['input']>;
  richTextTitle_contains: InputMaybe<Scalars['String']['input']>;
  richTextTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  richTextTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSummerSchoolSectionNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSummerSchoolSectionNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSummerSchoolSectionNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  internalTitle: InputMaybe<Scalars['String']['input']>;
  internalTitle_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_exists: InputMaybe<Scalars['Boolean']['input']>;
  internalTitle_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  internalTitle_not: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_contains: InputMaybe<Scalars['String']['input']>;
  internalTitle_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  introduction_contains: InputMaybe<Scalars['String']['input']>;
  introduction_exists: InputMaybe<Scalars['Boolean']['input']>;
  introduction_not_contains: InputMaybe<Scalars['String']['input']>;
  list_exists: InputMaybe<Scalars['Boolean']['input']>;
  postscript_contains: InputMaybe<Scalars['String']['input']>;
  postscript_exists: InputMaybe<Scalars['Boolean']['input']>;
  postscript_not_contains: InputMaybe<Scalars['String']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfSummerSchoolWebinarNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfSummerSchoolWebinarNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfSummerSchoolWebinarNestedFilter>>>;
  body_contains: InputMaybe<Scalars['String']['input']>;
  body_exists: InputMaybe<Scalars['Boolean']['input']>;
  body_not_contains: InputMaybe<Scalars['String']['input']>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  heading_contains: InputMaybe<Scalars['String']['input']>;
  heading_exists: InputMaybe<Scalars['Boolean']['input']>;
  heading_not_contains: InputMaybe<Scalars['String']['input']>;
  image_exists: InputMaybe<Scalars['Boolean']['input']>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url: InputMaybe<Scalars['String']['input']>;
  url_contains: InputMaybe<Scalars['String']['input']>;
  url_exists: InputMaybe<Scalars['Boolean']['input']>;
  url_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  url_not: InputMaybe<Scalars['String']['input']>;
  url_not_contains: InputMaybe<Scalars['String']['input']>;
  url_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfTeacherTestimonialBlockNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfTeacherTestimonialBlockNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfTeacherTestimonialBlockNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  testimonialsListCollection_exists: InputMaybe<Scalars['Boolean']['input']>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CfWritingLegendsFreeTrialBlockNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfWritingLegendsFreeTrialBlockNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfWritingLegendsFreeTrialBlockNestedFilter>>>;
  callToActionText: InputMaybe<Scalars['String']['input']>;
  callToActionText_contains: InputMaybe<Scalars['String']['input']>;
  callToActionText_exists: InputMaybe<Scalars['Boolean']['input']>;
  callToActionText_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  callToActionText_not: InputMaybe<Scalars['String']['input']>;
  callToActionText_not_contains: InputMaybe<Scalars['String']['input']>;
  callToActionText_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactEmail: InputMaybe<Scalars['String']['input']>;
  contactEmail_contains: InputMaybe<Scalars['String']['input']>;
  contactEmail_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactEmail_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactEmail_not: InputMaybe<Scalars['String']['input']>;
  contactEmail_not_contains: InputMaybe<Scalars['String']['input']>;
  contactEmail_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber: InputMaybe<Scalars['String']['input']>;
  contactNumber_contains: InputMaybe<Scalars['String']['input']>;
  contactNumber_exists: InputMaybe<Scalars['Boolean']['input']>;
  contactNumber_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contactNumber_not: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_contains: InputMaybe<Scalars['String']['input']>;
  contactNumber_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
  title: InputMaybe<Scalars['String']['input']>;
  title_contains: InputMaybe<Scalars['String']['input']>;
  title_exists: InputMaybe<Scalars['Boolean']['input']>;
  title_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title_not: InputMaybe<Scalars['String']['input']>;
  title_not_contains: InputMaybe<Scalars['String']['input']>;
  title_not_in: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  writingLegendsIntroVideo_exists: InputMaybe<Scalars['Boolean']['input']>;
};

export type CfbrandLogosMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfbrandLogosMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfbrandLogosMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type CfcarouselCardsMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfcarouselCardsMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfcarouselCardsMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type CfexternalLogosMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfexternalLogosMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfexternalLogosMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type CfmobilePageDividerAssetMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfmobilePageDividerAssetMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfmobilePageDividerAssetMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type CfpageDividerImageAssetMultiTypeNestedFilter = {
  AND: InputMaybe<Array<InputMaybe<CfpageDividerImageAssetMultiTypeNestedFilter>>>;
  OR: InputMaybe<Array<InputMaybe<CfpageDividerImageAssetMultiTypeNestedFilter>>>;
  contentfulMetadata: InputMaybe<ContentfulMetadataFilter>;
  sys: InputMaybe<SysFilter>;
};

export type FooterBlock_FragmentFragment = { __typename?: 'ComposeComponentWlFooterBlock', about3PLearning: string | null, aboutUs: string | null, collaborateWithUs: string | null, contactUs: string | null, dataBreachResponsePlan: string | null, facebook: string | null, instagram: string | null, linkedIn: string | null, pinterest: string | null, privacyPolicy: string | null, refundPolicy: string | null, responsibleDisclosureProgram: string | null, termsOfUse: string | null, tikTok: string | null, twitter: string | null, youtube: string | null, blakeELearningLogo: { __typename?: 'Asset', url: string | null } | null, pLearningLogo: { __typename?: 'Asset', url: string | null } | null } & { ' $fragmentName'?: 'FooterBlock_FragmentFragment' };

export type WritingLegendsFooterBlockQueryVariables = Exact<{
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type WritingLegendsFooterBlockQuery = { __typename?: 'Query', composeComponentWlFooterBlock: (
    { __typename?: 'ComposeComponentWlFooterBlock' }
    & { ' $fragmentRefs'?: { 'FooterBlock_FragmentFragment': FooterBlock_FragmentFragment } }
  ) | null };

export type ProductOwnersBlock_FragmentFragment = { __typename: 'ComposeComponentImageAndAdjacentText', imageAlignment: string | null, sys: { __typename?: 'Sys', id: string }, image: { __typename?: 'Asset', url: string | null, title: string | null } | null, text: { __typename?: 'ComposeComponentImageAndAdjacentTextText', json: any } | null } & { ' $fragmentName'?: 'ProductOwnersBlock_FragmentFragment' };

export type StudentOutcomesBlock_FragmentFragment = { __typename: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlock', json: any, links: { __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockLinks', entries: { __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlockEntries', block: Array<{ __typename?: 'ActivitySheetAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ActivitySheetAssetGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ActivitySheetSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BigSchoolResourceList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentArticleBody', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentBlockQuote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentDownloadableAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentFeaturedArticle', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalHorizontalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalVerticalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentHorizontalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentImage', sys: { __typename?: 'Sys', id: string } } | (
        { __typename?: 'ComposeComponentImageAndAdjacentText', sys: { __typename?: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ComposeComponentImageAndAdjacentText_FragmentFragment': ComposeComponentImageAndAdjacentText_FragmentFragment } }
      ) | { __typename?: 'ComposeComponentImageAndAdjacentTextList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentMissionStatement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentPopularArticles', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextColouredBackground', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBanner', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBannerItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTeacherSupportStatement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTextList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopic', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicBackground', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentUrl', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentVerticalImageCta', sys: { __typename?: 'Sys', id: string } } | (
        { __typename?: 'ComposeComponentVideoAndAdjacentText', sys: { __typename?: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ComposeComponentVideoAndAdjacentText_FragmentFragment': ComposeComponentVideoAndAdjacentText_FragmentFragment } }
      ) | { __typename?: 'ComposeComponentWlFooterBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlProductAimBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlTestimonialsBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentYoutubeVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageArticle', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageArticlesIndexPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageWlMarketingHomePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'GetReadyForBigSchoolList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxGuides', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusGuides', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolProgram', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JumpLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiButton', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiCallToActionBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiCarousel', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiColumnLayout', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLinkGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiHeroCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiImageWithLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiPageDivider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiProgramCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiSocialMediaLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiTestimonialCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiVideoBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LessonOverview', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MarketingBlogGlobalRegionalEdits', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MarketingBlogRegionalEdit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PCampaign', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PCampaignB2B', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PContentPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PFreeResource', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PJson', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PLinkedEntry', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ParentUiRichTextHyperlink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ParentUserGuide', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PlacementTestOverview', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PuiDashboardRedesignIntroVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'RewardMap', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'RolePermissions', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SampleLesson', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAssetGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaq', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaqList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolPlaceholder', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResource', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroupList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinarList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeacherTestimonialBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsFreeTrialBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAboutUsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAccessibilityPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPageV2', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteFaQsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteIndexPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTechReqPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTermsOfUsePage', sys: { __typename?: 'Sys', id: string } } | null> } } } & { ' $fragmentName'?: 'StudentOutcomesBlock_FragmentFragment' };

export type ProductSummaryBlock_FragmentFragment = { __typename: 'WritingLegendsMarketingSiteIndexPageSummaryBlock', json: any, links: { __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlockLinks', entries: { __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlockEntries', block: Array<{ __typename?: 'ActivitySheetAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ActivitySheetAssetGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ActivitySheetSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BigSchoolResourceList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentArticleBody', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentBlockQuote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentDownloadableAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentFeaturedArticle', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalHorizontalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalVerticalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentHorizontalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentImage', sys: { __typename?: 'Sys', id: string } } | (
        { __typename?: 'ComposeComponentImageAndAdjacentText', sys: { __typename?: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ComposeComponentImageAndAdjacentText_FragmentFragment': ComposeComponentImageAndAdjacentText_FragmentFragment } }
      ) | { __typename?: 'ComposeComponentImageAndAdjacentTextList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentMissionStatement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentPopularArticles', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextColouredBackground', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBanner', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBannerItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTeacherSupportStatement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTextList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopic', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicBackground', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentUrl', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentVerticalImageCta', sys: { __typename?: 'Sys', id: string } } | (
        { __typename?: 'ComposeComponentVideoAndAdjacentText', sys: { __typename?: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ComposeComponentVideoAndAdjacentText_FragmentFragment': ComposeComponentVideoAndAdjacentText_FragmentFragment } }
      ) | { __typename?: 'ComposeComponentWlFooterBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlProductAimBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlTestimonialsBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentYoutubeVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageArticle', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageArticlesIndexPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageWlMarketingHomePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'GetReadyForBigSchoolList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxGuides', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusGuides', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolProgram', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JumpLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiButton', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiCallToActionBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiCarousel', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiColumnLayout', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLinkGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiHeroCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiImageWithLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiPageDivider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiProgramCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiSocialMediaLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiTestimonialCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiVideoBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LessonOverview', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MarketingBlogGlobalRegionalEdits', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MarketingBlogRegionalEdit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PCampaign', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PCampaignB2B', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PContentPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PFreeResource', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PJson', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PLinkedEntry', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ParentUiRichTextHyperlink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ParentUserGuide', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PlacementTestOverview', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PuiDashboardRedesignIntroVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'RewardMap', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'RolePermissions', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SampleLesson', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAssetGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaq', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaqList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolPlaceholder', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResource', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroupList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinarList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeacherTestimonialBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsFreeTrialBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAboutUsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAccessibilityPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPageV2', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteFaQsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteIndexPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTechReqPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTermsOfUsePage', sys: { __typename?: 'Sys', id: string } } | null> } } } & { ' $fragmentName'?: 'ProductSummaryBlock_FragmentFragment' };

export type TeacherSupportStatementBlock_FragmentFragment = { __typename: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlock', json: any, links: { __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlockLinks', entries: { __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlockEntries', block: Array<{ __typename?: 'ActivitySheetAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ActivitySheetAssetGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ActivitySheetSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BigSchoolResourceList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentArticleBody', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentBlockQuote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentDownloadableAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentFeaturedArticle', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalHorizontalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalVerticalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentHorizontalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentImage', sys: { __typename?: 'Sys', id: string } } | (
        { __typename?: 'ComposeComponentImageAndAdjacentText', sys: { __typename?: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ComposeComponentImageAndAdjacentText_FragmentFragment': ComposeComponentImageAndAdjacentText_FragmentFragment } }
      ) | { __typename?: 'ComposeComponentImageAndAdjacentTextList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentMissionStatement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentPopularArticles', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextColouredBackground', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBanner', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBannerItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTeacherSupportStatement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTextList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopic', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicBackground', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentUrl', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentVerticalImageCta', sys: { __typename?: 'Sys', id: string } } | (
        { __typename?: 'ComposeComponentVideoAndAdjacentText', sys: { __typename?: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ComposeComponentVideoAndAdjacentText_FragmentFragment': ComposeComponentVideoAndAdjacentText_FragmentFragment } }
      ) | { __typename?: 'ComposeComponentWlFooterBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlProductAimBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlTestimonialsBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentYoutubeVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageArticle', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageArticlesIndexPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageWlMarketingHomePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'GetReadyForBigSchoolList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxGuides', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusGuides', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolProgram', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JumpLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiButton', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiCallToActionBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiCarousel', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiColumnLayout', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLinkGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiHeroCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiImageWithLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiPageDivider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiProgramCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiSocialMediaLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiTestimonialCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiVideoBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LessonOverview', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MarketingBlogGlobalRegionalEdits', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MarketingBlogRegionalEdit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PCampaign', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PCampaignB2B', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PContentPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PFreeResource', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PJson', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PLinkedEntry', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ParentUiRichTextHyperlink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ParentUserGuide', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PlacementTestOverview', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PuiDashboardRedesignIntroVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'RewardMap', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'RolePermissions', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SampleLesson', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAssetGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaq', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaqList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolPlaceholder', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResource', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroupList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinarList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeacherTestimonialBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsFreeTrialBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAboutUsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAccessibilityPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPageV2', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteFaQsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteIndexPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTechReqPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTermsOfUsePage', sys: { __typename?: 'Sys', id: string } } | null> } } } & { ' $fragmentName'?: 'TeacherSupportStatementBlock_FragmentFragment' };

export type VideoBlock_FragmentFragment = { __typename: 'WritingLegendsMarketingSiteIndexPageVideoBlock', json: any, links: { __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlockLinks', entries: { __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlockEntries', block: Array<{ __typename?: 'ActivitySheetAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ActivitySheetAssetGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ActivitySheetSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'BigSchoolResourceList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentArticleBody', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentBlockQuote', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentDownloadableAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentFeaturedArticle', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalHorizontalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalVerticalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentHorizontalImageCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentImage', sys: { __typename?: 'Sys', id: string } } | (
        { __typename?: 'ComposeComponentImageAndAdjacentText', sys: { __typename?: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ComposeComponentImageAndAdjacentText_FragmentFragment': ComposeComponentImageAndAdjacentText_FragmentFragment } }
      ) | { __typename?: 'ComposeComponentImageAndAdjacentTextList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentMissionStatement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentPopularArticles', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextColouredBackground', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextCta', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBanner', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBannerItem', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTeacherSupportStatement', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentText', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTextList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopic', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicBackground', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentUrl', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentVerticalImageCta', sys: { __typename?: 'Sys', id: string } } | (
        { __typename?: 'ComposeComponentVideoAndAdjacentText', sys: { __typename?: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ComposeComponentVideoAndAdjacentText_FragmentFragment': ComposeComponentVideoAndAdjacentText_FragmentFragment } }
      ) | { __typename?: 'ComposeComponentWlFooterBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlProductAimBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlTestimonialsBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposeComponentYoutubeVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageArticle', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageArticlesIndexPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ComposePageWlMarketingHomePage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'GetReadyForBigSchoolList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxGuides', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusGuides', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'HomeschoolProgram', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'JumpLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiButton', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiCallToActionBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiCarousel', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiColumn', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiColumnLayout', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooter', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLinkGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiHeroCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiImageWithLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiPageDivider', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiProgramCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiSocialMediaLink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiTestimonialCard', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LegoUiVideoBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'LessonOverview', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Link', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MarketingBlogGlobalRegionalEdits', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'MarketingBlogRegionalEdit', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PCampaign', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PCampaignB2B', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PContentPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PFreeResource', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PJson', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PLinkedEntry', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ParentUiRichTextHyperlink', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'ParentUserGuide', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PlacementTestOverview', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'PuiDashboardRedesignIntroVideo', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'RewardMap', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'RolePermissions', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SampleLesson', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAsset', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAssetGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaq', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaqList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolPlaceholder', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResource', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroup', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroupList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolSection', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinar', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinarList', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'TeacherTestimonialBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsFreeTrialBlock', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAboutUsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAccessibilityPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPageV2', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteFaQsPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteIndexPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTechReqPage', sys: { __typename?: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTermsOfUsePage', sys: { __typename?: 'Sys', id: string } } | null> } } } & { ' $fragmentName'?: 'VideoBlock_FragmentFragment' };

export type ComposeComponentVideoAndAdjacentText_FragmentFragment = { __typename: 'ComposeComponentVideoAndAdjacentText', videoAlignment: string | null, sys: { __typename?: 'Sys', id: string }, video: { __typename?: 'Asset', url: string | null, title: string | null, description: string | null } | null, description: { __typename?: 'ComposeComponentVideoAndAdjacentTextDescription', json: any, links: { __typename?: 'ComposeComponentVideoAndAdjacentTextDescriptionLinks', assets: { __typename?: 'ComposeComponentVideoAndAdjacentTextDescriptionAssets', block: Array<{ __typename?: 'Asset', title: string | null, description: string | null, url: string | null, width: number | null, height: number | null, sys: { __typename?: 'Sys', id: string } } | null> } } } | null } & { ' $fragmentName'?: 'ComposeComponentVideoAndAdjacentText_FragmentFragment' };

export type ComposeComponentText_FragmentFragment = { __typename: 'ComposeComponentText', title: string | null, sys: { __typename?: 'Sys', id: string }, text: { __typename?: 'ComposeComponentTextText', json: any } | null } & { ' $fragmentName'?: 'ComposeComponentText_FragmentFragment' };

export type ComposeComponentImageAndAdjacentText_FragmentFragment = { __typename: 'ComposeComponentImageAndAdjacentText', imageAlignment: string | null, sys: { __typename?: 'Sys', id: string }, image: { __typename?: 'Asset', url: string | null, title: string | null, description: string | null } | null, text: { __typename?: 'ComposeComponentImageAndAdjacentTextText', json: any } | null } & { ' $fragmentName'?: 'ComposeComponentImageAndAdjacentText_FragmentFragment' };

export type ComposeComponentTextList_FragmentFragment = { __typename: 'ComposeComponentTextList', sys: { __typename?: 'Sys', id: string }, textItemsCollection: { __typename: 'ComposeComponentTextListTextItemsCollection', items: Array<(
      { __typename: 'ComposeComponentText', sys: { __typename?: 'Sys', id: string } }
      & { ' $fragmentRefs'?: { 'ComposeComponentText_FragmentFragment': ComposeComponentText_FragmentFragment } }
    ) | null> } | null } & { ' $fragmentName'?: 'ComposeComponentTextList_FragmentFragment' };

export type ComposeComponentImage_FragmentFragment = { __typename?: 'ComposeComponentImage', altText: string | null, imageAsset: { __typename?: 'Asset', url: string | null, width: number | null, height: number | null } | null } & { ' $fragmentName'?: 'ComposeComponentImage_FragmentFragment' };

type RichTextBlockEntry_Fragment_ActivitySheetAsset_Fragment = { __typename: 'ActivitySheetAsset', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ActivitySheetAsset_Fragment' };

type RichTextBlockEntry_Fragment_ActivitySheetAssetGroup_Fragment = { __typename: 'ActivitySheetAssetGroup', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ActivitySheetAssetGroup_Fragment' };

type RichTextBlockEntry_Fragment_ActivitySheetSection_Fragment = { __typename: 'ActivitySheetSection', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ActivitySheetSection_Fragment' };

type RichTextBlockEntry_Fragment_BigSchoolResourceList_Fragment = { __typename: 'BigSchoolResourceList', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_BigSchoolResourceList_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentArticleBody_Fragment = { __typename: 'ComposeComponentArticleBody', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentArticleBody_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentBlockQuote_Fragment = { __typename: 'ComposeComponentBlockQuote', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentBlockQuote_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentDownloadableAsset_Fragment = { __typename: 'ComposeComponentDownloadableAsset', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentDownloadableAsset_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentFeaturedArticle_Fragment = { __typename: 'ComposeComponentFeaturedArticle', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentFeaturedArticle_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentGlobalHorizontalImageCta_Fragment = { __typename: 'ComposeComponentGlobalHorizontalImageCta', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentGlobalHorizontalImageCta_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentGlobalVerticalImageCta_Fragment = { __typename: 'ComposeComponentGlobalVerticalImageCta', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentGlobalVerticalImageCta_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentHorizontalImageCta_Fragment = { __typename: 'ComposeComponentHorizontalImageCta', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentHorizontalImageCta_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentImage_Fragment = { __typename: 'ComposeComponentImage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentImage_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentImageAndAdjacentText_Fragment = (
  { __typename: 'ComposeComponentImageAndAdjacentText', sys: { __typename?: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'ComposeComponentImageAndAdjacentText_FragmentFragment': ComposeComponentImageAndAdjacentText_FragmentFragment } }
) & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentImageAndAdjacentText_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentImageAndAdjacentTextList_Fragment = { __typename: 'ComposeComponentImageAndAdjacentTextList', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentImageAndAdjacentTextList_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentLink_Fragment = { __typename: 'ComposeComponentLink', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentLink_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentMissionStatement_Fragment = { __typename: 'ComposeComponentMissionStatement', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentMissionStatement_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentPopularArticles_Fragment = { __typename: 'ComposeComponentPopularArticles', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentPopularArticles_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentRichTextColouredBackground_Fragment = { __typename: 'ComposeComponentRichTextColouredBackground', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentRichTextColouredBackground_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentRichTextCta_Fragment = { __typename: 'ComposeComponentRichTextCta', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentRichTextCta_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentStickyBanner_Fragment = { __typename: 'ComposeComponentStickyBanner', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentStickyBanner_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentStickyBannerItem_Fragment = { __typename: 'ComposeComponentStickyBannerItem', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentStickyBannerItem_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentTeacherSupportStatement_Fragment = { __typename: 'ComposeComponentTeacherSupportStatement', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentTeacherSupportStatement_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentText_Fragment = (
  { __typename: 'ComposeComponentText', sys: { __typename?: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'ComposeComponentText_FragmentFragment': ComposeComponentText_FragmentFragment } }
) & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentText_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentTextList_Fragment = (
  { __typename: 'ComposeComponentTextList', sys: { __typename?: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'ComposeComponentTextList_FragmentFragment': ComposeComponentTextList_FragmentFragment } }
) & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentTextList_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentTopic_Fragment = { __typename: 'ComposeComponentTopic', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentTopic_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentTopicBackground_Fragment = { __typename: 'ComposeComponentTopicBackground', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentTopicBackground_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentTopicList_Fragment = { __typename: 'ComposeComponentTopicList', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentTopicList_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentUrl_Fragment = { __typename: 'ComposeComponentUrl', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentUrl_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentVerticalImageCta_Fragment = { __typename: 'ComposeComponentVerticalImageCta', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentVerticalImageCta_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentVideoAndAdjacentText_Fragment = (
  { __typename: 'ComposeComponentVideoAndAdjacentText', sys: { __typename?: 'Sys', id: string } }
  & { ' $fragmentRefs'?: { 'ComposeComponentVideoAndAdjacentText_FragmentFragment': ComposeComponentVideoAndAdjacentText_FragmentFragment } }
) & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentVideoAndAdjacentText_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentWlFooterBlock_Fragment = { __typename: 'ComposeComponentWlFooterBlock', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentWlFooterBlock_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentWlProductAimBlock_Fragment = { __typename: 'ComposeComponentWlProductAimBlock', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentWlProductAimBlock_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentWlTestimonialsBlock_Fragment = { __typename: 'ComposeComponentWlTestimonialsBlock', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentWlTestimonialsBlock_Fragment' };

type RichTextBlockEntry_Fragment_ComposeComponentYoutubeVideo_Fragment = { __typename: 'ComposeComponentYoutubeVideo', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposeComponentYoutubeVideo_Fragment' };

type RichTextBlockEntry_Fragment_ComposePageArticle_Fragment = { __typename: 'ComposePageArticle', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposePageArticle_Fragment' };

type RichTextBlockEntry_Fragment_ComposePageArticlesIndexPage_Fragment = { __typename: 'ComposePageArticlesIndexPage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposePageArticlesIndexPage_Fragment' };

type RichTextBlockEntry_Fragment_ComposePageWlMarketingHomePage_Fragment = { __typename: 'ComposePageWlMarketingHomePage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ComposePageWlMarketingHomePage_Fragment' };

type RichTextBlockEntry_Fragment_GetReadyForBigSchoolList_Fragment = { __typename: 'GetReadyForBigSchoolList', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_GetReadyForBigSchoolList_Fragment' };

type RichTextBlockEntry_Fragment_HomeschoolMaxGuides_Fragment = { __typename: 'HomeschoolMaxGuides', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_HomeschoolMaxGuides_Fragment' };

type RichTextBlockEntry_Fragment_HomeschoolMaxWebinar_Fragment = { __typename: 'HomeschoolMaxWebinar', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_HomeschoolMaxWebinar_Fragment' };

type RichTextBlockEntry_Fragment_HomeschoolPlusGuides_Fragment = { __typename: 'HomeschoolPlusGuides', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_HomeschoolPlusGuides_Fragment' };

type RichTextBlockEntry_Fragment_HomeschoolPlusWebinar_Fragment = { __typename: 'HomeschoolPlusWebinar', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_HomeschoolPlusWebinar_Fragment' };

type RichTextBlockEntry_Fragment_HomeschoolProgram_Fragment = { __typename: 'HomeschoolProgram', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_HomeschoolProgram_Fragment' };

type RichTextBlockEntry_Fragment_JumpLink_Fragment = { __typename: 'JumpLink', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_JumpLink_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiButton_Fragment = { __typename: 'LegoUiButton', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiButton_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiCallToActionBlock_Fragment = { __typename: 'LegoUiCallToActionBlock', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiCallToActionBlock_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiCarousel_Fragment = { __typename: 'LegoUiCarousel', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiCarousel_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiColumn_Fragment = { __typename: 'LegoUiColumn', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiColumn_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiColumnLayout_Fragment = { __typename: 'LegoUiColumnLayout', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiColumnLayout_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiFooter_Fragment = { __typename: 'LegoUiFooter', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiFooter_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiFooterLink_Fragment = { __typename: 'LegoUiFooterLink', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiFooterLink_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiFooterLinkGroup_Fragment = { __typename: 'LegoUiFooterLinkGroup', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiFooterLinkGroup_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiHeroCard_Fragment = { __typename: 'LegoUiHeroCard', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiHeroCard_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiImageWithLink_Fragment = { __typename: 'LegoUiImageWithLink', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiImageWithLink_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiPageDivider_Fragment = { __typename: 'LegoUiPageDivider', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiPageDivider_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiProgramCard_Fragment = { __typename: 'LegoUiProgramCard', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiProgramCard_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiSocialMediaLink_Fragment = { __typename: 'LegoUiSocialMediaLink', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiSocialMediaLink_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiTestimonialCard_Fragment = { __typename: 'LegoUiTestimonialCard', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiTestimonialCard_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiVideo_Fragment = { __typename: 'LegoUiVideo', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiVideo_Fragment' };

type RichTextBlockEntry_Fragment_LegoUiVideoBlock_Fragment = { __typename: 'LegoUiVideoBlock', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LegoUiVideoBlock_Fragment' };

type RichTextBlockEntry_Fragment_LessonOverview_Fragment = { __typename: 'LessonOverview', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_LessonOverview_Fragment' };

type RichTextBlockEntry_Fragment_Link_Fragment = { __typename: 'Link', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_Link_Fragment' };

type RichTextBlockEntry_Fragment_MarketingBlogGlobalRegionalEdits_Fragment = { __typename: 'MarketingBlogGlobalRegionalEdits', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_MarketingBlogGlobalRegionalEdits_Fragment' };

type RichTextBlockEntry_Fragment_MarketingBlogRegionalEdit_Fragment = { __typename: 'MarketingBlogRegionalEdit', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_MarketingBlogRegionalEdit_Fragment' };

type RichTextBlockEntry_Fragment_PCampaign_Fragment = { __typename: 'PCampaign', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_PCampaign_Fragment' };

type RichTextBlockEntry_Fragment_PCampaignB2B_Fragment = { __typename: 'PCampaignB2B', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_PCampaignB2B_Fragment' };

type RichTextBlockEntry_Fragment_PContentPage_Fragment = { __typename: 'PContentPage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_PContentPage_Fragment' };

type RichTextBlockEntry_Fragment_PFreeResource_Fragment = { __typename: 'PFreeResource', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_PFreeResource_Fragment' };

type RichTextBlockEntry_Fragment_PJson_Fragment = { __typename: 'PJson', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_PJson_Fragment' };

type RichTextBlockEntry_Fragment_PLinkedEntry_Fragment = { __typename: 'PLinkedEntry', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_PLinkedEntry_Fragment' };

type RichTextBlockEntry_Fragment_ParentUiRichTextHyperlink_Fragment = { __typename: 'ParentUiRichTextHyperlink', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ParentUiRichTextHyperlink_Fragment' };

type RichTextBlockEntry_Fragment_ParentUserGuide_Fragment = { __typename: 'ParentUserGuide', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_ParentUserGuide_Fragment' };

type RichTextBlockEntry_Fragment_PlacementTestOverview_Fragment = { __typename: 'PlacementTestOverview', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_PlacementTestOverview_Fragment' };

type RichTextBlockEntry_Fragment_Product_Fragment = { __typename: 'Product', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_Product_Fragment' };

type RichTextBlockEntry_Fragment_PuiDashboardRedesignIntroVideo_Fragment = { __typename: 'PuiDashboardRedesignIntroVideo', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_PuiDashboardRedesignIntroVideo_Fragment' };

type RichTextBlockEntry_Fragment_RewardMap_Fragment = { __typename: 'RewardMap', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_RewardMap_Fragment' };

type RichTextBlockEntry_Fragment_RolePermissions_Fragment = { __typename: 'RolePermissions', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_RolePermissions_Fragment' };

type RichTextBlockEntry_Fragment_SampleLesson_Fragment = { __typename: 'SampleLesson', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SampleLesson_Fragment' };

type RichTextBlockEntry_Fragment_SpanishActivitySheetAsset_Fragment = { __typename: 'SpanishActivitySheetAsset', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SpanishActivitySheetAsset_Fragment' };

type RichTextBlockEntry_Fragment_SpanishActivitySheetAssetGroup_Fragment = { __typename: 'SpanishActivitySheetAssetGroup', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SpanishActivitySheetAssetGroup_Fragment' };

type RichTextBlockEntry_Fragment_SpanishActivitySheetSection_Fragment = { __typename: 'SpanishActivitySheetSection', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SpanishActivitySheetSection_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolFaq_Fragment = { __typename: 'SummerSchoolFaq', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolFaq_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolFaqList_Fragment = { __typename: 'SummerSchoolFaqList', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolFaqList_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolPage_Fragment = { __typename: 'SummerSchoolPage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolPage_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolPlaceholder_Fragment = { __typename: 'SummerSchoolPlaceholder', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolPlaceholder_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolResource_Fragment = { __typename: 'SummerSchoolResource', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolResource_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolResourceGroup_Fragment = { __typename: 'SummerSchoolResourceGroup', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolResourceGroup_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolResourceGroupList_Fragment = { __typename: 'SummerSchoolResourceGroupList', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolResourceGroupList_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolResourceList_Fragment = { __typename: 'SummerSchoolResourceList', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolResourceList_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolSection_Fragment = { __typename: 'SummerSchoolSection', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolSection_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolWebinar_Fragment = { __typename: 'SummerSchoolWebinar', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolWebinar_Fragment' };

type RichTextBlockEntry_Fragment_SummerSchoolWebinarList_Fragment = { __typename: 'SummerSchoolWebinarList', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_SummerSchoolWebinarList_Fragment' };

type RichTextBlockEntry_Fragment_TeacherTestimonialBlock_Fragment = { __typename: 'TeacherTestimonialBlock', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_TeacherTestimonialBlock_Fragment' };

type RichTextBlockEntry_Fragment_WritingLegendsFreeTrialBlock_Fragment = { __typename: 'WritingLegendsFreeTrialBlock', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_WritingLegendsFreeTrialBlock_Fragment' };

type RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteAboutUsPage_Fragment = { __typename: 'WritingLegendsMarketingSiteAboutUsPage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteAboutUsPage_Fragment' };

type RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteAccessibilityPage_Fragment = { __typename: 'WritingLegendsMarketingSiteAccessibilityPage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteAccessibilityPage_Fragment' };

type RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteContactUsPage_Fragment = { __typename: 'WritingLegendsMarketingSiteContactUsPage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteContactUsPage_Fragment' };

type RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteContactUsPageV2_Fragment = { __typename: 'WritingLegendsMarketingSiteContactUsPageV2', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteContactUsPageV2_Fragment' };

type RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteFaQsPage_Fragment = { __typename: 'WritingLegendsMarketingSiteFaQsPage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteFaQsPage_Fragment' };

type RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteIndexPage_Fragment = { __typename: 'WritingLegendsMarketingSiteIndexPage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteIndexPage_Fragment' };

type RichTextBlockEntry_Fragment_WritingLegendsMarketingSitePrivacyPolicyPage_Fragment = { __typename: 'WritingLegendsMarketingSitePrivacyPolicyPage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_WritingLegendsMarketingSitePrivacyPolicyPage_Fragment' };

type RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteTechReqPage_Fragment = { __typename: 'WritingLegendsMarketingSiteTechReqPage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteTechReqPage_Fragment' };

type RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteTermsOfUsePage_Fragment = { __typename: 'WritingLegendsMarketingSiteTermsOfUsePage', sys: { __typename?: 'Sys', id: string } } & { ' $fragmentName'?: 'RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteTermsOfUsePage_Fragment' };

export type RichTextBlockEntry_FragmentFragment = RichTextBlockEntry_Fragment_ActivitySheetAsset_Fragment | RichTextBlockEntry_Fragment_ActivitySheetAssetGroup_Fragment | RichTextBlockEntry_Fragment_ActivitySheetSection_Fragment | RichTextBlockEntry_Fragment_BigSchoolResourceList_Fragment | RichTextBlockEntry_Fragment_ComposeComponentArticleBody_Fragment | RichTextBlockEntry_Fragment_ComposeComponentBlockQuote_Fragment | RichTextBlockEntry_Fragment_ComposeComponentDownloadableAsset_Fragment | RichTextBlockEntry_Fragment_ComposeComponentFeaturedArticle_Fragment | RichTextBlockEntry_Fragment_ComposeComponentGlobalHorizontalImageCta_Fragment | RichTextBlockEntry_Fragment_ComposeComponentGlobalVerticalImageCta_Fragment | RichTextBlockEntry_Fragment_ComposeComponentHorizontalImageCta_Fragment | RichTextBlockEntry_Fragment_ComposeComponentImage_Fragment | RichTextBlockEntry_Fragment_ComposeComponentImageAndAdjacentText_Fragment | RichTextBlockEntry_Fragment_ComposeComponentImageAndAdjacentTextList_Fragment | RichTextBlockEntry_Fragment_ComposeComponentLink_Fragment | RichTextBlockEntry_Fragment_ComposeComponentMissionStatement_Fragment | RichTextBlockEntry_Fragment_ComposeComponentPopularArticles_Fragment | RichTextBlockEntry_Fragment_ComposeComponentRichTextColouredBackground_Fragment | RichTextBlockEntry_Fragment_ComposeComponentRichTextCta_Fragment | RichTextBlockEntry_Fragment_ComposeComponentStickyBanner_Fragment | RichTextBlockEntry_Fragment_ComposeComponentStickyBannerItem_Fragment | RichTextBlockEntry_Fragment_ComposeComponentTeacherSupportStatement_Fragment | RichTextBlockEntry_Fragment_ComposeComponentText_Fragment | RichTextBlockEntry_Fragment_ComposeComponentTextList_Fragment | RichTextBlockEntry_Fragment_ComposeComponentTopic_Fragment | RichTextBlockEntry_Fragment_ComposeComponentTopicBackground_Fragment | RichTextBlockEntry_Fragment_ComposeComponentTopicList_Fragment | RichTextBlockEntry_Fragment_ComposeComponentUrl_Fragment | RichTextBlockEntry_Fragment_ComposeComponentVerticalImageCta_Fragment | RichTextBlockEntry_Fragment_ComposeComponentVideoAndAdjacentText_Fragment | RichTextBlockEntry_Fragment_ComposeComponentWlFooterBlock_Fragment | RichTextBlockEntry_Fragment_ComposeComponentWlProductAimBlock_Fragment | RichTextBlockEntry_Fragment_ComposeComponentWlTestimonialsBlock_Fragment | RichTextBlockEntry_Fragment_ComposeComponentYoutubeVideo_Fragment | RichTextBlockEntry_Fragment_ComposePageArticle_Fragment | RichTextBlockEntry_Fragment_ComposePageArticlesIndexPage_Fragment | RichTextBlockEntry_Fragment_ComposePageWlMarketingHomePage_Fragment | RichTextBlockEntry_Fragment_GetReadyForBigSchoolList_Fragment | RichTextBlockEntry_Fragment_HomeschoolMaxGuides_Fragment | RichTextBlockEntry_Fragment_HomeschoolMaxWebinar_Fragment | RichTextBlockEntry_Fragment_HomeschoolPlusGuides_Fragment | RichTextBlockEntry_Fragment_HomeschoolPlusWebinar_Fragment | RichTextBlockEntry_Fragment_HomeschoolProgram_Fragment | RichTextBlockEntry_Fragment_JumpLink_Fragment | RichTextBlockEntry_Fragment_LegoUiButton_Fragment | RichTextBlockEntry_Fragment_LegoUiCallToActionBlock_Fragment | RichTextBlockEntry_Fragment_LegoUiCarousel_Fragment | RichTextBlockEntry_Fragment_LegoUiColumn_Fragment | RichTextBlockEntry_Fragment_LegoUiColumnLayout_Fragment | RichTextBlockEntry_Fragment_LegoUiFooter_Fragment | RichTextBlockEntry_Fragment_LegoUiFooterLink_Fragment | RichTextBlockEntry_Fragment_LegoUiFooterLinkGroup_Fragment | RichTextBlockEntry_Fragment_LegoUiHeroCard_Fragment | RichTextBlockEntry_Fragment_LegoUiImageWithLink_Fragment | RichTextBlockEntry_Fragment_LegoUiPageDivider_Fragment | RichTextBlockEntry_Fragment_LegoUiProgramCard_Fragment | RichTextBlockEntry_Fragment_LegoUiSocialMediaLink_Fragment | RichTextBlockEntry_Fragment_LegoUiTestimonialCard_Fragment | RichTextBlockEntry_Fragment_LegoUiVideo_Fragment | RichTextBlockEntry_Fragment_LegoUiVideoBlock_Fragment | RichTextBlockEntry_Fragment_LessonOverview_Fragment | RichTextBlockEntry_Fragment_Link_Fragment | RichTextBlockEntry_Fragment_MarketingBlogGlobalRegionalEdits_Fragment | RichTextBlockEntry_Fragment_MarketingBlogRegionalEdit_Fragment | RichTextBlockEntry_Fragment_PCampaign_Fragment | RichTextBlockEntry_Fragment_PCampaignB2B_Fragment | RichTextBlockEntry_Fragment_PContentPage_Fragment | RichTextBlockEntry_Fragment_PFreeResource_Fragment | RichTextBlockEntry_Fragment_PJson_Fragment | RichTextBlockEntry_Fragment_PLinkedEntry_Fragment | RichTextBlockEntry_Fragment_ParentUiRichTextHyperlink_Fragment | RichTextBlockEntry_Fragment_ParentUserGuide_Fragment | RichTextBlockEntry_Fragment_PlacementTestOverview_Fragment | RichTextBlockEntry_Fragment_Product_Fragment | RichTextBlockEntry_Fragment_PuiDashboardRedesignIntroVideo_Fragment | RichTextBlockEntry_Fragment_RewardMap_Fragment | RichTextBlockEntry_Fragment_RolePermissions_Fragment | RichTextBlockEntry_Fragment_SampleLesson_Fragment | RichTextBlockEntry_Fragment_SpanishActivitySheetAsset_Fragment | RichTextBlockEntry_Fragment_SpanishActivitySheetAssetGroup_Fragment | RichTextBlockEntry_Fragment_SpanishActivitySheetSection_Fragment | RichTextBlockEntry_Fragment_SummerSchoolFaq_Fragment | RichTextBlockEntry_Fragment_SummerSchoolFaqList_Fragment | RichTextBlockEntry_Fragment_SummerSchoolPage_Fragment | RichTextBlockEntry_Fragment_SummerSchoolPlaceholder_Fragment | RichTextBlockEntry_Fragment_SummerSchoolResource_Fragment | RichTextBlockEntry_Fragment_SummerSchoolResourceGroup_Fragment | RichTextBlockEntry_Fragment_SummerSchoolResourceGroupList_Fragment | RichTextBlockEntry_Fragment_SummerSchoolResourceList_Fragment | RichTextBlockEntry_Fragment_SummerSchoolSection_Fragment | RichTextBlockEntry_Fragment_SummerSchoolWebinar_Fragment | RichTextBlockEntry_Fragment_SummerSchoolWebinarList_Fragment | RichTextBlockEntry_Fragment_TeacherTestimonialBlock_Fragment | RichTextBlockEntry_Fragment_WritingLegendsFreeTrialBlock_Fragment | RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteAboutUsPage_Fragment | RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteAccessibilityPage_Fragment | RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteContactUsPage_Fragment | RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteContactUsPageV2_Fragment | RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteFaQsPage_Fragment | RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteIndexPage_Fragment | RichTextBlockEntry_Fragment_WritingLegendsMarketingSitePrivacyPolicyPage_Fragment | RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteTechReqPage_Fragment | RichTextBlockEntry_Fragment_WritingLegendsMarketingSiteTermsOfUsePage_Fragment;

export type WritingLegendsMarketingSitePrivacyPolicyPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type WritingLegendsMarketingSitePrivacyPolicyPageQuery = { __typename?: 'Query', writingLegendsMarketingSitePrivacyPolicyPage: { __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPage', seoPageTitle: string | null, seoPageDescription: string | null, seoKeywords: Array<string | null> | null, sys: { __typename?: 'Sys', id: string }, privacyPolicyBody: { __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPagePrivacyPolicyBody', json: any } | null } | null };

export type WritingLegendsMarketingSiteTermsOfUsePageQueryVariables = Exact<{
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type WritingLegendsMarketingSiteTermsOfUsePageQuery = { __typename?: 'Query', writingLegendsMarketingSiteTermsOfUsePage: { __typename?: 'WritingLegendsMarketingSiteTermsOfUsePage', seoPageTitle: string | null, seoPageDescription: string | null, seoKeywords: Array<string | null> | null, sys: { __typename?: 'Sys', id: string }, termsOfUse: { __typename?: 'WritingLegendsMarketingSiteTermsOfUsePageTermsOfUse', json: any } | null } | null };

export type WritingLegendsMarketingSiteAboutUsPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type WritingLegendsMarketingSiteAboutUsPageQuery = { __typename?: 'Query', writingLegendsMarketingSiteAboutUsPage: { __typename?: 'WritingLegendsMarketingSiteAboutUsPage', seoPageTitle: string | null, seoPageDescription: string | null, seoKeywords: Array<string | null> | null, sys: { __typename?: 'Sys', id: string }, aboutUsText: { __typename?: 'WritingLegendsMarketingSiteAboutUsPageAboutUsText', json: any } | null } | null };

export type WritingLegendsMarketingSiteAccessibilityPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type WritingLegendsMarketingSiteAccessibilityPageQuery = { __typename?: 'Query', writingLegendsMarketingSiteAccessibilityPage: { __typename?: 'WritingLegendsMarketingSiteAccessibilityPage', seoPageTitle: string | null, seoPageDescription: string | null, seoKeywords: Array<string | null> | null, sys: { __typename?: 'Sys', id: string }, accessibilityText: { __typename?: 'WritingLegendsMarketingSiteAccessibilityPageAccessibilityText', json: any } | null } | null };

export type WritingLegendsMarketingSiteContactUsPageV2QueryVariables = Exact<{
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type WritingLegendsMarketingSiteContactUsPageV2Query = { __typename?: 'Query', writingLegendsMarketingSiteContactUsPageV2: { __typename?: 'WritingLegendsMarketingSiteContactUsPageV2', seoPageTitle: string | null, seoPageDescription: string | null, seoKeywords: Array<string | null> | null, formLink: string | null, phoneNumber: string | null, email: string | null, formTitle: string | null, downloadSectionDescription: string | null, downloadSectionLink: string | null, downloadSectionButtonText: string | null, sys: { __typename?: 'Sys', id: string }, contactUsVideoAndAdjacentText: (
      { __typename?: 'ComposeComponentVideoAndAdjacentText' }
      & { ' $fragmentRefs'?: { 'ComposeComponentVideoAndAdjacentText_FragmentFragment': ComposeComponentVideoAndAdjacentText_FragmentFragment } }
    ) | null, productInfoBlock: { __typename?: 'WritingLegendsMarketingSiteContactUsPageV2ProductInfoBlock', json: any } | null, downloadSectionImage: (
      { __typename?: 'ComposeComponentImage' }
      & { ' $fragmentRefs'?: { 'ComposeComponentImage_FragmentFragment': ComposeComponentImage_FragmentFragment } }
    ) | null, customerTestimonial: { __typename?: 'LegoUiTestimonialCard', quote: string | null, author: string | null, date: any | null, rating: number | null } | null } | null };

export type Faqs_FragmentFragment = { __typename: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestions', json: any, links: { __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsLinks', entries: { __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestionsEntries', block: Array<{ __typename?: 'ActivitySheetAsset', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ActivitySheetAssetGroup', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ActivitySheetSection', sys: { __typename: 'Sys', id: string } } | { __typename?: 'BigSchoolResourceList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentArticleBody', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentBlockQuote', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentDownloadableAsset', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentFeaturedArticle', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalHorizontalImageCta', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalVerticalImageCta', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentHorizontalImageCta', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentImage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentImageAndAdjacentText', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentImageAndAdjacentTextList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentLink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentMissionStatement', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentPopularArticles', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextColouredBackground', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextCta', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBanner', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBannerItem', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentTeacherSupportStatement', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentText', sys: { __typename: 'Sys', id: string } } | (
        { __typename?: 'ComposeComponentTextList', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ComposeComponentTextList_FragmentFragment': ComposeComponentTextList_FragmentFragment } }
      ) | { __typename?: 'ComposeComponentTopic', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicBackground', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentUrl', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentVerticalImageCta', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentVideoAndAdjacentText', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlFooterBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlProductAimBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlTestimonialsBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentYoutubeVideo', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposePageArticle', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposePageArticlesIndexPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposePageWlMarketingHomePage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'GetReadyForBigSchoolList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxGuides', sys: { __typename: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxWebinar', sys: { __typename: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusGuides', sys: { __typename: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusWebinar', sys: { __typename: 'Sys', id: string } } | { __typename?: 'HomeschoolProgram', sys: { __typename: 'Sys', id: string } } | { __typename?: 'JumpLink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiButton', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiCallToActionBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiCarousel', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiColumn', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiColumnLayout', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiFooter', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLinkGroup', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiHeroCard', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiImageWithLink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiPageDivider', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiProgramCard', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiSocialMediaLink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiTestimonialCard', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiVideo', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiVideoBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LessonOverview', sys: { __typename: 'Sys', id: string } } | { __typename?: 'Link', sys: { __typename: 'Sys', id: string } } | { __typename?: 'MarketingBlogGlobalRegionalEdits', sys: { __typename: 'Sys', id: string } } | { __typename?: 'MarketingBlogRegionalEdit', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PCampaign', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PCampaignB2B', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PContentPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PFreeResource', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PJson', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PLinkedEntry', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ParentUiRichTextHyperlink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ParentUserGuide', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PlacementTestOverview', sys: { __typename: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PuiDashboardRedesignIntroVideo', sys: { __typename: 'Sys', id: string } } | { __typename?: 'RewardMap', sys: { __typename: 'Sys', id: string } } | { __typename?: 'RolePermissions', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SampleLesson', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAsset', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAssetGroup', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetSection', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaq', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaqList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolPlaceholder', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolResource', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroup', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroupList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolSection', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinar', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinarList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'TeacherTestimonialBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsFreeTrialBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAboutUsPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAccessibilityPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPageV2', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteFaQsPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteIndexPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTechReqPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTermsOfUsePage', sys: { __typename: 'Sys', id: string } } | null> } } } & { ' $fragmentName'?: 'Faqs_FragmentFragment' };

export type WritingLegendsMarketingSiteFaQsPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type WritingLegendsMarketingSiteFaQsPageQuery = { __typename?: 'Query', writingLegendsMarketingSiteFaQsPage: { __typename?: 'WritingLegendsMarketingSiteFaQsPage', seoPageTitle: string | null, seoPageDescription: string | null, seoKeywords: Array<string | null> | null, sys: { __typename?: 'Sys', id: string }, frequentlyAskedQuestions: (
      { __typename?: 'WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestions', json: any }
      & { ' $fragmentRefs'?: { 'Faqs_FragmentFragment': Faqs_FragmentFragment } }
    ) | null } | null };

export type WritingLegendsMarketingSiteIndexPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type WritingLegendsMarketingSiteIndexPageQuery = { __typename?: 'Query', writingLegendsMarketingSiteIndexPage: { __typename?: 'WritingLegendsMarketingSiteIndexPage', seoPageTitle: string | null, seoPageDescription: string | null, seoKeywords: Array<string | null> | null, email: string | null, phoneNumber: string | null, sys: { __typename?: 'Sys', id: string }, summaryBlock: (
      { __typename?: 'WritingLegendsMarketingSiteIndexPageSummaryBlock' }
      & { ' $fragmentRefs'?: { 'ProductSummaryBlock_FragmentFragment': ProductSummaryBlock_FragmentFragment } }
    ) | null, videoBlock: (
      { __typename?: 'WritingLegendsMarketingSiteIndexPageVideoBlock' }
      & { ' $fragmentRefs'?: { 'VideoBlock_FragmentFragment': VideoBlock_FragmentFragment } }
    ) | null, studentOutcomesBlock: (
      { __typename?: 'WritingLegendsMarketingSiteIndexPageStudentOutcomesBlock' }
      & { ' $fragmentRefs'?: { 'StudentOutcomesBlock_FragmentFragment': StudentOutcomesBlock_FragmentFragment } }
    ) | null, productOwnersBlock: { __typename?: 'ActivitySheetAsset' } | { __typename?: 'ActivitySheetAssetGroup' } | { __typename?: 'ActivitySheetSection' } | { __typename?: 'BigSchoolResourceList' } | { __typename?: 'ComposeComponentArticleBody' } | { __typename?: 'ComposeComponentBlockQuote' } | { __typename?: 'ComposeComponentDownloadableAsset' } | { __typename?: 'ComposeComponentFeaturedArticle' } | { __typename?: 'ComposeComponentGlobalHorizontalImageCta' } | { __typename?: 'ComposeComponentGlobalVerticalImageCta' } | { __typename?: 'ComposeComponentHorizontalImageCta' } | { __typename?: 'ComposeComponentImage' } | (
      { __typename?: 'ComposeComponentImageAndAdjacentText' }
      & { ' $fragmentRefs'?: { 'ProductOwnersBlock_FragmentFragment': ProductOwnersBlock_FragmentFragment } }
    ) | { __typename?: 'ComposeComponentImageAndAdjacentTextList' } | { __typename?: 'ComposeComponentLink' } | { __typename?: 'ComposeComponentMissionStatement' } | { __typename?: 'ComposeComponentPopularArticles' } | { __typename?: 'ComposeComponentRichTextColouredBackground' } | { __typename?: 'ComposeComponentRichTextCta' } | { __typename?: 'ComposeComponentStickyBanner' } | { __typename?: 'ComposeComponentStickyBannerItem' } | { __typename?: 'ComposeComponentTeacherSupportStatement' } | { __typename?: 'ComposeComponentText' } | { __typename?: 'ComposeComponentTextList' } | { __typename?: 'ComposeComponentTopic' } | { __typename?: 'ComposeComponentTopicBackground' } | { __typename?: 'ComposeComponentTopicList' } | { __typename?: 'ComposeComponentUrl' } | { __typename?: 'ComposeComponentVerticalImageCta' } | { __typename?: 'ComposeComponentVideoAndAdjacentText' } | { __typename?: 'ComposeComponentWlFooterBlock' } | { __typename?: 'ComposeComponentWlProductAimBlock' } | { __typename?: 'ComposeComponentWlTestimonialsBlock' } | { __typename?: 'ComposeComponentYoutubeVideo' } | { __typename?: 'ComposePageArticle' } | { __typename?: 'ComposePageArticlesIndexPage' } | { __typename?: 'ComposePageWlMarketingHomePage' } | { __typename?: 'GetReadyForBigSchoolList' } | { __typename?: 'HomeschoolMaxGuides' } | { __typename?: 'HomeschoolMaxWebinar' } | { __typename?: 'HomeschoolPlusGuides' } | { __typename?: 'HomeschoolPlusWebinar' } | { __typename?: 'HomeschoolProgram' } | { __typename?: 'JumpLink' } | { __typename?: 'LegoUiButton' } | { __typename?: 'LegoUiCallToActionBlock' } | { __typename?: 'LegoUiCarousel' } | { __typename?: 'LegoUiColumn' } | { __typename?: 'LegoUiColumnLayout' } | { __typename?: 'LegoUiFooter' } | { __typename?: 'LegoUiFooterLink' } | { __typename?: 'LegoUiFooterLinkGroup' } | { __typename?: 'LegoUiHeroCard' } | { __typename?: 'LegoUiImageWithLink' } | { __typename?: 'LegoUiPageDivider' } | { __typename?: 'LegoUiProgramCard' } | { __typename?: 'LegoUiSocialMediaLink' } | { __typename?: 'LegoUiTestimonialCard' } | { __typename?: 'LegoUiVideo' } | { __typename?: 'LegoUiVideoBlock' } | { __typename?: 'LessonOverview' } | { __typename?: 'Link' } | { __typename?: 'MarketingBlogGlobalRegionalEdits' } | { __typename?: 'MarketingBlogRegionalEdit' } | { __typename?: 'PCampaign' } | { __typename?: 'PCampaignB2B' } | { __typename?: 'PContentPage' } | { __typename?: 'PFreeResource' } | { __typename?: 'PJson' } | { __typename?: 'PLinkedEntry' } | { __typename?: 'ParentUiRichTextHyperlink' } | { __typename?: 'ParentUserGuide' } | { __typename?: 'PlacementTestOverview' } | { __typename?: 'Product' } | { __typename?: 'PuiDashboardRedesignIntroVideo' } | { __typename?: 'RewardMap' } | { __typename?: 'RolePermissions' } | { __typename?: 'SampleLesson' } | { __typename?: 'SpanishActivitySheetAsset' } | { __typename?: 'SpanishActivitySheetAssetGroup' } | { __typename?: 'SpanishActivitySheetSection' } | { __typename?: 'SummerSchoolFaq' } | { __typename?: 'SummerSchoolFaqList' } | { __typename?: 'SummerSchoolPage' } | { __typename?: 'SummerSchoolPlaceholder' } | { __typename?: 'SummerSchoolResource' } | { __typename?: 'SummerSchoolResourceGroup' } | { __typename?: 'SummerSchoolResourceGroupList' } | { __typename?: 'SummerSchoolResourceList' } | { __typename?: 'SummerSchoolSection' } | { __typename?: 'SummerSchoolWebinar' } | { __typename?: 'SummerSchoolWebinarList' } | { __typename?: 'TeacherTestimonialBlock' } | { __typename?: 'WritingLegendsFreeTrialBlock' } | { __typename?: 'WritingLegendsMarketingSiteAboutUsPage' } | { __typename?: 'WritingLegendsMarketingSiteAccessibilityPage' } | { __typename?: 'WritingLegendsMarketingSiteContactUsPage' } | { __typename?: 'WritingLegendsMarketingSiteContactUsPageV2' } | { __typename?: 'WritingLegendsMarketingSiteFaQsPage' } | { __typename?: 'WritingLegendsMarketingSiteIndexPage' } | { __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPage' } | { __typename?: 'WritingLegendsMarketingSiteTechReqPage' } | { __typename?: 'WritingLegendsMarketingSiteTermsOfUsePage' } | null, teacherSupportBlock: (
      { __typename?: 'WritingLegendsMarketingSiteIndexPageTeacherSupportBlock' }
      & { ' $fragmentRefs'?: { 'TeacherSupportStatementBlock_FragmentFragment': TeacherSupportStatementBlock_FragmentFragment } }
    ) | null } | null };

export type SoftwareRequirements_FragmentFragment = { __typename: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirements', json: any, links: { __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsLinks', entries: { __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirementsEntries', block: Array<{ __typename?: 'ActivitySheetAsset', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ActivitySheetAssetGroup', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ActivitySheetSection', sys: { __typename: 'Sys', id: string } } | { __typename?: 'BigSchoolResourceList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentArticleBody', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentBlockQuote', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentDownloadableAsset', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentFeaturedArticle', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalHorizontalImageCta', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentGlobalVerticalImageCta', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentHorizontalImageCta', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentImage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentImageAndAdjacentText', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentImageAndAdjacentTextList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentLink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentMissionStatement', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentPopularArticles', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextColouredBackground', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentRichTextCta', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBanner', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentStickyBannerItem', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentTeacherSupportStatement', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentText', sys: { __typename: 'Sys', id: string } } | (
        { __typename?: 'ComposeComponentTextList', sys: { __typename: 'Sys', id: string } }
        & { ' $fragmentRefs'?: { 'ComposeComponentTextList_FragmentFragment': ComposeComponentTextList_FragmentFragment } }
      ) | { __typename?: 'ComposeComponentTopic', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicBackground', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentTopicList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentUrl', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentVerticalImageCta', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentVideoAndAdjacentText', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlFooterBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlProductAimBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentWlTestimonialsBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposeComponentYoutubeVideo', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposePageArticle', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposePageArticlesIndexPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ComposePageWlMarketingHomePage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'GetReadyForBigSchoolList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxGuides', sys: { __typename: 'Sys', id: string } } | { __typename?: 'HomeschoolMaxWebinar', sys: { __typename: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusGuides', sys: { __typename: 'Sys', id: string } } | { __typename?: 'HomeschoolPlusWebinar', sys: { __typename: 'Sys', id: string } } | { __typename?: 'HomeschoolProgram', sys: { __typename: 'Sys', id: string } } | { __typename?: 'JumpLink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiButton', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiCallToActionBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiCarousel', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiColumn', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiColumnLayout', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiFooter', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiFooterLinkGroup', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiHeroCard', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiImageWithLink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiPageDivider', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiProgramCard', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiSocialMediaLink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiTestimonialCard', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiVideo', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LegoUiVideoBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'LessonOverview', sys: { __typename: 'Sys', id: string } } | { __typename?: 'Link', sys: { __typename: 'Sys', id: string } } | { __typename?: 'MarketingBlogGlobalRegionalEdits', sys: { __typename: 'Sys', id: string } } | { __typename?: 'MarketingBlogRegionalEdit', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PCampaign', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PCampaignB2B', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PContentPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PFreeResource', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PJson', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PLinkedEntry', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ParentUiRichTextHyperlink', sys: { __typename: 'Sys', id: string } } | { __typename?: 'ParentUserGuide', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PlacementTestOverview', sys: { __typename: 'Sys', id: string } } | { __typename?: 'Product', sys: { __typename: 'Sys', id: string } } | { __typename?: 'PuiDashboardRedesignIntroVideo', sys: { __typename: 'Sys', id: string } } | { __typename?: 'RewardMap', sys: { __typename: 'Sys', id: string } } | { __typename?: 'RolePermissions', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SampleLesson', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAsset', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetAssetGroup', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SpanishActivitySheetSection', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaq', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolFaqList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolPlaceholder', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolResource', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroup', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceGroupList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolResourceList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolSection', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinar', sys: { __typename: 'Sys', id: string } } | { __typename?: 'SummerSchoolWebinarList', sys: { __typename: 'Sys', id: string } } | { __typename?: 'TeacherTestimonialBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsFreeTrialBlock', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAboutUsPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteAccessibilityPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteContactUsPageV2', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteFaQsPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteIndexPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSitePrivacyPolicyPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTechReqPage', sys: { __typename: 'Sys', id: string } } | { __typename?: 'WritingLegendsMarketingSiteTermsOfUsePage', sys: { __typename: 'Sys', id: string } } | null> } } } & { ' $fragmentName'?: 'SoftwareRequirements_FragmentFragment' };

export type WritingLegendsMarketingSiteTechReqPageQueryVariables = Exact<{
  id: Scalars['String']['input'];
  locale: InputMaybe<Scalars['String']['input']>;
}>;


export type WritingLegendsMarketingSiteTechReqPageQuery = { __typename?: 'Query', writingLegendsMarketingSiteTechReqPage: { __typename?: 'WritingLegendsMarketingSiteTechReqPage', seoPageTitle: string | null, seoPageDescription: string | null, seoKeywords: Array<string | null> | null, sys: { __typename?: 'Sys', id: string }, softwareRequirements: (
      { __typename?: 'WritingLegendsMarketingSiteTechReqPageSoftwareRequirements', json: any }
      & { ' $fragmentRefs'?: { 'SoftwareRequirements_FragmentFragment': SoftwareRequirements_FragmentFragment } }
    ) | null } | null };

export const FooterBlock_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FooterBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentWlFooterBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"about3PLearning"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUs"}},{"kind":"Field","name":{"kind":"Name","value":"blakeELearningLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaborateWithUs"}},{"kind":"Field","name":{"kind":"Name","value":"contactUs"}},{"kind":"Field","name":{"kind":"Name","value":"dataBreachResponsePlan"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"linkedIn"}},{"kind":"Field","name":{"kind":"Name","value":"pLearningLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinterest"}},{"kind":"Field","name":{"kind":"Name","value":"privacyPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"refundPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleDisclosureProgram"}},{"kind":"Field","name":{"kind":"Name","value":"termsOfUse"}},{"kind":"Field","name":{"kind":"Name","value":"tikTok"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}}]}}]} as unknown as DocumentNode<FooterBlock_FragmentFragment, unknown>;
export const ProductOwnersBlock_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductOwnersBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]} as unknown as DocumentNode<ProductOwnersBlock_FragmentFragment, unknown>;
export const ComposeComponentVideoAndAdjacentText_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<ComposeComponentVideoAndAdjacentText_FragmentFragment, unknown>;
export const ComposeComponentImageAndAdjacentText_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]} as unknown as DocumentNode<ComposeComponentImageAndAdjacentText_FragmentFragment, unknown>;
export const StudentOutcomesBlock_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StudentOutcomesBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteIndexPageStudentOutcomesBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]} as unknown as DocumentNode<StudentOutcomesBlock_FragmentFragment, unknown>;
export const ProductSummaryBlock_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSummaryBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteIndexPageSummaryBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]} as unknown as DocumentNode<ProductSummaryBlock_FragmentFragment, unknown>;
export const TeacherSupportStatementBlock_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeacherSupportStatementBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteIndexPageTeacherSupportBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]} as unknown as DocumentNode<TeacherSupportStatementBlock_FragmentFragment, unknown>;
export const VideoBlock_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteIndexPageVideoBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]} as unknown as DocumentNode<VideoBlock_FragmentFragment, unknown>;
export const ComposeComponentImage_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentImage_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"imageAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]} as unknown as DocumentNode<ComposeComponentImage_FragmentFragment, unknown>;
export const ComposeComponentText_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]} as unknown as DocumentNode<ComposeComponentText_FragmentFragment, unknown>;
export const ComposeComponentTextList_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textItemsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentText_Fragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]} as unknown as DocumentNode<ComposeComponentTextList_FragmentFragment, unknown>;
export const RichTextBlockEntry_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RichTextBlockEntry_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textItemsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentText_Fragment"}}]}}]}}]}}]} as unknown as DocumentNode<RichTextBlockEntry_FragmentFragment, unknown>;
export const Faqs_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faqs_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textItemsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentText_Fragment"}}]}}]}}]}}]} as unknown as DocumentNode<Faqs_FragmentFragment, unknown>;
export const SoftwareRequirements_FragmentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SoftwareRequirements_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteTechReqPageSoftwareRequirements"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textItemsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentText_Fragment"}}]}}]}}]}}]} as unknown as DocumentNode<SoftwareRequirements_FragmentFragment, unknown>;
export const WritingLegendsFooterBlockDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WritingLegendsFooterBlock"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"composeComponentWlFooterBlock"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"FooterBlock_Fragment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FooterBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentWlFooterBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"about3PLearning"}},{"kind":"Field","name":{"kind":"Name","value":"aboutUs"}},{"kind":"Field","name":{"kind":"Name","value":"blakeELearningLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"collaborateWithUs"}},{"kind":"Field","name":{"kind":"Name","value":"contactUs"}},{"kind":"Field","name":{"kind":"Name","value":"dataBreachResponsePlan"}},{"kind":"Field","name":{"kind":"Name","value":"facebook"}},{"kind":"Field","name":{"kind":"Name","value":"instagram"}},{"kind":"Field","name":{"kind":"Name","value":"linkedIn"}},{"kind":"Field","name":{"kind":"Name","value":"pLearningLogo"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}}]}},{"kind":"Field","name":{"kind":"Name","value":"pinterest"}},{"kind":"Field","name":{"kind":"Name","value":"privacyPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"refundPolicy"}},{"kind":"Field","name":{"kind":"Name","value":"responsibleDisclosureProgram"}},{"kind":"Field","name":{"kind":"Name","value":"termsOfUse"}},{"kind":"Field","name":{"kind":"Name","value":"tikTok"}},{"kind":"Field","name":{"kind":"Name","value":"twitter"}},{"kind":"Field","name":{"kind":"Name","value":"youtube"}}]}}]} as unknown as DocumentNode<WritingLegendsFooterBlockQuery, WritingLegendsFooterBlockQueryVariables>;
export const WritingLegendsMarketingSitePrivacyPolicyPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WritingLegendsMarketingSitePrivacyPolicyPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingLegendsMarketingSitePrivacyPolicyPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoPageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"privacyPolicyBody"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]}}]} as unknown as DocumentNode<WritingLegendsMarketingSitePrivacyPolicyPageQuery, WritingLegendsMarketingSitePrivacyPolicyPageQueryVariables>;
export const WritingLegendsMarketingSiteTermsOfUsePageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"writingLegendsMarketingSiteTermsOfUsePage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingLegendsMarketingSiteTermsOfUsePage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoPageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"termsOfUse"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}}]}}]} as unknown as DocumentNode<WritingLegendsMarketingSiteTermsOfUsePageQuery, WritingLegendsMarketingSiteTermsOfUsePageQueryVariables>;
export const WritingLegendsMarketingSiteAboutUsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WritingLegendsMarketingSiteAboutUsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingLegendsMarketingSiteAboutUsPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aboutUsText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoPageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}}]}}]}}]} as unknown as DocumentNode<WritingLegendsMarketingSiteAboutUsPageQuery, WritingLegendsMarketingSiteAboutUsPageQueryVariables>;
export const WritingLegendsMarketingSiteAccessibilityPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WritingLegendsMarketingSiteAccessibilityPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingLegendsMarketingSiteAccessibilityPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessibilityText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoPageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}}]}}]}}]} as unknown as DocumentNode<WritingLegendsMarketingSiteAccessibilityPageQuery, WritingLegendsMarketingSiteAccessibilityPageQueryVariables>;
export const WritingLegendsMarketingSiteContactUsPageV2Document = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WritingLegendsMarketingSiteContactUsPageV2"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingLegendsMarketingSiteContactUsPageV2"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoPageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"formLink"}},{"kind":"Field","name":{"kind":"Name","value":"contactUsVideoAndAdjacentText"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productInfoBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"formTitle"}},{"kind":"Field","name":{"kind":"Name","value":"downloadSectionDescription"}},{"kind":"Field","name":{"kind":"Name","value":"downloadSectionLink"}},{"kind":"Field","name":{"kind":"Name","value":"downloadSectionButtonText"}},{"kind":"Field","name":{"kind":"Name","value":"downloadSectionImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentImage_Fragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"customerTestimonial"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"quote"}},{"kind":"Field","name":{"kind":"Name","value":"author"}},{"kind":"Field","name":{"kind":"Name","value":"date"}},{"kind":"Field","name":{"kind":"Name","value":"rating"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentImage_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImage"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"altText"}},{"kind":"Field","name":{"kind":"Name","value":"imageAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]} as unknown as DocumentNode<WritingLegendsMarketingSiteContactUsPageV2Query, WritingLegendsMarketingSiteContactUsPageV2QueryVariables>;
export const WritingLegendsMarketingSiteFaQsPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WritingLegendsMarketingSiteFaQsPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingLegendsMarketingSiteFaQsPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoPageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"frequentlyAskedQuestions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"Faqs_Fragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textItemsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentText_Fragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Faqs_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteFaQsPageFrequentlyAskedQuestions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WritingLegendsMarketingSiteFaQsPageQuery, WritingLegendsMarketingSiteFaQsPageQueryVariables>;
export const WritingLegendsMarketingSiteIndexPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WritingLegendsMarketingSiteIndexPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingLegendsMarketingSiteIndexPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoPageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"summaryBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductSummaryBlock_Fragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoBlock_Fragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"studentOutcomesBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"StudentOutcomesBlock_Fragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"productOwnersBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductOwnersBlock_Fragment"}}]}},{"kind":"Field","name":{"kind":"Name","value":"teacherSupportBlock"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TeacherSupportStatementBlock_Fragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"videoAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"video"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"description"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"assets"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Asset"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}}]}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductSummaryBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteIndexPageSummaryBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteIndexPageVideoBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"StudentOutcomesBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteIndexPageStudentOutcomesBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"}}]}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductOwnersBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"TeacherSupportStatementBlock_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteIndexPageTeacherSupportBlock"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentVideoAndAdjacentText_Fragment"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentImageAndAdjacentText_Fragment"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WritingLegendsMarketingSiteIndexPageQuery, WritingLegendsMarketingSiteIndexPageQueryVariables>;
export const WritingLegendsMarketingSiteTechReqPageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"writingLegendsMarketingSiteTechReqPage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locale"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"writingLegendsMarketingSiteTechReqPage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"locale"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locale"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"seoPageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"seoPageDescription"}},{"kind":"Field","name":{"kind":"Name","value":"seoKeywords"}},{"kind":"Field","name":{"kind":"Name","value":"softwareRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"SoftwareRequirements_Fragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentText_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentText"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"text"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"json"}}]}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"textItemsCollection"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"20"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"items"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentText_Fragment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SoftwareRequirements_Fragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WritingLegendsMarketingSiteTechReqPageSoftwareRequirements"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"json"}},{"kind":"Field","name":{"kind":"Name","value":"links"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"block"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sys"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}}]}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ComposeComponentTextList"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ComposeComponentTextList_Fragment"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<WritingLegendsMarketingSiteTechReqPageQuery, WritingLegendsMarketingSiteTechReqPageQueryVariables>;